var _h = Object.defineProperty;
var Wh = (q, f, bt) => (f in q ? _h(q, f, { enumerable: !0, configurable: !0, writable: !0, value: bt }) : (q[f] = bt));
var o = (q, f, bt) => (Wh(q, typeof f != 'symbol' ? f + '' : f, bt), bt);
(function (q, f) {
  typeof exports == 'object' && typeof module < 'u'
    ? f(exports)
    : typeof define == 'function' && define.amd
    ? define(['exports'], f)
    : ((q = typeof globalThis < 'u' ? globalThis : q || self), f((q['xo-webcomponents'] = {})));
})(this, function (q) {
  var Hn, Rn, qn, Vn, zn, Bn, _n, Wn, Ae, zs, Un, Xn, Yn, Gn, jn, Qn, Zn, Kn, $e, Jn, tr, _s, Ws, Me, Us;
  ('use strict');
  /*! (c) Andrea Giammarchi @webreflection ISC */ (function () {
    var n = function (C, w) {
      var S = function (z) {
          for (var O = 0, R = z.length; O < R; O++) I(z[O]);
        },
        I = function (z) {
          var O = z.target,
            R = z.attributeName,
            tt = z.oldValue;
          O.attributeChangedCallback(R, tt, O.getAttribute(R));
        };
      return function (N, z) {
        var O = N.constructor.observedAttributes;
        return (
          O &&
            C(z).then(function () {
              new w(S).observe(N, { attributes: !0, attributeOldValue: !0, attributeFilter: O });
              for (var R = 0, tt = O.length; R < tt; R++) N.hasAttribute(O[R]) && I({ target: N, attributeName: O[R], oldValue: null });
            }),
          N
        );
      };
    };
    function i(C, w) {
      if (!!C) {
        if (typeof C == 'string') return t(C, w);
        var S = Object.prototype.toString.call(C).slice(8, -1);
        if ((S === 'Object' && C.constructor && (S = C.constructor.name), S === 'Map' || S === 'Set')) return Array.from(C);
        if (S === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S)) return t(C, w);
      }
    }
    function t(C, w) {
      (w == null || w > C.length) && (w = C.length);
      for (var S = 0, I = new Array(w); S < w; S++) I[S] = C[S];
      return I;
    }
    function e(C, w) {
      var S = (typeof Symbol < 'u' && C[Symbol.iterator]) || C['@@iterator'];
      if (!S) {
        if (Array.isArray(C) || (S = i(C)) || (w && C && typeof C.length == 'number')) {
          S && (C = S);
          var I = 0,
            N = function () {};
          return {
            s: N,
            n: function () {
              return I >= C.length ? { done: !0 } : { done: !1, value: C[I++] };
            },
            e: function (tt) {
              throw tt;
            },
            f: N,
          };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
  In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var z = !0,
        O = !1,
        R;
      return {
        s: function () {
          S = S.call(C);
        },
        n: function () {
          var tt = S.next();
          return (z = tt.done), tt;
        },
        e: function (tt) {
          (O = !0), (R = tt);
        },
        f: function () {
          try {
            !z && S.return != null && S.return();
          } finally {
            if (O) throw R;
          }
        },
      };
    }
    /*! (c) Andrea Giammarchi - ISC */ var s = !0,
      r = !1,
      a = 'querySelectorAll',
      l = function (w) {
        var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document,
          I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MutationObserver,
          N = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ['*'],
          z = function tt(Ut, Xt, ht, F, j, et) {
            var mt = e(Ut),
              de;
            try {
              for (mt.s(); !(de = mt.n()).done; ) {
                var rt = de.value;
                (et || a in rt) &&
                  (j ? ht.has(rt) || (ht.add(rt), F.delete(rt), w(rt, j)) : F.has(rt) || (F.add(rt), ht.delete(rt), w(rt, j)), et || tt(rt[a](Xt), Xt, ht, F, j, s));
              }
            } catch (yo) {
              mt.e(yo);
            } finally {
              mt.f();
            }
          },
          O = new I(function (tt) {
            if (N.length) {
              var Ut = N.join(','),
                Xt = new Set(),
                ht = new Set(),
                F = e(tt),
                j;
              try {
                for (F.s(); !(j = F.n()).done; ) {
                  var et = j.value,
                    mt = et.addedNodes,
                    de = et.removedNodes;
                  z(de, Ut, Xt, ht, r, r), z(mt, Ut, Xt, ht, s, r);
                }
              } catch (rt) {
                F.e(rt);
              } finally {
                F.f();
              }
            }
          }),
          R = O.observe;
        return (
          (O.observe = function (tt) {
            return R.call(O, tt, { subtree: s, childList: s });
          })(S),
          O
        );
      },
      h = 'querySelectorAll',
      d = self,
      u = d.document,
      p = d.Element,
      m = d.MutationObserver,
      x = d.Set,
      y = d.WeakMap,
      b = function (w) {
        return h in w;
      },
      v = [].filter,
      k = function (C) {
        var w = new y(),
          S = function (F) {
            for (var j = 0, et = F.length; j < et; j++) w.delete(F[j]);
          },
          I = function () {
            for (var F = Ut.takeRecords(), j = 0, et = F.length; j < et; j++) O(v.call(F[j].removedNodes, b), !1), O(v.call(F[j].addedNodes, b), !0);
          },
          N = function (F) {
            return F.matches || F.webkitMatchesSelector || F.msMatchesSelector;
          },
          z = function (F, j) {
            var et;
            if (j)
              for (var mt, de = N(F), rt = 0, yo = R.length; rt < yo; rt++)
                de.call(F, (mt = R[rt])) && (w.has(F) || w.set(F, new x()), (et = w.get(F)), et.has(mt) || (et.add(mt), C.handle(F, j, mt)));
            else
              w.has(F) &&
                ((et = w.get(F)),
                w.delete(F),
                et.forEach(function (Bh) {
                  C.handle(F, j, Bh);
                }));
          },
          O = function (F) {
            for (var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, et = 0, mt = F.length; et < mt; et++) z(F[et], j);
          },
          R = C.query,
          tt = C.root || u,
          Ut = l(z, tt, m, R),
          Xt = p.prototype.attachShadow;
        return (
          Xt &&
            (p.prototype.attachShadow = function (ht) {
              var F = Xt.call(this, ht);
              return Ut.observe(F), F;
            }),
          R.length && O(tt[h](R)),
          { drop: S, flush: I, observer: Ut, parse: O }
        );
      },
      A = self,
      T = A.document,
      M = A.Map,
      L = A.MutationObserver,
      V = A.Object,
      ot = A.Set,
      ut = A.WeakMap,
      pt = A.Element,
      gt = A.HTMLElement,
      _t = A.Node,
      Le = A.Error,
      kt = A.TypeError,
      ct = A.Reflect,
      Wt = V.defineProperty,
      co = V.keys,
      ho = V.getOwnPropertyNames,
      Ie = V.setPrototypeOf,
      De = !self.customElements,
      er = function (w) {
        for (var S = co(w), I = [], N = new ot(), z = S.length, O = 0; O < z; O++) {
          I[O] = w[S[O]];
          try {
            delete w[S[O]];
          } catch {
            N.add(O);
          }
        }
        return function () {
          for (var R = 0; R < z; R++) N.has(R) || (w[S[R]] = I[R]);
        };
      };
    if (De) {
      var uo = function () {
          var w = this.constructor;
          if (!po.has(w)) throw new kt('Illegal constructor');
          var S = po.get(w);
          if (Ys) return nr(Ys, S);
          var I = sr.call(T, S);
          return nr(Ie(I, w.prototype), S);
        },
        sr = T.createElement,
        po = new M(),
        Xs = new M(),
        ir = new M(),
        Ne = new M(),
        or = [],
        Th = function (w, S, I) {
          var N = ir.get(I);
          if (S && !N.isPrototypeOf(w)) {
            var z = er(w);
            Ys = Ie(w, N);
            try {
              new N.constructor();
            } finally {
              (Ys = null), z();
            }
          }
          var O = ''.concat(S ? '' : 'dis', 'connectedCallback');
          O in N && w[O]();
        },
        $h = k({ query: or, handle: Th }),
        Mh = $h.parse,
        Ys = null,
        mo = function (w) {
          if (!Xs.has(w)) {
            var S,
              I = new Promise(function (N) {
                S = N;
              });
            Xs.set(w, { $: I, _: S });
          }
          return Xs.get(w).$;
        },
        nr = n(mo, L);
      (self.customElements = {
        define: function (w, S) {
          if (Ne.has(w)) throw new Le('the name "'.concat(w, '" has already been used with this registry'));
          po.set(S, w),
            ir.set(w, S.prototype),
            Ne.set(w, S),
            or.push(w),
            mo(w).then(function () {
              Mh(T.querySelectorAll(w));
            }),
            Xs.get(w)._(S);
        },
        get: function (w) {
          return Ne.get(w);
        },
        whenDefined: mo,
      }),
        Wt((uo.prototype = gt.prototype), 'constructor', { value: uo }),
        (self.HTMLElement = uo),
        (T.createElement = function (C, w) {
          var S = w && w.is,
            I = S ? Ne.get(S) : Ne.get(C);
          return I ? new I() : sr.call(T, C);
        }),
        'isConnected' in _t.prototype ||
          Wt(_t.prototype, 'isConnected', {
            configurable: !0,
            get: function () {
              return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
            },
          });
    } else if (((De = !self.customElements.get('extends-br')), De))
      try {
        var rr = function C() {
          return self.Reflect.construct(HTMLBRElement, [], C);
        };
        rr.prototype = HTMLLIElement.prototype;
        var ar = 'extends-br';
        self.customElements.define('extends-br', rr, { extends: 'br' }), (De = T.createElement('br', { is: ar }).outerHTML.indexOf(ar) < 0);
        var lr = self.customElements,
          Lh = lr.get,
          Ih = lr.whenDefined;
        self.customElements.whenDefined = function (C) {
          var w = this;
          return Ih.call(this, C).then(function (S) {
            return S || Lh.call(w, C);
          });
        };
      } catch {}
    if (De) {
      var cr = function (w) {
          var S = fo.get(w);
          mr(S.querySelectorAll(this), w.isConnected);
        },
        At = self.customElements,
        hr = T.createElement,
        Dh = At.define,
        Nh = At.get,
        Oh = At.upgrade,
        Fh = ct || {
          construct: function (w) {
            return w.call(this);
          },
        },
        Hh = Fh.construct,
        fo = new ut(),
        xo = new ot(),
        Gs = new M(),
        js = new M(),
        dr = new M(),
        Qs = new M(),
        ur = [],
        Zs = [],
        pr = function (w) {
          return Qs.get(w) || Nh.call(At, w);
        },
        Rh = function (w, S, I) {
          var N = dr.get(I);
          if (S && !N.isPrototypeOf(w)) {
            var z = er(w);
            Ks = Ie(w, N);
            try {
              new N.constructor();
            } finally {
              (Ks = null), z();
            }
          }
          var O = ''.concat(S ? '' : 'dis', 'connectedCallback');
          O in N && w[O]();
        },
        qh = k({ query: Zs, handle: Rh }),
        mr = qh.parse,
        Vh = k({
          query: ur,
          handle: function (w, S) {
            fo.has(w) && (S ? xo.add(w) : xo.delete(w), Zs.length && cr.call(Zs, w));
          },
        }),
        zh = Vh.parse,
        fr = pt.prototype.attachShadow;
      fr &&
        (pt.prototype.attachShadow = function (C) {
          var w = fr.call(this, C);
          return fo.set(this, w), w;
        });
      var go = function (w) {
          if (!js.has(w)) {
            var S,
              I = new Promise(function (N) {
                S = N;
              });
            js.set(w, { $: I, _: S });
          }
          return js.get(w).$;
        },
        bo = n(go, L),
        Ks = null;
      ho(self)
        .filter(function (C) {
          return /^HTML.*Element$/.test(C);
        })
        .forEach(function (C) {
          var w = self[C];
          function S() {
            var I = this.constructor;
            if (!Gs.has(I)) throw new kt('Illegal constructor');
            var N = Gs.get(I),
              z = N.is,
              O = N.tag;
            if (z) {
              if (Ks) return bo(Ks, z);
              var R = hr.call(T, O);
              return R.setAttribute('is', z), bo(Ie(R, I.prototype), z);
            } else return Hh.call(this, w, [], I);
          }
          Wt((S.prototype = w.prototype), 'constructor', { value: S }), Wt(self, C, { value: S });
        }),
        (T.createElement = function (C, w) {
          var S = w && w.is;
          if (S) {
            var I = Qs.get(S);
            if (I && Gs.get(I).tag === C) return new I();
          }
          var N = hr.call(T, C);
          return S && N.setAttribute('is', S), N;
        }),
        (At.get = pr),
        (At.whenDefined = go),
        (At.upgrade = function (C) {
          var w = C.getAttribute('is');
          if (w) {
            var S = Qs.get(w);
            if (S) {
              bo(Ie(C, S.prototype), w);
              return;
            }
          }
          Oh.call(At, C);
        }),
        (At.define = function (C, w, S) {
          if (pr(C)) throw new Le("'".concat(C, "' has already been defined as a custom element"));
          var I,
            N = S && S.extends;
          Gs.set(w, N ? { is: C, tag: N } : { is: '', tag: C }),
            N ? ((I = ''.concat(N, '[is="').concat(C, '"]')), dr.set(I, w.prototype), Qs.set(C, w), Zs.push(I)) : (Dh.apply(At, arguments), ur.push((I = C))),
            go(C).then(function () {
              N ? (mr(T.querySelectorAll(I)), xo.forEach(cr, [I])) : zh(T.querySelectorAll(I));
            }),
            js.get(C)._(w);
        });
    }
  })();
  const f = {
    get: (n, i) => (n.getAttribute(i) === 'false' ? !1 : n.hasAttribute(i)),
    set: (n, i, t) => {
      t ? n.setAttribute(i, '') : n.removeAttribute(i);
    },
  };
  function bt(n, i) {
    var t;
    if ((t = window.xbEditor) != null && t.designMode)
      console.warn(`${n}

  ${
    i
      ? `Example:
  ${i}`
      : ''
  }`);
    else
      throw new Error(`${n}

  ${
    i
      ? `Example:
  ${i}`
      : ''
  }`);
  }
  function W(n, i, t) {
    t ||
      bt(
        `${n} must have a \`${i}\` attribute.`,
        `
  <${n} ${i}="..."></${n}>
      `,
      );
  }
  function Y(n, i, t) {
    return Math.min(Math.max(n, i), t);
  }
  function ee(n) {
    return Object.prototype.toString.call(n).slice(8, -1).toLowerCase();
  }
  function xr(n) {
    return n === null || (typeof n != 'function' && typeof n != 'object');
  }
  ee.primitive = xr;
  function ue(n) {
    if (ee(n) === 'array') return n.map((i) => ue(i));
    if (ee(n) === 'object') {
      const i = {};
      for (const t in n) i[t] = ue(n[t]);
      return i;
    } else return n;
  }
  function E(n, i) {
    for (let t = 0; t < n.length; t++) i(n[t], t, n);
  }
  const ft = (n) => Object.keys(n);
  function B(n, i) {
    E(ft(n), (t) => {
      customElements.get(t) || customElements.define(t, n[t], i);
    });
  }
  function It(n, i) {
    const t = [];
    for (let e = 0; e < n.length; e++) i(n[e], e, n) && t.push(n[e]);
    return t;
  }
  class pe {
    constructor() {
      o(this, 'id');
      o(this, 'events');
      (this.id = 0), (this.events = {});
    }
    on(i, t) {
      return this.id++, (this.events = { ...this.events, [i]: [...(this.events[i] || []), { listener: t, id: this.id }] }), this.id;
    }
    off(i) {
      for (const t in this.events) this.events = { ...this.events, [t]: It(this.events[t], (e) => e.id !== i) };
    }
    emit(i, t) {
      this.events[i] &&
        E(this.events[i], ({ listener: e }) => {
          e(t);
        });
    }
  }
  function _() {
    const n = new pe();
    let i = -1,
      t = -1,
      e = -1,
      s = 0,
      r = -1,
      a = -1;
    function l({ to: h, from: d, duration: u = 1e3, friction: p = 1, reverseEasing: m = !1, easing: x, onStart: y, onUpdate: b, onEnd: v }) {
      let k = null;
      (s = d), y == null || y(s), n.emit('start', s), cancelAnimationFrame(a);
      function A(T) {
        k || (k = T);
        const M = T - k,
          L = Math.min(M / u, 1);
        (s = d + (h - d) * L * p),
          typeof x == 'function' && (m ? (s = d + (h - d) * (1 - x(1 - L))) : (s = d + (h - d) * x(L))),
          n.emit('update', s),
          b == null || b(s),
          L < 1 && (a = requestAnimationFrame(A));
      }
      return (
        (a = requestAnimationFrame(A)),
        (r = window.setTimeout(() => {
          cancelAnimationFrame(a), clearTimeout(r), (s = h), b == null || b(s), v == null || v(s), n.emit('update', s), n.emit('end', s);
        }, u)),
        () => {
          clearTimeout(r), cancelAnimationFrame(a);
        }
      );
    }
    return (
      (l.onStart = (h) => ((i = n.on('start', h)), () => n.off(i))),
      (l.onUpdate = (h) => ((t = n.on('update', h)), () => n.off(t))),
      (l.onEnd = (h) => ((e = n.on('end', h)), () => n.off(e))),
      (l.off = () => {
        n.off(i), n.off(t), n.off(e), cancelAnimationFrame(a), clearTimeout(r);
      }),
      (l.getValue = () => s),
      l
    );
  }
  function Js(n) {
    let i = 5381,
      t = n.length;
    for (; t; ) i = (i * 33) ^ n.charCodeAt(--t);
    return i >>> 0;
  }
  function vo(n) {
    return n.replace(/\s+/g, ' ').trim();
  }
  function Oe(n = 'global') {
    return (i, ...t) => {
      let e = vo(i.reduce((r, a, l) => (t[l] == null ? r + a : r + a + t[l]), ''));
      const s = {};
      return (
        n === 'scope' &&
          (e = vo(
            e.replace(/(:global\(|)(?:[\.]{1})([a-zA-Z_]+[\w-_\\\[\]\+\=\{\}\?\*\!\(\)]*)(?:[\s\.\,\{\>#\:]{0})/gim, (r) => {
              if (r.includes(':global(')) {
                const h = r.replace(/:global\(\s*\.|\)$/g, '');
                return (s[h] = h), `.${h}`;
              }
              const a = r.trim().replace(/^\./g, ''),
                l = `xo-${a}-${Js(e)}`;
              return (s[a] = l), `.${l}`;
            }),
          )),
        { classes: s, cssText: e }
      );
    };
  }
  function Eo(n, i) {
    var e;
    const t = i.querySelector('.xo-styles');
    if (t) t.textContent && !((e = t.textContent) != null && e.includes(n)) && (t.textContent += n);
    else {
      const s = document.createElement('style');
      s.classList.add('xo-styles'), (s.textContent = n), i.appendChild(s);
    }
  }
  function st(n, i = 300) {
    let t = -1;
    return function (...s) {
      const r = this;
      clearTimeout(t),
        (t = window.setTimeout(() => {
          n.apply(r, s);
        }, i));
    };
  }
  function P(n = 0) {
    return new Promise((i) => {
      const t = window.setTimeout(() => {
        i(() => window.clearTimeout(t)), clearTimeout(t);
      }, n);
    });
  }
  function se(n) {
    /comp|inter/.test(document.readyState)
      ? n()
      : 'addEventListener' in document
      ? document.addEventListener('DOMContentLoaded', n)
      : document.attachEvent('onreadystatechange', () => {
          document.readyState === 'complete' && n();
        });
  }
  const H = {
    linear: (n) => n,
    ease: (n) => 0.5 * (1 - Math.cos(Math.PI * n)),
    easeInQuad: (n) => n * n,
    easeOutQuad: (n) => n * (2 - n),
    easeInOutQuad: (n) => (n < 0.5 ? 2 * n * n : -1 + (4 - 2 * n) * n),
    easeInCubic: (n) => n * n * n,
    easeOutCubic: (n) => --n * n * n + 1,
    easeInOutCubic: (n) => (n < 0.5 ? 4 * n * n * n : (n - 1) * (2 * n - 2) * (2 * n - 2) + 1),
    easeInQuart: (n) => n * n * n * n,
    easeOutQuart: (n) => 1 - --n * n * n * n,
    easeInOutQuart: (n) => (n < 0.5 ? 8 * n * n * n * n : 1 - 8 * --n * n * n * n),
    easeInQuint: (n) => n * n * n * n * n,
    easeOutQuint: (n) => 1 + --n * n * n * n * n,
    easeInOutQuint: (n) => (n < 0.5 ? 16 * n * n * n * n * n : 1 + 16 * --n * n * n * n * n),
    easeOutBounce: (n) =>
      n < 1 / 2.75
        ? 7.5625 * n * n
        : n < 2 / 2.75
        ? 7.5625 * (n -= 1.5 / 2.75) * n + 0.75
        : n < 2.5 / 2.75
        ? 7.5625 * (n -= 2.25 / 2.75) * n + 0.9375
        : 7.5625 * (n -= 2.625 / 2.75) * n + 0.984375,
    easeInBounce: (n) => 1 - H.easeOutBounce(1 - n),
    easeOutBack: (n) => 1 + 2.70158 * (n - 1) ** 3 + 1.70158 * (n - 1) ** 2,
    easeInBack: (n) => 2.70158 * n * n * n - 1.70158 * n * n,
    easeInOut: (n) => (n < 0.5 ? H.easeInBack(n * 2) / 2 : H.easeOutBack(n * 2 - 1) / 2 + 0.5),
    easeInElastic: (n) => {
      const i = (2 * Math.PI) / 3;
      return n === 0 ? 0 : n === 1 ? 1 : -(2 ** (10 * n - 10)) * Math.sin((n * 10 - 10.75) * i);
    },
    easeOutElastic: (n) => {
      const i = (2 * Math.PI) / 3;
      return n === 0 ? 0 : n === 1 ? 1 : 2 ** (-10 * n) * Math.sin((n * 10 - 0.75) * i) + 1;
    },
    easeInExpo: (n) => (n === 0 ? 0 : 2 ** (10 * n - 10)),
    easeOutExpo: (n) => (n === 1 ? 1 : 1 - 2 ** (-10 * n)),
    spring: (n) => 1 - Math.cos(n * 4.5 * Math.PI) * Math.exp(-n * 6),
    decay: (n) => 1 - Math.exp(-n * 6),
  };
  function Pt(n, i) {
    if (ee.primitive(n) || ee.primitive(n) || n == null || i == null) return n === i;
    const t = Object.keys(n),
      e = Object.keys(i);
    if (t.length !== e.length) return !1;
    for (const s of t) {
      const r = n[s],
        a = i[s];
      if (typeof r == 'object' && typeof a == 'object') {
        if (!Pt(r, a)) return !1;
      } else if (r !== a) return !1;
    }
    return !0;
  }
  function ti(n, i) {
    for (let t = 0; t < n.length; t++) if (i(n[t], t, n)) return t;
    return -1;
  }
  function nt(n, i) {
    const t = [];
    for (let e = 0; e < n.length; e++) t.push(i(n[e], e, n));
    return t;
  }
  function yt(n, i, t) {
    let e = t;
    for (let s = 0; s < n.length; s++) e = i(e, n[s], s, n);
    return e;
  }
  class gr {
    constructor() {
      o(this, 'frameId');
      o(this, 'keepAliveFrameId');
      o(this, 'lastTimestamp');
      o(this, 'frames');
      o(this, 'keepAliveFrames');
      o(this, 'defaultTimestep');
      o(this, 'handleFrameLoop', (i) => {
        if (this.lastTimestamp) {
          const t = i - this.lastTimestamp;
          E(this.keepAliveFrames, (e) => e.call(this, { delta: t, timestamp: i }));
        }
        (this.lastTimestamp = i), this.keepAliveFrameId && cancelAnimationFrame(this.keepAliveFrameId), (this.keepAliveFrameId = requestAnimationFrame(this.handleFrameLoop));
      });
      o(this, 'handleFrame', (i) => {
        E(this.frames, (t) => t.call(this, { delta: this.defaultTimestep, timestamp: i }));
      });
      o(this, 'getFrames', () => this.frames);
      o(
        this,
        'add',
        (i, t = !1) => (
          this.cancelFrame(), this.frames.includes(i) || this.frames.push(i), t && !this.keepAliveFrames.includes(i) && this.keepAliveFrames.push(i), this.start(), this
        ),
      );
      o(this, 'start', () => {
        (this.frameId = requestAnimationFrame(this.handleFrame)), (this.keepAliveFrameId = requestAnimationFrame(this.handleFrameLoop));
      });
      o(this, 'cancelFrame', () => {
        this.frameId != null && (cancelAnimationFrame(this.frameId), (this.frameId = null)),
          this.keepAliveFrameId != null && (cancelAnimationFrame(this.keepAliveFrameId), (this.keepAliveFrameId = null));
      });
      o(this, 'stopFrame', (i, t) => {
        const e = i.indexOf(t);
        e !== -1 && i.splice(e, 1), i.length === 0 && (this.cancelFrame(), (this.lastTimestamp = null));
      });
      o(this, 'remove', (i) => (this.stopFrame(this.frames, i), this.stopFrame(this.keepAliveFrames, i), this));
      o(this, 'clear', () => ((this.frames = []), (this.keepAliveFrames = []), this.cancelFrame(), (this.lastTimestamp = null), this));
      (this.frameId = null), (this.keepAliveFrameId = null), (this.lastTimestamp = null), (this.frames = []), (this.keepAliveFrames = []), (this.defaultTimestep = (1 / 60) * 1e3);
    }
  }
  const G = new gr();
  function br(n) {
    return n.replace(/([_]\w)/g, (i) => i[1].toUpperCase());
  }
  function yr(n) {
    return n.replace(/(\-\w|\_\w)/g, (i) => i[1].toUpperCase()).replace(/^(\w)/, (i) => i[0].toUpperCase());
  }
  function wo(n) {
    return n.replace(/[A-Z]/g, (i) => `_${i.toLowerCase()}`);
  }
  function vr(n) {
    return n.replace(/^(\w)/, (i) => i[0].toUpperCase());
  }
  function Er(n) {
    return wo(n).replace(/^_/g, '');
  }
  function wr(n) {
    return n.replace(/^(\w)/, (i) => i[0].toLowerCase());
  }
  function Cr(n) {
    return n.replace(/([-]\w)/g, (i) => i[1].toUpperCase());
  }
  function Sr(n) {
    return n.replace(/([-]\w)/g, (i) => i[1].toUpperCase()).replace(/^(\w)/, (i) => i[0].toUpperCase());
  }
  function Co(n) {
    return n.replace(/[A-Z]/g, (i) => `-${i.toLowerCase()}`);
  }
  function kr(n) {
    return Co(n).replace(/^-/g, '');
  }
  const Yt = {
    snakeToCamel: br,
    snakeToPascal: yr,
    camelToSnake: wo,
    camelToPascal: vr,
    pascalToSnake: Er,
    pascalToCamel: wr,
    kebabToCamel: Cr,
    kebabToPascal: Sr,
    camelToKebab: Co,
    pascalToKebab: kr,
  };
  function at(n) {
    const i = n.trim();
    if (/^{|\[/g.test(i))
      try {
        const e = new Function(`return ${i}`)();
        return JSON.parse(JSON.stringify(e));
      } catch {
        return /^\[/g.test(i) ? [] : {};
      }
    else return {};
  }
  function Ar(n, i) {
    switch (i) {
      case 'string':
        return n;
      case 'number':
        return Number(n);
      case 'string | number': {
        const t = Number(n);
        return isNaN(t) ? n : t;
      }
      case 'boolean':
        return n === 'true' || n === '';
      case 'object':
        return at(n);
      case 'array':
        return at(n);
      default:
        return n;
    }
  }
  function $(n, { pick: i, types: t, camelCase: e = !0, propTransformer: s } = {}) {
    let r = {};
    if (n == null) return r;
    const a = Array.from(n.attributes);
    i == null && (i = nt(a, (l) => l.name));
    for (const l of a) {
      let h = e ? Yt.kebabToCamel(l.name) : l.name;
      const d = t == null ? void 0 : t[h];
      l.value != null &&
        (i == null ? void 0 : i.includes(h)) &&
        (typeof s == 'function' && (h = s(h)), !!t && d != null ? (r = { ...r, [h]: Ar(l.value, d) }) : (r = { ...r, [h]: l.value }));
    }
    return r;
  }
  function So(n, { width: i, height: t } = {}) {
    const e = n.replace(/(\?|&)width=\d*/g, ''),
      s = e.includes('?') ? '&' : '?',
      r = i ? `${s}width=${i}` : '',
      a = t ? `${s}height=${t}` : '';
    return `${e}${r}${a}`;
  }
  function D({ inputRange: n, outputRange: i, value: t, easing: e = (a) => a, reverseEasing: s = !1, extrapolate: r = 'extend' }) {
    const a = nt(n, (m, x) => ({ input: n[x], output: i[x] })).sort((m, x) => m.input - x.input),
      l = nt(a, ({ input: m }) => m),
      h = nt(a, ({ output: m }) => m);
    if (t <= l[0]) return h[0];
    if (t >= l[l.length - 1]) return h[h.length - 1];
    let d = 0;
    for (const m of l) m < t && d++;
    const u = d - 1;
    let p = (t - l[u]) / (l[d] - l[u]);
    return typeof e == 'function' && (s ? (p = 1 - e(1 - p)) : (p = e(p))), r === 'clamp' && (p = Math.max(Math.min(p, 1), 0)), h[u] * (1 - p) + h[d] * p;
  }
  const U = {
    android: !!navigator.userAgent.match(/Android/i),
    blackBerry: !!navigator.userAgent.match(/BlackBerry/i),
    ipad: !!navigator.userAgent.match(/iPad/i),
    iOS: !!navigator.userAgent.match(/iPhone|iPad|iPod/i),
    opera: !!navigator.userAgent.match(/Opera Mini/i),
    windows: !!navigator.userAgent.match(/Windows Phone/i),
    amazonePhone: !!navigator.userAgent.match(/(?:SD4930UR|\\bSilk(?:.+)Mobile\\b)/i),
    amazoneTablet: !!navigator.userAgent.match(/Silk/i),
    any: !!navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|Windows Phone|(?:SD4930UR|\bSilk(?:.+)Mobile\b)|Silk/i),
  };
  se(() => {
    const n = document.documentElement;
    U.any ? n.classList.add('is-mobile') : n.classList.add('is-desktop');
  });
  const ie = (n) => Object.values(n);
  function Pr(n) {
    return n.nodeType === 9 && n.defaultView;
  }
  function X(n) {
    const i = n == null ? void 0 : n.ownerDocument,
      t = i.documentElement,
      e = Pr(i);
    let s = { top: 0, left: 0 };
    return i
      ? (typeof n.getBoundingClientRect < 'u' && (s = n.getBoundingClientRect()), { top: s.top + e.scrollY - t.clientTop, left: s.left + e.scrollX - t.clientLeft })
      : { top: 0, left: 0 };
  }
  class Tr {
    constructor(i) {
      o(this, 'dx');
      o(this, 'dy');
      o(this, 'vx', 0);
      o(this, 'vy', 0);
      o(this, 'isStart', !1);
      o(this, 'startX', 0);
      o(this, 'startX2', 0);
      o(this, 'startY', 0);
      o(this, 'startY2', 0);
      o(this, 'options');
      o(this, 'handleMouseDown', (i) => {
        const { onStart: t } = this.options;
        if ((i.type === 'touchstart' && i.touches.length > 1) || (i.type === 'mousedown' && i.button !== 0)) return;
        const e = i.target;
        !U.any && (e.closest('a') || e.closest('img')) && i.preventDefault(),
          (this.isStart = !0),
          i.type === 'touchstart'
            ? ((this.startX = i.touches[0].clientX), (this.startY = i.touches[0].clientY), (this.startX2 = i.touches[0].clientX), (this.startY2 = i.touches[0].clientY))
            : ((this.startX = i.clientX), (this.startY = i.clientY), (this.startX2 = i.clientX), (this.startY2 = i.clientY)),
          t == null || t(i),
          document.addEventListener('mousemove', this.handleMouseMove),
          document.addEventListener('touchmove', this.handleMouseMove, { passive: !1 }),
          document.addEventListener('mouseup', this.handleMouseUp),
          document.addEventListener('touchend', this.handleMouseUp);
      });
      o(this, 'handleMouseMove', (i) => {
        const { onMove: t } = this.options;
        if ((i.type === 'touchmove' && i.touches.length > 1) || (i.type === 'mousemove' && i.button !== 0) || (U.any || i.preventDefault(), !this.isStart)) return;
        let e, s;
        i.type === 'touchmove' ? ((e = i.touches[0].clientX), (s = i.touches[0].clientY)) : ((e = i.clientX), (s = i.clientY));
        const r = e - this.startX,
          a = s - this.startY;
        (this.startX = e),
          (this.startY = s),
          (this.dx += r),
          (this.dy += a),
          (this.vx = r),
          (this.vy = a),
          t == null || t({ dx: this.dx, dy: this.dy, vx: this.vx, vy: this.vy, isHorizontalSwipe: Math.abs(e - this.startX2) > Math.abs(s - this.startY2) }, i);
      });
      o(this, 'handleEnd', (i, t) => {
        const { onEnd: e } = this.options;
        !this.isStart ||
          ((this.isStart = !1),
          t && ((this.dx = t.dx), (this.dy = t.dy), (this.vx = t.vx), (this.vy = t.vy)),
          e == null || e({ dx: this.dx, dy: this.dy, vx: this.vx, vy: this.vy }, i),
          document.removeEventListener('mousemove', this.handleMouseMove),
          document.removeEventListener('touchmove', this.handleMouseMove),
          document.removeEventListener('mouseup', this.handleMouseUp),
          document.removeEventListener('touchend', this.handleMouseUp));
      });
      o(this, 'handleMouseUp', (i) => {
        U.any || i.preventDefault(), this.handleEnd(i);
      });
      o(this, 'setValue', ({ dx: i, dy: t }) => {
        i != null && (this.dx = i), t != null && (this.dy = t);
      });
      o(this, 'destroy', () => {
        this.options.element.removeEventListener('mousedown', this.handleMouseDown),
          this.options.element.removeEventListener('touchstart', this.handleMouseDown),
          document.removeEventListener('mousemove', this.handleMouseMove),
          document.removeEventListener('touchmove', this.handleMouseMove),
          document.removeEventListener('mouseup', this.handleMouseUp),
          document.removeEventListener('touchend', this.handleMouseUp);
      });
      (this.options = i),
        (this.dx = i.dx || 0),
        (this.dy = i.dy || 0),
        i.element.addEventListener('mousedown', this.handleMouseDown),
        U.any && i.element.addEventListener('touchstart', this.handleMouseDown);
    }
  }
  function Gt(n) {
    return new Tr(n);
  }
  class $r {
    constructor(i, t) {
      o(this, 'target');
      o(this, 'options');
      o(this, 'top');
      o(this, 'left');
      o(this, 'handlePlacement', () => {
        const { element: i, placement: t, offset: e } = this.options,
          { offsetWidth: s, offsetHeight: r } = this.target,
          { top: a, left: l } = X(this.target),
          { offsetWidth: h, offsetHeight: d } = i;
        switch (t) {
          case 'top-left':
            (this.top = a - d - e), (this.left = l);
            break;
          case 'top-center':
            (this.top = a - d - e), (this.left = l + s / 2 - h / 2);
            break;
          case 'top-right':
            (this.top = a - d - e), (this.left = l + s - h);
            break;
          case 'bottom-left':
            (this.top = a + r + e), (this.left = l);
            break;
          case 'bottom-center':
            (this.top = a + r + e), (this.left = l + s / 2 - h / 2);
            break;
          case 'bottom-right':
            (this.top = a + r + e), (this.left = l + s - h);
            break;
          case 'left-top':
            (this.top = a), (this.left = l - h - e);
            break;
          case 'left-center':
            (this.top = a + r / 2 - d / 2), (this.left = l - h - e);
            break;
          case 'left-bottom':
            (this.top = a + r - d), (this.left = l - h - e);
            break;
          case 'right-top':
            (this.top = a), (this.left = l + s + e);
            break;
          case 'right-center':
            (this.top = a + r / 2 - d / 2), (this.left = l + s + e);
            break;
          case 'right-bottom':
            (this.top = a + r - d), (this.left = l + s + e);
            break;
        }
      });
      o(this, 'checkBoundary', () => {
        const { element: i } = this.options,
          { offsetWidth: t, offsetHeight: e } = i,
          { clientWidth: s, clientHeight: r } = document.documentElement;
        this.top < window.scrollY ? (this.top = window.scrollY) : this.top + e > r + window.scrollY && (this.top = r + window.scrollY - e),
          this.left < 0 ? (this.left = window.scrollX) : this.left + t > s + window.scrollX && (this.left = s + window.scrollX - t);
      });
      o(this, 'init', () => {
        const { element: i } = this.options,
          { width: t, height: e } = i.getBoundingClientRect();
        return this.handlePlacement(), this.checkBoundary(), { top: this.top, left: this.left, width: t, height: e };
      });
      (this.target = i), (this.options = t), (this.top = 0), (this.left = 0);
    }
  }
  function ko(n, { element: i, placement: t = 'bottom-center', offset: e = 0 }) {
    return new $r(n, { element: i, placement: t, offset: e }).init();
  }
  function Mr(n, i = !1) {
    const t = i ? {} : [],
      e = new URLSearchParams(n);
    for (const s of e.entries())
      if (i) {
        const [r, a] = s;
        t[r] = a;
      } else t.push([s[0], s[1]]);
    return t;
  }
  function Lr(n) {
    return new URLSearchParams(n)
      .toString()
      .replace(
        /&/g,
        `&
  `,
      )
      .replace(/\w.*=&?$/gm, '')
      .replace(/\n+/g, '')
      .replace(/&$/g, '');
  }
  const vt = { parse: Mr, stringify: Lr };
  function Ao(n, i, t = 0.55) {
    return (n * i * t) / (i + t * n);
  }
  function Po(n, i, t, e) {
    return t < n ? -Ao(n - t, i - n, e) + n : t > i ? Ao(t - i, i - n, e) + i : t;
  }
  function Ir() {
    let n = !1;
    const i = () => {
      if (!n) {
        n = !0;
        const s = '@xoLocalStorageCheck';
        try {
          return window.localStorage.setItem(s, s), window.localStorage.removeItem(s), !0;
        } catch {
          return !1;
        }
      }
      return !0;
    };
    return (() =>
      i()
        ? window.localStorage
        : {
            getItem() {
              return null;
            },
            setItem() {},
            removeItem() {},
            clear() {},
            key() {
              return null;
            },
            length: 0,
          })();
  }
  const oe = Ir();
  class Fe {
    constructor(i = {}) {
      o(this, '_store');
      o(this, '_prevStore');
      o(this, '_options');
      o(this, '_listeners');
      o(this, '_storageRegisters');
      o(this, '_useDeepEquals');
      o(this, '_handleListeners', (i) => {
        if (this._listeners[i]) {
          const t = this.get(i);
          for (let e = 0; e < this._listeners[i].length; e++) {
            const { equal: s, listener: r } = this._listeners[i][e];
            if (!s) r(t);
            else {
              const a = ue(this._prevStore[i]);
              s(a, t) || r(t);
            }
          }
        }
      });
      o(this, '_getState', (i, t) => {
        const e = oe.getItem(i);
        return e != null && e !== void 0 && this._storageRegisters[i] ? JSON.parse(e) : t;
      });
      o(this, '_setStorage', (i, t) => {
        if (!!i && t !== void 0 && this._storageRegisters[i]) {
          const e = JSON.stringify(t);
          oe.setItem(i, e);
        }
      });
      o(this, '_set', (i, t) => {
        const { logger: e, loggerCollapsed: s } = this._options;
        return (this._useDeepEquals[i] ? !Pt(this._store[i], t) : this._store[i] !== t) &&
          ((this._prevStore[i] = ue(this._store[i])), (this._store[i] = t), this._setStorage(i, t), this._handleListeners(i), e)
          ? (a) => {
              Fe.logger(a, t, i, s, this._prevStore, this._store);
            }
          : () => {};
      });
      o(this, 'create', (i, { initialState: t, useStorage: e, useDeepEqual: s }) => {
        const { logger: r, loggerCollapsed: a } = this._options;
        this._store[i] ||
          ((this._storageRegisters[i] = e),
          this._getState(i, t) || this._setStorage(i, t),
          (this._store[i] = this._getState(i, t)),
          e || oe.removeItem(i),
          this._handleListeners(i),
          r && Fe.logger('@store/initialState', t, i, a)),
          this._useDeepEquals[i] || (this._useDeepEquals[i] = !!s);
      });
      (this._store = {}),
        (this._prevStore = {}),
        (this._listeners = {}),
        (this._storageRegisters = {}),
        (this._options = { logger: i.logger || !1, loggerCollapsed: i.loggerCollapsed || !1 }),
        (this._useDeepEquals = {});
    }
    static logger(i, t, e, s = !1, r, a) {
      const h = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
        d = e,
        u =
          d.length < 9
            ? Array(9 - d.length)
                .fill(' ')
                .join('')
            : '';
      console[s ? 'groupCollapsed' : 'group'](`%c XOStore: ${i}`, 'color: #614eff', `@${h}`),
        r && console.log('%c Prev Store ', 'color: #999; font-weight: 600', r),
        console.log(`%c ${d}  ${u}`, 'color: #44b0e2; font-weight: 600', t),
        a && console.log('%c Next Store ', 'color: #7ac143; font-weight: 600', a),
        console.groupEnd();
    }
    get(i) {
      return i ? this._store[i] : this._store;
    }
    set(i, t) {
      if (typeof t == 'function') {
        const e = t,
          s = this._store[i];
        return this._set(i, e(s));
      }
      return this._set(i, t);
    }
    subscribe(i, t, e) {
      if (((this._listeners[i] = this._listeners[i] || []), this._listeners[i].push({ listener: t, equal: e }), Object.keys(this._store).includes(i))) {
        const s = this.get(i),
          r = ue(this._prevStore[i]);
        (e && e(r, s)) || t(s);
      }
      return () => {
        this._listeners[i] = It(this._listeners[i], ({ listener: s }) => s !== t);
      };
    }
  }
  let To = null;
  function $o() {
    if (!document.body || document.body.scrollHeight <= window.innerHeight) return 0;
    const n = document.createElement('div'),
      i = 100;
    return (
      (n.style.display = 'block'),
      (n.style.width = `${i}px`),
      (n.style.height = `${i}px`),
      (n.style.overflow = 'scroll'),
      (n.style.position = 'fixed'),
      (n.style.top = '-9999px'),
      document.body.appendChild(n),
      (To = i - n.clientWidth),
      document.body.removeChild(n),
      To
    );
  }
  function Dt(n) {
    if (n == null) return;
    const i = ft(n || {}),
      t = yt(
        i,
        (e, s, r) => {
          var h, d;
          const a = parseInt(s.toString()) || 0,
            l = parseInt(((d = (h = i[r - 1]) == null ? void 0 : h.toString) == null ? void 0 : d.call(h)) || '0');
          return window.innerWidth > l && window.innerWidth <= a ? { ...e, ...n[s] } : e;
        },
        {},
      );
    if (!!ft(t).length) return t;
  }
  function me(n, i) {
    let t = window.innerWidth,
      e = window.innerHeight;
    return function (...r) {
      var l;
      const a = this;
      (l = window.xbEditor) != null && l.designMode
        ? i.apply(a, r)
        : (n === 'x' ? t !== window.innerWidth && i.apply(a, r) : n === 'y' && e !== window.innerHeight && i.apply(a, r), (t = window.innerWidth), (e = window.innerHeight));
    };
  }
  const Dr = ({ file: n, content: i, insertPosition: t = 'beforeend', id: e, parentElement: s = document.head }) => {
      if (e) {
        const r = document.getElementById(e);
        r == null || r.remove();
      }
      if (n) {
        const r = document.createElement('link');
        return e && (r.id = e), (r.rel = 'stylesheet'), (r.href = n), s.insertAdjacentElement(t, r), r;
      }
      if (i) {
        const r = document.createElement('style');
        return e && (r.id = e), (r.textContent = i), s.insertAdjacentElement(t, r), r;
      }
    },
    ei = async ({ file: n, content: i, insertPosition: t = 'beforeend', id: e, parentElement: s = document.head, type: r }) => {
      if (e) {
        const l = document.getElementById(e);
        l == null || l.remove();
      }
      const a = document.createElement('script');
      return (
        e && (a.id = e),
        n && ((a.src = n), r && (a.type = r)),
        i && (a.textContent = i),
        !!n || !!i
          ? (s.insertAdjacentElement(t, a),
            new Promise((l) => {
              a.onload = () => {
                l(a);
              };
            }))
          : new Promise((l) => {
              l(a);
            })
      );
    };
  class si {
    static toArray(i) {
      const t = [],
        e = i.match(/[a-df-z][^a-df-z]*/gi);
      if (!e) return t;
      for (let s = 0; s < e.length; s++) {
        const r = e[s],
          a = r.charAt(0),
          l = r
            .substring(1)
            .split(/[\s,]+|(?=\s?[+\-])/)
            .map((h) => +h);
        t.push({ type: a, values: l });
      }
      return t;
    }
    static toString(i) {
      let t = '';
      for (let e = 0; e < i.length; e++) {
        const s = i[e],
          r = s.type,
          a = s.values;
        t += r;
        for (let l = 0; l < a.length; l++) {
          const h = a[l];
          t += h + (l < a.length - 1 ? ' ' : '');
        }
      }
      return t;
    }
  }
  function He(n, i, t) {
    let e = t - i + 1;
    return (((n - i) % e) + e) % e;
  }
  class Et extends HTMLElement {
    constructor() {
      super();
      o(this, '$attributeObserver$', null);
      o(this, 'props', {});
      o(this, 'state', {});
      o(this, '_setProps', () => {
        const t = this.__proto__.constructor.propTypes,
          e = this.__proto__.constructor.defaultProps,
          s = $(this, { pick: Object.keys(t), types: t });
        this.props = { ...e, ...s };
      });
      o(this, 'handlePropUpdate', () => {
        const t = this.__proto__.constructor.observedProps;
        !t ||
          !t.length ||
          ((this.$attributeObserver$ = new MutationObserver((e) => {
            e.forEach((s) => {
              const r = s.attributeName;
              if (r && s.type === 'attributes') {
                const a = Yt.kebabToCamel(r),
                  l = s.oldValue,
                  h = this.getAttribute(r);
                t.includes(a) && l !== h && (this._setProps(), this.propUpdate({ name: a, prevProp: l, nextProp: h }));
              }
            });
          })),
          this.$attributeObserver$.observe(this, { attributes: !0, attributeOldValue: !0, attributeFilter: t.map((e) => Yt.camelToKebab(e)) }));
      });
    }
    setState(t) {
      const e = this.state;
      typeof t == 'object' && !Array.isArray(t) && t !== null ? (this.state = { ...this.state, ...t }) : typeof t == 'function' && (this.state = { ...this.state, ...t(e) }),
        this.stateUpdate(e);
    }
    setProps(t) {
      const e = this.props;
      typeof t == 'object' && !Array.isArray(t) && t !== null ? (this.props = { ...this.props, ...t }) : typeof t == 'function' && (this.props = { ...this.props, ...t(e) }),
        Object.entries(this.props).forEach(([r, a]) => {
          const l = r.includes('-') ? r : Yt.camelToKebab(r);
          typeof a == 'boolean' ? f.set(this, l, a) : this.setAttribute(l, typeof a == 'string' ? a : JSON.stringify(a));
        });
    }
    connectedCallback() {
      this._setProps(), this.setProps({}), this.mount(), this.handlePropUpdate();
    }
    disconnectedCallback() {
      var t;
      (t = this.$attributeObserver$) == null || t.disconnect(), this.unmount();
    }
    emit(t, e) {
      const s = new CustomEvent(t, e);
      return this.dispatchEvent(s), s;
    }
    stateUpdate(t) {}
    propUpdate({ name: t, prevProp: e, nextProp: s }) {}
    mount() {}
    unmount() {}
  }
  o(Et, 'defaultProps', {}), o(Et, 'propTypes', {}), o(Et, 'observedProps', []);
  function Nt(n, i) {
    return (t) => {
      window.customElements.get(n) || window.customElements.define(n, t, i);
    };
  }
  function Mo(n) {
    return new Promise((i) => {
      n.length === 0 && i();
      let t = 0;
      n.forEach((e) => {
        const s = new Image(),
          r = () => {
            (t += 1), t === n.length && i();
          };
        (s.onload = r),
          (s.onerror = (a) => {
            console.error(a), r();
          }),
          (s.src = e);
      });
    });
  }
  function Nr(n, i) {
    var e;
    const t = n.closest('section[xo-preset]');
    if (t && ((e = window.xbEditor) == null ? void 0 : e.designMode)) {
      const s = new MutationObserver(() => {
        i();
      });
      return s.observe(t, { attributes: !0, attributeFilter: ['xo-preset'] }), s.disconnect;
    }
    return () => {};
  }
  function Re() {
    return typeof HTMLDialogElement == 'function';
  }
  function ii(n) {
    var i;
    !Re() || (n.hasAttribute('popover') && ((i = n == null ? void 0 : n.showPopover) == null || i.call(n)));
  }
  function qe(n) {
    var i;
    !Re() || (n.hasAttribute('popover') && ((i = n == null ? void 0 : n.hidePopover) == null || i.call(n)));
  }
  const Lo = 'width',
    Or = (Hn = window == null ? void 0 : window.xoImgDevicePixelRatio) != null ? Hn : 1.5,
    Fr = (Rn = window == null ? void 0 : window.xoImgDevicePixelRatio) != null ? Rn : 1.5,
    Hr = 2e3;
  function oi(n, i, t, e) {
    const s = n;
    if (!s) return '';
    if (s.includes('data:')) return s;
    const r = s.replace(/(\?|&)(w|width)=\d*/g, '').replace(new RegExp(`(\\?|&)${Lo}=\\d*`, 'g'), ''),
      a = Y(window.devicePixelRatio, Or, Fr),
      l = Y(Math.min(Math.round(i * a), Hr), t, e);
    if (l === 0) return s;
    const h = `${Lo}=${l}`;
    return r.includes('?') ? `${r}&${h}` : `${r}?${h}`;
  }
  function Rr(n) {
    const i = Number(n.getAttribute('xo-intrinsic-width')) || Number(n.getAttribute('data-intrinsic-width')) || 0,
      t = Number(n.getAttribute('xo-intrinsic-height')) || Number(n.getAttribute('data-intrinsic-height')) || 0;
    return { intrinsicWidth: i, intrinsicHeight: t };
  }
  function qr(n) {
    return Number(n.getAttribute('xo-fallback-width')) || Number(n.getAttribute('data-fallback-width')) || 400;
  }
  function Vr(n) {
    return n.hasAttribute('xo-width-range') || n.hasAttribute('data-width-range');
  }
  function Io(n) {
    return at(n.getAttribute('xo-width-range') || n.getAttribute('data-width-range') || '[200, 1920]');
  }
  function zr(n) {
    return n.intrinsicWidth > 0 && n.intrinsicHeight > 0;
  }
  function ni(n) {
    const i = Rr(n),
      t = qr(n),
      { width: e, height: s } = n.getBoundingClientRect(),
      r = n.parentElement,
      a = Vr(n) ? e : Math.max(e, t);
    if (!r) return a;
    if (zr(i)) {
      const { intrinsicWidth: l, intrinsicHeight: h } = i,
        d = l / h,
        u = a / s;
      return d > u ? Math.round(s * d) : Math.round(a);
    }
    return a;
  }
  const c = {
    CircleBar: 'xo-circle-bar',
    ScrollX: 'xo-scroll-x',
    ScrollXInner: 'xo-scroll-x-inner',
    ScrollXItem: 'xo-scroll-x-item',
    Toggle: 'xo-toggle',
    ToggleTrigger: 'xo-toggle-trigger',
    Modal: 'xo-modal',
    ModalTrigger: 'xo-modal-trigger',
    ModalInner: 'xo-modal-inner',
    ModalContent: 'xo-modal-content',
    ModalBackdrop: 'xo-modal-backdrop',
    ModalPan: 'xo-modal-pan',
    Toast: 'xo-toast',
    ToastPortal: 'xo-toast-portal',
    ToastContent: 'xo-toast-content',
    ToastPlaceholder: 'xo-toast-placeholder',
    ToastCloseButton: 'xo-toast-close-button',
    Popover: 'xo-popover',
    PopoverTrigger: 'xo-popover-trigger',
    BuilderPopover: 'xo-builder-popover',
    BuilderPopoverContent: 'xo-builder-popover-content',
    Tooltip: 'xo-tooltip',
    TooltipContent: 'xo-tooltip-content',
    TooltipTrigger: 'xo-tooltip-trigger',
    Sticky: 'xo-sticky',
    StickyInner: 'xo-sticky-inner',
    StickyContent: 'xo-sticky-content',
    StickySpace: 'xo-sticky-space',
    Collapse: 'xo-collapse',
    CollapseTrigger: 'xo-collapse-trigger',
    CollapseProvider: 'xo-collapse-provider',
    List: 'xo-list',
    ListTrigger: 'xo-list-trigger',
    ListPortal: 'xo-list-portal',
    ListItem: 'xo-list-item',
    Tabs: 'xo-tabs',
    TabsPane: 'xo-tabs-pane',
    TabsTrigger: 'xo-tabs-trigger',
    TabsActive: 'xo-tabs-active',
    Parallax: 'xo-parallax',
    ParallaxScroll: 'xo-parallax-scroll',
    ParallaxHover: 'xo-parallax-hover',
    ParallaxHoverInner: 'xo-parallax-hover-inner',
    Carousel: 'xo-carousel',
    CarouselThumbnail: 'xo-carousel-thumbnail',
    CarouselList: 'xo-carousel-list',
    CarouselInner: 'xo-carousel-inner',
    CarouselSlide: 'xo-carousel-slide',
    CarouselNext: 'xo-carousel-next',
    CarouselPrev: 'xo-carousel-prev',
    CarouselPagination: 'xo-carousel-pagination',
    CarouselBullet: 'xo-carousel-bullet',
    CarouselSize: 'xo-carousel-size',
    CarouselPage: 'xo-carousel-page',
    ScrollCarousel: 'xo-scroll-carousel',
    ScrollCarouselNext: 'xo-scroll-carousel-next',
    ScrollCarouselPrev: 'xo-scroll-carousel-prev',
    Range: 'xo-range',
    RangePrice: 'xo-range-price',
    RangeTrack: 'xo-range-track',
    RangeThumb: 'xo-range-thumb',
    RangeProgress: 'xo-range-progress',
    Filters: 'xo-filters',
    FiltersMobile: 'xo-filters-mobile',
    FiltersField: 'xo-filters-field',
    FiltersContent: 'xo-filters-content',
    FiltersRefine: 'xo-filters-refine',
    FiltersClear: 'xo-filters-clear',
    FiltersFallback: 'xo-filters-fallback',
    FiltersCount: 'xo-filters-count',
    FiltersActiveSize: 'xo-filters-active-size',
    FiltersPaginate: 'xo-filters-paginate',
    FiltersTop: 'xo-filters-top',
    FiltersSortBySelected: 'xo-filters-sort-by-selected',
    FiltersRefineClearIcon: 'xo-filters-refine-clear-icon',
    Gallery: 'xo-gallery',
    GalleryItem: 'xo-gallery-item',
    GalleryPortal: 'xo-gallery-portal',
    GalleryNext: 'xo-gallery-next',
    GalleryPrev: 'xo-gallery-prev',
    GalleryCounter: 'xo-gallery-counter',
    Cart: 'xo-cart',
    CartMini: 'xo-cart-mini',
    CartSize: 'xo-cart-size',
    CartAdd: 'xo-cart-add',
    CartFly: 'xo-cart-fly',
    CartRemove: 'xo-cart-remove',
    CartChangeFallback: 'xo-cart-change-fallback',
    CartQuantity: 'xo-cart-quantity',
    CartQuantityMinus: 'xo-cart-quantity-minus',
    CartQuantityPlus: 'xo-cart-quantity-plus',
    CartNote: 'xo-cart-note',
    CartNoteSubmit: 'xo-cart-note-submit',
    CartShippingRates: 'xo-cart-shipping-rates',
    CartShippingRatesField: 'xo-cart-shipping-rates-field',
    CartShippingRatesSubmit: 'xo-cart-shipping-rates-submit',
    CartShippingRatesError: 'xo-cart-shipping-rates-error',
    CartDiscount: 'xo-cart-discount',
    CartDiscountSubmit: 'xo-cart-discount-submit',
    CartScroll: 'xo-cart-scroll',
    CartAddError: 'xo-cart-add-error',
    CartAddErrorMessage: 'xo-cart-add-error-message',
    CartWillChange: 'xo-cart-will-change',
    Product: 'xo-product',
    ProductWillChange: 'xo-product-will-change',
    ProductVariant: 'xo-product-variant',
    ProductVariantActive: 'xo-product-variant-active',
    ProductData: 'xo-product-data',
    ProductPickupAvailability: 'xo-product-pickup-availability',
    ProductPickupAvailabilityList: 'xo-product-pickup-availability-list',
    ProductQuickView: 'xo-product-quick-view',
    ProductQuickViewTrigger: 'xo-product-quick-view-trigger',
    ProductQuickViewVariant: 'xo-product-quick-view-variant',
    ProductLiquidStatic: 'xo-product-liquid-static',
    ProductVariantSelected: 'xo-product-variant-selected',
    ProductRecipientForm: 'xo-product-recipient-form',
    ProductRecipientFormError: 'xo-product-recipient-form-error',
    ProductRecommendations: 'xo-product-recommendations',
    MarqueeScrollTransform: 'xo-marquee-scroll-transform',
    Marquee: 'xo-marquee',
    MarqueeItem: 'xo-marquee-item',
    Group: 'xo-group',
    GroupButton: 'xo-group-button',
    Animate: 'xo-animate',
    ImageZoom: 'xo-image-zoom',
    ImageZoomInner: 'xo-image-zoom-inner',
    ImageZoomItem: 'xo-image-zoom-item',
    ImageZoomThumb: 'xo-image-zoom-thumb',
    ImageZoomManual: 'xo-image-zoom-manual',
    Countdown: 'xo-countdown',
    CountdownDay: 'xo-countdown-day',
    CountdownHour: 'xo-countdown-hour',
    CountdownMinute: 'xo-countdown-minute',
    CountdownSecond: 'xo-countdown-second',
    Countto: 'xo-countto',
    CounttoNumber: 'xo-countto-number',
    VideoCover: 'xo-video-cover',
    VideoCoverButton: 'xo-video-cover-button',
    VideoCoverItem: 'xo-video-cover-item',
    Ripple: 'xo-ripple',
    RippleItem: 'xo-ripple-item',
    Typing: 'xo-typing',
    TypingInner: 'xo-typing-inner',
    TypingContent: 'xo-typing-content',
    ImageComparison: 'xo-image-comparison',
    Instagram: 'xo-instagram',
    InstagramTemplate: 'xo-instagram-template',
    InstagramItem: 'xo-instagram-item',
    InstagramNext: 'xo-instagram-next',
    InstagramPrev: 'xo-instagram-prev',
    DarkMode: 'xo-dark-mode',
    MegaMenu: 'xo-mega-menu',
    Masonry: 'xo-masonry',
    MasonryItem: 'xo-masonry-item',
    Lazyload: 'xo-lazyload',
    Cursor: 'xo-cursor',
    CursorItem: 'xo-cursor-item',
    VirtualScroll: 'xo-virtual-scroll',
    Drr: 'xo-drr',
    Drr2: 'xo-drr-2',
    DrrAction: 'xo-drr-action',
    Xo360Viewer: 'xo-360-viewer',
    Xo360ViewerContent: 'xo-360-viewer-content',
    Xo360ViewerNext: 'xo-360-viewer-next',
    Xo360ViewerPrev: 'xo-360-viewer-prev',
    Xo360ViewerPlay: 'xo-360-viewer-play',
    Xo360ViewerPause: 'xo-360-viewer-pause',
    Magnetic: 'xo-magnetic',
    MagneticContent: 'xo-magnetic-content',
    LineChart: 'xo-line-chart',
    ScrollScene: 'xo-scroll-scene',
    ScrollSceneInner: 'xo-scroll-scene-inner',
    ScrollSceneItem: 'xo-scroll-scene-item',
  };
  class Br extends HTMLImageElement {
    constructor() {
      super(...arguments);
      o(this, 'removeOverlay', async () => {
        var e;
        window.XO_DEV && (await P(1e3));
        const t = (e = this.parentElement) == null ? void 0 : e.querySelector('.xo-lazyload-overlay');
        t == null || t.remove();
      });
      o(this, 'handleLoad', () => {
        this.removeEventListener('load', this.handleLoad), this.removeOverlay();
      });
      o(this, 'init', async () => {
        const t = this.getAttribute('xo-src') || this.getAttribute('data-src') || this.src,
          [e, s] = Io(this);
        if ((this.loading !== 'lazy' && (this.loading = 'lazy'), this.closest(c.CarouselSlide))) {
          await P(50);
          const a = ni(this),
            l = oi(t, a, e, s);
          t && (this.src = l), this.srcset && (this.srcset = `${l} ${a}w`), this.complete && this.removeOverlay(), this.addEventListener('load', this.handleLoad);
        } else {
          const a = ni(this),
            l = oi(t, a, e, s);
          t && (this.src = l), this.srcset && (this.srcset = `${l} ${a}w`), this.complete && this.removeOverlay(), this.addEventListener('load', this.handleLoad);
        }
      });
      o(
        this,
        'handleResize',
        st(() => this.init(), 500),
      );
    }
    static get observedAttributes() {
      return ['xo-src', 'data-src'];
    }
    connectedCallback() {
      this.init(), window.addEventListener('resize', this.handleResize, !1);
    }
    disconnectedCallback() {
      this.removeEventListener('load', this.handleLoad), window.removeEventListener('resize', this.handleResize, !1);
    }
    attributeChangedCallback(t, e, s) {
      e !== s && this.init();
    }
  }
  function _r(n) {
    const i = n.replace(/url\(["']|["']\)/g, '');
    return i === window.location.href.replace(/\?.*/g, '') || i === 'none' ? '' : i;
  }
  let St = null;
  function Wr(n) {
    function i(t) {
      const e = _r(window.getComputedStyle(t).backgroundImage) || t.getAttribute('xo-src') || t.getAttribute('data-src') || '';
      if (e) {
        const [s, r] = Io(t),
          a = oi(e, ni(t), s, r);
        t.style.backgroundImage = `url('${a}')`;
        const l = t.querySelector('.xo-lazyload-overlay');
        l == null || l.remove();
      }
    }
    'IntersectionObserver' in window
      ? (St == null || St.disconnect(),
        (St = new IntersectionObserver((t) => {
          t.forEach(async (e) => {
            if ((await P(window.XO_DEV ? 1e3 : 50), e.isIntersecting)) {
              const s = e.target;
              i(s), St == null || St.unobserve(s);
            }
          });
        })),
        n.forEach((t) => {
          St == null || St.observe(t);
        }))
      : n.forEach(i);
  }
  function Ve(n = document) {
    const i = Array.from(n.querySelectorAll('.xo-background-lazyload'));
    Wr(i);
  }
  se(Ve),
    document.addEventListener('shopify:section:load', (n) => Ve(n.target)),
    document.addEventListener('shopify:section:reorder', (n) => Ve(n.target)),
    window.addEventListener(
      'resize',
      st(() => Ve(), 500),
    );
  const Uh = '';
  customElements.get(c.Lazyload) || customElements.define(c.Lazyload, Br, { extends: 'img' });
  const Xh = '',
    Yh = '';
  function Ur() {
    var n;
    ((n = window.xbEditor) != null && n.designMode) ||
      window.addEventListener('click', (i) => {
        const e = i.target.closest('[xb-href]'),
          s = e == null ? void 0 : e.getAttribute('xb-href');
        s && (i.preventDefault(), e.getAttribute('xb-target') === '_blank' || i.ctrlKey || i.metaKey ? window.open(s, '_blank') : (window.location.href = s));
      });
  }
  Ur();
  const jt = (n, i, t) => n + (i - n) * t,
    Q = '===empty===',
    Xr = 1e3 / 60,
    Do = 0,
    No = 100,
    ri = /(px|%|vh|vw|em|rem|pt|cm|mm|in|pc|ex|ch|vmin|vmax|lh|rlh|vb|vi|svw|svh|lvw|lvh|dvw|dvh|deg)/g;
  class Yr {
    constructor(i, t, e) {
      o(this, 'el');
      o(this, 'cloneEl');
      o(this, 'options');
      o(this, 'contextOptions');
      o(this, 'currentValue');
      o(this, 'targetValue');
      o(this, 'handleFrameSyncUpdate', ({ delta: i }) => {
        const { lerpEase: t } = this.contextOptions;
        if (Math.abs(this.targetValue - this.currentValue) < 0.001) return;
        let s = i / Xr;
        const r = Math.round(s);
        r >= 1 && (s = r);
        const a = jt(this.currentValue, this.targetValue, t * s);
        this.setStyles(this.el, a), (this.currentValue = a);
      });
      o(this, 'destroy', () => {
        if (this.el) {
          const { style: i } = this.cloneEl;
          this.el.removeAttribute('style'),
            E(Array.from(i), (t) => {
              const e = i[t];
              this.el.style[t] = e;
            }),
            G.remove(this.handleFrameSyncUpdate);
        }
      });
      o(this, 'getElement', () => this.el);
      (this.el = i),
        (this.cloneEl = this.el.cloneNode()),
        (this.options = t),
        (this.contextOptions = e),
        (this.currentValue = 0),
        (this.targetValue = 0),
        G.add(this.handleFrameSyncUpdate, !0);
    }
    getInputRange() {
      const { keyframes: i } = this.options;
      return yt(
        ft(i),
        (t, e) => {
          const s = Number(e.replace('%', ''));
          return isNaN(s) ? t : [...t, s];
        },
        [],
      ).sort((t, e) => t - e);
    }
    getKeyframesByProp(i) {
      const { keyframes: t } = this.options,
        e = this.getInputRange();
      Math.max(...e) > 100 && bt('Max value of input range must be less than 100%');
      let s = null;
      return yt(
        e,
        (r, a) => {
          const l = `${a}%`,
            h = t[l][i];
          return h != null && r.push(String(h)), (s = r[r.length - 1]), h == null && s != null && r.push(s), r;
        },
        [],
      );
    }
    getDefaultUnit(i) {
      switch (i) {
        case 'x':
        case 'y':
        case 'width':
        case 'height':
        case 'backgroundPositionY':
        case 'blur':
        case 'borderRadius':
          return 'px';
        case 'rotate':
        case 'rotateX':
        case 'rotateY':
        case 'skew':
        case 'skewX':
        case 'skewY':
        case 'hueRotate':
          return 'deg';
        case 'backgroundSizeX':
        case 'backgroundSizeY':
        case 'grayscale':
          return '%';
        case 'scale':
        case 'scaleX':
        case 'scaleY':
        case 'opacity':
        case 'videoTime':
        case 'brightness':
        case 'contrast':
        default:
          return '';
      }
    }
    interpolate(i, t) {
      const e = this.getKeyframesByProp(t),
        s = String(e[0]).replace(/[0-9.,-]/g, ''),
        r = e.map((l) => Number(String(l).replace(ri, '')));
      return e.length === 0 ? Q : `${D({ value: i, inputRange: this.getInputRange(), outputRange: r })}${s || this.getDefaultUnit(t)}`;
    }
    setStyles(i, t) {
      const { setStyles: e } = this.contextOptions,
        s = this.interpolate(t, 'x'),
        r = this.interpolate(t, 'y'),
        a = this.interpolate(t, 'rotate'),
        l = this.interpolate(t, 'rotateX'),
        h = this.interpolate(t, 'rotateY'),
        d = this.interpolate(t, 'scale'),
        u = this.interpolate(t, 'scaleX'),
        p = this.interpolate(t, 'scaleY'),
        m = this.interpolate(t, 'skew'),
        x = this.interpolate(t, 'skewX'),
        y = this.interpolate(t, 'skewY'),
        b = this.interpolate(t, 'opacity'),
        v = this.interpolate(t, 'borderRadius'),
        k = this.interpolate(t, 'width'),
        A = this.interpolate(t, 'height'),
        T = this.interpolate(t, 'brightness'),
        M = this.interpolate(t, 'contrast'),
        L = this.interpolate(t, 'hueRotate'),
        V = this.interpolate(t, 'blur'),
        ot = this.interpolate(t, 'grayscale'),
        ut = this.interpolate(t, 'backgroundPositionY'),
        pt = this.interpolate(t, 'backgroundSizeX'),
        gt = this.interpolate(t, 'backgroundSizeY'),
        _t = this.interpolate(t, 'videoTime'),
        Le = this.interpolate(t, 'groupImg'),
        kt = [];
      if (
        ((i.style.transform = It(
          [
            `translateX(${s})`,
            `translateY(${r})`,
            `rotate(${a})`,
            `rotateX(${l})`,
            `rotateY(${h})`,
            `scale(${d})`,
            `scaleX(${u})`,
            `scaleY(${p})`,
            `skew(${m})`,
            `skewX(${x})`,
            `skewY(${y})`,
          ],
          (ct) => !!ct && !ct.includes(Q),
        ).join(' ')),
        k !== Q && (i.style.width = `${k}`),
        A !== Q && (i.style.height = `${A}`),
        b !== Q && (i.style.opacity = `${b}`),
        v !== Q && (i.style.borderRadius = `${v}`),
        T !== Q && kt.push(`brightness(${T})`),
        M !== Q && kt.push(`contrast(${M})`),
        L !== Q && kt.push(`hue-rotate(${L})`),
        V !== Q && kt.push(`blur(${V})`),
        ot !== Q && kt.push(`grayscale(${ot})`),
        kt.length > 0 && (i.style.filter = kt.join(' ')),
        ut !== Q &&
          ((i.style.backgroundSize = 'cover'),
          (i.style.backgroundPosition = 'center'),
          U.iOS ? (i.style.backgroundPosition = `50% calc(${ut} * -1)`) : ((i.style.backgroundAttachment = 'fixed'), (i.style.backgroundPosition = `50% ${ut}`))),
        pt !== Q && gt === Q && (i.style.backgroundSize = `${pt} 100%`),
        pt === Q && gt !== Q && (i.style.backgroundSize = `100% ${gt}`),
        pt !== Q && gt !== Q && (i.style.backgroundSize = `${pt} ${gt}`),
        _t !== Q)
      ) {
        const ct = i.querySelector('video');
        if (ct && ct.duration) {
          const Wt = D({ value: Number(_t.replace(ri, '')), inputRange: [0, 100], outputRange: [0, ct.duration] });
          ct.currentTime = Wt;
        }
      }
      if (Le !== Q) {
        window.getComputedStyle(i).position === 'static' && (i.style.position = 'relative');
        const ct = Array.from(i.querySelectorAll('img')),
          Wt = Math.floor(D({ value: Number(Le.replace(ri, '')), inputRange: [0, 100], outputRange: [0, ct.length - 1] }));
        E(ct, (co, ho) => {
          co.style.visibility = ho === Wt ? 'visible' : 'hidden';
        });
      }
      e && e({ element: i, createValue: (ct) => this.interpolate(t, ct), EMPTY: Q });
    }
    handleParallax() {
      const i = window.scrollY - this.getFrom(),
        t = this.getTo() - this.getFrom(),
        e = Y((i / t) * 100, Do, No);
      e >= Do && e <= No && (this.targetValue = e);
    }
    getFrom() {
      const { from: i } = this.options;
      return typeof i == 'function' ? i() : i;
    }
    getTo() {
      const { to: i } = this.options;
      return typeof i == 'function' ? i() : i;
    }
    init() {
      this.handleParallax();
    }
  }
  const Ni = class {
    constructor(i) {
      o(this, 'options');
      o(this, 'items');
      o(this, 'handlerScroll', () => {
        for (const i of this.items) i.init();
      });
      o(this, 'add', (i, t) => (this.items.push(new Yr(i, t, this.options)), this));
      o(this, 'remove', (i) => {
        const t = this.items.find((e) => e.getElement() === i);
        (this.items = this.items.filter((e) => e.getElement() !== i)), t && t.destroy();
      });
      o(this, 'run', () => {
        const { targetElement: i } = this.options;
        this.handlerScroll(), i.removeEventListener('scroll', this.handlerScroll, !1), i.addEventListener('scroll', this.handlerScroll, !1);
      });
      o(this, 'destroy', () => {
        const { targetElement: i } = this.options;
        i.removeEventListener('scroll', this.handlerScroll, !1);
        for (const t of this.items) t.destroy();
      });
      (this.options = { ...Ni.defaultOptions, ...i }), (this.items = []);
    }
  };
  let ze = Ni;
  o(ze, 'defaultOptions', { targetElement: window, setStyles: void 0, lerpEase: 0.08 });
  const jh = '';
  function Be(n = {}) {
    return new ze(n);
  }
  window.xoParallaxScroll = Be;
  const Qh = '',
    Zh = '',
    Gr = 14,
    Oi = class extends HTMLElement {
      constructor() {
        super(...arguments);
        o(this, 'index', 0);
        o(this, 'frameId', 0);
        o(this, 'cancelDelay', () => {});
        o(this, '_options');
        o(this, 'imageLoaded', !1);
        o(this, 'parallax', null);
        o(this, 'disconnect', () => {});
        o(this, 'setOptions', () => {
          this.options = $(this, {
            pick: ['xoSpeed', 'xoRtl', 'xoPauseOnHover', 'xoScrollEnabled', 'xoScrollSpeed', 'xoAutoRun'],
            types: { xoSpeed: 'number', xoRtl: 'boolean', xoPauseOnHover: 'boolean', xoScrollEnabled: 'boolean', xoAutoRun: 'boolean', xoScrollSpeed: 'number' },
          });
        });
        o(this, 'getChildWidth', () => {
          const t = Array.from(this.children);
          return yt(t, (s, r, a) => (a < t.length ? s + r.clientWidth : s), 0);
        });
        o(this, 'setDuration', async () => {
          const e = Array.from(this.querySelectorAll('img')).map((l) => l.src);
          await Mo(e);
          const { xoSpeed: s, xoRtl: r, xoAutoRun: a } = this.options;
          if (a) {
            const l = this.children[0],
              h = Y(l.offsetWidth * Gr - (s - 1) * l.offsetWidth, l.offsetWidth, 1 / 0);
            this.style.setProperty('--xo-marquee-from', '0'),
              this.style.setProperty('--xo-marquee-to', r ? '100%' : '-100%'),
              this.style.setProperty('--xo-marquee-duration', `${h}ms`);
          }
        });
        o(this, 'handleClone', () => {
          const { xoScrollEnabled: t, xoScrollSpeed: e } = this.options;
          this.frameId = requestAnimationFrame(() => {
            const s = Array.from(this.children);
            if (this.getChildWidth() === 0) {
              const r = this.appendChild(s[this.index].cloneNode(!0));
              f.set(r, 'xo-cloned', !0), this.setDuration(), cancelAnimationFrame(this.frameId);
            } else if (this.getChildWidth() <= this.offsetWidth * (t ? 2 * Math.min(e, 3) : 1)) {
              const r = this.appendChild(s[this.index].cloneNode(!0));
              f.set(r, 'xo-cloned', !0), this.handleClone(), this.index === s.length - 1 ? (this.index = 0) : this.index++, s.length >= 200 && this.update();
            } else {
              const r = this.appendChild(s[this.index].cloneNode(!0));
              f.set(r, 'xo-cloned', !0), this.setDuration(), cancelAnimationFrame(this.frameId);
            }
          });
        });
        o(this, 'removeCloned', () => {
          const t = Array.from(this.querySelectorAll(`${c.MarqueeItem}[xo-cloned]`));
          E(t, (s) => {
            s.remove();
          });
          const e = this.querySelector(c.MarqueeItem);
          if (e) {
            const s = Array.from(e.children);
            E(s, (r) => {
              this.appendChild(r);
            }),
              e.remove();
          }
        });
        o(this, 'handler', async () => {
          const { xoRtl: t } = this.options,
            e = Array.from(this.children);
          if ((f.set(this, 'xo-rtl', t), !this.imageLoaded)) {
            await P(500);
            const r = Array.from(this.querySelectorAll('img')).map((a) => a.src);
            await Mo(r), (this.imageLoaded = !0);
          }
          if (e[0].tagName.toLowerCase() !== c.MarqueeItem) {
            const s = document.createElement(c.MarqueeItem);
            E(e, (r) => {
              s.appendChild(r);
            }),
              this.appendChild(s);
          }
          this.handleClone(),
            requestAnimationFrame(() => {
              f.set(this, 'xo-ready', !0);
            });
        });
        o(this, 'handleParallax', () => {
          var h;
          const { xoScrollEnabled: t, xoScrollSpeed: e, xoRtl: s } = this.options;
          if (!t) return;
          (h = this.parallax) == null || h.destroy(),
            (this.parallax = Be({
              lerpEase: 1,
              setStyles: ({ element: d, createValue: u, EMPTY: p }) => {
                const m = u('marqueeScroll');
                m !== p && d.style.setProperty('--xo-marquee-scroll', `${Number(m) * e}px`);
              },
            }));
          const r = this.closest(c.MarqueeScrollTransform),
            a = () => (r ? X(r).top - window.innerHeight : X(this).top - window.innerHeight),
            l = () => (r ? X(r).top + this.getBoundingClientRect().height : X(this).top + this.getBoundingClientRect().height);
          this.parallax.add(this, { from: a, to: l, keyframes: { '0%': { marqueeScroll: 0 }, '100%': { marqueeScroll: window.innerHeight * (s ? 1 : -1) } } }).run();
        });
        o(this, 'destroy', () => {
          var t;
          (t = this.parallax) == null || t.destroy(), this.cancelDelay(), cancelAnimationFrame(this.frameId), (this.index = 0);
        });
        o(this, 'update', async () => {
          this.destroy(), this.setOptions(), this.removeCloned(), await this.handler(), this.handleParallax();
        });
        o(this, 'sectionListenerForBuilder', () => {
          this.disconnect = Nr(this, () => {
            this.update();
          });
        });
      }
      get options() {
        return { ...Oi.defaultOptions, ...this._options };
      }
      set options(t) {
        this._options = t;
      }
      static get observedAttributes() {
        return ['xo-observed'];
      }
      async connectedCallback() {
        var t;
        (t = window.xbEditor) != null && t.designMode && (await P(100)),
          this.setOptions(),
          this.removeCloned(),
          await this.handler(),
          this.handleParallax(),
          this.sectionListenerForBuilder();
      }
      async attributeChangedCallback(t, e, s) {
        t === 'xo-observed' && e != null && e !== s && this.imageLoaded && (this.cancelDelay(), (this.cancelDelay = await P(200)), this.update());
      }
      disconnectedCallback() {
        this.destroy(), this.disconnect();
      }
    };
  let _e = Oi;
  o(_e, 'defaultOptions', { xoSpeed: 6, xoRtl: document.documentElement.dir === 'rtl', xoPauseOnHover: !1, xoAutoRun: !0, xoScrollEnabled: !1, xoScrollSpeed: 1 }),
    B({ [c.Marquee]: _e });
  const g = new Fe({ logger: !1, loggerCollapsed: !0 });
  window.xoStore = g;
  class Tt {
    constructor(i) {
      o(this, 'stateName');
      o(this, 'getTriggerElement', (i, t) => (t != null ? t : document.querySelector(`${c.PopoverTrigger}[xo-name="${i}"]`)));
      o(this, 'toggle', (i, t) => {
        const e = this.getTriggerElement(i, t);
        g.set(this.stateName, (s) => {
          var r;
          return {
            ...s,
            trigger: { ...s.trigger, [this.stateName]: i },
            data: { ...s.data, [i]: { ...s.data[i], isOpen: !((r = s.data[i]) != null && r.isOpen), ...(e != null ? { triggerElement: e } : {}) } },
          };
        })(`${this.stateName}/toggle`);
      });
      o(this, 'open', (i, t) => {
        const e = this.getTriggerElement(i, t);
        g.set(this.stateName, (s) => ({
          ...s,
          trigger: { ...s.trigger, [this.stateName]: i },
          data: { ...s.data, [i]: { ...s.data[i], isOpen: !0, ...(e != null ? { triggerElement: e } : {}) } },
        }))(`${this.stateName}/open`);
      });
      o(this, 'close', (i, t) => {
        const e = t === 'empty' ? t : this.getTriggerElement(i, t);
        g.set(this.stateName, (s) => ({
          ...s,
          trigger: { ...s.trigger, [this.stateName]: i },
          data: { ...s.data, [i]: { ...s.data[i], isOpen: !1, ...(e != null ? { triggerElement: e === 'empty' ? null : e } : {}) } },
        }))(`${this.stateName}/close`);
      });
      o(this, 'on', (i, t, e) =>
        g.subscribe(this.stateName, ({ data: s }) => {
          s[t] != null && ((i === 'open' && s[t].isOpen) || (i === 'close' && !s[t].isOpen)) && e();
        }),
      );
      this.stateName = i;
    }
  }
  const ai = 'button, a, input, select, textarea, summary, details, label, [tabindex], [contenteditable], [role], [aria-label], [aria-labelledby], [aria-describedby]',
    jr = Oe();
  class li extends HTMLElement {
    constructor() {
      super();
      o(this, 'unsubscribe', null);
      o(this, 'sectionEl', null);
      o(this, 'initialized', !1);
      o(this, 'prevIsOpen', !1);
      o(this, 'allA11yEls', []);
      o(this, 'a11yEls', []);
      o(this, 'firstA11yEl', null);
      o(this, 'lastA11yEl', null);
      o(this, 'firstA11yIndex', null);
      o(this, 'lastA11yIndex', null);
      o(this, 'focusIndex', null);
      o(this, 'toggleIndex', null);
      o(this, 'listener', () => {
        var e;
        const { isOpen: t } = this.state;
        this.initialized &&
          t !== this.prevIsOpen &&
          (t
            ? (f.set(this, 'xo-active', !0),
              this.componentOpen(),
              this.handleAutoFocus(),
              document.addEventListener('keydown', this.handleA11y),
              (this.toggleIndex = this.focusIndex))
            : (f.set(this, 'xo-active', !1),
              this.toggleIndex != null && ((e = this.allA11yEls[this.toggleIndex]) == null || e.focus(), (this.toggleIndex = null)),
              this.componentClose(),
              document.removeEventListener('keydown', this.handleA11y)),
          (this.prevIsOpen = t)),
          this.initialized && this.subscribe();
      });
      o(this, 'setState', (t) =>
        g.set(this.stateName, (e) => {
          const s = e;
          return { ...e, data: { ...s.data, ...(typeof t == 'function' ? t(s.data) : t) } };
        }),
      );
      o(this, 'setCssVariables', (t, e) => {
        const { xoName: s } = this.options;
        W(this.componentName, 'xo-name', s);
        let r = '';
        const a = e || this.options;
        for (const h in a) {
          const d = a[h];
          if (d != null && typeof d != 'object') {
            let u = Yt.camelToKebab(h);
            u = u.includes('xo-') ? u : `xo-${u}`;
            const p = t != null ? ' !important' : '';
            r += `--${u}: ${d}${p};`;
          }
        }
        const { cssText: l } = jr`
        ${this.componentName}[xo-name="${s}"] {
          ${r}
        }
      `;
        t == null ? Eo(l, document.head) : Eo(`@media (max-width: ${t}px) { ${l} }`, document.head);
      });
      o(this, 'handleA11y', (t) => {
        const { isOpen: e } = this.state;
        (this.allA11yEls = Array.from(document.querySelectorAll(ai))), (this.a11yEls = Array.from(this.querySelectorAll(ai)));
        const s = t.shiftKey,
          r = t.key === 'Tab';
        if (t.key === 'Escape' && e) {
          const { xoName: l } = this.options;
          W(this.componentName, 'xo-name', l), new Tt(this.stateName).close(l);
        }
        if (!this.a11yEls.length) {
          const { isOpen: l } = this.state;
          l && t.preventDefault();
          return;
        }
        if (
          ((this.firstA11yEl = this.a11yEls[0]),
          (this.lastA11yEl = this.a11yEls[this.a11yEls.length - 1]),
          (this.firstA11yIndex = this.allA11yEls.indexOf(this.firstA11yEl)),
          (this.lastA11yIndex = this.allA11yEls.indexOf(this.lastA11yEl)),
          r)
        ) {
          const l = t.target,
            h = l.shadowRoot && typeof t.composedPath == 'function' ? t.composedPath()[0] : l;
          let d = this.allA11yEls.indexOf(h);
          s ? d === this.firstA11yIndex && (d = this.lastA11yIndex + 1) : d === this.lastA11yIndex && (d = this.firstA11yIndex - 1),
            E(this.allA11yEls, (u, p) => {
              p === d ? u.focus() : u.blur();
            });
        }
      });
      o(this, 'handleAutoFocus', async () => {
        const { xoAutofocus: t = !1 } = this.options;
        if (this.componentName === 'xo-modal' || this.componentName === 'xo-popover') {
          const s = Number(this.getAttribute('xo-duration')) || 300;
          await P(s);
        }
        if ((this.focus(), t)) {
          const s = this.querySelector(
            'input[type="text"], input[type="email"], input[type="password"], input[type="number"], input[type="tel"], input[type="url"], input[type="search"], textarea',
          );
          s == null || s.focus();
        }
      });
      o(this, 'handleShopifySectionSelect', () => {
        const { xoName: t } = this.options;
        new Tt(this.stateName).open(t);
      });
      o(this, 'handleShopifySectionDeselect', () => {
        const { xoName: t } = this.options;
        new Tt(this.stateName).close(t);
      });
      o(this, 'handleDesignMode', () => {
        var t, e, s;
        ((t = window.Shopify) == null ? void 0 : t.designMode) &&
          !!f.get(this, 'xo-section-select') &&
          ((e = this.sectionEl) == null || e.addEventListener('shopify:section:select', this.handleShopifySectionSelect),
          (s = this.sectionEl) == null || s.addEventListener('shopify:section:deselect', this.handleShopifySectionDeselect));
      });
      o(this, 'handleFocusIn', (t) => {
        const e = Array.from(document.querySelectorAll(ai));
        this.focusIndex = e.indexOf(t.target);
      });
      o(this, 'componentOpen', () => {});
      o(this, 'componentClose', () => {});
      o(this, 'componentMount', () => {});
      o(this, 'componentUnmount', () => {});
      o(this, 'subscribe', () => {});
      o(this, 'componentBeforeMount', () => {});
      this.sectionEl = this.closest('.shopify-section');
    }
    get options() {
      return $(this, { pick: ['xoName', 'xoAutofocus', 'xoSectionSelect'], types: { xoName: 'string', xoAutofocus: 'boolean', xoSectionSelect: 'boolean' } });
    }
    get state() {
      var r;
      const { xoName: t } = this.options;
      W(this.componentName, 'xo-name', t);
      const e = g.get(this.stateName),
        s = (r = e == null ? void 0 : e.data) == null ? void 0 : r[t];
      return typeof s != 'object' && s.isOpen == null ? {} : s;
    }
    async connectedCallback() {
      var e;
      this.componentBeforeMount();
      const { xoName: t } = this.options;
      W(this.componentName, 'xo-name', t),
        f.set(this, 'xo-content', !0),
        this.getAttribute('tabindex') == null && ((e = this.parentElement) == null ? void 0 : e.tagName.toLowerCase()) !== c.GalleryPortal && (this.tabIndex = 0),
        document.addEventListener('focusin', this.handleFocusIn),
        g.set(this.stateName, (s) => {
          const r = s;
          return { ...r, data: { ...r.data, [t]: { isOpen: !1, ...r.data[t] } } };
        })(`${this.stateName}/mount`),
        (this.unsubscribe = g.subscribe(this.stateName, this.listener, (s, r) => t !== r.trigger[this.stateName])),
        await P(0),
        this.componentMount(),
        this.handleDesignMode(),
        (this.initialized = !0);
    }
    disconnectedCallback() {
      var t, e, s;
      (t = this.unsubscribe) == null || t.call(this),
        this.componentUnmount(),
        document.removeEventListener('keydown', this.handleA11y),
        document.removeEventListener('focusin', this.handleFocusIn),
        (e = this.sectionEl) == null || e.removeEventListener('shopify:section:select', this.handleShopifySectionSelect),
        (s = this.sectionEl) == null || s.removeEventListener('shopify:section:deselect', this.handleShopifySectionDeselect);
    }
  }
  class fe extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', null);
      o(this, 'initialized', !1);
      o(this, 'prevIsOpen', !1);
      o(this, 'contentTarget', !1);
      o(this, 'bindClick', () => {
        this.addEventListener('click', this.handleTrigger);
      });
      o(this, 'bindHover', () => {
        const { xoName: t } = this.options,
          e = document.querySelector(`[xo-content][xo-name="${t}"]`);
        this.addEventListener('mouseenter', this.handleMouseEnter),
          this.addEventListener('mouseleave', this.handleMouseLeave),
          e && (e.addEventListener('mouseenter', this.handleMouseEnter), e.addEventListener('mouseleave', this.handleMouseLeave));
      });
      o(this, 'handleMouseEnter', (t) => {
        this.contains(t.target) || (this.contentTarget = !!t.target), this.state.isOpen || this.handleToggle('open');
      });
      o(this, 'handleMouseLeave', async () => {
        this.state.isOpen && (await P(200), this.contentTarget || this.handleToggle('close'), (this.contentTarget = !1));
      });
      o(this, 'handleTrigger', () => {
        this.handleToggle(this.actionType);
      });
      o(this, 'handleToggle', (t) => {
        const { xoName: e } = this.options;
        W(this.componentName, 'xo-name', e);
        const s = new Tt(this.stateName);
        t !== 'none' && s[t](e), this.componentTrigger();
      });
      o(this, 'listener', () => {
        const { isOpen: t } = this.state;
        this.initialized &&
          t !== this.prevIsOpen &&
          (t ? (f.set(this, 'xo-active', !0), this.componentOpen()) : (f.set(this, 'xo-active', !1), this.componentClose()), (this.prevIsOpen = t));
      });
      o(this, 'setState', (t) =>
        g.set(this.stateName, (e) => {
          const s = e;
          return { ...e, data: { ...s.data, ...(typeof t == 'function' ? t(s.data) : t) } };
        }),
      );
      o(this, 'componentOpen', () => {});
      o(this, 'componentClose', () => {});
      o(this, 'componentMount', () => {});
      o(this, 'componentUnmount', () => {});
      o(this, 'componentTrigger', () => {});
      o(this, 'componentBeforeMount', () => {});
    }
    async connectedCallback() {
      this.componentBeforeMount();
      const { xoName: t } = this.options;
      W(this.componentName, 'xo-name', t),
        this.eventType === 'click' ? this.bindClick() : this.eventType === 'hover' && (U.any ? this.bindClick() : this.bindHover()),
        (this.unsubscribe = g.subscribe(this.stateName, this.listener, (e, s) => t !== s.trigger[this.stateName])),
        await P(0),
        this.componentMount(),
        (this.initialized = !0);
    }
    disconnectedCallback() {
      var t;
      this.removeEventListener('click', this.handleTrigger),
        U.any || (this.removeEventListener('mouseenter', this.handleMouseEnter), this.removeEventListener('mouseleave', this.handleMouseLeave)),
        (t = this.unsubscribe) == null || t.call(this),
        this.componentUnmount();
    }
    get actionType() {
      return 'toggle';
    }
    get eventType() {
      return 'click';
    }
    get state() {
      var r;
      const { xoName: t } = this.options;
      W(this.componentName, 'xo-name', t);
      const e = g.get(this.stateName),
        s = (r = e == null ? void 0 : e.data) == null ? void 0 : r[t];
      return typeof s != 'object' && (s == null ? void 0 : s.isOpen) == null ? {} : s;
    }
    get options() {
      const t = $(this, { pick: ['xoName'], types: { xoName: 'string' } }),
        e = this.closest('[xo-name]');
      return e ? { ...$(e, { pick: ['xoName'], types: { xoName: 'string' } }), ...t } : t;
    }
  }
  const Qr = new Tt('xo-toggle'),
    Fi = class extends li {
      constructor() {
        super(...arguments);
        o(this, '_options');
        o(this, 'parentEl', null);
        o(this, 'setOptions', () => {
          var s;
          const t = $(this, {
              pick: ['xoName', 'xoAutofocus', 'xoOutsideClickEnabled', 'xoSectionSelect', 'xoPortal', 'xoParentSelector', 'xoBreakpoints'],
              types: {
                xoName: 'string',
                xoAutofocus: 'boolean',
                xoOutsideClickEnabled: 'boolean',
                xoSectionSelect: 'boolean',
                xoPortal: 'boolean',
                xoParentSelector: 'string',
                xoBreakpoints: 'object',
              },
            }),
            e = Dt((s = t.xoBreakpoints) != null ? s : {});
          this.options = { ...t, xoPortal: (e == null ? void 0 : e.portal) != null ? e.portal : t.xoPortal };
        });
        o(this, 'handleOutsideClick', (t) => {
          const { xoName: e, xoOutsideClickEnabled: s } = this.options,
            { isOpen: r } = this.state,
            a = t.target,
            l = document.querySelector(`${c.ToggleTrigger}[xo-name="${e}"]`);
          r && s && !this.contains(a) && !(l != null && l.contains(a)) && e && Qr.close(e);
        });
        o(this, 'handleTopSelector', async () => {
          const { xoPortal: t } = this.options;
          if (!!t && this.parentEl) {
            const { width: e, height: s, top: r } = this.parentEl.getBoundingClientRect(),
              { left: a } = X(this.parentEl);
            this.style.setProperty('--xo-top', `${r}px`),
              this.style.setProperty('--xo-left', `${a}px`),
              this.style.setProperty('--xo-width', `${e}px`),
              this.style.setProperty('--xo-height', `${s}px`),
              await P(500),
              this.handleTopSelector();
          }
        });
        o(this, 'handleScroll', () => {
          this.handleTopSelector();
        });
        o(
          this,
          'handleResize',
          st(
            me('x', () => {
              this.setOptions(), this.init();
            }),
            500,
          ),
        );
        o(this, 'componentBeforeMount', () => {
          this.setOptions();
        });
        o(this, 'componentOpen', async () => {
          await P();
          const { xoParentSelector: t } = this.options;
          t && (this.parentEl = document.querySelector(t)), this.handleTopSelector();
        });
        o(this, 'init', () => {
          const { xoPortal: t, xoName: e, xoParentSelector: s } = this.options;
          s && (this.parentEl = document.querySelector(s)),
            t &&
              e &&
              s &&
              (this.setAttribute('popover', e),
              this.style.setProperty('--xo-right', `${$o()}px`),
              ii(this),
              this.handleTopSelector(),
              window.addEventListener('scroll', this.handleScroll)),
            t ||
              (qe(this),
              this.removeAttribute('popover'),
              this.style.removeProperty('--xo-top'),
              this.style.removeProperty('--xo-left'),
              this.style.removeProperty('--xo-right'),
              this.style.removeProperty('--xo-width'),
              this.style.removeProperty('--xo-height')),
            document.addEventListener('click', this.handleOutsideClick);
        });
        o(this, 'componentMount', () => {
          const { xoBreakpoints: t } = this.options;
          this.init(), t && ft(t).length > 0 && window.addEventListener('resize', this.handleResize);
        });
        o(this, 'componentUnmount', () => {
          document.addEventListener('click', this.handleOutsideClick),
            window.removeEventListener('scroll', this.handleScroll),
            window.removeEventListener('resize', this.handleResize),
            qe(this);
        });
      }
      static get observedAttributes() {
        return ['xo-portal', 'xo-breakpoints'];
      }
      get options() {
        return { ...Fi.defaultOptions, ...this._options };
      }
      get stateName() {
        return 'xo-toggle';
      }
      get componentName() {
        return c.Toggle;
      }
      set options(t) {
        this._options = t;
      }
      async attributeChangedCallback(t, e, s) {
        e !== s && (await P(100), this.setOptions(), this.init());
      }
    };
  let We = Fi;
  o(We, 'defaultOptions', { xoName: null, xoOutsideClickEnabled: !1, xoPortal: !1, xoParentSelector: '' });
  class Zr extends fe {
    get stateName() {
      return 'xo-toggle';
    }
    get componentName() {
      return c.ToggleTrigger;
    }
  }
  g.create('xo-toggle', { initialState: { trigger: {}, data: {} } });
  const Kh = '',
    Kr = new Tt('xo-toggle');
  (window.xoToggle = Kr), B({ [c.Toggle]: We, [c.ToggleTrigger]: Zr });
  const K = {
      none: (n, { value: i }) => {
        n.style.visibility = i === 0 ? 'hidden' : 'visible';
      },
      zoom:
        (n = !1) =>
        (t, { value: e, isOpen: s, usePan: r = !1, easing: a }) => {
          if (r) (t.style.visibility = 'hidden'), (t.style.opacity = '0');
          else {
            const l = s ? [0, 1] : [1, 0],
              h = !s,
              d = D({ value: e, inputRange: l, easing: a, reverseEasing: h, outputRange: s ? [0.5, 1] : [1, 0.5] });
            if (n) {
              const u = D({ value: e, inputRange: l, easing: H.ease, reverseEasing: h, outputRange: s ? [0, 1] : [1, 0] });
              t.style.opacity = `${u}`;
            }
            (t.style.transform = `scale(${d})`), (t.style.visibility = e === 0 ? 'hidden' : 'visible');
          }
        },
      move:
        ({ dx: n = 0, dy: i = 0, opacity: t = 0 } = {}) =>
        (s, { value: r, isOpen: a, usePan: l = !1, easing: h }) => {
          if (l) (s.style.visibility = 'hidden'), (s.style.opacity = '0');
          else {
            const d = a ? [0, 1] : [1, 0],
              u = !a,
              p = D({ value: r, inputRange: d, easing: H.ease, reverseEasing: u, outputRange: a ? [t, 1] : [1, t] }),
              m = (x) => D({ value: r, inputRange: d, easing: h, reverseEasing: u, outputRange: a ? [x, 0] : [0, x] });
            (s.style.transform = `translate(${m(typeof n == 'function' ? n(s) : n)}px, ${m(typeof i == 'function' ? i(s) : i)}px)`),
              (s.style.opacity = `${p}`),
              (s.style.visibility = r === 0 ? 'hidden' : 'visible');
          }
        },
    },
    Oo =
      (n = !1) =>
      (t, { value: e, isOpen: s, triggerEl: r, dy: a = 0, modalEl: l, easing: h }) => {
        if (!r) return K.zoom(n)(t, { value: e, isOpen: s, easing: h });
        const d = l.querySelector('img[xo-cropped]'),
          u = r.getBoundingClientRect(),
          p = s ? [0, 1] : [1, 0],
          m = !s,
          x = u.width / t.offsetWidth,
          y = u.height / t.offsetHeight,
          b = u.left + u.width / 2 - l.scrollWidth / 2,
          v = t.offsetHeight > l.offsetHeight ? t.offsetHeight : l.offsetHeight,
          k = u.top + u.height / 2 - v / 2 + l.scrollTop,
          A = D({ value: e, inputRange: p, easing: h, reverseEasing: m, outputRange: s ? [x, 1] : [1, x] }),
          T = D({ value: e, inputRange: p, easing: h, reverseEasing: m, outputRange: s ? [y, 1] : [1, y] }),
          M = D({ value: e, inputRange: p, easing: h, reverseEasing: m, outputRange: s ? [b, 0] : [0, b] }),
          L = D({ value: e, inputRange: p, easing: h, reverseEasing: m, outputRange: s ? [k, a] : [a, k] });
        if (n) {
          const V = D({ value: e, inputRange: p, easing: H.ease, reverseEasing: m, outputRange: s ? [0, 1] : [1, 0] });
          t.style.opacity = `${V}`;
        }
        (t.style.transform = `translateX(${M}px) translateY(${L}px) scaleX(${A}) scaleY(${T})`),
          (t.style.visibility = e === 0 ? 'hidden' : 'visible'),
          d && (A > T ? (d.style.transform = `scaleY(${A / T})`) : (d.style.transform = `scaleX(${T / A})`));
      },
    Fo = {
      none: K.none,
      zoom: K.zoom(!0),
      'smart-zoom': Oo(),
      'smart-fade-zoom': Oo(!0),
      fade: K.move(),
      'fade-up': K.move({ dy: 100 }),
      'fade-down': K.move({ dy: -100 }),
      'fade-left': K.move({ dx: 100 }),
      'fade-right': K.move({ dx: -100 }),
      'slide-up': K.move({
        dy: (n) => {
          const { offsetTop: i } = n;
          return window.innerHeight - i;
        },
        opacity: 1,
      }),
      'slide-down': K.move({
        dy: (n) => {
          const { offsetTop: i, offsetHeight: t } = n;
          return -1 * (t + i);
        },
        opacity: 1,
      }),
      'slide-left': K.move({
        dx: (n) => {
          const { offsetLeft: i } = n;
          return window.innerWidth - i;
        },
        opacity: 1,
      }),
      'slide-right': K.move({
        dx: (n) => {
          const { offsetLeft: i, offsetWidth: t } = n;
          return -1 * (t + i);
        },
        opacity: 1,
      }),
    },
    Ho = Oe(),
    Jr = (n, i) => Ho`
    ${c.ModalBackdrop} {
      position: absolute;
      inset: 0;
      z-index: 1;
      background-color: ${n || 'var(--xo-backdrop-color, rgba(0, 0, 0, 0.5))'};
      backdrop-filter: blur(${i ? `${i}px` : 'var(--xo-backdrop-blur, 0px)'});
      pointer-events: auto;
    }
    ${c.ModalInner} {
      position: relative;
      display: flex;
      min-height: 100%;
    }
    ${c.ModalInner}[xo-placement="center"] {
      align-items: center;
      justify-content: center;
    }
    ${c.ModalInner}[xo-placement="top-center"] {
      justify-content: center;
    }
    ${c.ModalInner}[xo-placement="top-right"] {
      justify-content: flex-end;
    }
    ${c.ModalInner}[xo-placement="bottom-left"] {
      align-items: flex-end;
    }
    ${c.ModalInner}[xo-placement="bottom-center"] {
      align-items: flex-end;
      justify-content: center;
    }
    ${c.ModalInner}[xo-placement="bottom-right"] {
      align-items: flex-end;
      justify-content: flex-end;
    }
    ${c.ModalContent} {
      position: relative;
      z-index: 9;
      display: block;
      visibility: hidden;
      width: fit-content;
      height: fit-content;
      pointer-events: none;
    }
  `,
    ta = () => Ho`
    ${c.ModalContent} * {
      pointer-events: auto;
    }
  `;
  function ea() {
    const n = $o();
    document.body.style.setProperty('--scroll-bar-width', `${n}px`), document.body.classList.add('xo-modal-open');
  }
  function sa() {
    const { data: n } = g.get('xo-modal');
    ie(n).some((t) => t.isOpen) || (document.body.style.removeProperty('--scroll-bar-width'), document.body.classList.remove('xo-modal-open'));
  }
  const Hi = class extends li {
    constructor() {
      super(...arguments);
      o(this, 'animated', _());
      o(this, 'cancel', () => {});
      o(this, 'shadow', this.attachShadow({ mode: 'open' }));
      o(this, 'dialog', document.createElement('div'));
      o(this, '_options');
      o(this, 'setOptions', () => {
        var s;
        const t = $(this, {
            pick: [
              'xoName',
              'xoDuration',
              'xoEasing',
              'xoAnimate',
              'xoBackdropColor',
              'xoBackdropBlur',
              'xoBackdropDisabled',
              'xoPortal',
              'xoPlacement',
              'xoDisabled',
              'xoBreakpoints',
              'xoAutofocus',
              'xoSectionSelect',
              'xoVideoAutoplay',
            ],
            types: {
              xoName: 'string',
              xoDuration: 'number',
              xoEasing: 'string',
              xoAnimate: 'string',
              xoBackdropColor: 'string',
              xoBackdropBlur: 'number',
              xoBackdropDisabled: 'boolean',
              xoPortal: 'boolean',
              xoPlacement: 'string',
              xoDisabled: 'boolean',
              xoBreakpoints: 'object',
              xoAutofocus: 'boolean',
              xoSectionSelect: 'boolean',
              xoVideoAutoplay: 'boolean',
            },
          }),
          e = Dt((s = t.xoBreakpoints) != null ? s : {});
        this.options = JSON.parse(
          JSON.stringify({
            ...t,
            xoDisabled: (e == null ? void 0 : e.disabled) != null ? e.disabled : t.xoDisabled,
            xoDuration: (e == null ? void 0 : e.duration) != null ? e.duration : t.xoDuration,
            xoEasing: (e == null ? void 0 : e.easing) != null ? e.easing : t.xoEasing,
            xoAnimate: (e == null ? void 0 : e.animate) != null ? e.animate : t.xoAnimate,
            xoBackdropColor: (e == null ? void 0 : e.backdropColor) != null ? e.backdropColor : t.xoBackdropColor,
            xoBackdropBlur: (e == null ? void 0 : e.backdropBlur) != null ? e.backdropBlur : t.xoBackdropBlur,
            xoBackdropDisabled: (e == null ? void 0 : e.backdropDisabled) != null ? e.backdropDisabled : t.xoBackdropDisabled,
            xoPlacement: (e == null ? void 0 : e.placement) != null ? e.placement : t.xoPlacement,
          }),
        );
      });
      o(this, 'componentOpen', () => {
        const { xoDuration: t, xoVideoAutoplay: e } = this.options;
        if ((ii(this), ea(), this.cancel(), (this.cancel = this.animated({ from: 0, to: 1, duration: t })), e)) {
          const s = this.querySelector('video');
          s == null || s.play();
        }
      });
      o(this, 'componentClose', () => {
        const { xoDuration: t, xoVideoAutoplay: e } = this.options;
        if (
          (sa(),
          this.cancel(),
          this.animated({
            from: 1,
            to: 0,
            duration: t,
            onEnd: () => {
              qe(this);
            },
          }),
          e)
        ) {
          const s = this.querySelector('video');
          s == null || s.pause();
        }
      });
      o(this, 'setStyles', (t) => {
        const { xoAnimate: e, xoEasing: s } = this.options,
          { isOpen: r, triggerElement: a, dy: l, usePan: h = !1 } = this.state,
          d = this.shadow.querySelector(c.ModalContent),
          { cssText: u } = ta(),
          p = this.shadow.querySelector('style');
        t === 0 ? (this.style.removeProperty('visibility'), this.style.removeProperty('opacity')) : ((this.style.visibility = 'visible'), (this.style.opacity = '1')),
          t === 1
            ? (this.style.removeProperty('pointer-events'), p && !p.innerText.includes(u) && (p.innerText = p.innerText + u))
            : ((this.style.pointerEvents = 'none'), p && (p.innerText = p.innerText.replace(u, ''))),
          Fo[e] && Fo[e](d, { value: t, isOpen: r, triggerEl: a, dy: l, modalEl: this, usePan: h, easing: H[s] });
      });
      o(this, 'render', () => {
        const { xoName: t, xoBackdropColor: e, xoBackdropBlur: s, xoBackdropDisabled: r, xoPlacement: a, xoDisabled: l } = this.options,
          { cssText: h } = Jr(e, s),
          d = r ? '' : `<${c.ModalBackdrop} xo-name="${t}"></${c.ModalBackdrop}>`;
        return l
          ? `
          <${c.ModalInner} xo-placement="${a}">
            <${c.ModalContent}>
              <slot name="${t}-inner"></slot>
            </${c.ModalContent}>
            ${d}
            <slot name="${t}-outer"></slot>
          </${c.ModalInner}>
        `
          : `
        <style>${h}</style>
        <${c.ModalInner} xo-placement="${a}">
          <${c.ModalContent}>
            <slot name="${t}-inner"></slot>
          </${c.ModalContent}>
          ${d}
          <slot name="${t}-outer"></slot>
        </${c.ModalInner}>
      `;
      });
      o(this, 'addSlotName', (t) => {
        const e = Array.from(this.querySelectorAll(c.Modal)),
          s = Array.from(this.children);
        E(s, (r) => {
          e.includes(r) || r.setAttribute('slot', `${t}-inner`);
        }),
          E(e, (r) => {
            r.setAttribute('slot', `${t}-outer`), s.includes(r) || this.appendChild(r);
          });
      });
      o(this, 'setOptionsState', (t) => {
        this.setState((e) => ({ ...e, [t]: { ...e[t], options: this.options } }));
      });
      o(this, 'checkSmartAnimateSupport', () => {
        const { xoAnimate: t, xoPlacement: e } = this.options;
        t.includes('smart-') && e !== 'center' && bt(`[${c.Modal}] xo-placement="${e}" is not supported with xo-animate="${t}"`);
      });
      o(this, 'handleImageCropped', () => {
        const t = this.querySelector('img[xo-cropped]');
        if (t) {
          const e = t.naturalWidth / t.naturalHeight,
            s = window.innerWidth / window.innerHeight;
          e > s ? ((t.style.width = '100vw'), (t.style.height = 'auto')) : ((t.style.width = 'auto'), (t.style.height = '100vh'), (t.style.maxWidth = 'none'));
        }
      });
      o(this, 'componentBeforeMount', () => {
        this.setOptions();
      });
      o(
        this,
        'handleResize',
        st(
          me('x', () => {
            const { xoName: t } = this.options;
            this.setOptions(), this.animated.off(), ne.close(t), this.mounted();
          }),
          500,
        ),
      );
      o(this, 'setCurrentDisabled', () => {
        const { xoDisabled: t } = this.options;
        f.set(this, 'xo-current-disabled', t);
      });
      o(this, 'handleDialogCancel', (t) => {
        t.preventDefault();
      });
      o(this, 'mounted', () => {
        const { xoName: t, xoDisabled: e, xoBreakpoints: s, xoPortal: r } = this.options;
        W(this.componentName, 'xo-name', t),
          this.addSlotName(t),
          this.setCurrentDisabled(),
          r && Re() && this.setAttribute('popover', t),
          (this.shadow.innerHTML = this.render()),
          this.setCssVariables(),
          s &&
            ft(s).length > 0 &&
            E(ft(s).sort(), (a) => {
              const l = s[a];
              this.setCssVariables(Number(a), l);
            }),
          e || (this.setOptionsState(t), this.checkSmartAnimateSupport(), this.animated.onUpdate(this.setStyles), this.handleImageCropped());
      });
      o(this, 'componentMount', () => {
        const { xoBreakpoints: t } = this.options;
        this.mounted(), t && ft(t).length > 0 && window.addEventListener('resize', this.handleResize);
      });
      o(this, 'componentUnmount', () => {
        this.animated.off(), window.removeEventListener('resize', this.handleResize), this.dialog.removeEventListener('cancel', this.handleDialogCancel);
      });
      o(this, 'handleClose', () => {
        const { xoName: t } = this.options;
        W(this.componentName, 'xo-name', t), this.setState((e) => ({ ...e, [t]: { ...e[t], triggerElement: e[t].triggerElement, usePan: !1, isOpen: !1 } }));
      });
    }
    get stateName() {
      return 'xo-modal';
    }
    get componentName() {
      return c.Modal;
    }
    get options() {
      var r, a, l, h;
      const { xoPlacement: t } = this._options,
        e =
          !t || t === 'center'
            ? {}
            : {
                xoDuration: (a = (r = window.settings) == null ? void 0 : r.drawer_duration) != null ? a : 300,
                xoEasing: (h = (l = window.settings) == null ? void 0 : l.drawer_easing) != null ? h : 'decay',
                xoAnimate: 'smart-fade-zoom',
              },
        s = { ...Hi.defaultOptions, ...e, ...this._options };
      return { ...s, xoDuration: s.xoAnimate === 'none' ? 0 : s.xoDuration };
    }
    set options(t) {
      this._options = t;
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    async attributeChangedCallback(t, e, s) {
      if (t === 'xo-observed' && e != null && e !== s) {
        await P(100), this.setOptions(), this.componentUnmount(), this.componentMount(), this.handleClose();
        const r = Array.from(document.querySelectorAll(`${c.ModalTrigger}[xo-name="${this.options.xoName}"]`));
        E(r, (a) => {
          a.setAttribute('xo-observed', s);
        });
      }
    }
  };
  let Ue = Hi;
  o(Ue, 'defaultOptions', {
    xoName: null,
    xoDuration: (Vn = (qn = window.settings) == null ? void 0 : qn.modal_duration) != null ? Vn : 300,
    xoEasing: (Bn = (zn = window.settings) == null ? void 0 : zn.modal_easing) != null ? Bn : 'decay',
    xoAnimate: (Wn = (_n = window.settings) == null ? void 0 : _n.modal_animate) != null ? Wn : 'smart-fade-zoom',
    xoBackdropDisabled: !1,
    xoPortal: Re(),
    xoPlacement: 'center',
    xoDisabled: !1,
    xoBreakpoints: {},
    xoScrollDisabled: !1,
    xoAutofocus: !1,
    xoVideoAutoplay: !1,
  });
  const Ro = 1e3 / 60,
    Hs = class extends fe {
      constructor() {
        super(...arguments);
        o(this, 'timeId', -1);
        o(this, 'timeId2', -1);
        o(this, '_options');
        o(this, 'setOptions', () => {
          this.options = $(this, { pick: ['xoName', 'xoSync'], types: { xoName: 'string', xoSync: 'boolean' } });
        });
        o(this, 'setTriggerElement', () => {
          const { xoName: t } = this.options,
            { isOpen: e } = this.state;
          W(this.componentName, 'xo-name', t),
            this.setState((s) => {
              var r;
              return { ...s, [t]: { ...s[t], triggerElement: e ? this : (r = s[t]) == null ? void 0 : r.triggerElement, usePan: !1 } };
            });
        });
        o(this, 'componentTrigger', () => {
          const { isOpen: t } = this.state,
            { xoSync: e } = this.options;
          this.setTriggerElement(),
            e &&
              t &&
              (this.timeId2 = window.setTimeout(() => {
                (this.style.visibility = 'hidden'), clearTimeout(this.timeId2);
              }, Ro));
        });
        o(this, 'componentBeforeMount', () => {
          this.setOptions();
        });
        o(this, 'componentMount', () => {
          this.setTriggerElement();
        });
        o(this, 'componentUnmount', () => {
          clearTimeout(this.timeId), clearTimeout(this.timeId2);
        });
        o(this, 'componentClose', () => {
          const { xoSync: t } = this.options;
          if (t) {
            const { options: e } = this.state,
              { xoDuration: s } = e;
            this.timeId = window.setTimeout(() => {
              (this.style.visibility = 'visible'), clearTimeout(this.timeId);
            }, s - Ro);
          }
        });
      }
      get stateName() {
        return 'xo-modal';
      }
      get componentName() {
        return c.ModalTrigger;
      }
      get options() {
        const t = this.closest('[xo-name]');
        if (t) {
          const e = $(t, { pick: ['xoName'], types: { xoName: 'string' } });
          return { ...Hs.defaultOptions, ...e, ...this._options };
        }
        return { ...Hs.defaultOptions, ...this._options };
      }
      set options(t) {
        this._options = t;
      }
      static get observedAttributes() {
        return ['xo-observed'];
      }
      async attributeChangedCallback(t, e, s) {
        t === 'xo-observed' && e != null && e !== s && (await P(100), this.setOptions());
      }
    };
  let Xe = Hs;
  o(Xe, 'defaultOptions', { xoName: null, xoSync: !1 });
  class ia extends fe {
    constructor() {
      super(...arguments);
      o(this, 'animated', _());
      o(this, 'cancel', () => {});
      o(this, 'componentOpen', () => {
        const { options: t } = this.state,
          { xoDuration: e } = t;
        this.cancel(), (this.cancel = this.animated({ from: 0, to: 1, duration: e, easing: H.decay }));
      });
      o(this, 'componentClose', () => {
        const { options: t, opacity: e = 1, usePan: s = !1 } = this.state,
          { xoDuration: r } = t;
        this.cancel(), (this.cancel = this.animated({ from: e, to: 0, duration: s ? 0 : r, easing: H.decay }));
      });
      o(this, 'componentMount', () => {
        const { options: t } = this.state,
          { xoAnimate: e } = t;
        (this.style.visibility = 'hidden'),
          this.animated.onUpdate((s) => {
            e !== 'none' && (this.style.opacity = `${s}`), s === 0 ? (this.style.visibility = 'hidden') : (this.style.visibility = 'visible');
          });
      });
      o(this, 'componentUnmount', () => {
        this.animated.off();
      });
    }
    get stateName() {
      return 'xo-modal';
    }
    get componentName() {
      return c.ModalBackdrop;
    }
    get actionType() {
      return 'close';
    }
  }
  const Qt = { Idle: 'idle', Target: 'target', Lock: 'lock' },
    Rs = class extends fe {
      constructor() {
        super(...arguments);
        o(this, 'animated', _());
        o(this, 'panAnimated', _());
        o(this, 'panCloseAnimated', _());
        o(this, 'cancel', () => {});
        o(this, 'modalEl', null);
        o(this, 'backdropEl', null);
        o(this, 'contentEl', null);
        o(this, 'distance', 0);
        o(this, 'opacity', 1);
        o(this, 'timeId', -1);
        o(this, 'pan', null);
        o(this, 'axis', Qt.Idle);
        o(this, 'componentOpen', () => {
          const { options: t } = this.state,
            { xoDuration: e } = t;
          this.cancel(), (this.cancel = this.animated({ from: 0, to: 1, duration: e }));
        });
        o(this, 'componentClose', () => {
          const { options: t } = this.state,
            { xoDuration: e } = t;
          this.cancel(), (this.cancel = this.animated({ from: 1, to: 0, duration: e }));
        });
        o(this, 'componentUnmount', () => {
          clearTimeout(this.timeId), this.pan && this.pan.destroy(), this.animated.off(), this.panAnimated.off(), this.panCloseAnimated.off();
        });
        o(this, 'resetModalMeasure', () => {
          const { xoName: t } = this.options;
          W(this.componentName, 'xo-name', t), this.setState((e) => ({ ...e, [t]: { ...e[t], dy: 0, opacity: 1 } }))(`${this.stateName}/resetModalContentMeasure`);
        });
        o(this, 'componentMount', () => {
          const { xoName: t, xoVertical: e, xoThreshold: s, xoIntentionalAxis: r } = this.options,
            { options: a } = this.state,
            { xoEasing: l, xoAnimate: h } = a,
            d = new Tt(this.stateName);
          W(this.componentName, 'xo-name', t),
            (this.pan = Gt({
              element: this,
              onMove: ({ dx: u, dy: p }) => {
                var x, y, b, v, k, A, T;
                const m = this.querySelector(c.ImageZoomItem);
                if (!(Number((x = m == null ? void 0 : m.getAttribute('xo-zoom')) != null ? x : '1') > 1))
                  if (
                    ((this.modalEl = this.closest(c.Modal)),
                    (this.backdropEl =
                      (v = (b = (y = this.modalEl) == null ? void 0 : y.shadowRoot) == null ? void 0 : b.querySelector) == null ? void 0 : v.call(b, c.ModalBackdrop)),
                    (this.contentEl =
                      (T = (A = (k = this.modalEl) == null ? void 0 : k.shadowRoot) == null ? void 0 : A.querySelector) == null ? void 0 : T.call(A, c.ModalContent)),
                    this.axis === Qt.Idle && (Math.abs(e ? u : p) / s >= Math.abs(e ? p : u) ? (this.axis = Qt.Target) : (this.axis = Qt.Lock)),
                    this.axis === Qt.Target || !r)
                  ) {
                    this.style.touchAction = 'none';
                    const M = (e ? window.innerWidth - this.offsetWidth : window.innerHeight - this.offsetHeight) / 2,
                      L = (e ? this.offsetWidth : this.offsetHeight) + M;
                    this.backdropEl &&
                      ((this.opacity = D({ value: e ? u : p, inputRange: [-L, 0, L], outputRange: [0, 1, 0] })), (this.backdropEl.style.opacity = `${this.opacity}`)),
                      this.contentEl &&
                        (h.includes('smart-')
                          ? e
                            ? (this.contentEl.style.transform = `translateX(${u}px)`)
                            : (this.contentEl.style.transform = `translateY(${p}px)`)
                          : e
                          ? (this.contentEl.style.transform = `translateX(${u}px)`)
                          : (this.contentEl.style.transform = `translateY(${p}px)`));
                  } else this.pan && this.pan.setValue({ dx: 0, dy: 0 });
              },
              onEnd: ({ dx: u, dy: p, vx: m, vy: x }) => {
                var A;
                const y = this.querySelector(c.ImageZoomItem);
                if (Number((A = y == null ? void 0 : y.getAttribute('xo-zoom')) != null ? A : '1') > 1) return;
                const { options: b } = this.state,
                  { xoDuration: v, xoAnimate: k } = b;
                if ((this.axis === Qt.Target || !r) && ((this.style.pointerEvents = 'none'), (this.distance = e ? u : p), this.contentEl)) {
                  let T = (e ? window.innerWidth : window.innerHeight) / 3;
                  r && (T = (e ? this.contentEl.offsetWidth : this.contentEl.offsetHeight) / 2);
                  const M = Math.abs(this.distance) > T || Math.abs(e ? m : x) > 8;
                  this.setState((L) => ({ ...L, [t]: { ...L[t], dy: p, opacity: this.opacity } }))(`${this.stateName}/setModalContentMeasure`),
                    M ? (k.includes('smart-') ? d.close(t) : this.panCloseAnimated({ from: 0, to: 1, duration: 300 })) : this.panAnimated({ from: 0, to: 1, duration: 300 }),
                    this.pan && this.pan.setValue({ dx: 0, dy: 0 }),
                    (this.timeId = window.setTimeout(() => {
                      this.resetModalMeasure(), clearTimeout(this.timeId), this.style.removeProperty('pointer-events');
                    }, v));
                }
                this.style.removeProperty('touch-action'), (this.axis = Qt.Idle);
              },
            })),
            this.panAnimated.onUpdate((u) => {
              if (this.backdropEl) {
                const p = D({ value: u, inputRange: [0, 1], outputRange: [this.opacity, 1] });
                this.backdropEl.style.opacity = `${p}`;
              }
              if (this.contentEl) {
                const p = D({ value: u, inputRange: [0, 1], outputRange: [this.distance, 0], easing: H[l] });
                e
                  ? (this.contentEl.style.transform = `translateX(${p}px) translateY(0px) scale(1)`)
                  : (this.contentEl.style.transform = `translateX(0px) translateY(${p}px) scale(1)`);
              }
            }),
            this.panCloseAnimated.onUpdate((u) => {
              if (this.backdropEl) {
                const p = D({ value: u, inputRange: [0, 1], outputRange: [this.opacity, 0] });
                this.backdropEl.style.opacity = `${p}`;
              }
              if (this.contentEl) {
                const { offsetTop: p, offsetLeft: m, offsetWidth: x, offsetHeight: y } = this.contentEl;
                let b = -1 * (e ? x + m : y + p);
                this.distance >= 0 && (b = e ? window.innerWidth - m : window.innerHeight - p);
                const v = D({ value: u, inputRange: [0, 1], outputRange: [this.distance, b], easing: H[l] });
                e
                  ? (this.contentEl.style.transform = `translateX(${v}px) translateY(0px) scale(1)`)
                  : (this.contentEl.style.transform = `translateX(0px) translateY(${v}px) scale(1)`);
              }
            }),
            this.panCloseAnimated.onEnd(() => {
              this.setState((u) => ({ ...u, [t]: { ...u[t], usePan: !0 } })), d.close(t);
            });
        });
      }
      get stateName() {
        return 'xo-modal';
      }
      get componentName() {
        return c.ModalPan;
      }
      get actionType() {
        return 'none';
      }
      get options() {
        const t = $(this, {
            pick: ['xoName', 'xoVertical', 'xoThreshold', 'xoIntentionalAxis'],
            types: { xoName: 'string', xoVertical: 'boolean', xoThreshold: 'number', xoIntentionalAxis: 'boolean' },
          }),
          e = this.closest('[xo-name]');
        if (e) {
          const s = $(e, { pick: ['xoName'], types: { xoName: 'string' } });
          return { ...Rs.defaultOptions, ...s, ...t };
        }
        return { ...Rs.defaultOptions, ...t };
      }
    };
  let Ye = Rs;
  o(Ye, 'defaultOptions', { xoName: null, xoVertical: !1, xoThreshold: 1.5, xoIntentionalAxis: !1 }), g.create('xo-modal', { initialState: { trigger: {}, data: {} } });
  const sd = '',
    ne = new Tt('xo-modal');
  (window.xoModal = ne), B({ [c.Modal]: Ue, [c.ModalTrigger]: Xe, [c.ModalBackdrop]: ia, [c.ModalPan]: Ye });
  const oa = Oe()`
    ${c.ScrollXInner} {
      display: block;
      position: sticky;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
    }
  `;
  class na extends HTMLElement {
    constructor() {
      super();
      o(this, 'shadow');
      o(this, 'instance');
      o(this, 'elementStyle', (t) => {
        (this.style.height = `${t * 100}vh`),
          (this.shadow.innerHTML = `
        <style>${oa.cssText}</style>
        <${c.ScrollXInner}><slot></slot></${c.ScrollXInner}>
      `);
      });
      o(this, 'handleChild', (t, e) => {
        if (t.tagName.toLowerCase() === c.ScrollXItem && e > 0) {
          const s = X(this).top;
          this.instance.add(t, {
            from: () => s - window.innerHeight * 2 + window.innerHeight * (e + 1),
            to: () => s - window.innerHeight + window.innerHeight * (e + 1),
            keyframes: { '0%': { width: '0%' }, '100%': { width: '100%' } },
          });
        }
      });
      (this.shadow = this.attachShadow({ mode: 'open' })),
        (this.instance = Be({
          setStyles({ element: t, createValue: e }) {
            const s = e('width');
            t.style.width = `${s}`;
          },
        }));
    }
    connectedCallback() {
      const t = Array.from(this.children);
      this.elementStyle(t.length), E(t, this.handleChild), this.instance.run();
    }
  }
  const od = '';
  B({ [c.ScrollX]: na });
  const xe = {
      set(n, i) {
        g.set('xo-circle-bar', (t) => ({ ...t, [n]: i }));
      },
      animate(n, { value: i, duration: t = 1e3, easing: e }) {
        const s = _();
        return (
          s({
            from: 0,
            to: i,
            duration: t,
            easing: e ? H[e] : void 0,
            onUpdate(r) {
              g.set('xo-circle-bar', (a) => ({ ...a, [n]: r }));
            },
          }),
          s.off
        );
      },
    },
    qo = {},
    ci = new IntersectionObserver(
      (n) => {
        const i = requestAnimationFrame(() => {
          n.forEach(async (t) => {
            const e = t.target,
              { xoDuration: s, xoName: r, xoEasing: a, xoValue: l } = e.getOptions();
            if (t.isIntersecting && r && l) {
              const h = qo[r];
              h == null || h();
              const d = xe.animate(r, { value: l, duration: s, easing: a });
              (qo[r] = d), cancelAnimationFrame(i), ci.unobserve(e);
            }
          });
        });
      },
      { rootMargin: '0px 0px -50px 0px' },
    ),
    Ri = class extends HTMLElement {
      constructor() {
        super(...arguments);
        o(this, 'unsubscribe', null);
        o(this, 'getOptions', () => {
          const t = $(this, {
            pick: ['xoName', 'xoFill', 'xoStrokeWidth', 'xoSize', 'xoTrackColor', 'xoThumbColor', 'xoStrokeLinecap', 'xoAnimateOnScroll', 'xoEasing', 'xoValue', 'xoDuration'],
            types: {
              xoName: 'string',
              xoFill: 'string',
              xoStrokeWidth: 'number',
              xoSize: 'number',
              xoTrackColor: 'string',
              xoThumbColor: 'string',
              xoStrokeLinecap: 'string',
              xoAnimateOnScroll: 'boolean',
              xoEasing: 'string',
              xoValue: 'number',
              xoDuration: 'number',
            },
          });
          return { ...Ri.defaultOptions, ...t };
        });
        o(this, 'listener', () => {
          var h;
          const { xoName: t, xoSize: e, xoStrokeWidth: s } = this.getOptions();
          this.closest(c.Carousel) || W(c.CircleBar, 'xo-name', t);
          const a = this.querySelector('.circle-bar-thumb'),
            l = (h = g.get('xo-circle-bar')) == null ? void 0 : h[t];
          if (l != null) {
            const d = D({ value: l, inputRange: [0, 100], outputRange: [e * Math.PI, s * Math.PI] });
            a.style.strokeDashoffset = `${d}`;
          }
        });
        o(this, 'render', () => {
          const { xoSize: t, xoStrokeWidth: e, xoTrackColor: s, xoThumbColor: r, xoStrokeLinecap: a, xoFill: l } = this.getOptions();
          return `
        <svg width="${t}" height="${t}" viewport="0 0 ${t} ${t}" version="1.1" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle">
          <circle
            fill="${l}"
            stroke-width="${e}"
            r="${(t - e) / 2}"
            cx="${t / 2}"
            cy="${t / 2}"
            stroke="${s}"
          >
          </circle>
          <circle
            class="circle-bar-thumb"
            stroke-width="${e}"
            r="${(t - e) / 2}"
            cx="${t / 2}"
            cy="${t / 2}"
            stroke="${r}"
            stroke-linecap="${a}"
            stroke-dashoffset="${t * Math.PI}"
            stroke-dasharray="${t * Math.PI}"
            fill="transparent"
            transform="rotate(-90)"
            transform-origin="50% 50%"
          >
          </circle>
        </svg>
      `;
        });
      }
      static get observedAttributes() {
        return ['xo-observed'];
      }
      connectedCallback() {
        const t = this.getOptions();
        (this.innerHTML = this.render()), (this.style.display = 'block'), t.xoAnimateOnScroll && ci.observe(this), (this.unsubscribe = g.subscribe('xo-circle-bar', this.listener));
      }
      async attributeChangedCallback(t, e, s) {
        t === 'xo-observed' && e !== s && (await P(100), this.disconnectedCallback(), this.connectedCallback());
      }
      disconnectedCallback() {
        var t;
        (t = this.unsubscribe) == null || t.call(this), ci.unobserve(this);
      }
    };
  let ge = Ri;
  o(ge, 'defaultOptions', {
    xoName: null,
    xoFill: 'transparent',
    xoSize: 100,
    xoStrokeWidth: 2,
    xoTrackColor: '#ebebeb',
    xoThumbColor: '#ea5b5b',
    xoStrokeLinecap: 'round',
    xoAnimateOnScroll: !1,
    xoEasing: 'ease',
    xoValue: 0,
    xoDuration: 1e3,
  }),
    g.create('xo-circle-bar', { initialState: {} }),
    (window.xoCircleBar = xe),
    B({ [c.CircleBar]: ge });
  const hi = new pe(),
    qs = class {
      constructor() {
        o(this, 'placements', ['top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right']);
        o(this, 'getOptions', (i) => (typeof i == 'string' ? { ...qs.defaultOptions, content: i } : { ...qs.defaultOptions, ...i }));
        o(this, 'createToastRoot', (i) => {
          if (!document.querySelector(`${c.ToastPortal}[xo-placement="${i}"]`)) {
            const e = document.createElement(c.ToastPortal);
            e.setAttribute('xo-placement', i), document.body.appendChild(e);
          }
        });
        o(this, 'action', (i) => {
          const t = this.getOptions(i);
          this.createToastRoot(t.placement);
          for (const e of this.placements) this.createToastRoot(e);
          hi.emit('toast:action', t);
        });
      }
    };
  let Ge = qs;
  o(Ge, 'defaultOptions', {
    name: '',
    content: '',
    duration: 200,
    delay: 2e3,
    className: '',
    style: {},
    placement: 'bottom-center',
    easing: 'decay',
    closeButtonDisabled: !1,
    closeButtonClassName: '',
    closeButtonPlacement: 'top-right',
    onShow() {},
    onHide() {},
  });
  const be = new Ge().action;
  class ra extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'offId', -1);
      o(
        this,
        'renderCloseButton',
        (t) => `
        <${c.ToastCloseButton} class="${t.closeButtonClassName}" xo-placement="${t.closeButtonPlacement}"><svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M6.707 5.293a1 1 0 0 0-1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293 3.293 3.293a1 1 0 0 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293-3.293-3.293Z"></path></svg></${c.ToastCloseButton}>
      `,
      );
      o(this, 'listener', (t) => {
        if (t.name) {
          const e = document.querySelector(`${c.Toast}[xo-name="${t.name}"]`);
          if (e.parentNode !== this) {
            const s = $(e, {
                pick: ['xoDuration', 'xoClassName', 'xoDelay', 'xoEasing', 'xoPlacement', 'xoCloseButtonClassName', 'xoCloseButtonDisabled', 'xoCloseButtonPlacement'],
                types: {
                  xoDuration: 'number',
                  xoClassName: 'string',
                  xoDelay: 'number',
                  xoEasing: 'string',
                  xoPlacement: 'string',
                  xoCloseButtonClassName: 'string',
                  xoCloseButtonDisabled: 'boolean',
                  xoCloseButtonPlacement: 'string',
                },
                propTransformer: (a) => Yt.pascalToCamel(a.replace(/^xo/, '')),
              }),
              r = { ...t, ...s };
            if (r.placement === this.getAttribute('xo-placement')) {
              const a = document.createElement(c.ToastPlaceholder);
              a.setAttribute('xo-name', r.name),
                r.closeButtonDisabled || e.insertAdjacentHTML('beforeend', this.renderCloseButton(r)),
                (e.message = r),
                e.after(a),
                r.placement.includes('top-') ? this.insertAdjacentElement('beforeend', e) : this.insertAdjacentElement('afterbegin', e);
            }
          }
        } else if (t.placement === this.getAttribute('xo-placement')) {
          const e = document.createElement(c.Toast);
          t.closeButtonDisabled ? (e.innerHTML = t.content) : (e.innerHTML = t.content + this.renderCloseButton(t)),
            (e.message = t),
            t.placement.includes('top-') ? this.insertAdjacentElement('beforeend', e) : this.insertAdjacentElement('afterbegin', e);
        }
      });
    }
    connectedCallback() {
      this.offId = hi.on('toast:action', this.listener);
    }
    disconnectedCallback() {
      hi.off(this.offId);
    }
  }
  const Vo = 20;
  class aa extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'timeId', -1);
      o(this, 'animatedIn', _());
      o(this, 'animatedOut', _());
      o(this, 'message', null);
      o(this, 'prevTimestamp', null);
      o(this, 'delayFromMouseEnter', 0);
      o(this, 'closeEl', null);
      o(this, 'unmounted', !1);
      o(this, 'destroy', () => {
        clearTimeout(this.timeId),
          this.animatedIn.off(),
          this.animatedOut.off(),
          this.removeEventListener('mouseenter', this.handleMouseEnter),
          this.removeEventListener('mouseleave', this.handleMouseLeave),
          this.closeEl && this.closeEl.removeEventListener('click', this.handleCloseClick);
      });
      o(this, 'getHeight', () => {
        var l, h;
        const { placement: t } = this.message,
          { marginTop: e, marginBottom: s } = window.getComputedStyle(this),
          r = (l = parseInt(e)) != null ? l : 0,
          a = (h = parseInt(s)) != null ? h : 0;
        return t.includes('top-') ? this.offsetHeight + a : this.offsetHeight + r;
      });
      o(this, 'getValueY', (t) => {
        const { placement: e } = this.message;
        return (e.includes('top-') ? -1 : 1) * (t + Vo);
      });
      o(this, 'handleMouseEnter', () => {
        (this.delayFromMouseEnter = Math.max(0, this.delayFromMouseEnter - (Date.now() - this.prevTimestamp))), clearTimeout(this.timeId);
      });
      o(this, 'handleMouseLeave', () => {
        (this.timeId = window.setTimeout(() => {
          this.unmount();
        }, this.delayFromMouseEnter)),
          (this.prevTimestamp = Date.now());
      });
      o(this, 'handleCloseClick', () => {
        this.unmount();
      });
      o(this, 'setStyles', () => {
        var r, a;
        const { closeButtonPlacement: t } = this.message,
          { className: e, style: s } = this.message;
        if ((e && (this.className = e), Object.assign(this.style, s), this.closeEl)) {
          const l =
            this.closeEl.offsetWidth +
            ((r = parseInt(window.getComputedStyle(this.closeEl).marginRight)) != null ? r : 0) +
            ((a = parseInt(window.getComputedStyle(this.closeEl).marginLeft)) != null ? a : 0);
          t.includes('left') ? (this.style.paddingLeft = `${l}px`) : (this.style.paddingRight = `${l}px`);
        }
      });
      o(this, 'setCssVariables', () => {
        for (const t in this.message) {
          const e = this.message[t];
          e != null && !/onShow|onHide|className|closeButtonClassName|style|content/g.test(t) && this.style.setProperty(`--xo-${Yt.camelToKebab(t)}`, ` ${JSON.stringify(e)}`);
        }
      });
      o(this, 'mount', () => {
        const { duration: t, onShow: e, easing: s } = this.message,
          r = this.getHeight(),
          a = this.getValueY(r);
        (this.closeEl = this.querySelector(c.ToastCloseButton)),
          (this.prevTimestamp = Date.now()),
          e(this),
          this.setStyles(),
          this.setCssVariables(),
          this.closeEl && this.closeEl.addEventListener('click', this.handleCloseClick),
          this.addEventListener('mouseenter', this.handleMouseEnter),
          this.addEventListener('mouseleave', this.handleMouseLeave),
          this.animatedIn({
            from: a,
            to: 0,
            duration: t,
            easing: H[s],
            onUpdate: (l) => {
              this.style.transform = `translateY(${l}px)`;
            },
          }),
          (this.unmounted = !1);
      });
      o(this, 'unmount', () => {
        const { duration: t, placement: e, onHide: s, easing: r, name: a } = this.message,
          l = this.getHeight();
        this.unmounted ||
          ((this.unmounted = !0),
          (this.style.pointerEvents = 'none'),
          this.animatedOut({
            from: 0,
            to: 1,
            duration: t,
            onUpdate: (h) => {
              const d = D({ value: h, inputRange: [0, 1], outputRange: [0, -l], easing: H[r] }),
                u = D({ value: h, inputRange: [0, 1], outputRange: [0, Vo], easing: H[r] });
              e.includes('top-')
                ? ((this.style.marginTop = `${d}px`), (this.style.transform = `translateY(-${u}px)`))
                : ((this.style.marginBottom = `${d}px`), (this.style.transform = `translateY(${u}px)`));
            },
            onEnd: () => {
              if ((this.style.removeProperty('pointer-events'), a)) {
                const h = document.querySelector(`${c.ToastPlaceholder}[xo-name="${a}"]`),
                  d = this.querySelector(c.ToastCloseButton);
                h &&
                  (this.style.removeProperty('margin-top'),
                  this.style.removeProperty('margin-bottom'),
                  this.style.removeProperty('transform'),
                  h.after(this),
                  h.remove(),
                  d == null || d.remove(),
                  this.destroy());
              } else this.remove();
              s(this);
            },
          }));
      });
    }
    connectedCallback() {
      if (this.message) {
        const { delay: t } = this.message;
        (this.delayFromMouseEnter = t),
          this.mount(),
          (this.timeId = window.setTimeout(() => {
            this.unmount();
          }, t));
      }
    }
    disconnectedCallback() {
      this.destroy();
    }
  }
  const rd = '';
  (window.xoToast = be), B({ [c.ToastPortal]: ra, [c.Toast]: aa });
  const re = new Tt('xo-popover'),
    zo = {
      none: K.none,
      zoom: K.zoom(!0),
      fade: K.move(),
      'fade-up': K.move({ dy: 50 }),
      'fade-down': K.move({ dy: -50 }),
      'fade-left': K.move({ dx: 50 }),
      'fade-right': K.move({ dx: -50 }),
    };
  function di(n) {
    const i = n.closest(c.Modal),
      t = n.closest(c.Sticky);
    return typeof HTMLDialogElement == 'function' && !i && !t;
  }
  const qi = class extends li {
    constructor() {
      super(...arguments);
      o(this, 'animated', _());
      o(this, 'canClose', !1);
      o(this, '_options');
      o(this, 'setOptions', () => {
        var s;
        const t = $(this, {
            pick: [
              'xoName',
              'xoAnimate',
              'xoEasing',
              'xoDuration',
              'xoPlacement',
              'xoPortal',
              'xoDisabled',
              'xoBreakpoints',
              'xoAutofocus',
              'xoSectionSelect',
              'xoModalScrollSelector',
              'xoOffset',
            ],
            types: {
              xoName: 'string',
              xoAnimate: 'string',
              xoEasing: 'string',
              xoDuration: 'number',
              xoPlacement: 'string',
              xoPortal: 'boolean',
              xoDisabled: 'boolean',
              xoBreakpoints: 'object',
              xoAutofocus: 'boolean',
              xoSectionSelect: 'boolean',
              xoModalScrollSelector: 'string',
              xoOffset: 'number',
            },
          }),
          e = Dt((s = t.xoBreakpoints) != null ? s : {});
        this.options = JSON.parse(
          JSON.stringify({
            ...t,
            xoDisabled: (e == null ? void 0 : e.disabled) != null ? e.disabled : t.xoDisabled,
            xoDuration: (e == null ? void 0 : e.duration) != null ? e.duration : t.xoDuration,
            xoEasing: (e == null ? void 0 : e.easing) != null ? e.easing : t.xoEasing,
            xoAnimate: (e == null ? void 0 : e.animate) != null ? e.animate : t.xoAnimate,
            xoPlacement: (e == null ? void 0 : e.placement) != null ? e.placement : t.xoPlacement,
            xoOffset: (e == null ? void 0 : e.offset) != null ? e.offset : t.xoOffset,
          }),
        );
      });
      o(this, 'handleCalTopLeft', () => {
        var a, l;
        const { xoPlacement: t, xoOffset: e, xoModalScrollSelector: s } = this.options,
          { triggerElement: r } = this.state;
        if (r) {
          const h = ko(r, { placement: t, offset: e, element: this }),
            d = this.closest(c.Modal),
            u = this.closest(`${c.Sticky}:not([xo-disabled])`);
          if (d) {
            const p = (a = d.shadowRoot) == null ? void 0 : a.querySelector(c.ModalContent),
              x = (s ? d.querySelector(s) : null) || p,
              { left: y, top: b } = X(x);
            (this.style.top = `${h.top - b}px`), (this.style.left = `${h.left - y}px`);
          } else if (u) {
            const p = (l = u.shadowRoot) == null ? void 0 : l.querySelector(c.StickyContent),
              { left: m, top: x } = X(p);
            (this.style.top = `${h.top - x}px`), (this.style.left = `${h.left - m}px`);
          } else (this.style.top = `${h.top - window.scrollY}px`), (this.style.left = `${h.left}px`);
          this.style.setProperty('--xo-popover-trigger-width', `${r.offsetWidth}px`);
        }
      });
      o(this, 'subscribe', () => {
        const { xoDuration: t, xoDisabled: e } = this.options,
          { triggerElement: s, isOpen: r } = this.state;
        e || (this.handleCalTopLeft(), s && this.animated({ from: r ? 0 : 1, to: r ? 1 : 0, duration: t }));
      });
      o(this, 'handleOutsideClick', (t) => {
        const { xoDuration: e, xoName: s, xoDisabled: r } = this.options,
          { isOpen: a, triggerElement: l } = this.state,
          h = t.target;
        this.canClose && a && !r && !this.contains(h) && !(l != null && l.contains(h)) && (this.animated({ from: 1, to: 0, duration: e }), s && re.close(s, 'empty'));
      });
      o(this, 'resetStyles', () => {
        const { xoDisabled: t } = this.options;
        t &&
          (this.style.removeProperty('top'),
          this.style.removeProperty('left'),
          this.style.removeProperty('opacity'),
          this.style.removeProperty('visibility'),
          this.style.removeProperty('transform'));
      });
      o(
        this,
        'handleResize',
        st(() => {
          this.setOptions(), this.resetStyles(), this.handleCalTopLeft(), this.componentUnmount(), this.componentMount();
        }, 500),
      );
      o(this, 'setCurrentDisabled', () => {
        const { xoDisabled: t } = this.options;
        f.set(this, 'xo-current-disabled', t);
      });
      o(this, 'componentOpen', () => {
        const { xoPortal: t } = this.options;
        t && di(this) && ii(this);
      });
      o(this, 'componentClose', () => {
        const { xoDuration: t } = this.options;
        this.animated.getValue() > 0 && this.animated.getValue() < 1 && (this.animated({ from: 1, to: 0, duration: t }), this.style.removeProperty('pointer-events'));
      });
      o(this, 'componentBeforeMount', () => {
        this.setOptions();
      });
      o(this, 'componentMount', async () => {
        const { xoName: t, xoAnimate: e, xoEasing: s, xoPortal: r, xoBreakpoints: a, xoModalScrollSelector: l } = this.options;
        W(this.componentName, 'xo-name', t),
          r && di(this) && this.setAttribute('popover', t),
          this.setCurrentDisabled(),
          this.setCssVariables(),
          a &&
            E(ft(a).sort(), (u) => {
              const p = a[u];
              this.setCssVariables(Number(u), p);
            });
        const h = this.closest(c.Modal),
          d = this.closest(c.Sticky);
        h || d ? (this.style.position = 'absolute') : (this.style.position = 'fixed'),
          document.addEventListener('click', this.handleOutsideClick),
          this.animated.onUpdate((u) => {
            const { isOpen: p } = this.state;
            (p ? u === 1 : u === 0) ? this.style.removeProperty('pointer-events') : (this.style.pointerEvents = 'none'),
              zo[e] && zo[e](this, { isOpen: p, easing: H[s], value: u }),
              (this.canClose = u === 1);
          }),
          this.animated.onEnd(() => {
            const { isOpen: u } = this.state;
            !u && r && di(this) && qe(this);
          }),
          window.addEventListener('resize', this.handleResize),
          h ? ((l && h.querySelector(l)) || window).addEventListener('scroll', this.handleCalTopLeft) : window.addEventListener('scroll', this.handleCalTopLeft);
      });
      o(this, 'componentUnmount', () => {
        const { xoModalScrollSelector: t } = this.options;
        this.animated.off(), document.removeEventListener('click', this.handleOutsideClick), window.removeEventListener('resize', this.handleResize);
        const e = this.closest(c.Modal);
        e ? ((t && e.querySelector(t)) || window).removeEventListener('scroll', this.handleCalTopLeft) : window.removeEventListener('scroll', this.handleCalTopLeft);
      });
    }
    static get observedAttributes() {
      return ['xo-placement', 'xo-offset', 'xo-breakpoints'];
    }
    get stateName() {
      return 'xo-popover';
    }
    get componentName() {
      return c.Popover;
    }
    get options() {
      return { ...qi.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    async attributeChangedCallback(t, e, s) {
      e !== s && (await P(100), this.setOptions(), this.resetStyles(), this.handleCalTopLeft());
    }
  };
  let je = qi;
  o(je, 'defaultOptions', {
    xoName: null,
    xoAnimate: 'fade-up',
    xoEasing: 'decay',
    xoDuration: 300,
    xoPlacement: 'bottom-center',
    xoPortal: !1,
    xoOffset: 10,
    xoDisabled: !1,
    xoBreakpoints: {},
    xoAutofocus: !1,
  });
  const Vs = class extends fe {
    constructor() {
      super(...arguments);
      o(this, 'componentTrigger', () => {
        const { xoName: t, xoType: e } = this.options,
          { isOpen: s } = this.state;
        W(this.componentName, 'xo-name', t),
          this.setState((r) => ({ ...r, [t]: { ...r[t], triggerElement: s ? this : r[t].triggerElement, eventType: e } }))(`${this.componentName}/setTriggerElement`);
      });
    }
    get stateName() {
      return 'xo-popover';
    }
    get componentName() {
      return c.PopoverTrigger;
    }
    get eventType() {
      return this.options.xoType;
    }
    get actionType() {
      return 'toggle';
    }
    get options() {
      const t = $(this, { pick: ['xoName', 'xoType'], types: { xoName: 'string', xoType: 'string' } }),
        e = this.closest('[xo-name]');
      if (e) {
        const s = $(e, { pick: ['xoName'], types: { xoName: 'string' } });
        return { ...Vs.defaultOptions, ...s, ...t };
      }
      return { ...Vs.defaultOptions, ...t };
    }
  };
  let Qe = Vs;
  o(Qe, 'defaultOptions', { xoName: null, xoType: 'click' }), g.create('xo-popover', { initialState: { trigger: {}, data: {} } });
  const ad = '';
  function Ot(n, i, t, e) {
    var s = arguments.length,
      r = s < 3 ? i : e === null ? (e = Object.getOwnPropertyDescriptor(i, t)) : e,
      a;
    if (typeof Reflect == 'object' && typeof Reflect.decorate == 'function') r = Reflect.decorate(n, i, t, e);
    else for (var l = n.length - 1; l >= 0; l--) (a = n[l]) && (r = (s < 3 ? a(r) : s > 3 ? a(i, t, r) : a(i, t)) || r);
    return s > 3 && r && Object.defineProperty(i, t, r), r;
  }
  function Bo(n, i) {
    if (typeof Reflect == 'object' && typeof Reflect.metadata == 'function') return Reflect.metadata(n, i);
  }
  typeof SuppressedError == 'function' && SuppressedError;
  let _o =
    ((Ae = class extends Et {
      constructor() {
        super();
        o(this, 'handleToggle', (t) => {
          t.target.closest(c.BuilderPopoverContent) || this.setState({ isOpen: !this.state.isOpen });
        });
        o(this, 'handleDocumentClick', (t) => {
          const e = t.target;
          this.contains(e) || this.setState({ isOpen: !1 });
        });
        o(this, 'bindEvent', () => {
          const { xoType: t } = this.props;
          t === 'click' && (this.addEventListener('click', this.handleToggle), document.addEventListener('click', this.handleDocumentClick));
        });
        o(this, 'addCssVars', () => {
          const { xoDuration: t } = this.props;
          this.style.setProperty('--xo-popover-duration', `${t}ms`);
        });
        this.state = { isOpen: !1 };
      }
      mount() {
        this.addCssVars(), this.bindEvent();
      }
      unmount() {
        this.removeEventListener('click', this.handleToggle);
      }
      stateUpdate(t) {
        if (t.isOpen !== this.state.isOpen) {
          const e = this.querySelector(c.BuilderPopoverContent);
          f.set(this, 'xo-open', this.state.isOpen), e && f.set(e, 'xo-open', this.state.isOpen);
        }
      }
      propUpdate({ name: t, prevProp: e, nextProp: s }) {
        t === 'xoDuration' && e !== s && this.addCssVars(), t === 'xoType' && e !== s && (this.removeEventListener('click', this.handleToggle), this.bindEvent());
      }
    }),
    o(Ae, 'propTypes', { xoAnimate: 'string', xoDuration: 'number', xoPlacement: 'string', xoType: 'string' }),
    o(Ae, 'defaultProps', { xoType: 'click', xoPlacement: 'bottom-center', xoAnimate: 'fade-up', xoDuration: 300 }),
    o(Ae, 'observedProps', ['xoType', 'xoDuration']),
    Ae);
  _o = Ot([Nt(c.BuilderPopover), Bo('design:paramtypes', [])], _o);
  const ld = '';
  (window.xoPopover = re), B({ [c.Popover]: je, [c.PopoverTrigger]: Qe });
  const Vi = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'contentEl', null);
      o(this, '_options');
      o(this, 'setOptions', () => {
        this.options = $(this, {
          pick: ['xoTitle', 'xoAnimate', 'xoDuration', 'xoPlacement', 'xoPortalClass'],
          types: { xoTitle: 'string', xoAnimate: 'string', xoDuration: 'number', xoPlacement: 'string', xoPortalClass: 'string' },
        });
      });
      o(this, 'handleShow', async () => {
        window.removeEventListener('scroll', this.handleHide, !1),
          window.addEventListener('scroll', this.handleHide, !1),
          this.contentEl || ((this.contentEl = this.createPortal()), document.body.appendChild(this.contentEl));
        const { xoPlacement: t, xoAnimate: e, xoDuration: s, xoOffset: r, xoTitle: a, xoPortalClass: l } = this.options;
        (this.contentEl.innerHTML = a),
          this.contentEl.style.removeProperty('transition-duration'),
          this.contentEl.setAttribute('xo-placement', t),
          this.contentEl.setAttribute('xo-animate', e),
          l && this.contentEl.classList.add(l);
        const h = ko(this, { placement: t, offset: r, element: this.contentEl }),
          d = `${h.top - window.scrollY}px`,
          u = `${h.left}px`;
        this.contentEl.style.top !== d && (this.contentEl.style.top = d),
          this.contentEl.style.left !== u && (this.contentEl.style.left = u),
          await P(0),
          (this.contentEl.style.transitionDuration = `${e ? s : 0}ms`),
          f.set(this.contentEl, 'xo-active', !0);
      });
      o(this, 'handleHide', async () => {
        this.contentEl && f.set(this.contentEl, 'xo-active', !1);
      });
      o(this, 'handleTooltip', (t) => {
        this.contains(t.target) || this.handleHide();
      });
      o(this, 'createPortal', () => document.createElement(c.TooltipContent));
    }
    get options() {
      return { ...Vi.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    connectedCallback() {
      this.setOptions(), this.addEventListener('mouseenter', this.handleShow, !1), window.addEventListener('mousemove', this.handleTooltip, !1);
    }
    disconnectedCallback() {
      window.removeEventListener('mousemove', this.handleTooltip, !1),
        window.removeEventListener('scroll', this.handleHide, !1),
        this.removeEventListener('mouseenter', this.handleShow, !1);
    }
  };
  let Ze = Vi;
  o(Ze, 'defaultOptions', { xoTitle: '', xoAnimate: 'fade-down', xoDuration: 400, xoPlacement: 'top-center', xoPortalClass: '', xoOffset: 10 });
  const cd = '';
  B({ [c.Tooltip]: Ze });
  class la {
    constructor() {
      o(this, 'stateName', 'xo-collapse');
      o(this, 'toggle', (i) => {
        g.set(this.stateName, (t) => ({ ...t, [i]: { ...t[i], isOpen: !t[i].isOpen } }))(`${this.stateName}/toggle`);
      });
      o(this, 'open', (i) => {
        g.set(this.stateName, (t) => ({ ...t, [i]: { ...t[i], isOpen: !0 } }))(`${this.stateName}/open`);
      });
      o(this, 'close', (i) => {
        g.set(this.stateName, (t) => ({ ...t, [i]: { ...t[i], isOpen: !1 } }))(`${this.stateName}/close`);
      });
    }
  }
  const Ke = new la();
  function ye(n) {
    return n && n.tagName.toLowerCase() === c.CollapseProvider;
  }
  function ca(n) {
    return n && n.tagName.toLowerCase() === c.CollapseTrigger;
  }
  const Pe = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'animated', _());
      o(this, 'unsubscribe', null);
      o(this, 'frameId', -1);
      o(this, 'clear', () => {});
      o(this, 'initialized', !1);
      o(this, 'prevIsOpen', !1);
      o(this, '_options');
      o(this, 'componentOpen', () => {
        const { xoDuration: t, xoEasing: e } = this.options,
          s = this.scrollHeight;
        this.animated({
          from: 0,
          to: s,
          duration: t,
          easing: H[e],
          onUpdate: (r) => {
            s === 0 ? (this.style.height = 'auto') : (this.style.height = `${r}px`);
          },
          onEnd: () => {
            this.style.height = 'auto';
          },
        });
      });
      o(this, 'componentClose', () => {
        const { xoDuration: t, xoEasing: e } = this.options,
          s = this.scrollHeight;
        this.animated({
          from: s,
          to: 0,
          duration: t,
          easing: H[e],
          onUpdate: (r) => {
            this.style.height = `${r}px`;
          },
        });
      });
      o(this, 'listener', (t) => {
        const { xoName: e } = this.options;
        if ((W(this.componentName, 'xo-name', e), t[e])) {
          const { isOpen: s } = t[e];
          this.initialized &&
            s !== this.prevIsOpen &&
            (s ? (f.set(this, 'xo-active', !0), this.componentOpen()) : (f.set(this, 'xo-active', !1), this.componentClose()), (this.prevIsOpen = s));
        }
      });
      o(this, 'setOptions', () => {
        const t = $(this, { pick: ['xoName', 'xoDuration', 'xoEasing'], types: { xoName: 'string', xoDuration: 'number', xoEasing: 'string' } });
        if (ye(this.providerElement) && ca(this.triggerElement)) {
          const e = { xoName: this.triggerElement.xoNameProp, xoDuration: Number(this.providerElement.getAttribute('xo-duration') || 300) };
          this.options = { ...Pe.defaultOptions, ...e, ...t };
        } else this.options = { ...Pe.defaultOptions, ...t };
      });
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    get componentName() {
      return c.Collapse;
    }
    get options() {
      return { ...Pe.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    get providerElement() {
      return this.closest(c.CollapseProvider);
    }
    get triggerElement() {
      return this.previousElementSibling;
    }
    async connectedCallback() {
      this.setOptions();
      const { xoName: t } = this.options;
      W(this.componentName, 'xo-name', t),
        (this.initialized = !0),
        f.get(this, 'xo-active') && (await P(), Ke.open(t)),
        (this.unsubscribe = g.subscribe('xo-collapse', this.listener));
    }
    attributeChangedCallback(t, e, s) {
      if (t === 'xo-observed' && e !== s) {
        this.setOptions();
        const r = f.get(this, 'xo-active');
        r ? (this.style.height = 'auto') : this.style.removeProperty('height');
        const { xoName: a } = this.options;
        W(this.componentName, 'xo-name', a), g.set('xo-collapse', (l) => ({ ...l, [a]: { ...(l == null ? void 0 : l[a]), isOpen: r } }));
      }
    }
    disconnectedCallback() {
      var t;
      this.animated.off(), (t = this.unsubscribe) == null || t.call(this), this.clear(), cancelAnimationFrame(this.frameId);
    }
  };
  let Je = Pe;
  o(Je, 'defaultOptions', { xoName: null, xoDuration: 300, xoEasing: 'decay' });
  let Wo = 0;
  const Te = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'xoNameProp', '');
      o(this, '_options');
      o(this, 'handleCollapseHasProvider', () => {
        const { xoName: t } = this.options;
        ye(this.providerElement) || W(this.componentName, 'xo-name', t);
        const e = Array.from(this.providerElement.querySelectorAll(c.CollapseTrigger));
        E(e, (s) => {
          const r = s.getAttribute('xo-name') || s.xoNameProp;
          this !== s || this.hasAttribute('xo-active') ? f.set(s, 'xo-active', !1) : f.set(s, 'xo-active', !0),
            r &&
              g.set('xo-collapse', (a) => {
                var l;
                return { ...a, [r]: { ...(a == null ? void 0 : a[r]), isOpen: this === s ? !((l = a == null ? void 0 : a[r]) != null && l.isOpen) : !1 } };
              });
        });
      });
      o(this, 'handleCollapse', () => {
        const { xoName: t } = this.options;
        ye(this.providerElement) || W(this.componentName, 'xo-name', t), f.get(this, 'xo-active') ? f.set(this, 'xo-active', !1) : f.set(this, 'xo-active', !0), Ke.toggle(t);
      });
      o(this, 'handleClick', () => {
        var a, l;
        const { xoName: t } = this.options,
          s =
            Number((a = this.providerElement) == null ? void 0 : a.getAttribute('xo-duration')) ||
            Number((l = document.querySelector(`${c.Collapse}[xo-name="${t}"]`)) == null ? void 0 : l.getAttribute('xo-duration')) ||
            300,
          r = Date.now();
        r - Wo < s || ((Wo = r), ye(this.providerElement) ? this.handleCollapseHasProvider() : this.handleCollapse());
      });
    }
    get componentName() {
      return c.CollapseTrigger;
    }
    get options() {
      return { ...Te.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    setOptions() {
      const t = $(this, { pick: ['xoName'], types: { xoName: 'string' } });
      if (ye(this.providerElement)) {
        const e = Array.from(this.providerElement.querySelectorAll(c.CollapseTrigger)).indexOf(this),
          s = { xoName: `${this.providerElement.xoName}-${e}` };
        this.options = { ...Te.defaultOptions, ...s, ...t };
      } else this.options = { ...Te.defaultOptions, ...t };
    }
    get providerElement() {
      return this.closest(c.CollapseProvider);
    }
    connectedCallback() {
      var e;
      if ((this.setOptions(), (e = this.providerElement) != null && e.xoName)) {
        const s = Array.from(this.providerElement.querySelectorAll(c.CollapseTrigger)).indexOf(this);
        this.xoNameProp = `${this.providerElement.xoName}-${s}`;
      }
      const { xoName: t } = this.options;
      W(this.componentName, 'xo-name', t),
        g.set('xo-collapse', (s) => {
          var r, a;
          return { ...s, [t]: { ...(s == null ? void 0 : s[t]), isOpen: (a = (r = s == null ? void 0 : s[t]) == null ? void 0 : r.isOpen) != null ? a : !1 } };
        }),
        this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }
  };
  let ts = Te;
  o(ts, 'defaultOptions', { xoName: null });
  let Uo = 0;
  class ha extends HTMLElement {
    constructor() {
      super();
      o(this, 'xoName');
      Uo++, (this.xoName = `collapse-${Uo}`);
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    attributeChangedCallback(t, e, s) {
      if (t === 'xo-observed' && e !== s) {
        const r = Array.from(this.querySelectorAll(c.CollapseTrigger)),
          a = Array.from(this.querySelectorAll(c.Collapse));
        E([...r, ...a], (l) => {
          l.setAttribute('xo-observed', s);
        });
      }
    }
  }
  g.create('xo-collapse', { initialState: {} });
  const hd = '';
  (window.xoCollapse = Ke), B({ [c.CollapseProvider]: ha, [c.CollapseTrigger]: ts, [c.Collapse]: Je });
  function Xo(n) {
    return n && n.tagName.toLowerCase() === c.Tabs;
  }
  const zi = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', null);
      o(this, 'listener', (t) => {
        const { xoName: e } = this.options;
        if ((W(this.componentName, 'xo-name', e), t[this.providerElement.xoName])) {
          const { name: s } = t[this.providerElement.xoName];
          f.set(this, 'xo-active', s === e);
        }
      });
    }
    get componentName() {
      return c.TabsPane;
    }
    get providerElement() {
      return this.closest(c.Tabs);
    }
    get options() {
      const t = $(this, { pick: ['xoName'], types: { xoName: 'string' } });
      return { ...zi.defaultOptions, ...t };
    }
    connectedCallback() {
      const { xoName: t } = this.options;
      W(this.componentName, 'xo-name', t),
        Xo(this.providerElement) || bt(`The ${this.componentName} component must be a child of the ${c.Tabs} component`),
        (this.unsubscribe = g.subscribe('xo-tabs', this.listener));
    }
    disconnectedCallback() {
      var t;
      (t = this.unsubscribe) == null || t.call(this);
    }
  };
  let es = zi;
  o(es, 'defaultOptions', { xoName: null });
  function da() {
    g.create('xo-tabs', { initialState: {} });
  }
  function ui(n, { name: i, width: t = 0, left: e }) {
    g.set('xo-tabs', (s) => {
      var r, a, l, h;
      return {
        ...s,
        [n]: {
          ...s[n],
          name: i,
          width: t == null ? ((a = (r = s[n]) == null ? void 0 : r.width) != null ? a : 0) : t,
          left: e == null ? ((h = (l = s[n]) == null ? void 0 : l.left) != null ? h : 0) : e,
        },
      };
    });
  }
  const Yo = { active: ui },
    Bi = class extends HTMLElement {
      constructor() {
        super(...arguments);
        o(this, 'unsubscribe', null);
        o(this, 'providerName', null);
        o(this, '_options');
        o(this, 'setOptions', () => {
          this.options = $(this, { pick: ['xoName', 'xoTrigger', 'xoActive'], types: { xoName: 'string', xoTrigger: 'string', xoActive: 'boolean' } });
        });
        o(this, 'listener', (t) => {
          const { xoName: e } = this.options;
          if ((W(this.componentName, 'xo-name', e), this.providerName && t[this.providerName])) {
            const { name: s } = t[this.providerName];
            f.set(this, 'xo-active', s === e);
          }
        });
        o(this, 'handleActive', async (t) => {
          const { xoName: e } = this.options;
          if ((W(this.componentName, 'xo-name', e), await P(0), this.providerName))
            if (this.providerElement) {
              const s = this.providerElement.querySelector(c.TabsActive),
                r = s == null ? void 0 : s.parentElement,
                a = r ? X(this).left - X(r).left : 0;
              r && window.getComputedStyle(r).position === 'static' && (r.style.position = 'relative'), ui(this.providerName, { name: e, left: a, width: this.offsetWidth });
            } else {
              const s = Array.from(document.querySelectorAll(c.ListPortal));
              E(s, (r) => {
                if (t && t.target instanceof HTMLElement && r.contains(t.target)) {
                  const a = t.currentTarget,
                    l = setTimeout(() => {
                      this.providerName && ui(this.providerName, { name: e, width: a.offsetWidth, left: a.offsetLeft }), clearTimeout(l);
                    }, 0);
                }
              });
            }
        });
        o(this, 'addTrigger', () => {
          this.options.xoTrigger === 'hover' && !U.any ? this.addEventListener('mouseenter', this.handleActive) : this.addEventListener('click', this.handleActive);
        });
        o(this, 'removeTrigger', () => {
          this.removeEventListener('mouseenter', this.handleActive), this.removeEventListener('click', this.handleActive);
        });
      }
      get componentName() {
        return c.TabsTrigger;
      }
      get providerElement() {
        return this.closest(c.Tabs);
      }
      get options() {
        return { ...Bi.defaultOptions, ...this._options };
      }
      set options(t) {
        this._options = t;
      }
      static get observedAttributes() {
        return ['xo-observed'];
      }
      connectedCallback() {
        var t;
        this.setOptions(),
          (t = this.providerElement) != null && t.xoName && (this.providerName = this.providerElement.xoName),
          f.get(this, 'xo-active') && this.handleActive(),
          (this.unsubscribe = g.subscribe('xo-tabs', this.listener)),
          this.addTrigger();
      }
      disconnectedCallback() {
        var t;
        this.removeTrigger(), (t = this.unsubscribe) == null || t.call(this);
      }
      async attributeChangedCallback(t, e, s) {
        var r;
        t === 'xo-observed' &&
          e !== s &&
          (await P(100),
          this.setOptions(),
          (r = this.providerElement) != null && r.xoName && (this.providerName = this.providerElement.xoName),
          f.get(this, 'xo-active') && this.handleActive(),
          this.removeTrigger(),
          this.addTrigger(),
          this.listener(g.get('xo-tabs')));
      }
    };
  let ss = Bi;
  o(ss, 'defaultOptions', { xoName: null, xoTrigger: 'click' });
  let Go = 0;
  class ua extends HTMLElement {
    constructor() {
      super();
      o(this, 'xoName');
      Go++, (this.xoName = `tabs-${Go}`);
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    attributeChangedCallback(t, e, s) {
      if (t === 'xo-observed' && e != null && e !== s) {
        const r = Array.from(this.querySelectorAll(c.TabsActive)),
          a = Array.from(this.querySelectorAll(c.TabsTrigger)),
          l = Array.from(this.querySelectorAll(c.TabsPane));
        E([...r, ...a, ...l], (h) => {
          h.setAttribute('xo-observed', s);
        });
      }
    }
  }
  const _i = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'animated', _());
      o(this, 'prevLeft', 0);
      o(this, 'prevWidth', 0);
      o(this, 'initialized', !1);
      o(this, '_options');
      o(this, 'setOptions', () => {
        this.options = $(this, { pick: ['xoDuration', 'xoEasing'], types: { xoDuration: 'number', xoEasing: 'string' } });
      });
      o(this, 'listener', (t) => {
        const { xoDuration: e, xoEasing: s } = this.options;
        if (Xo(this.providerElement) && t[this.providerElement.xoName]) {
          const { width: r = 0, left: a = 0 } = t[this.providerElement.xoName];
          if (!this.initialized) (this.style.width = `${r}px`), (this.style.transform = `translateX(${a}px)`), (this.prevLeft = a), (this.prevWidth = r);
          else {
            const h = a + 100;
            this.animated.off(),
              this.animated({
                from: this.prevLeft,
                to: h,
                duration: e,
                onUpdate: (d) => {
                  const u = D({ value: d, inputRange: [this.prevLeft, h], outputRange: [this.prevWidth, r], reverseEasing: this.prevLeft > a, easing: H[s] }),
                    p = D({ value: d, inputRange: [this.prevLeft, h], outputRange: [this.prevLeft, a], reverseEasing: this.prevLeft > a, easing: H[s] });
                  (this.style.width = `${u}px`), (this.style.transform = `translateX(${p}px)`);
                },
                onEnd: () => {
                  (this.prevLeft = a), (this.prevWidth = r);
                },
              });
          }
          this.initialized = !0;
        }
      });
    }
    get options() {
      return { ..._i.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    get providerElement() {
      return this.closest(c.Tabs);
    }
    connectedCallback() {
      this.setOptions(), (this.unsubscribe = g.subscribe('xo-tabs', this.listener));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.animated.off();
    }
    attributeChangedCallback(t, e, s) {
      t === 'xo-observed' && e !== s && (this.setOptions(), (this.initialized = !1), this.listener(g.get('xo-tabs') || {}));
    }
  };
  let is = _i;
  o(is, 'defaultOptions', { xoDuration: 200, xoEasing: 'ease' });
  const dd = '';
  da(), (window.xoTabs = Yo), B({ [c.Tabs]: ua, [c.TabsActive]: is, [c.TabsTrigger]: ss, [c.TabsPane]: es });
  class pa extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'keyframes', {});
      o(this, 'parallax', null);
      o(this, 'beautyAttr', () => {
        const t = this.getAttribute('xo-breakpoints'),
          e = this.getAttribute('xo-keyframes');
        t && this.setAttribute('xo-breakpoints', t.replace(/\s+/g, ' ').trim()), e && this.setAttribute('xo-keyframes', e.replace(/\s+/g, ' ').trim());
      });
      o(this, 'init', () => {
        const t = this.closest(`${c.Parallax}, [${c.Parallax}]`);
        if (
          (this.getAttribute('xo-keyframes') || bt(`The ${c.ParallaxScroll} component must have the "xo-keyframes" attribute`),
          t && (t.tagName.toLowerCase() === c.Parallax || t.hasAttribute(c.Parallax)))
        ) {
          const { xoLerpEase: e = 0.08, xoBackfaceVisibility: s = 'hidden' } = this.getOptions();
          s === 'hidden' && (this.style.backfaceVisibility = 'hidden'),
            this.setKeyframes(),
            (this.parallax = Be({ lerpEase: e })),
            this.beautyAttr(),
            this.parallax.add(this, { from: () => X(t).top - window.innerHeight, to: () => X(t).top + t.offsetHeight, keyframes: this.keyframes }).run();
        }
      });
      o(
        this,
        'handleResize',
        st(
          me('x', () => {
            var t;
            (t = this.parallax) == null || t.destroy(), this.init();
          }),
          500,
        ),
      );
    }
    static get observedAttributes() {
      return ['xo-observed', 'xo-keyframes', 'xo-breakpoints', 'xo-lerp-ease', 'xo-backface-visibility'];
    }
    getOptions() {
      return $(this, {
        pick: ['xoKeyframes', 'xoBreakpoints', 'xoLerpEase', 'xoBackfaceVisibility'],
        types: { xoKeyframes: 'object', xoBreakpoints: 'object', xoLerpEase: 'number', xoBackfaceVisibility: 'string' },
      });
    }
    setKeyframes() {
      var s;
      const { xoKeyframes: t, xoBreakpoints: e } = this.getOptions();
      this.keyframes = (s = Dt(e)) != null ? s : t;
    }
    connectedCallback() {
      this.init(), window.addEventListener('resize', this.handleResize);
    }
    disconnectedCallback() {
      var t;
      (t = this.parallax) == null || t.destroy(), window.removeEventListener('resize', this.handleResize);
    }
    async attributeChangedCallback(t, e, s) {
      (t === 'xo-observed' || t === 'xo-keyframes' || t === 'xo-breakpoints' || t === 'xo-lerp-ease' || t === 'xo-backface-visibility') &&
        e !== s &&
        (await P(100), this.disconnectedCallback(), this.connectedCallback());
    }
  }
  const ma = 1e3 / 60,
    Wi = class extends HTMLElement {
      constructor() {
        super(...arguments);
        o(this, 'shadow', this.attachShadow({ mode: 'open' }));
        o(this, 'providerEl', null);
        o(this, 'targetValueX', 0);
        o(this, 'targetValueY', 0);
        o(this, 'currentValueX', 0);
        o(this, 'currentValueY', 0);
        o(this, 'handleParallax', (t) => {
          var p;
          const { xoStrength: e, xo3d: s } = this.getOptions();
          let r = t / ma;
          const a = Math.round(r);
          a >= 1 && (r = a);
          const l = Number(((p = this.providerEl) == null ? void 0 : p.getAttribute('xo-lerp-ease')) || '0.08'),
            h = jt(this.currentValueX, this.targetValueX, l * r),
            d = jt(this.currentValueY, this.targetValueY, l * r),
            u = this.shadow.querySelector(c.ParallaxHoverInner);
          s
            ? ((u.style.transformStyle = 'preserve-3d'), (u.style.transform = `perspective(2000px) rotateX(${(-d / 4) * e}deg) rotateY(${(h / 4) * e}deg)`))
            : (u.style.transform = `translate3d(${h * e}px, ${d * e}px, 0)`),
            (this.currentValueX = h),
            (this.currentValueY = d);
        });
        o(this, 'handleFrameSyncUpdate', ({ delta: t }) => {
          const e = Math.abs(this.targetValueX - this.currentValueX),
            s = Math.abs(this.targetValueY - this.currentValueY);
          (e < 0.001 && s < 0.001) || this.handleParallax(t);
        });
        o(this, 'setTargetValue', (t, e, s, r, a) => {
          const l = X(this).left + this.offsetWidth / 2,
            h = X(this).top + this.offsetHeight / 2;
          (this.targetValueX = D({ value: t.pageX - e, inputRange: [0, l - e, r], outputRange: [-1, 0, 1] })),
            (this.targetValueY = D({ value: t.pageY - s, inputRange: [0, h - s, a], outputRange: [-1, 0, 1] }));
        });
        o(this, 'handleMouseMove', (t) => {
          const e = X(this.providerEl).left,
            s = X(this.providerEl).top,
            r = this.providerEl.offsetWidth,
            a = this.providerEl.offsetHeight;
          this.setTargetValue(t, e, s, r, a);
        });
        o(this, 'handleMouseLeave', () => {
          const { xoResetPosition: t } = this.getOptions();
          t && ((this.targetValueX = 0), (this.targetValueY = 0));
        });
      }
      static get observedAttributes() {
        return ['xo-observed', 'xo-strength', 'xo-reset-position', 'xo-3d', 'xo-inner-width'];
      }
      getOptions() {
        const t = $(this, {
          pick: ['xoStrength', 'xoResetPosition', 'xo3d', 'xoInnerWidth'],
          types: { xoStrength: 'number', xoResetPosition: 'boolean', xo3d: 'boolean', xoInnerWidth: 'string' },
        });
        return { ...Wi.defaultOptions, ...t };
      }
      connectedCallback() {
        if ((G.remove(this.handleFrameSyncUpdate), G.add(this.handleFrameSyncUpdate, !0), (this.providerEl = this.closest(`${c.Parallax}, [${c.Parallax}]`)), !this.providerEl))
          throw new Error(`The ${c.ParallaxHover} component must be a child of ${c.Parallax}`);
        if (!this.shadow.innerHTML) {
          const { xoInnerWidth: t } = this.getOptions();
          this.shadow.innerHTML = `<${c.ParallaxHoverInner} style="display: block; width: ${t}"><slot></slot></${c.ParallaxHoverInner}>`;
        }
        this.handleParallax((1 / 60) * 1e3),
          this.providerEl.addEventListener('mousemove', this.handleMouseMove),
          this.providerEl.addEventListener('mouseleave', this.handleMouseLeave);
      }
      disconnectedCallback() {
        var t, e;
        G.remove(this.handleFrameSyncUpdate),
          (t = this.providerEl) == null || t.removeEventListener('mousemove', this.handleMouseMove),
          (e = this.providerEl) == null || e.removeEventListener('mouseleave', this.handleMouseLeave);
      }
      async attributeChangedCallback(t, e, s) {
        (t === 'xo-observed' || t === 'xo-strength' || t === 'xo-reset-position' || t === 'xo-3d' || t === 'xo-inner-width') &&
          e !== s &&
          (await P(100), this.disconnectedCallback(), this.connectedCallback());
      }
    };
  let os = Wi;
  o(os, 'defaultOptions', { xoStrength: 100, xoResetPosition: !0, xo3d: !1, xoInnerWidth: 'fit-content' });
  const pd = '';
  B({ [c.ParallaxScroll]: pa, [c.ParallaxHover]: os });
  function fa() {
    g.create('xo-carousel', { initialState: {}, useDeepEqual: !0 });
  }
  function xa(n, i) {
    g.set('xo-carousel', (t) => ({ ...t, [n]: { ...t[n], options: i } }));
  }
  function ga(n, i) {
    g.set('xo-carousel', (t) => ({ ...t, [n]: { ...t[n], thumbnailOptions: i } }));
  }
  function ba(n, i, t) {
    g.set('xo-carousel', (e) => ({ ...e, [n]: { ...e[n], containerWidth: i, containerHeight: t } }));
  }
  function ya(n, i) {
    g.set('xo-carousel', (t) => ({ ...t, [n]: { ...t[n], slideLength: i } }));
  }
  function ns(n, i) {
    g.set('xo-carousel', (t) => {
      var p, m, x, y, b, v, k, A, T, M, L, V, ot, ut, pt, gt, _t;
      const e = (m = (p = t[n]) == null ? void 0 : p.slideLength) != null ? m : 0,
        s = (b = (y = (x = t[n]) == null ? void 0 : x.options) == null ? void 0 : y.xoPerView) != null ? b : 0,
        r = (A = (k = (v = t[n]) == null ? void 0 : v.options) == null ? void 0 : k.xoRewind) != null ? A : !1,
        a =
          ((L = (M = (T = t[n]) == null ? void 0 : T.options) == null ? void 0 : M.xoLoop) != null ? L : !1) &&
          ((ot = (V = t[n]) == null ? void 0 : V.options) == null ? void 0 : ot.xoType) !== 'slide',
        l = (pt = (ut = t[n]) == null ? void 0 : ut.activeIndex) != null ? pt : 0,
        h = (_t = (gt = t[n]) == null ? void 0 : gt.thumbnailActiveIndex) != null ? _t : 0;
      let d = a ? He(l + i, 0, e - s) : Y(l + i, 0, e - s),
        u = Y(h + i, 0, e - 1);
      return r && l === e - s && (d = 0), r && h === e - 1 && (u = 0), { ...t, [n]: { ...t[n], activeIndex: d, thumbnailActiveIndex: u, useAnimated: !0, timestamp: Date.now() } };
    })('xo-carousel/nextSlide');
  }
  function pi(n, i) {
    g.set('xo-carousel', (t) => {
      var d, u, p, m, x, y, b, v, k, A, T, M, L, V, ot;
      const e = (p = (u = (d = t[n]) == null ? void 0 : d.options) == null ? void 0 : u.xoPerView) != null ? p : 0,
        s = (x = (m = t[n]) == null ? void 0 : m.slideLength) != null ? x : e,
        r = (b = (y = t[n]) == null ? void 0 : y.activeIndex) != null ? b : 0,
        a = (A = (k = (v = t[n]) == null ? void 0 : v.options) == null ? void 0 : k.xoRewind) != null ? A : !1;
      let h =
        ((L = (M = (T = t[n]) == null ? void 0 : T.options) == null ? void 0 : M.xoLoop) != null ? L : !1) &&
        ((ot = (V = t[n]) == null ? void 0 : V.options) == null ? void 0 : ot.xoType) !== 'slide'
          ? He(r - i, 0, s - e)
          : Math.max(r - i, 0);
      return a && r === 0 && (h = s - e), { ...t, [n]: { ...t[n], activeIndex: h, thumbnailActiveIndex: h, useAnimated: !0, timestamp: Date.now() } };
    })('xo-carousel/prevSlide');
  }
  function Ft(n, i, t) {
    g.set('xo-carousel', (e) => {
      var h, d, u, p, m;
      const s = (u = (d = (h = e[n]) == null ? void 0 : h.options) == null ? void 0 : d.xoPerView) != null ? u : 0,
        r = (m = (p = e[n]) == null ? void 0 : p.slideLength) != null ? m : s;
      let a = Y(i, 0, r - s),
        l = Y(i, 0, r - 1);
      return { ...e, [n]: { ...e[n], activeIndex: a, thumbnailActiveIndex: l, useAnimated: t, timestamp: Date.now() } };
    })('xo-carousel/goToSlide');
  }
  function Z(n) {
    var i;
    return { activeIndex: 0, thumbnailActiveIndex: 0, ...((i = g.get('xo-carousel')) == null ? void 0 : i[n]) };
  }
  function Ht(n, i, t) {
    return g.subscribe(
      'xo-carousel',
      (e) => i(e[n]),
      (e, s) => (t ? t(e, s) : Pt(e == null ? void 0 : e[n], s == null ? void 0 : s[n])),
    );
  }
  const jo = {
      next: ns,
      prev: pi,
      goTo: (n, i) => {
        const { options: t } = Z(n);
        let e = i;
        t.xoLoop && (e = i + t.xoPerView * 2), Ft(n, e, !0);
      },
    },
    rs = {
      init: (n, i) => {
        n.dispatchEvent(new CustomEvent('xo:carousel:init', { bubbles: !0, detail: i }));
      },
      change: (n, i) => {
        n.dispatchEvent(new CustomEvent('xo:carousel:change', { bubbles: !0, detail: { activeIndex: i } }));
      },
      destroy: (n) => {
        n.dispatchEvent(new CustomEvent('xo:carousel:destroy', { bubbles: !0 }));
      },
      resize: (n, i, t) => {
        n.dispatchEvent(new CustomEvent('xo:carousel:resize', { bubbles: !0, detail: { width: i, height: t } }));
      },
    },
    as = window.navigator.hardwareConcurrency === 4 ? 1e3 : 500;
  function va(n) {
    const i = n.offsetHeight,
      t = getComputedStyle(n),
      e = parseInt(t.marginTop || '0', 10),
      s = parseInt(t.marginBottom || '0', 10),
      { boxShadow: r } = window.getComputedStyle(n),
      [a, l, h] = r.split(' ').reverse(),
      d = parseInt(l || '0', 10) + parseInt(h || '0', 10);
    return i + e + s + d;
  }
  function Ea(n, i) {
    const t = Array.from(n.children),
      e = [...t.slice(0, i * 2), ...t.slice(0, i * 2)],
      s = [...t.slice(-i * 2), ...t.slice(-i * 2)];
    E(e, (r, a) => {
      if (a < i * 2 && r.tagName.toLowerCase() === c.CarouselSlide) {
        const l = r.cloneNode(!0);
        l.removeAttribute('xo-active'), l.removeAttribute('xo-visible'), f.set(l, 'xo-cloned', !0), n.appendChild(l);
      }
    }),
      E(s, (r, a) => {
        if (a >= s.length - i * 2 && r.tagName.toLowerCase() === c.CarouselSlide) {
          const l = r.cloneNode(!0);
          l.removeAttribute('xo-active'), l.removeAttribute('xo-visible'), f.set(l, 'xo-cloned', !0), n.insertBefore(l, t[0]);
        }
      });
  }
  let Qo = 0;
  function Zo(n) {
    Qo = n;
  }
  function Ko() {
    return Qo;
  }
  let Jo = 0;
  const Ui = class extends HTMLElement {
    constructor() {
      super();
      o(this, 'unsubscribe', () => {});
      o(this, 'xoName');
      o(this, '_options');
      o(this, 'prevActiveIndex', -1);
      o(this, 'prevPaginationProgress', 0);
      o(this, 'animated1', _());
      o(this, 'animated2', _());
      o(this, 'resizeObserver', null);
      o(this, 'prevWidth', 0);
      o(this, 'setOptions', () => {
        this.options = $(this, {
          pick: [
            'xoName',
            'xoActiveIndex',
            'xoPerView',
            'xoPerMove',
            'xoGap',
            'xoSpeed',
            'xoEasing',
            'xoOverflow',
            'xoVertical',
            'xoAutoplay',
            'xoHoverPause',
            'xoRewind',
            'xoRtl',
            'xoBreakpoints',
            'xoRenderBullet',
            'xoAutoheight',
            'xoType',
            'xoLoop',
            'xoColumnWidth',
            'xoSnake',
            'xoStopAutoplayOnInteraction',
          ],
          types: {
            xoName: 'string',
            xoActiveIndex: 'number',
            xoPerView: 'number',
            xoPerMove: 'number',
            xoGap: 'number',
            xoSpeed: 'number',
            xoEasing: 'string',
            xoOverflow: 'string',
            xoVertical: 'boolean',
            xoAutoplay: 'number',
            xoHoverPause: 'boolean',
            xoRewind: 'boolean',
            xoRtl: 'boolean',
            xoBreakpoints: 'object',
            xoRenderBullet: 'string',
            xoAutoheight: 'boolean',
            xoType: 'string',
            xoLoop: 'boolean',
            xoColumnWidth: 'number',
            xoSnake: 'boolean',
            xoStopAutoplayOnInteraction: 'boolean',
          },
        });
      });
      o(this, 'setOptionsForStore', () => {
        var k, A, T, M, L;
        const { xoBreakpoints: t, xoPerView: e, xoPerMove: s, xoGap: r, xoOverflow: a, xoType: l, xoColumnWidth: h, xoSnake: d, xoVertical: u } = this.options,
          p = Dt(t),
          m = l === 'slide',
          x = !!this.querySelector(c.CarouselThumbnail),
          y = this.querySelector(c.CarouselInner);
        let b = {
          ...this.options,
          xoPerView: m ? ((k = p == null ? void 0 : p.perView) != null ? k : e) : 1,
          xoPerMove: m ? ((A = p == null ? void 0 : p.perMove) != null ? A : Math.min(s, e)) : 1,
          xoGap: m ? ((T = p == null ? void 0 : p.gap) != null ? T : r) : 0,
          xoAutoheight: m ? this.options.xoAutoheight : !0,
          xoOverflow: (M = p == null ? void 0 : p.overflow) != null ? M : a,
          xoVertical: (L = p == null ? void 0 : p.vertical) != null ? L : u,
          xoRewind: this.options.xoRewind,
          xoLoop: x ? !1 : this.options.xoLoop,
        };
        if ((b.xoPerView && b.xoLoop && y && y.querySelectorAll(`${c.CarouselSlide}:not([xo-cloned])`).length <= b.xoPerView && (b = { ...b, xoLoop: !1 }), h)) {
          const V = this.hasAttribute('xo-per-view'),
            ot = Math.floor((this.offsetWidth + r) / (h + r)),
            ut = V ? Math.min(e, ot) : ot;
          b = { ...b, xoPerView: ut, xoPerMove: Math.min(ut, s) };
        }
        d && (b = { ...b, xoPerMove: b.xoPerView }),
          xa(this.xoName, b),
          this.style.setProperty('--xo-per-view', `${b.xoPerView}`),
          this.style.setProperty('--xo-gap', `${b.xoGap}px`),
          (l === 'fade' || l === 'nature' || l === 'water' || l === 'urban') && this.style.setProperty('--xo-speed', `${b.xoSpeed}ms`);
        let v = 0;
        b.xoLoop && b.xoType === 'slide' && (v = b.xoPerView * 4),
          y &&
            (ya(this.xoName, y.querySelectorAll(`${c.CarouselSlide}:not([xo-cloned])`).length + v),
            b.xoOverflow === 'visible' ? (y.style.overflow = 'visible') : (y.style.overflow = 'hidden')),
          Ft(this.xoName, this.options.xoActiveIndex + (b.xoLoop && b.xoType === 'slide' ? e * 2 : 0), !0);
      });
      o(this, 'beautyBreakpoints', () => {
        const t = this.getAttribute('xo-breakpoints');
        t && this.setAttribute('xo-breakpoints', t.replace(/\s+/g, ' ').trim());
      });
      o(this, 'setHeightForVertical', () => {
        const { xoVertical: t, xoPerView: e, xoGap: s } = this.options;
        if (t) {
          const r = this.querySelector(c.CarouselInner),
            a = this.querySelectorAll(c.CarouselSlide);
          if (r) {
            const l = a[0].offsetHeight * e + (e - 1) * s;
            r.style.height = r.style.height || `${l}px`;
          }
        }
      });
      o(this, 'init', () => {
        this.setHeightForVertical(), this.setOptionsForStore(), rs.init(this, this.options);
      });
      o(
        this,
        'handleResize',
        st((t) => {
          for (let e of t) {
            const s = e.contentRect.width,
              r = e.contentRect.height;
            s !== this.prevWidth && (this.init(), (this.prevWidth = s), rs.resize(this, s, r));
          }
        }, as),
      );
      Jo++, this.setOptions(), this.options.xoName ? (this.xoName = this.options.xoName) : (this.xoName = `carousel-${Jo}`);
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    get options() {
      return { ...Ui.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    connectedCallback() {
      this.setOptions(),
        this.init(),
        this.beautyBreakpoints(),
        (this.resizeObserver = new ResizeObserver(this.handleResize)),
        this.resizeObserver.observe(this),
        (this.unsubscribe = Ht(this.xoName, ({ options: t, slideLength: e, activeIndex: s }) => {
          if (this.prevActiveIndex !== s) {
            const r = t.xoLoop && t.xoType === 'slide' ? e - t.xoPerView * 4 : e,
              a = t.xoLoop && t.xoType === 'slide' ? Math.min(Math.max(s - t.xoPerView * 2, 0), r - t.xoPerView) : s,
              l = D({ value: a, inputRange: [0, r - t.xoPerView], outputRange: [0, 100] });
            this.animated1.off(),
              this.animated1({
                from: this.prevPaginationProgress,
                to: l,
                duration: this.prevPaginationProgress === 100 ? 0 : t.xoSpeed,
                onUpdate: (h) => {
                  this.style.setProperty('--xo-pagination-progress', `${h}%`);
                },
                onEnd: () => {
                  this.prevPaginationProgress = l;
                },
              }),
              t.xoAutoplay &&
                (this.animated2.off(),
                this.animated2({
                  from: 0,
                  to: 100,
                  duration: t.xoAutoplay,
                  onUpdate: (h) => {
                    this.style.setProperty('--xo-autoplay-progress', `${h}%`);
                  },
                })),
              this.dispatchEvent(new CustomEvent('change', { bubbles: !0, detail: { activeIndex: a } })),
              (this.prevActiveIndex = s);
          }
        }));
    }
    async attributeChangedCallback(t, e, s) {
      if (t === 'xo-observed' && e !== s) {
        await P(50), this.setOptions(), this.setHeightForVertical(), this.setOptionsForStore();
        const r = Array.from(this.querySelectorAll(c.CarouselList));
        E(r, (a) => {
          a.closest(c.CarouselThumbnail) || a.setAttribute('xo-observed', s);
        });
      }
    }
    disconnectedCallback() {
      var t;
      this.unsubscribe(), this.animated1.off(), this.animated2.off(), (t = this.resizeObserver) == null || t.disconnect(), rs.destroy(this);
    }
  };
  let ls = Ui;
  o(ls, 'defaultOptions', {
    xoName: '',
    xoActiveIndex: 0,
    xoPerView: 1,
    xoPerMove: 1,
    xoGap: 20,
    xoSpeed: 200,
    xoEasing: 'easeOutQuad',
    xoOverflow: 'hidden',
    xoVertical: !1,
    xoAutoplay: 0,
    xoHoverPause: !1,
    xoRewind: !1,
    xoRtl: document.documentElement.dir === 'rtl',
    xoRenderBullet: '<span></span>',
    xoBreakpoints: {},
    xoAutoheight: !1,
    xoType: 'slide',
    xoLoop: !1,
    xoColumnWidth: 0,
    xoSnake: !1,
    xoStopAutoplayOnInteraction: !1,
  });
  const Xi = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, '_options');
      o(this, 'resizeObserver', null);
      o(this, 'prevWidth', 0);
      o(this, 'setOptions', () => {
        this.options = $(this, {
          pick: ['xoPerView', 'xoPerMove', 'xoGap', 'xoBreakpoints', 'xoVertical'],
          types: { xoPerView: 'number', xoPerMove: 'number', xoGap: 'number', xoBreakpoints: 'object', xoVertical: 'boolean' },
        });
      });
      o(this, 'setOptionsForStore', () => {
        var u, p, m, x;
        const { xoBreakpoints: t, xoPerView: e, xoPerMove: s, xoGap: r, xoVertical: a } = this.options,
          l = Dt(t),
          h = {
            ...this.options,
            xoPerView: (u = l == null ? void 0 : l.perView) != null ? u : e,
            xoPerMove: (p = l == null ? void 0 : l.perMove) != null ? p : Math.min(s, e),
            xoGap: (m = l == null ? void 0 : l.gap) != null ? m : r,
            xoVertical: (x = l == null ? void 0 : l.vertical) != null ? x : a,
          },
          { xoName: d } = this.getProviderElement();
        ga(d, h), this.style.setProperty('--xo-per-view', `${h.xoPerView}`), this.style.setProperty('--xo-gap', `${h.xoGap}px`);
      });
      o(
        this,
        'handleResize',
        st((t) => {
          for (let e of t) {
            const s = e.contentRect.width;
            s !== this.prevWidth && (this.setOptionsForStore(), (this.prevWidth = s));
          }
        }, as),
      );
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    getProviderElement() {
      return this.closest(c.Carousel);
    }
    get options() {
      return { ...Xi.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    async connectedCallback() {
      await P(50);
      const t = this.getProviderElement();
      !t ||
        ((this.prevWidth = t.clientWidth),
        this.setOptions(),
        this.setOptionsForStore(),
        (this.resizeObserver = new ResizeObserver(this.handleResize)),
        this.resizeObserver.observe(t));
    }
    attributeChangedCallback(t, e, s) {
      t === 'xo-observed' && e !== s && (this.setOptions(), this.setOptionsForStore());
    }
    disconnectedCallback() {
      var t;
      (t = this.resizeObserver) == null || t.disconnect();
    }
  };
  let cs = Xi;
  o(cs, 'defaultOptions', { xoPerView: 5, xoPerMove: 1, xoGap: 10, xoBreakpoints: {}, xoVertical: !1 });
  const it = { Idle: 'idle', Target: 'target', Lock: 'lock' };
  class wa extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'isThumbMoving', !1);
      o(this, 'unsubscribe', () => {});
      o(this, 'animated', _());
      o(this, 'thumbAnimated', _());
      o(this, 'snakeAnimated', _());
      o(this, 'prevTranslate', 0);
      o(this, 'prevThumbTranslate', 0);
      o(this, 'axis', it.Idle);
      o(this, 'pan', null);
      o(this, 'thumbPan', null);
      o(this, 'dEnd', 0);
      o(this, 'prevDx', null);
      o(this, 'prevDy', null);
      o(this, 'prevThumbDx', null);
      o(this, 'prevThumbDy', null);
      o(this, 'isMove', !1);
      o(this, 'timeoutId', -1);
      o(this, 'anchorEls', []);
      o(this, '_options');
      o(this, 'initialized', !1);
      o(this, 'autoPlayStart', Date.now());
      o(this, 'autoPlayNext', Date.now());
      o(this, 'tempStop', !1);
      o(this, 'prevScrollY', -1);
      o(this, 'startClientX', 0);
      o(this, 'isNextForSnake', !1);
      o(this, 'isSnakeUpdated', !1);
      o(this, 'resizeObserver', null);
      o(this, 'prevWidth', 0);
      o(this, 'setOptions', () => {
        const { options: t, thumbnailOptions: e } = Z(this.providerElement.xoName);
        this.isThumbnail ? (this.options = { ...t, ...e }) : (this.options = t);
      });
      o(this, 'withRtl', (t) => (this.options.xoRtl ? t * -1 : t));
      o(this, 'setTranslate', (t) => {
        if (this.providerElement && !isNaN(t)) {
          const { xoType: e, xoVertical: s } = this.options;
          e === 'slide' && (s ? (this.style.transform = `translate3d(0, ${t}px, 0)`) : (this.style.transform = `translate3d(${this.withRtl(t)}px, 0, 0)`));
        }
      });
      o(this, 'handleSlide', (t) => {
        if (!this.providerElement) return;
        const { options: e, activeIndex: s } = this,
          { slideLength: r } = Z(this.providerElement.xoName),
          a = this.isThumbnail ? r : r - e.xoPerView,
          l = this.isThumbnail ? Math.floor(e.xoPerView / 2) : 0,
          h = this.isThumbnail ? e.xoPerView - l : 0,
          d = this.isThumbnail ? Y(s, l, a - h) : s;
        if (d <= a - h) {
          const p = this.isThumbnail ? Y(d - l, 0, a) : s,
            m = r > e.xoPerView ? -p * this.slideSize : 0;
          e.xoType === 'slide' &&
            this.animated({
              from: this.isThumbnail ? this.prevThumbTranslate : this.prevTranslate,
              to: m,
              duration: t,
              easing: H[e.xoEasing],
              onUpdate: this.setTranslate,
              onEnd: (x) => {
                if (
                  (this.pan && (e.xoVertical ? this.pan.setValue({ dy: x }) : this.pan.setValue({ dx: this.withRtl(x) })),
                  this.thumbPan && (e.xoVertical ? this.thumbPan.setValue({ dy: x }) : this.thumbPan.setValue({ dx: this.withRtl(x) })),
                  this.isThumbnail ? (this.prevThumbTranslate = x) : (this.prevTranslate = x),
                  e.xoLoop)
                ) {
                  const y = p - e.xoPerView * 2;
                  if (y <= e.xoPerView * -1) {
                    const b = a - (e.xoPerView * 2 + e.xoPerView * -1 - y);
                    Ft(this.providerElement.xoName, b, !1);
                  } else if (y >= a - e.xoPerView * 3) {
                    const b = e.xoPerView * 2 + y - (a - e.xoPerView * 3);
                    Ft(this.providerElement.xoName, b, !1);
                  }
                }
              },
            }),
            this.handleActiveSlide(p);
        }
      });
      o(this, 'handleSnake', () => {
        const { activeIndex: t, options: e } = Z(this.providerElement.xoName),
          { xoSpeed: s, xoEasing: r, xoPerView: a } = e;
        this.snakeAnimated({
          from: 0,
          to: 1,
          duration: s,
          easing: H[r],
          onUpdate: (l) => {
            const h = D({ value: l, inputRange: [0, 0.5, 1], outputRange: [0, 15, 0] });
            (this.style.gap = `${h}rem`),
              this.isNextForSnake ? (this.style.marginLeft = `-${h * t}rem`) : (this.style.marginLeft = `-${h * (t + a - 1)}rem`),
              (this.isSnakeUpdated = !0);
          },
          onEnd: () => {
            this.isSnakeUpdated = !1;
          },
        });
      });
      o(this, 'listener', () => {
        if (this.initialized) {
          const { xoSpeed: t, xoSnake: e } = this.options,
            { useAnimated: s } = Z(this.providerElement.xoName);
          (this.autoPlayStart = Date.now()),
            this.handleSlide(s ? t : 0),
            !this.isSnakeUpdated && e && this.handleSnake(),
            this.providerElement && rs.change(this.providerElement, this.activeIndex);
        }
      });
      o(this, 'rubberBandClamp', (t) => {
        const { slideLength: e } = Z(this.providerElement.xoName),
          s = this.slideSize * e;
        return Po(this.getContainerSize() - s, 0, t, 0.2);
      });
      o(this, 'panMove', ({ dx: t, dy: e, vx: s, vy: r }, a) => {
        if (a.target.closest('model-viewer')) return;
        const { options: h } = this;
        if (
          ((this.isMove = !0),
          this.prevDx == null && (this.prevDx = -this.slideSize * this.activeIndex),
          this.prevDy == null && (this.prevDy = 0),
          h.xoVertical
            ? (this.axis = it.Target)
            : U.any
            ? this.axis === it.Idle && (Math.abs(t - this.prevDx) > Math.abs(e - this.prevDy) * 2.5 ? (this.axis = it.Target) : (this.axis = it.Lock))
            : (this.axis = it.Target),
          this.axis === it.Target)
        ) {
          U.any && window.scrollY !== this.prevScrollY && this.prevScrollY !== -1 && this.panEnd({ dx: t, dy: e, vx: s, vy: r }, a);
          const d = h.xoVertical ? e : this.withRtl(t),
            u = this.rubberBandClamp(d);
          h.xoSnake ? (this.isNextForSnake = !0) : this.setTranslate(u), (this.prevTranslate = u);
        } else U.any && this.style.removeProperty('touch-action');
      });
      o(this, 'magnet', (t, e, s, r, a) => Y(Math.round(t + (a ? r : -r)), e, s));
      o(this, 'panEnd', (t, e) => {
        if (!this.providerElement) return;
        const { options: s } = this;
        if (s.xoSnake) {
          const r = e instanceof MouseEvent ? e.clientX : e.changedTouches[0].clientX;
          (this.isNextForSnake = this.startClientX >= r), this.isNextForSnake ? ns(this.providerElement.xoName, s.xoPerMove) : pi(this.providerElement.xoName, s.xoPerMove);
        } else {
          const { d: r, v: a } = this.getDxy(t),
            { slideLength: l, activeIndex: h } = Z(this.providerElement.xoName),
            d = this.slideSize * l,
            u = l - s.xoPerView,
            p = s.xoPerView > 2 ? s.xoPerView : 1,
            m = a === 0 ? r : this.dEnd > r ? r - a * p : r + a * p,
            x = (s.xoVertical ? t.vy : t.vx) < 0,
            b = (() =>
              s.xoType === 'slide'
                ? this.magnet(D({ value: m, inputRange: [0, -d], outputRange: [0, l] }), 0, u, 0.4, this.dEnd > r)
                : s.xoLoop
                ? He(x ? h + 1 : h - 1, 0, u)
                : Y(x ? h + 1 : h - 1, 0, u))();
          if ((this.axis === it.Target && Ft(this.providerElement.xoName, b, !0), b > 0 && b <= u)) {
            if (this.pan)
              if (this.axis === it.Target) {
                if (s.xoVertical) {
                  const v = -b * this.slideSize;
                  this.pan.setValue({ dx: 0, dy: v }), (this.dEnd = v), (this.prevDx = 0), (this.prevDy = v);
                } else {
                  const v = this.withRtl(-b * this.slideSize);
                  this.pan.setValue({ dx: v, dy: 0 }), (this.dEnd = v), (this.prevDx = v), (this.prevDy = 0);
                }
                this.handleAutoPlay();
              } else this.pan.setValue({ dx: this.prevDx, dy: this.prevDy });
          } else
            b === 0
              ? this.pan && (this.pan.setValue({ dx: 0, dy: 0 }), (this.dEnd = 0), (this.prevDx = 0), (this.prevDy = 0), this.handleAutoPlay())
              : this.animated({
                  from: this.prevTranslate,
                  to: -(l - s.xoPerView) * this.slideSize,
                  duration: s.xoSpeed,
                  easing: H[s.xoEasing],
                  onUpdate: (v) => {
                    this.handlePause(), this.setTranslate(v);
                  },
                  onEnd: (v) => {
                    this.pan &&
                      (s.xoVertical
                        ? (this.pan.setValue({ dx: 0, dy: v }), (this.dEnd = v), (this.prevDx = 0), (this.prevDy = v))
                        : (this.pan.setValue({ dx: this.withRtl(v), dy: 0 }), (this.dEnd = this.withRtl(v)), (this.prevDx = this.withRtl(v)), (this.prevDy = 0)),
                      this.handleAutoPlay()),
                      (this.prevTranslate = v);
                  },
                });
          (this.axis = it.Idle),
            clearTimeout(this.timeoutId),
            (this.timeoutId = window.setTimeout(() => {
              this.style.removeProperty('touch-action');
            }, 300)),
            (this.prevScrollY = window.scrollY);
        }
      });
      o(this, 'thumbPanMove', ({ dx: t, dy: e, vx: s, vy: r }) => {
        var h, d;
        const { options: a } = this,
          { slideLength: l } = Z(this.providerElement.xoName);
        if (
          ((this.isThumbMoving = !0),
          this.prevThumbDx == null && (this.prevThumbDx = -this.slideSize * this.activeIndex),
          this.prevThumbDy == null && (this.prevThumbDy = 0),
          a.xoVertical
            ? (this.axis = it.Target)
            : U.any
            ? this.axis === it.Idle && (Math.abs(t - this.prevThumbDx) > Math.abs(e - this.prevThumbDy) * 2.5 ? (this.axis = it.Target) : (this.axis = it.Lock))
            : (this.axis = it.Target),
          this.axis === it.Target)
        ) {
          U.any && window.scrollY !== this.prevScrollY && this.thumbPanEnd({ dx: t, dy: e, vx: s, vy: r });
          const u = a.xoVertical ? e : this.withRtl(t),
            p = Y(u, -this.slideSize * (l - a.xoPerView), 0);
          this.setTranslate(p),
            a.xoVertical ? (h = this.thumbPan) == null || h.setValue({ dx: 0, dy: p }) : (d = this.thumbPan) == null || d.setValue({ dx: p, dy: 0 }),
            (this.prevThumbTranslate = p);
        }
      });
      o(this, 'thumbPanEnd', ({ vx: t, vy: e }) => {
        const { options: s } = this,
          { slideLength: r } = Z(this.providerElement.xoName),
          a = s.xoVertical ? e : this.withRtl(t);
        this.thumbAnimated({
          from: this.prevThumbTranslate,
          to: this.prevThumbTranslate + a * 10,
          duration: s.xoSpeed,
          easing: H.easeOutQuad,
          onUpdate: (l) => {
            if (this.isThumbMoving) {
              const h = Y(l, -this.slideSize * (r - s.xoPerView), 0);
              this.setTranslate(h);
            }
          },
          onEnd: (l) => {
            const h = Y(l, -this.slideSize * (r - s.xoPerView), 0);
            this.thumbPan &&
              this.isThumbMoving &&
              (s.xoVertical
                ? (this.thumbPan.setValue({ dx: 0, dy: h }), (this.prevThumbDx = 0), (this.prevThumbDy = h))
                : (this.thumbPan.setValue({ dx: h, dy: 0 }), (this.prevThumbDx = this.withRtl(h)), (this.prevThumbDy = 0))),
              (this.axis = it.Idle),
              clearTimeout(this.timeoutId),
              (this.timeoutId = window.setTimeout(() => {
                this.style.removeProperty('touch-action');
              }, 300)),
              this.isThumbMoving && (this.prevThumbTranslate = h),
              (this.isThumbMoving = !1),
              (this.prevScrollY = window.scrollY);
          },
        });
      });
      o(this, 'frameAutoPlay', () => {
        if (this.providerElement && !this.isThumbnail) {
          const t = this.providerElement.xoName,
            { options: e } = this;
          this.tempStop
            ? (this.autoPlayStart = Date.now())
            : ((this.autoPlayNext = Date.now()), this.autoPlayNext - this.autoPlayStart >= e.xoAutoplay && (ns(t, e.xoPerMove), (this.autoPlayStart = Date.now())));
        }
      });
      o(this, 'removeFrameAutoPlay', () => {
        G.remove(this.frameAutoPlay);
      });
      o(this, 'handlePause', () => {
        (this.autoPlayNext = Date.now()), (this.tempStop = !0);
      });
      o(this, 'handlePauseHover', () => {
        const { options: t } = this;
        t.xoHoverPause && this.handlePause();
      });
      o(this, 'handleAutoPlay', () => {
        this.tempStop = !1;
      });
      o(this, 'handleActiveSlide', (t) => {
        let e = -1,
          s = 0;
        const { options: r, activeIndex: a } = this,
          { slideLength: l } = Z(this.providerElement.xoName),
          h = r.xoLoop && r.xoType === 'slide' ? a - r.xoPerView * 2 : a,
          d = this.isThumbnail && t != null ? t : h;
        E(Array.from(this.children), async (u) => {
          if (u.tagName.toLowerCase() === c.CarouselSlide && !f.get(u, 'xo-cloned'))
            if (
              (e++,
              (u.index = e),
              u.setAttribute('aria-label', `${e + 1} / ${r.xoLoop && r.xoType === 'slide' ? l - r.xoPerView * 4 : l}`),
              u.setAttribute('role', 'tabpanel'),
              h === e ? f.set(u, 'xo-active', !0) : f.set(u, 'xo-active', !1),
              e >= d && e < d + r.xoPerView)
            )
              if ((f.set(u, 'xo-visible', !0), r.xoAutoheight)) {
                if (u.children[0] instanceof HTMLElement) {
                  t || (await P(500));
                  const p = va(u.children[0]);
                  if (s < p) {
                    s = p;
                    const m = this.closest(c.CarouselInner),
                      x = m == null ? void 0 : m.closest(c.CarouselThumbnail);
                    m && !x && ((m.style.height = `${s}px`), (m.style.transition = `height ${r.xoSpeed}ms`));
                  }
                }
              } else {
                const p = this.closest(c.CarouselInner);
                p && !r.xoVertical && p.style.removeProperty('height');
              }
            else f.set(u, 'xo-visible', !1);
        });
      });
      o(this, 'setContainerSize', () => {
        this.parentElement && ba(this.providerElement.xoName, this.parentElement.offsetWidth, this.parentElement.offsetHeight);
      });
      o(
        this,
        'handleResize',
        st((t) => {
          for (let e of t) {
            const s = e.contentRect.width;
            s !== this.prevWidth && (this.disconnectedCallback(), this.connectedCallback(), (this.prevWidth = s));
          }
        }, as),
      );
      o(
        this,
        'handleWindowResize',
        st(
          me('x', () => {
            Ft(this.providerElement.xoName, 0, !1);
          }),
          as,
        ),
      );
      o(this, 'handleAnchor', (t) => {
        this.isMove && t.preventDefault();
      });
      o(this, 'bindAnchor', () => {
        (this.anchorEls = Array.from(this.querySelectorAll('a'))),
          E(this.anchorEls, (t) => {
            t.addEventListener('click', this.handleAnchor);
          });
      });
      o(this, 'handleLoop', () => {
        const { xoPerView: t, xoLoop: e, xoType: s } = this.options;
        !e || (s === 'slide' && Ea(this, t));
      });
      o(this, 'removeSlideCloned', () => {
        E(Array.from(this.children), (t) => {
          t.tagName.toLowerCase() === c.CarouselSlide && f.get(t, 'xo-cloned') && this.removeChild(t);
        });
      });
      o(this, 'handleSlideClick', () => {
        this.options.xoStopAutoplayOnInteraction && this.removeFrameAutoPlay();
      });
      o(this, 'reset', () => {
        var t, e, s;
        this.unsubscribe(),
          this.removeFrameAutoPlay(),
          this.removeSlideCloned(),
          (t = this.pan) == null || t.destroy(),
          (e = this.thumbPan) == null || e.destroy(),
          clearTimeout(this.timeoutId),
          this.animated.off(),
          this.snakeAnimated.off(),
          (s = this.resizeObserver) == null || s.disconnect(),
          this.providerElement &&
            (this.providerElement.removeEventListener('click', this.handleSlideClick),
            this.providerElement.removeEventListener('mouseenter', this.handlePauseHover),
            this.providerElement.removeEventListener('mouseleave', this.handleAutoPlay),
            this.providerElement.removeEventListener('touchstart', this.handlePauseHover),
            this.providerElement.removeEventListener('touchend', this.handleAutoPlay)),
          E(this.anchorEls, (r) => {
            r.removeEventListener('click', this.handleAnchor);
          }),
          U.any || window.removeEventListener('resize', this.handleWindowResize);
      });
    }
    get providerElement() {
      return this.closest(c.Carousel);
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    get slideSize() {
      const { slideLength: t } = Z(this.providerElement.xoName);
      return this.options.xoVertical ? this.scrollHeight / t : this.scrollWidth / t;
    }
    getContainerSize() {
      const { containerWidth: t, containerHeight: e } = Z(this.providerElement.xoName);
      return this.options.xoVertical ? e : t;
    }
    get isThumbnail() {
      return !!this.closest(c.CarouselThumbnail);
    }
    get options() {
      return this._options;
    }
    set options(t) {
      this._options = t;
    }
    get activeIndex() {
      const { activeIndex: t, thumbnailActiveIndex: e } = Z(this.providerElement.xoName);
      return this.isThumbnail ? e : t;
    }
    getDxy({ dx: t, dy: e, vx: s, vy: r }) {
      return this.options.xoVertical ? { d: e, v: Math.abs(r) } : { d: this.withRtl(t), v: Math.abs(s) };
    }
    async connectedCallback() {
      if ((await P(100), !this.providerElement)) return;
      this.reset(),
        this.setOptions(),
        this.handleLoop(),
        this.setContainerSize(),
        (this.resizeObserver = new ResizeObserver(this.handleResize)),
        this.resizeObserver.observe(this.providerElement),
        U.any || window.addEventListener('resize', this.handleWindowResize),
        this.providerElement.addEventListener('click', this.handleSlideClick);
      const { options: t } = this;
      if ((this.handleSlide(0), this.isThumbnail))
        this.thumbPan = Gt({
          element: this,
          onStart: () => {
            this.style.touchAction = 'none';
          },
          onMove: this.thumbPanMove,
          onEnd: this.thumbPanEnd,
        });
      else {
        const { slideLength: e } = Z(this.providerElement.xoName);
        if (e <= t.xoPerView && !this.isThumbnail) return;
        this.pan = Gt({
          element: this,
          onStart: (s) => {
            s.target.closest('model-viewer') ||
              ((this.isMove = !1),
              (this.autoPlayStart = Date.now()),
              (this.tempStop = !0),
              (this.startClientX = s instanceof MouseEvent ? s.clientX : s.touches[0].clientX),
              (this.style.touchAction = 'none'));
          },
          onMove: t.xoSnake ? void 0 : this.panMove,
          onEnd: (s, r) => {
            const a = r.target.closest(c.CarouselNext),
              l = r.target.closest(c.CarouselPrev);
            a || l || r.target.closest('model-viewer') || this.panEnd(s, r);
          },
        });
      }
      t.xoAutoplay && G.add(this.frameAutoPlay, !0),
        this.handleActiveSlide(),
        this.bindAnchor(),
        (this.unsubscribe = Ht(this.providerElement.xoName, this.listener)),
        this.providerElement.addEventListener('mouseenter', this.handlePauseHover),
        this.providerElement.addEventListener('mouseleave', this.handleAutoPlay),
        U.any && (this.providerElement.addEventListener('touchstart', this.handlePauseHover), this.providerElement.addEventListener('touchend', this.handleAutoPlay)),
        f.set(this.providerElement, 'xo-initialized', !0),
        (this.initialized = !0);
    }
    async attributeChangedCallback(t, e, s) {
      t === 'xo-observed' && e !== s && (await P(100), this.connectedCallback());
    }
    disconnectedCallback() {
      this.reset();
    }
  }
  class Ca extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'index', 0);
      o(this, 'handleClick', () => {
        const t = this.closest(c.CarouselList);
        if (!(t != null && t.isThumbMoving)) {
          const { xoName: e } = this.providerElement;
          Ft(e, this.index, !0);
        }
      });
    }
    get providerElement() {
      return this.closest(c.Carousel);
    }
    get isThumbnail() {
      return !!this.closest(c.CarouselThumbnail);
    }
    connectedCallback() {
      !this.providerElement || (this.isThumbnail && (U.any ? this.addEventListener('touchend', this.handleClick) : this.addEventListener('mouseup', this.handleClick)));
    }
    disconnectedCallback() {
      !this.providerElement ||
        (this.unsubscribe(), this.isThumbnail && (U.any ? this.removeEventListener('touchend', this.handleClick) : this.removeEventListener('mouseup', this.handleClick)));
    }
  }
  class Sa extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'setAttrDisabled', ({ options: t, activeIndex: e, slideLength: s }) => {
        t.xoLoop || (!t.xoRewind && e === s - t.xoPerView ? f.set(this, 'xo-disabled', !0) : f.set(this, 'xo-disabled', !1)),
          s <= t.xoPerView ? f.set(this, 'xo-hide', !0) : f.set(this, 'xo-hide', !1);
      });
      o(this, 'listener', (t) => {
        this.setAttrDisabled(t);
      });
      o(this, 'nextSlide', () => {
        var s;
        if (!this.providerElement) return;
        const { options: t } = Z(this.providerElement.xoName),
          e = Date.now();
        if (!(e - Ko() < t.xoSpeed + 100) && (Zo(e), ns(this.providerElement.xoName, t.xoPerMove), t.xoSnake)) {
          const r = (s = this.providerElement) == null ? void 0 : s.querySelector(c.CarouselList);
          r && (r.isNextForSnake = !0);
        }
      });
    }
    get providerElement() {
      return this.closest(c.Carousel);
    }
    async connectedCallback() {
      var e;
      if (((e = window.xbEditor) != null && e.designMode && (await P(100)), !this.providerElement)) return;
      const t = Z(this.providerElement.xoName);
      this.setAttrDisabled(t), this.addEventListener('click', this.nextSlide), (this.unsubscribe = Ht(this.providerElement.xoName, this.listener));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.removeEventListener('click', this.nextSlide);
    }
  }
  class ka extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'setAttrDisabled', ({ options: t, activeIndex: e, slideLength: s }) => {
        t.xoLoop || (!t.xoRewind && e === 0 ? f.set(this, 'xo-disabled', !0) : f.set(this, 'xo-disabled', !1)),
          s <= t.xoPerView ? f.set(this, 'xo-hide', !0) : f.set(this, 'xo-hide', !1);
      });
      o(this, 'listener', (t) => {
        this.setAttrDisabled(t);
      });
      o(this, 'prevSlide', () => {
        var s;
        if (!this.providerElement) return;
        const { options: t } = Z(this.providerElement.xoName),
          e = Date.now();
        if (!(e - Ko() < t.xoSpeed + 100) && (Zo(e), pi(this.providerElement.xoName, t.xoPerMove), t.xoSnake)) {
          const r = (s = this.providerElement) == null ? void 0 : s.querySelector(c.CarouselList);
          r && (r.isNextForSnake = !1);
        }
      });
    }
    get providerElement() {
      return this.closest(c.Carousel);
    }
    connectedCallback() {
      if (!this.providerElement) return;
      const t = Z(this.providerElement.xoName);
      this.setAttrDisabled(t), this.addEventListener('click', this.prevSlide), (this.unsubscribe = Ht(this.providerElement.xoName, this.listener));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.removeEventListener('click', this.prevSlide);
    }
  }
  class Aa extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'listener', (t) => {
        this.renderBullet(t.slideLength, t.options);
      });
      o(this, 'renderBullet', (t, e) => {
        const s = e.xoLoop && e.xoType === 'slide' ? t - e.xoPerView * 4 : t,
          r = Array(Math.ceil(s / e.xoPerView)).fill(0);
        if (s <= e.xoPerView) {
          this.innerHTML = '';
          return;
        }
        this.innerHTML = nt(
          r,
          (a, l) => `
          <${c.CarouselBullet} xo-index="${l}" xo-page="${l + 1}">
            ${e.xoRenderBullet}
          </${c.CarouselBullet}>
        `,
        ).join('');
      });
    }
    get providerElement() {
      return this.closest(c.Carousel);
    }
    async connectedCallback() {
      if ((await P(100), !this.providerElement)) return;
      const t = Z(this.providerElement.xoName);
      this.renderBullet(t.slideLength, t.options),
        (this.unsubscribe = Ht(this.providerElement.xoName, this.listener, (e, s) => {
          var r, a;
          return Pt((r = e[this.providerElement.xoName]) == null ? void 0 : r.options, (a = s[this.providerElement.xoName]) == null ? void 0 : a.options);
        }));
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  let tn = 0;
  class Pa extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'circleEl', null);
      o(this, 'listener', (t) => {
        this.handler(t);
      });
      o(this, 'handler', async ({ activeIndex: t, options: e, slideLength: s }) => {
        var d;
        const r = Number((d = this.getAttribute('xo-index')) != null ? d : 0),
          a = e.xoLoop && e.xoType === 'slide' ? s - e.xoPerView * 4 : s,
          l = e.xoLoop && e.xoType === 'slide' ? Math.min(t - e.xoPerView * 2, a - e.xoPerView) : t,
          h = Math.ceil(l / e.xoPerView);
        await P(0),
          r === h
            ? (f.set(this, 'xo-active', !0), xe.animate(this.getCircleBarName(), { duration: e.xoAutoplay, value: 100 }))
            : (f.set(this, 'xo-active', !1), xe.animate(this.getCircleBarName(), { duration: e.xoAutoplay, value: 0 }));
      });
      o(this, 'handleClick', () => {
        var x, y;
        const { xoName: t } = this.getProviderElement(),
          { options: e, slideLength: s, activeIndex: r } = Z(t),
          a = Date.now();
        if (a - tn < e.xoSpeed + 200) return;
        tn = a;
        const l = s % e.xoPerView,
          h = e.xoLoop && e.xoType === 'slide' ? e.xoPerView * 2 : 0,
          d = Number((x = this.getAttribute('xo-index')) != null ? x : 0) * e.xoPerView + h,
          u = s - 1 - (e.xoPerView === 1 ? 0 : e.xoPerView - l);
        let p = Y(d, h, u);
        const m = (y = this.getProviderElement()) == null ? void 0 : y.querySelector(c.CarouselList);
        Ft(t, d, !0), e.xoSnake && m && (m.isNextForSnake = p > r);
      });
      o(this, 'getCircleBarName', () => (this.getProviderElement() ? `${this.getProviderElement().xoName}-${this.getAttribute('xo-index')}` : ''));
      o(this, 'handleCircleBar', () => {
        (this.circleEl = this.querySelector(c.CircleBar)), this.circleEl && this.circleEl.setAttribute('xo-name', this.getCircleBarName());
      });
    }
    getProviderElement() {
      return this.closest(c.Carousel);
    }
    connectedCallback() {
      const t = this.getProviderElement();
      if (!t) return;
      const e = Z(t.xoName);
      this.handler(e), this.handleCircleBar(), this.addEventListener('click', this.handleClick), (this.unsubscribe = Ht(t.xoName, this.listener));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.removeEventListener('click', this.handleClick);
    }
  }
  class Ta extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'listener', ({ options: t, slideLength: e }) => {
        t.xoLoop ? (this.innerText = `${e - t.xoPerView * 4}`) : (this.innerText = `${e}`);
      });
    }
    get providerElement() {
      return this.closest(c.Carousel);
    }
    connectedCallback() {
      !this.providerElement || (this.unsubscribe = Ht(this.providerElement.xoName, this.listener));
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  class $a extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'listener', ({ options: t, activeIndex: e, slideLength: s }) => {
        const r = t.xoLoop && t.xoType === 'slide' ? s - t.xoPerView * 4 : s,
          a = t.xoLoop && t.xoType === 'slide' ? Math.min(e - t.xoPerView * 2, r - t.xoPerView) : e,
          l = Math.ceil(a / t.xoPerView);
        this.innerText = `${l + 1}`;
      });
    }
    get providerElement() {
      return this.closest(c.Carousel);
    }
    connectedCallback() {
      !this.providerElement || (this.unsubscribe = Ht(this.providerElement.xoName, this.listener));
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  const md = '';
  fa(), (window.xoCarousel = jo);
  const Ma = jo;
  B({
    [c.Carousel]: ls,
    [c.CarouselThumbnail]: cs,
    [c.CarouselSlide]: Ca,
    [c.CarouselNext]: Sa,
    [c.CarouselPrev]: ka,
    [c.CarouselList]: wa,
    [c.CarouselPagination]: Aa,
    [c.CarouselBullet]: Pa,
    [c.CarouselSize]: Ta,
    [c.CarouselPage]: $a,
  });
  const Yi = class extends HTMLElement {
    constructor() {
      super();
      o(this, 'inputEl1', null);
      o(this, 'inputEl2', null);
      o(this, 'trackEl', null);
      o(this, 'thumbEl1', null);
      o(this, 'thumbEl2', null);
      o(this, 'progressEl', null);
      o(this, 'priceEls', []);
      o(this, 'valueEls', []);
      o(this, 'initialized', !1);
      o(this, 'resizeObserver', null);
      o(this, 'prevWidth', 0);
      o(this, '_value', [0, 100]);
      o(this, 'min', 0);
      o(this, 'max', 100);
      o(this, 'createChildComponent', (t) => document.createElement(t));
      o(this, 'createRange', (t) => {
        const { xoName: e, xoMin: s, xoMax: r, xoStep: a, xoValue: l } = this.options,
          h = document.createElement('input');
        return (
          (h.type = 'range'),
          (h.name = `${e}`),
          (h.min = `${s}`),
          (h.max = `${r}`),
          (h.step = `${a}`),
          (h.value = `${l[t]}`),
          h.addEventListener('input', this.handleInput),
          h.addEventListener('click', this.handleInput),
          h.addEventListener('mouseup', this.handleChangeEnd),
          h.addEventListener('touchend', this.handleChangeEnd),
          h
        );
      });
      o(this, 'handleInput', (t) => {
        var r, a, l, h;
        const e = (a = Number((r = this.inputEl1) == null ? void 0 : r.value)) != null ? a : 0,
          s = (h = Number((l = this.inputEl2) == null ? void 0 : l.value)) != null ? h : 0;
        if (this.inputEl1 && t.target === this.inputEl1 && e >= s) {
          this.inputEl1.value = `${s}`;
          return;
        }
        if (this.inputEl2 && t.target === this.inputEl2 && s <= e) {
          this.inputEl2.value = `${e}`;
          return;
        }
        this.setAttribute('xo-value', `[${e}, ${s}]`), this.dispatchEvent(new CustomEvent('change', { bubbles: !0, detail: { value: [e, s] } }));
      });
      o(this, 'handler', ([t, e]) => {
        if (!this.inputEl1 || !this.inputEl2 || !this.thumbEl1 || !this.thumbEl2 || !this.progressEl) return;
        const { xoMin: s, xoMax: r, xoName: a, xoComponentName: l } = this.options;
        this.inputEl1.setAttribute('value', `${t}`),
          (this.inputEl1.value = `${t}`),
          this.inputEl2.setAttribute('value', `${e}`),
          (this.inputEl2.value = `${e}`),
          this.inputEl1.setAttribute('name', `${a[0]}`),
          this.inputEl2.setAttribute('name', `${a[1]}`),
          E(this.priceEls, (u) => {
            var m, x, y;
            const p = (y = (x = (m = u.closest(c.Filters)) == null ? void 0 : m.getAttribute('xo-money-format')) != null ? x : u.getAttribute('xo-money-format')) != null ? y : '';
            u.getAttribute('xo-component-name') === l &&
              (u.getAttribute('xo-type') === 'min'
                ? (u.innerHTML = p.replace(/{.*}|(\d+(,|\.)?)+/g, `${t}`))
                : u.getAttribute('xo-type') === 'max' && (u.innerHTML = p.replace(/{.*}|(\d+(,|\.)?)+/g, `${e}`)));
          }),
          E(this.valueEls, (u) => {
            u.getAttribute('xo-component-name') === l &&
              (u.getAttribute('xo-type') === 'min'
                ? (u.setAttribute('value', `${t}`), (u.value = `${t}`))
                : u.getAttribute('xo-type') === 'max' && (u.setAttribute('value', `${e}`), (u.value = `${e}`)));
          });
        const h = D({ value: t, inputRange: [s, r], outputRange: [0, this.offsetWidth - this.thumbEl1.offsetWidth] }),
          d = D({ value: e, inputRange: [s, r], outputRange: [0, this.offsetWidth - this.thumbEl2.offsetWidth] });
        (this.thumbEl1.style.transform = `translateX(${h}px)`),
          (this.thumbEl2.style.transform = `translateX(${d}px)`),
          (this.progressEl.style.transform = `translateX(${h}px)`),
          (this.progressEl.style.width = `${d - h}px`);
      });
      o(this, 'handleValueInput', (t) => {
        const e = t.currentTarget,
          s = Number(e.value),
          r = 10;
        if (s !== null) {
          if (e.getAttribute('xo-type') === 'min') {
            const a = e.value ? Math.min(s, this.value[1] - r) : 0;
            this.value = [a, this.value[1]];
          } else if (e.getAttribute('xo-type') === 'max') {
            const a = e.value ? Math.max(s, this.value[0] + r) : 0;
            this.value = [this.value[0], a];
          }
          this.handleChangeEnd();
        }
      });
      o(this, 'handleChangeEnd', () => {
        this.dispatchEvent(new CustomEvent('changed', { bubbles: !0, detail: { value: this.value } }));
      });
      o(this, 'setSize', () => {
        this.style.setProperty('--size', `${this.thumbEl1.offsetHeight}`);
      });
      this.innerHTML = '';
    }
    get options() {
      const t = $(this, {
        pick: ['xoComponentName', 'xoName', 'xoMin', 'xoMax', 'xoStep', 'xoValue'],
        types: { xoComponentName: 'string', xoName: 'array', xoMin: 'number', xoMax: 'number', xoStep: 'number', xoValue: 'array' },
      });
      return { ...Yi.defaultOptions, ...t };
    }
    get value() {
      return this._value;
    }
    set value(t) {
      (this._value = t), this.setAttribute('xo-value', `[${t[0]}, ${t[1]}]`);
    }
    static get observedAttributes() {
      return ['xo-value', 'xo-observed'];
    }
    async connectedCallback() {
      const { xoValue: t, xoMin: e, xoMax: s, xoComponentName: r } = this.options;
      (this.innerHTML = ''),
        (this.inputEl1 = this.appendChild(this.createRange(0))),
        (this.inputEl2 = this.appendChild(this.createRange(1))),
        (this.trackEl = this.appendChild(this.createChildComponent(c.RangeTrack))),
        (this.thumbEl1 = this.appendChild(this.createChildComponent(c.RangeThumb))),
        (this.thumbEl2 = this.appendChild(this.createChildComponent(c.RangeThumb))),
        (this.progressEl = this.trackEl.appendChild(this.createChildComponent(c.RangeProgress))),
        await P(0),
        this.thumbEl1.setAttribute('xo-index', '0'),
        this.thumbEl2.setAttribute('xo-index', '1'),
        (this.value = t),
        this.setSize(),
        (this.min = e),
        (this.max = s),
        (this.priceEls = Array.from(document.querySelectorAll(`${c.RangePrice}[xo-component-name=${r}]`))),
        (this.valueEls = Array.from(document.querySelectorAll(`input[xo-component-name=${r}]`))),
        this.handler(this.value),
        E(this.valueEls, (a) => {
          a.getAttribute('xo-component-name') === r && a.addEventListener('input', this.handleValueInput);
        }),
        (this.resizeObserver = new ResizeObserver((a) => {
          for (let l of a) {
            const h = l.contentRect.width;
            h !== this.prevWidth && (this.setSize(), this.handler(this.value), (this.prevWidth = h));
          }
        })),
        this.resizeObserver.observe(this);
    }
    attributeChangedCallback(t, e, s) {
      if (((e != null && s != null) || t === 'xo-observed') && e !== s) {
        const r = at(s);
        (this.value = r), this.handler(r), this.initialized && this.dispatchEvent(new CustomEvent('change', { bubbles: !0, detail: { value: r } })), (this.initialized = !0);
      }
    }
    disconnectedCallback() {
      var t;
      !this.inputEl1 ||
        !this.inputEl2 ||
        (this.inputEl1.removeEventListener('input', this.handleInput),
        this.inputEl2.removeEventListener('input', this.handleInput),
        this.inputEl1.removeEventListener('mouseup', this.handleChangeEnd),
        this.inputEl2.removeEventListener('mouseup', this.handleChangeEnd),
        this.inputEl1.removeEventListener('touchend', this.handleChangeEnd),
        this.inputEl2.removeEventListener('touchend', this.handleChangeEnd),
        this.inputEl1.removeEventListener('click', this.handleInput),
        this.inputEl2.removeEventListener('click', this.handleInput),
        E(this.valueEls, (e) => {
          e.removeEventListener('input', this.handleValueInput);
        }),
        (t = this.resizeObserver) == null || t.disconnect());
    }
  };
  let hs = Yi;
  o(hs, 'defaultOptions', { xoComponentName: 'xo-range', xoName: ['', ''], xoMin: 0, xoMax: 100, xoStep: 1, xoValue: [0, 100] });
  const fd = '';
  B({ [c.Range]: hs });
  function La() {
    g.create('xo-filters', {
      initialState: { fieldInfo: {}, formData: new FormData(), refine: [], status: 'idle', html: '', prevHtml: '', priceMax: 0, priceMin: 0, sectionId: '' },
    });
  }
  function Ia(n, i) {
    g.set('xo-filters', (t) => ({ ...t, priceMin: n, priceMax: i }))('xo-filters/setPriceMinMax');
  }
  function Da(n) {
    g.set('xo-filters', (i) => ({ ...i, sectionId: n }))('xo-filters/setSectionId');
  }
  function Na() {
    const n = new URL(window.location.href),
      i = vt.parse(n.search),
      t = new FormData();
    E(i, ([e, s]) => {
      t.append(e, s);
    }),
      g.set(
        'xo-filters',
        (e) => (
          Number(t.get('filter.v.price.gte')) === e.priceMin &&
            Number(t.get('filter.v.price.lte')) === e.priceMax &&
            (t.delete('filter.v.price.gte'), t.delete('filter.v.price.lte')),
          { ...e, formData: Ee(t) }
        ),
      )('xo-filters/setDefaultFormData');
  }
  function ds() {
    g.set('xo-filters', (n) => {
      const { formData: i } = n,
        t = Array.from(Ee(i)),
        e = yt(Array.from(t), (s, [r, a]) => (a === '' || a == null ? s : [...s, { name: r, value: a }]), []);
      return { ...n, refine: e };
    })('xo-filters/setRefine');
  }
  function Oa(n) {
    const i = n instanceof FormData ? n : new FormData(n);
    g.set(
      'xo-filters',
      (t) => (
        Number(i.get('filter.v.price.gte')) === t.priceMin &&
          Number(i.get('filter.v.price.lte')) === t.priceMax &&
          (i.delete('filter.v.price.gte'), i.delete('filter.v.price.lte')),
        { ...t, formData: Ee(i) }
      ),
    )('xo-filters/setFormData');
  }
  function Fa(n, i) {
    g.set('xo-filters', (t) => {
      const { formData: e } = t;
      return e.append(n, i), { ...t, formData: e };
    })('xo-filters/pushFormDataItem');
  }
  function ve(n, i, t) {
    g.set('xo-filters', (e) => {
      const { formData: s } = e;
      return s.set(n, i), t || s.delete('page'), { ...e, formData: s };
    })('xo-filters/updateFormDataItem');
  }
  function us(n, i) {
    const t = i != null;
    g.set('xo-filters', (e) => {
      const { formData: s } = e;
      s.delete('page');
      const r = Array.from(Ee(s)),
        a = yt(
          r,
          (l, [h, d]) => {
            if (t) {
              if (h === n && d === i) return l;
            } else if (h === n) return l;
            return l.append(h, d), l;
          },
          new FormData(),
        );
      return { ...e, formData: a };
    })('xo-filters/removeFormDataItem');
  }
  function en(n, i) {
    const t = i != null;
    g.set('xo-filters', (e) => ({ ...e, refine: It(e.refine, (s) => (t ? !(s.name === n && s.value === i) : s.name !== n)) }))('xo-filters/removeRefineItem');
  }
  function Ha() {
    g.set('xo-filters', (n) => {
      const { formData: i } = n,
        t = i.get('q'),
        e = new FormData();
      return t && e.append('q', t), { ...n, refine: [], formData: e };
    })('xo-filters/removeAllRefineAndFormData');
  }
  const ae = new Map();
  async function sn(n) {
    ae.size > 10 && ae.delete(ae.keys().next().value);
    try {
      if ((g.set('xo-filters', (i) => ({ ...i, status: 'request' }))('xo-filters/getHtml/request'), ae.has(n))){
        await P(10), g.set('xo-filters', (i) => ({ ...i, status: 'success', html: ae.get(n), prevHtml: i.html }))('xo-filters/getHtml/success');
      }
      else {
        const t = await (await fetch(n)).text();
        ae.set(n, t), g.set('xo-filters', (e) => ({ ...e, status: 'success', html: t, prevHtml: e.html }))('xo-filters/getHtml/success');
      }
    } catch {
      g.set('xo-filters', (i) => ({ ...i, status: 'failure' }))('xo-filters/getHtml/failure');
    }
  }
  function Ra() {
    g.set('xo-filters', (n) => ({ ...n, status: 'idle' }))('xo-filters/resetStatus');
  }
  function wt() {
    return g.get('xo-filters');
  }
  function $t(n, i) {
    return g.subscribe('xo-filters', n, i);
  }
  const xt = { sort: 'sort_by', page: 'page', price: "['filter.v.price.gte', 'filter.v.price.lte']" };
  function dt(n, i) {
    if (!n) return !1;
    const t = n.tagName.toLowerCase();
    return t === 'input' ? n.getAttribute('type') === i : t === i;
  }
  function qa(n) {
    if (n.children.length !== 1 && !/input|select|xo-range/g.test(n.children[0].tagName.toLowerCase()))
      throw new Error(`${c.FiltersField}: field must have one child and it must be an input, select or ${c.Range}`);
  }
  function Ee(n) {
    var e, s;
    if (!n.get('filter.v.price.gte')) return n;
    const i = (e = Number(n.get('filter.v.price.gte'))) != null ? e : 0,
      t = (s = Number(n.get('filter.v.price.lte'))) != null ? s : 0;
    return n.delete('filter.v.price.gte'), n.delete('filter.v.price.lte'), n.set(xt.price, `[${i}, ${t}]`), n;
  }
  function on(n) {
    if (!n.get(xt.price)) return n;
    const i = n.get(xt.price);
    n.delete(xt.price);
    const [t, e] = at(i);    
    return n.set('filter.v.price.gte', String(t)), n.set('filter.v.price.lte', String(e)), n;
  }
  function Va() {
    const { formData: n } = wt(),
      i = new URL(window.location.href.replace(window.location.search, ''));
    (i.search = vt.stringify(on(n)).replaceAll(' ', '')), i.href !== window.location.href && window.history.pushState(null, '', i.href);
  }
  async function mi() {
    const { formData: n, sectionId: i } = wt(),
      t = new URL(window.location.href.replace(window.location.search, ''));
    (t.search = vt.stringify(on(n)).replaceAll(' ', '')),
      await sn(i ? (t.href.includes('?') ? `${t.href}&section_id=${i}` : `${t.href}?section_id=${i}`) : t.href),
      t.href !== window.location.href && window.history.pushState(null, '', t.href);
  }
  function za(n) {
    let i = -1;
    return (
      'requestIdleCallback' in window
        ? (i = requestIdleCallback(() => {
            n(), cancelIdleCallback(i);
          }))
        : (i = setTimeout(() => {
            n(), clearTimeout(i);
          }, 0)),
      i
    );
  }
  function Ba(n) {
    'requestIdleCallback' in window ? cancelIdleCallback(n) : clearTimeout(n);
  }
  function _a() {
    let n = 0;
    const i = () => {
        var l;
        const s = '::disabled',
          r = document.querySelector(c.Filters),
          a = document.querySelector(c.FiltersMobile);
        if (r && a) {
          const h = Array.from(a.querySelectorAll(`${c.FiltersField} input[type="radio"]`)),
            d = Array.from(r.querySelectorAll(`${c.FiltersField} input[type="radio"]`)).filter((x) => !x.closest(c.FiltersMobile)),
            p = (l = $(a, { pick: ['xoMobileMaxWidth'], types: { xoMobileMaxWidth: 'number' } }).xoMobileMaxWidth) != null ? l : 767;
          window.innerWidth <= p || U.any
            ? (E(h, (x) => {
                const y = x.getAttribute('name');
                y && (x.hasAttribute('checked') && (x.checked = !0), x.setAttribute('name', y.replace(s, '')));
              }),
              E(d, (x) => {
                const y = x.getAttribute('name');
                y && !y.includes(s) && ((x.checked = !1), x.setAttribute('name', y + s));
              }))
            : (E(d, (x) => {
                const y = x.getAttribute('name');
                y && (x.hasAttribute('checked') && (x.checked = !0), x.setAttribute('name', y.replace(s, '')));
              }),
              E(h, (x) => {
                const y = x.getAttribute('name');
                y && !y.includes(s) && ((x.checked = !1), x.setAttribute('name', y + s));
              }));
        }
      },
      t = st((s) => {
        for (let r of s) {
          const a = r.contentRect.width;
          a !== n && (i(), (n = a));
        }
      }, 300);
    i(), new ResizeObserver(t).observe(document.body);
  }
  const Wa = Oe()`
    ${c.StickyInner} {
      position: relative;
    }
    ${c.StickyInner}[xo-is-sticky] {
      position: fixed;
      left: 0;
      right: 0;
      z-index: 1000;
      transition: all 0.3s;
      backface-visibility: hidden;
    }
    ${c.StickyInner}[xo-lock] {
      transform: translateY(0) !important;
    }
    ${c.StickyContent} {
      display: block;
    }
  `;
  function Ua() {
    g.create('xo-sticky', { initialState: { topNodes: [], bottomNodes: [] } });
  }
  function Rt(n) {
    const i = g.get('xo-sticky');
    return n === 'top' ? i.topNodes : i.bottomNodes;
  }
  function ps(n) {
    return n === 'top' ? 'topNodes' : 'bottomNodes';
  }
  function Xa(n, i, t) {
    g.set('xo-sticky', (e) => {
      const s = Rt(t),
        r = s.find((h) => h.element === n),
        a = { element: n, height: n.offsetHeight, isSticky: !1, direction: i, directionDownHide: !1 },
        l = r ? s : t === 'top' ? [...s, a] : [a, ...s];
      return { ...e, [ps(t)]: l };
    });
  }
  function Ya(n, i) {
    g.set('xo-sticky', (t) => {
      const e = Rt(i),
        s = It(e, (r) => r.element !== n);
      return { ...t, [ps(i)]: s };
    });
  }
  function qt(n, i, t) {
    g.set('xo-sticky', (e) => {
      const s = Rt(t);
      return { ...e, [ps(t)]: nt(s, (r) => (r.element === n ? { ...r, isSticky: i } : r)) };
    });
  }
  function le(n, i, t) {
    g.set('xo-sticky', (e) => {
      const s = Rt(t);
      return { ...e, [ps(t)]: nt(s, (r) => (r.element === n ? { ...r, directionDownHide: i } : r)) };
    });
  }
  const nn = new Map();
  function fi(n, i) {
    var a;
    const t = Rt(i),
      e = ti(t, (l) => l.element === n),
      s = It(t, (l, h) => h < e && l.isSticky),
      r = yt(s, (l, h) => l + h.height, 0);
    return nn.set(n, r), (a = nn.get(n)) != null ? a : 0;
  }
  function rn(n, i) {
    const t = Rt(i),
      e = ti(t, (s) => s.element === n);
    return yt(t, (s, r, a) => (a < e && r.direction === 'up' && r.isSticky ? s + r.height : s), 0);
  }
  function xi(n) {
    const i = Rt(n);
    return yt(i, (e, s) => (s.directionDownHide ? e : s.isSticky ? e + s.height : e), 0);
  }
  function an(n, i) {
    return g.subscribe('xo-sticky', n, i);
  }
  const Gi = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'frameId', -1);
      o(this, 'shadow', null);
      o(this, 'innerEl');
      o(this, 'contentEl');
      o(this, 'prevScrollY', window.scrollY);
      o(this, '_options');
      o(this, 'setOptions', () => {
        this.options = $(this, { pick: ['xoDirection', 'xoPlacement', 'xoDisabled'], types: { xoDirection: 'string', xoPlacement: 'string', xoDisabled: 'boolean' } });
      });
      o(this, 'addSticky', () => {
        const { xoPlacement: t } = this.options,
          e = fi(this.contentEl, t);
        f.set(this.innerEl, 'xo-is-sticky', !0), t === 'top' ? (this.innerEl.style.top = `${e}px`) : (this.innerEl.style.bottom = `${e}px`);
      });
      o(this, 'removeStick', () => {
        const { xoPlacement: t } = this.options;
        f.set(this.innerEl, 'xo-is-sticky', !1), t === 'top' ? this.innerEl.style.removeProperty('top') : this.innerEl.style.removeProperty('bottom');
      });
      o(this, 'handleStickyTop', () => {
        const { xoDirection: t } = this.options,
          e = fi(this.contentEl, 'top'),
          s = rn(this.contentEl, 'top'),
          { top: r } = this.getBoundingClientRect(),
          a = window.scrollY < this.prevScrollY,
          l = this.contentEl.offsetHeight;
        t === 'up'
          ? a
            ? (r < e - l
                ? (this.addSticky(), qt(this.contentEl, !0, 'top'), le(this.contentEl, !1, 'top'), f.set(this, 'xo-is-sticky', !0))
                : r >= e && (this.removeStick(), qt(this.contentEl, !1, 'top'), le(this.contentEl, !0, 'top'), f.set(this, 'xo-is-sticky', !1)),
              (this.innerEl.style.transform = 'translateY(0px)'))
            : (r < e - l && (this.innerEl.style.transform = `translateY(-${l + e}px)`), le(this.contentEl, !0, 'top'))
          : (r < e - s
              ? (this.addSticky(), qt(this.contentEl, !0, 'top'), f.set(this, 'xo-is-sticky', !0))
              : r >= e && (this.removeStick(), qt(this.contentEl, !1, 'top'), f.set(this, 'xo-is-sticky', !1)),
            a ? (this.innerEl.style.transform = 'translateY(0px)') : (this.innerEl.style.transform = `translateY(-${s}px)`));
      });
      o(this, 'handleStickyBottom', () => {
        const { xoDirection: t } = this.options,
          e = fi(this.contentEl, 'bottom'),
          s = rn(this.contentEl, 'bottom'),
          { top: r } = this.getBoundingClientRect(),
          a = window.scrollY < this.prevScrollY,
          l = this.contentEl.offsetHeight,
          h = r - window.innerHeight + l;
        t === 'up'
          ? (h < e - s + l
              ? (this.addSticky(),
                qt(this.contentEl, !0, 'bottom'),
                le(this.contentEl, !1, 'bottom'),
                (this.innerEl.style.transform = 'translateY(0px)'),
                a && f.set(this, 'xo-is-sticky', !0))
              : h >= e + l &&
                (qt(this.contentEl, !1, 'bottom'), le(this.contentEl, !0, 'bottom'), (this.innerEl.style.transform = `translateY(${l + e}px)`), f.set(this, 'xo-is-sticky', !1)),
            a || ((this.innerEl.style.transform = `translateY(${l + e}px)`), le(this.contentEl, !0, 'bottom')))
          : (h < e - s
              ? (this.addSticky(), qt(this.contentEl, !0, 'bottom'), f.set(this, 'xo-is-sticky', !0))
              : h >= e && (this.removeStick(), qt(this.contentEl, !1, 'bottom'), f.set(this, 'xo-is-sticky', !1)),
            a ? (this.innerEl.style.transform = 'translateY(0px)') : (this.innerEl.style.transform = `translateY(${s}px)`));
      });
      o(this, 'handler', () => {
        this.frameId = requestAnimationFrame(() => {
          const { xoPlacement: t } = this.options,
            e = this.contentEl.offsetHeight;
          (this.contentEl.style.height = `${e}px`),
            (this.innerEl.style.height = `${e}px`),
            t === 'top' ? this.handleStickyTop() : this.handleStickyBottom(),
            (this.prevScrollY = window.scrollY);
        });
      });
      o(this, 'render', () => {
        const { cssText: t } = Wa;
        return `
        <style>${t}</style>
        <${c.StickyInner}>
          <${c.StickyContent}><slot></slot></${c.StickyContent}>
        </${c.StickyInner}>
      `;
      });
      o(this, 'init', async () => {
        const { xoDirection: t, xoPlacement: e } = this.options;
        (this.shadow = this.shadow || this.attachShadow({ mode: 'open' })),
          this.shadow.innerHTML || (this.shadow.innerHTML = this.render()),
          (this.innerEl = this.shadow.querySelector(c.StickyInner)),
          (this.contentEl = this.shadow.querySelector(c.StickyContent)),
          await P(100),
          Xa(this.contentEl, t, e),
          e === 'top' && (this.style.height = `${this.contentEl.offsetHeight}px`),
          this.handler(),
          window.addEventListener('scroll', this.handler),
          window.addEventListener('resize', this.handler);
      });
    }
    get options() {
      return { ...Gi.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    static get observedAttributes() {
      return ['xo-observed', 'xo-direction', 'xo-placement'];
    }
    connectedCallback() {
      this.setOptions();
      const { xoDisabled: t } = this.options;
      t ||
        (this.init(),
        (this.unsubscribe = g.subscribe('xo-popover', (e) => {
          const s = ie(e.data).find((h) => h.isOpen),
            r = !!(s != null && s.isOpen),
            a = s == null ? void 0 : s.triggerElement;
          (a == null ? void 0 : a.closest(c.Sticky)) ? f.set(this.innerEl, 'xo-lock', r && !!this.innerEl) : f.set(this.innerEl, 'xo-lock', !1);
        })));
    }
    disconnectedCallback() {
      const { xoPlacement: t } = this.options;
      this.innerEl &&
        (this.innerEl.style.removeProperty('height'),
        this.innerEl.style.removeProperty('transform'),
        this.innerEl.style.removeProperty('top'),
        this.innerEl.style.removeProperty('bottom')),
        this.contentEl && this.contentEl.style.removeProperty('height'),
        this.style.removeProperty('height'),
        f.set(this, 'xo-is-sticky', !1),
        this.innerEl && f.set(this.innerEl, 'xo-is-sticky', !1),
        window.removeEventListener('scroll', this.handler),
        window.removeEventListener('resize', this.handler),
        cancelAnimationFrame(this.frameId),
        this.contentEl && Ya(this.contentEl, t),
        this.unsubscribe();
    }
    async attributeChangedCallback(t, e, s) {
      e !== s && (this.disconnectedCallback(), await P(100), this.connectedCallback());
    }
  };
  let ms = Gi;
  o(ms, 'defaultOptions', { xoDirection: 'up', xoPlacement: 'top', xoDisabled: !1 });
  const ji = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', null);
      o(this, 'prevStickyHeight', 0);
    }
    get options() {
      const t = $(this, { pick: ['xoPlacement'], types: { xoPlacement: 'string' } });
      return { ...ji.defaultOptions, ...t };
    }
    connectedCallback() {
      const { xoPlacement: t } = this.options;
      this.unsubscribe = an(() => {
        const e = xi(t);
        this.prevStickyHeight !== e && ((this.style.height = `${e}px`), (this.prevStickyHeight = e));
      });
    }
    disconnectedCallback() {
      var t;
      (t = this.unsubscribe) == null || t.call(this);
    }
  };
  let fs = ji;
  o(fs, 'defaultOptions', { xoPlacement: 'top' });
  const gd = '';
  Ua();
  const gi = { subscribe: an, getStickyHeight: xi, getNodes: Rt };
  (window.xoSticky = gi), B({ [c.Sticky]: ms, [c.StickySpace]: fs });
  const Qi = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'unsubscribe2', () => {});
      o(this, 'timeId', -1);
      o(this, '_options');
      o(this, 'setOptions', () => {
        this.options = $(this, { pick: ['xoScrollTop', 'xoSectionId'], types: { xoScrollTop: 'boolean', xoSectionId: 'string' } });
      });
      o(this, 'getStickyHeight', () => {
        const t = gi.getNodes('top');
        return yt(t, (s, r) => s + r.height, 0);
      });
      o(this, 'listener', async () => {
        const { xoScrollTop: t } = this.options;
        if ((await P(100), t)) {
          const e = document.querySelector(c.FiltersTop);
          e ? window.scrollY > X(e).top && window.scrollTo({ top: X(e).top - this.getStickyHeight(), behavior: 'smooth' }) : window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
      o(this, 'listener2', () => {
        const { status: t } = wt();
        t === 'request' ? f.set(this, 'xo-loading', !0) : t === 'success' && f.set(this, 'xo-loading', !1);
      });
      o(this, 'handlePopState', async (t) => {
        t.preventDefault();
        const { search: e } = window.location,
          s = vt.parse(e),
          r = new FormData();
        E(s, ([a, l]) => {
          r.append(a, l);
        }),
          Oa(r),
          await sn(window.location.href),
          ds();
      });
      o(this, 'setDefaultFieldsFromParams', () => {
        const { search: t } = window.location,
          e = vt.parse(t),
          s = new FormData();
        E(e, ([l, h]) => {
          s.append(l, h);
        });
        const r = Ee(s),
          a = vt.parse(r);
        E(a, ([l, h]) => {
          const d = Array.from(this.querySelectorAll(`${c.FiltersField} [name="${l}"], ${c.FiltersField} xo-range[xo-name="${xt.price}"]`));
          E(d, (u) => {
            if (u)
              if ((dt(u, 'checkbox') || dt(u, 'radio')) && l === u.getAttribute('name')) {
                const p = this.querySelector(`[name='${l}'][value='${h}']`);
                if (((p.checked = !0), dt(p, 'radio'))) {
                  const m = Array.from(this.querySelectorAll(c.FiltersSortBySelected));
                  E(m, (x) => {
                    var y;
                    p.name === xt.sort && (x.textContent = (y = p.getAttribute('xo-label')) != null ? y : h);
                  });
                }
              } else if (dt(u, 'xo-range') && l === u.getAttribute('xo-name')) {
                const [p, m] = at(h);
                u.setAttribute('xo-value', `[${p}, ${m}]`), (u.value = [p, m]);
              } else u instanceof HTMLSelectElement && (u.value = h);
          });
        });
      });
    }
    get options() {
      return { ...Qi.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    async connectedCallback() {
      this.setOptions(),
        (this.timeId = window.setTimeout(() => {
          Na(), this.setDefaultFieldsFromParams(), ds(), Va(), Da(this.options.xoSectionId), clearTimeout(this.timeId);
        }, 50)),
        window.addEventListener('popstate', this.handlePopState),
        (this.unsubscribe = $t(
          this.listener,
          (t, e) =>
            !(
              (t != null && (t == null ? void 0 : t.html) !== (e == null ? void 0 : e.html) && t != null) ||
              (t != null && !Pt(t == null ? void 0 : t.refine, e == null ? void 0 : e.refine))
            ),
        )),
        (this.unsubscribe2 = $t(this.listener2, (t, e) => (t == null ? void 0 : t.status) === (e == null ? void 0 : e.status)));
    }
    attributeChangedCallback(t, e, s) {
      t === 'xo-observed' && e !== s && this.setOptions();
    }
    disconnectedCallback() {
      this.unsubscribe(), this.unsubscribe2(), window.removeEventListener('popstate', this.handlePopState), clearTimeout(this.timeId);
    }
  };
  let xs = Qi;
  o(xs, 'defaultOptions', { xoScrollTop: !0, xoSectionId: '' });
  class Ga extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'handleInput', async (t) => {
        var r, a;
        const e = t.target;
        if (e instanceof HTMLInputElement && e.type !== 'range')
          if (dt(e, 'checkbox')) e.checked ? Fa(e.name, e.value) : us(e.name, e.value);
          else {
            const l = document.querySelector(c.Filters);
            if (l && dt(e, 'radio')) {
              const h = e.closest(c.Popover),
                d = h == null ? void 0 : h.getAttribute('xo-name'),
                u = document.querySelector(`${c.PopoverTrigger}[xo-name="${d}"]`),
                p = Array.from((u != null ? u : l).querySelectorAll(c.FiltersSortBySelected));
              E(p, (m) => {
                var x;
                e.name === xt.sort && (m.textContent = (x = e.getAttribute('xo-label')) != null ? x : e.value);
              }),
                e.name === xt.sort && h && d && re.close(d);
            }
            ve(e.name, e.value);
          }
        else if (e instanceof HTMLSelectElement) ve(e.name, e.value);
        else if (dt(e, 'xo-range')) {
          const [l, h] = e.value,
            d = (r = Number(e.getAttribute('xo-min'))) != null ? r : 0,
            u = (a = Number(e.getAttribute('xo-max'))) != null ? a : 0;
          l === d && h === u ? us(xt.price) : ve(xt.price, `[${l}, ${h}]`);
        }
        const s = vt.parse(window.location.search, !0);
        s.page && ve('page', s.page), mi(), ds();
      });
      o(this, 'handleRange', st(this.handleInput));
      o(this, 'handler', (t) => {
        var e, s;
        !t ||
          (dt(t, 'xo-range')
            ? (Ia((e = Number(t.getAttribute('xo-min'))) != null ? e : 0, (s = Number(t.getAttribute('xo-max'))) != null ? s : 0), t.addEventListener('changed', this.handleRange))
            : t.addEventListener('change', this.handleInput));
      });
    }
    connectedCallback() {
      qa(this);
      const t = Array.from(this.querySelectorAll('input, select, xo-range'));
      E(t, this.handler);
    }
    disconnectedCallback() {
      const t = Array.from(this.querySelectorAll('input, select, xo-range'));
      E(t, (e) => {
        dt(e, 'xo-range') ? e.removeEventListener('change', this.handleRange) : e.removeEventListener('change', this.handleInput);
      });
    }
  }
  const Zi = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'listener', () => {
        const { refine: t, priceMin: e, priceMax: s } = wt(),
          { xoName: r, xoClearAll: a } = this.options;
        if (a) {
          const l = !!It(t, (h) => /filter./g.test(h.name)).length;
          f.set(this, 'xo-visible', l);
        } else f.set(this, 'xo-visible', !1);
        E(t, (l) => {
          if (!l.name.includes('filter.v.price.') && l.name === r) f.set(this, 'xo-visible', !0);
          else if (l.name.includes('filter.v.price.') && r.includes('filter.v.price.')) {
            const [h, d] = at(l.value);
            (h !== e || d !== s) && f.set(this, 'xo-visible', !0);
          }
        });
      });
      o(this, 'resetFields', () => {
        const { xoName: t, xoValue: e, xoClearAll: s } = this.options;
        let r = Array.from(
          document.querySelectorAll(
            `${c.FiltersField} input[type="radio"][name="${t}"]${e ? `[value="${e}"]` : ''}, ${c.FiltersField} input[type="checkbox"][name="${t}"]${e ? `[value="${e}"]` : ''}, ${
              c.FiltersField
            } xo-range[xo-name="${t}"], ${c.FiltersField} select[name="${t}"]`,
          ),
        );
        s &&
          (r = Array.from(
            document.querySelectorAll(`${c.FiltersField} input[type="radio"], ${c.FiltersField} input[type="checkbox"], ${c.FiltersField} xo-range, ${c.FiltersField} select`),
          )),
          E(r, (a) => {
            if ((a && dt(a, 'checkbox')) || dt(a, 'radio')) a.removeAttribute('checked'), (a.checked = !1);
            else if (dt(a, 'xo-range')) a.value = [a.min, a.max];
            else if (dt(a, 'select')) {
              const l = a.querySelector('option');
              a.value = (l == null ? void 0 : l.value) || '';
            }
          });
      });
      o(this, 'handleClick', async () => {
        const { xoName: t, xoValue: e, xoClearAll: s } = this.options;
        s ? Ha() : (en(t, e), us(t, e), t.includes('filter.v.price.') && (en(xt.price), us(xt.price))), await mi(), this.resetFields();
      });
    }
    get options() {
      const t = $(this, { pick: ['xoName', 'xoValue', 'xoClearAll'], types: { xoName: 'string', xoValue: 'string', xoClearAll: 'boolean' } });
      return { ...Zi.defaultOptions, ...t };
    }
    connectedCallback() {
      this.addEventListener('click', this.handleClick), (this.unsubscribe = $t(this.listener));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.removeEventListener('click', this.handleClick);
    }
  };
  let gs = Zi;
  o(gs, 'defaultOptions', { xoName: '', xoClearAll: !1 });
  class ja extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'childEls', []);
      o(this, 'setEmpty', () => {
        const { refine: t } = wt(),
          e = !It(t, (s) => /filter./g.test(s.name)).length;
        f.set(this, 'xo-empty', e);
      });
      o(this, 'render', () => {
        var s, r;
        const t = (r = (s = this.closest(c.Filters)) == null ? void 0 : s.getAttribute('xo-money-format')) != null ? r : '',
          { refine: e } = wt();
        return nt(e, (a) => {
          var u, p, m;
          if (!/filter./g.test(a.name)) return '';
          const l = document.querySelector(
              `${c.FiltersField} input[type="radio"][name="${a.name}"][value="${a.value}"], ${c.FiltersField} input[type="checkbox"][name="${a.name}"][value="${a.value}"], ${c.FiltersField} xo-range[xo-name="${a.name}"]`,
            ),
            h = a.name.includes('filter.v.price.')
              ? nt(at(a.value), (x) => t.replace(/{.*}|(\d+(,|\.)?)+/g, `${x}`)).join(' - ')
              : (u = l == null ? void 0 : l.getAttribute('xo-label')) != null
              ? u
              : '',
            d = (m = (p = this.querySelector(c.FiltersRefineClearIcon)) == null ? void 0 : p.innerHTML) != null ? m : '<span>&times;</span>';
          return `
          <${c.FiltersClear} xo-name="${a.name}" xo-value="${a.value}">
            ${h} ${d}
          </${c.FiltersClear}>
        `;
        });
      });
      o(this, 'listener', () => {
        this.setEmpty(),
          (this.innerHTML = this.render().join('')),
          E(this.childEls, (t) => {
            this.appendChild(t);
          });
      });
    }
    connectedCallback() {
      this.childEls.length === 0 && (this.childEls = Array.from(this.childNodes)), this.setEmpty(), (this.unsubscribe = $t(this.listener));
    }
    disconnectedCallback() {
      var t;
      (t = this.unsubscribe) == null || t.call(this);
    }
  }
  const bi = new pe();
  class Qa extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'callback', null);
      o(this, 'handleContent', (t) => {
        this.callback = t;
      });
      o(this, 'listener', () => {
        const { html: t, prevHtml: e, status: s } = wt();
        if (s === 'success' && t !== e) {
          const l = new DOMParser().parseFromString(t, 'text/html').querySelector(c.FiltersContent);
          if (l) {
            const h = l.cloneNode(!0),
              d = Array.from(h.querySelectorAll(c.Animate));
            E(d, (u) => {
              f.set(u, 'xo-disabled', !0);
            }),
              this.callback ? (this.innerHTML = this.callback(h.innerHTML)) : (this.innerHTML = h.innerHTML),
              bi.emit('done', void 0),
              Ra();
          }
        }
      });
    }
    connectedCallback() {
      this.unsubscribe = $t(this.listener);
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  class Za extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'listener', () => {
        const { status: t } = wt();
        t === 'request' ? f.set(this, 'xo-visible', !0) : t === 'success' && f.set(this, 'xo-visible', !1);
      });
    }
    connectedCallback() {
      this.unsubscribe = $t(this.listener, (t, e) => t.status === e.status);
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  const Ki = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'queueId', -1);
      o(this, 'listener', () => {
        Ba(this.queueId),
          (this.queueId = za(() => {
            var l;
            const { xoUniqueId: t } = this.options,
              { html: e } = wt(),
              a = new DOMParser().parseFromString(e, 'text/html').querySelector(`${c.FiltersCount}[xo-unique-id="${t}"]`);
            if (a && a.textContent && this.textContent !== a.textContent) {
              const h = (l = Number(a.textContent.trim().replace(/\D*/g, ''))) != null ? l : 0;
              this.textContent = a.textContent;
              const d = this.closest(c.FiltersField);
              d && f.set(d, 'xo-disabled', h === 0);
            }
          }));
      });
    }
    get options() {
      const t = $(this, { pick: ['xoUniqueId'], types: { xoUniqueId: 'string' } });
      return { ...Ki.defaultOptions, ...t };
    }
    connectedCallback() {
      const { xoUniqueId: t } = this.options,
        e = this.closest(c.FiltersField);
      if (!t) throw new Error(`${c.FiltersCount}: Attribute xo-unique-id is required (Note: xo-unique-id is unique)`);
      if (!e) throw new Error(`${c.FiltersCount} must be inside ${c.FiltersField}`);
      this.unsubscribe = $t(this.listener);
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  };
  let bs = Ki;
  o(bs, 'defaultOptions', { xoUniqueId: '' });
  const Ji = class extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'listener', () => {
        const { xoUniqueId: t } = this.options,
          { html: e } = wt(),
          a = new DOMParser().parseFromString(e, 'text/html').querySelector(`${c.FiltersActiveSize}[xo-unique-id="${t}"]`);
        a && a.textContent && (this.textContent = a.textContent);
      });
    }
    get options() {
      const t = $(this, { pick: ['xoUniqueId'], types: { xoUniqueId: 'string' } });
      return { ...Ji.defaultOptions, ...t };
    }
    connectedCallback() {
      const { xoUniqueId: t } = this.options;
      if (!t) throw new Error(`${c.FiltersActiveSize}: Attribute xo-unique-id is required (Note: xo-unique-id is unique)`);
      this.unsubscribe = $t(this.listener);
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  };
  let ys = Ji;
  o(ys, 'defaultOptions', { xoUniqueId: '' });
  class Ka extends HTMLElement {
    constructor() {
      super();
      o(this, 'unsubscribe', () => {});
      o(this, 'anchorEls');
      o(this, 'observer');
      o(this, 'handleClick', (t) => {
        t.preventDefault();
        const e = new URL(t.currentTarget.href),
          s = vt.parse(e.search, !0);
        ve('page', s.page, !0), mi(), ds();
      });
      o(this, 'listener', () => {
        const { html: t } = wt(),
          r = new DOMParser().parseFromString(t, 'text/html').querySelector(c.FiltersPaginate);
        r && r.innerHTML && (this.innerHTML = r.innerHTML);
      });
      (this.anchorEls = Array.from(this.querySelectorAll('a'))),
        (this.observer = new MutationObserver(() => {
          (this.anchorEls = Array.from(this.querySelectorAll('a'))),
            E(this.anchorEls, (t) => {
              t.removeEventListener('click', this.handleClick), t.addEventListener('click', this.handleClick);
            });
        })),
        this.observer.observe(this, { childList: !0 });
    }
    connectedCallback() {
      (this.unsubscribe = $t(this.listener)),
        E(this.anchorEls, (t) => {
          t.removeEventListener('click', this.handleClick), t.addEventListener('click', this.handleClick);
        });
    }
    disconnectedCallback() {
      this.unsubscribe(),
        this.observer.disconnect(),
        E(this.anchorEls, (t) => {
          t.removeEventListener('click', this.handleClick);
        });
    }
  }
  const bd = '';
  _a(),
    La(),
    (window.xoFilters = bi),
    B({
      [c.Filters]: xs,
      [c.FiltersField]: Ga,
      [c.FiltersClear]: gs,
      [c.FiltersRefine]: ja,
      [c.FiltersContent]: Qa,
      [c.FiltersFallback]: Za,
      [c.FiltersCount]: bs,
      [c.FiltersActiveSize]: ys,
      [c.FiltersPaginate]: Ka,
    });
  const yi = {
    arrow: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#fff" x="0px" y="0px" width="18" viewBox="0 0 263.7 473.1" xml:space="preserve">
    <path d="M244.5,473.1c-4.9,0-9.8-1.9-13.6-5.6L0,236.5L230.9,5.6c7.5-7.5,19.7-7.5,27.2,0c7.5,7.5,7.5,19.7,0,27.2L54.3,236.5 l203.7,203.7c7.5,7.5,7.5,19.7,0,27.2C254.3,471.2,249.4,473.1,244.5,473.1z"/>
  </svg>`,
    close: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#fff"  width="18" x="0px" y="0px" viewBox="0 0 56.213 55.962" xml:space="preserve">
    <path d="M48.82,53.907,27.483,32.572,6.146,53.907a3.6,3.6,0,0,1-5.091-5.09L22.393,27.481,1.055,6.145a3.6,3.6,0,0,1,5.09-5.09L27.483,22.391,48.82,1.055a3.6,3.6,0,0,1,5.09,5.09L32.573,27.482,53.911,48.818a3.6,3.6,0,1,1-5.09,5.09Z" transform="translate(0.747 0.5)"/>
  </svg>`,
  };
  let Vt = 0;
  const to = class extends HTMLElement {
    constructor() {
      super();
      o(this, 'itemEls', []);
      o(this, 'portalEl', null);
      o(this, 'portalContent');
      o(this, '_options');
      o(this, 'setOptions', () => {
        this.options = {
          ...$(this, {
            pick: ['xoAnimate', 'xoDuration', 'xoEasing', 'xoBackdropColor', 'xoSync', 'xoPortalClass'],
            types: { xoAnimate: 'string', xoDuration: 'number', xoEasing: 'string', xoBackdropColor: 'string', xoSync: 'boolean', xoPortalClass: 'string' },
          }),
        };
      });
      o(this, 'renderPortal', (t, e) => {
        const { xoAnimate: s, xoDuration: r, xoEasing: a, xoBackdropColor: l } = this.options;
        t.setAttribute('xo-name', `${Vt}`), t.setAttribute('xo-index', `${e}`);
        const h = t.getAttribute('xo-intrinsic-width'),
          d = t.getAttribute('xo-src'),
          p = /\.(mp4|webm|ogg)$/i.test(d),
          m = h ? So(d, { width: h }) : d,
          x = p
            ? `<video src="${d}" controls title="Video" />`
            : `<${c.ImageZoom} xo-zoom="1" xo-zoom-src="${m}" xo-zoom-full><img xo-cropped src="${d}" alt="" width="1000" height="1000"></${c.ImageZoom}>`;
        return `
        <${c.Modal} xo-portal="false" xo-name="${Vt}" xo-duration="${r}" xo-animate="${s}" xo-easing="${a}" xo-backdrop-color="${l}">
          <${c.ModalPan} xo-intentional-axis>
            ${x}
          </${c.ModalPan}>
        </${c.Modal}>
      `;
      });
      o(
        this,
        'renderContent',
        () => `
        ${this.portalContent}
        <${c.GalleryPrev}>
          ${yi.arrow}
        </${c.GalleryPrev}>
        <${c.GalleryNext}>
          ${yi.arrow}
        </${c.GalleryNext}>
        <${c.ModalTrigger} xo-name="${Vt}">
          ${yi.close}
        </${c.ModalTrigger}>
        <${c.GalleryCounter} xo-name="${Vt}"></${c.GalleryCounter}>
      `,
      );
      o(this, 'handlePortal', () => {
        const { xoPortalClass: t } = this.options,
          e = document.querySelector(`${c.GalleryPortal}[xo-name="${Vt}"]`);
        e && e.remove(),
          (this.itemEls = Array.from(this.querySelectorAll(c.GalleryItem))),
          (this.portalContent = nt(this.itemEls, this.renderPortal).join('')),
          (this.portalEl = document.createElement(c.GalleryPortal)),
          (this.portalEl.className = t),
          this.portalEl.setAttribute('xo-name', `${Vt}`),
          (this.portalEl.innerHTML = this.renderContent()),
          document.body.appendChild(this.portalEl);
      });
      Vt++;
    }
    get options() {
      return { ...to.defaultOptions, ...this._options };
    }
    set options(t) {
      this._options = t;
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    async connectedCallback() {
      var t;
      (t = window.xbEditor) != null && t.designMode && (await P(100)), this.setAttribute('xo-name', `${Vt}`), this.setOptions(), this.handlePortal();
    }
    disconnectedCallback() {
      var t;
      (this.itemEls = []), (t = this.portalEl) == null || t.remove();
    }
    attributeChangedCallback(t, e, s) {
      if (t === 'xo-observed' && e !== s) {
        this.setOptions(), this.handlePortal();
        const r = Array.from(this.querySelectorAll(c.GalleryItem));
        E(r, (a) => {
          a.setAttribute('xo-observed', s);
        });
      }
    }
  };
  let vs = to;
  o(vs, 'defaultOptions', { xoAnimate: 'smart-zoom', xoDuration: 300, xoEasing: 'decay', xoBackdropColor: 'rgba(0, 0, 0, 0.5)', xoSync: !0, xoPortalClass: '' });
  function Ja() {
    g.create('xo-gallery', { initialState: { indexes: {}, galleryName: '' } });
  }
  function Zt(n, i) {
    g.set('xo-gallery', (t) => ({ ...t, indexes: { ...t.indexes, [n]: i } }));
  }
  function tl(n) {
    g.set('xo-gallery', (i) => ({ ...i, galleryName: n }));
  }
  function el(n) {
    const { indexes: i } = Kt(),
      e = (i[n] || 0) + 1;
    Zt(n, e);
  }
  function sl(n) {
    const { indexes: i } = Kt(),
      e = (i[n] || 0) - 1;
    Zt(n, e);
  }
  function Kt() {
    return g.get('xo-gallery');
  }
  function vi(n) {
    return g.subscribe('xo-gallery', n);
  }
  class il extends HTMLElement {
    constructor() {
      super();
      o(this, 'triggerEl');
      o(this, 'unsubscribe', () => {});
      o(this, 'listener', () => {
        const { indexes: t, galleryName: e } = Kt(),
          s = t[e],
          r = this.getAttribute('xo-name');
        (this.triggerEl.style.visibility = 'visible'),
          r === e && s === this.getIndex() && this.triggerEl.getAttribute('xo-sync') != null && (this.triggerEl.style.visibility = 'hidden');
      });
      o(this, 'handleClick', (t) => {
        const s = t.target.closest(c.GalleryItem),
          r = Number(s.getAttribute('xo-index')),
          a = s.getAttribute('xo-name'),
          l = document.querySelector(`${c.GalleryPortal}[xo-name="${a}"]`);
        l && l.scrollTo({ left: r * l.offsetWidth }), tl(a), Zt(a, r);
      });
      this.triggerEl = this.querySelector(c.ModalTrigger);
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    getSrc() {
      return this.getAttribute('xo-thumb-src') || '';
    }
    getName() {
      return this.getAttribute('xo-name') || '';
    }
    getIndex() {
      return Number(this.getAttribute('xo-index'));
    }
    async connectedCallback() {
      var e;
      (e = window.xbEditor) != null && e.designMode && (await P(100)), (this.triggerEl = this.querySelector(c.ModalTrigger));
      const t = this.closest(c.Gallery);
      if (t) {
        if (this.getSrc()) {
          const s = this.querySelector(c.ModalTrigger);
          s && s.remove(),
            this.insertAdjacentHTML(
              'afterbegin',
              `<${c.ModalTrigger} xo-name="${this.getName()}" ${
                t.options.xoSync && t.options.xoAnimate === 'smart-zoom' ? 'xo-sync' : ''
              }><img src="${this.getSrc()}" loading="lazy" alt="" width="500" height="500"></${c.ModalTrigger}>`,
            );
        } else {
          if (this.children.length > 1) throw new Error(`${c.GalleryItem} should have only one child.`);
          const s = this.children[0],
            r = document.createElement(c.ModalTrigger);
          r.setAttribute('xo-name', this.getName()), r.appendChild(s), t.options.xoSync && t.options.xoAnimate === 'smart-zoom' && f.set(r, 'xo-sync', !0), this.appendChild(r);
        }
        (this.triggerEl = this.querySelector(c.ModalTrigger)), this.triggerEl.addEventListener('click', this.handleClick), (this.unsubscribe = vi(this.listener));
      }
    }
    disconnectedCallback() {
      this.triggerEl.removeEventListener('click', this.handleClick), this.unsubscribe();
    }
    async attributeChangedCallback(t, e, s) {
      if (t === 'xo-observed' && e !== s) {
        await P(100);
        const { galleryName: r } = Kt();
        Zt(r, -1), this.disconnectedCallback(), this.connectedCallback();
      }
    }
  }
  class ol extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'unsubscribe2', () => {});
      o(this, 'listener', () => {
        const { indexes: t, galleryName: e } = Kt(),
          s = t[e],
          r = document.querySelector(`${c.Gallery}[xo-name="${e}"]`),
          a = Array.from(this.querySelectorAll(`${c.Modal} video`));
        E(a, (l, h) => {
          h === s ? l.play() : l.pause();
        }),
          s >= 0 &&
            g.set('xo-modal', (l) => ({
              ...l,
              data: { ...l.data, [this.getName()]: { ...l.data[this.getName()], triggerElement: r.querySelectorAll(c.GalleryItem)[s].querySelector(c.ModalTrigger) } },
            }));
      });
      o(this, 'handleScroll', () => {
        const { indexes: t, galleryName: e } = Kt(),
          s = t[e],
          { scrollLeft: r } = this,
          a = Math.round(r / this.offsetWidth);
        s !== a && Zt(e, a);
      });
    }
    getName() {
      return this.getAttribute('xo-name') || '';
    }
    connectedCallback() {
      this.addEventListener('scroll', this.handleScroll),
        (this.unsubscribe = g.subscribe('xo-modal', (t) => {
          var s, r;
          const e = (r = (s = t.data) == null ? void 0 : s[this.getName()]) == null ? void 0 : r.isOpen;
          f.set(this, 'xo-active', e), e ? (document.body.style.overflow = 'hidden') : document.body.style.removeProperty('overflow');
        })),
        (this.unsubscribe2 = vi(this.listener));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.unsubscribe2(), this.removeEventListener('scroll', this.handleScroll);
    }
  }
  const nl = 20;
  class rl extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'handleClick', () => {
        const t = this.closest(c.GalleryPortal),
          e = t.getAttribute('xo-name') || '';
        if (t.scrollLeft - t.offsetWidth >= nl) t.scrollTo(t.scrollLeft - t.offsetWidth, 0), sl(e);
        else {
          t.scrollTo(t.scrollWidth - t.offsetWidth, 0);
          const s = Math.round((t.scrollWidth - t.offsetWidth) / t.offsetWidth);
          Zt(e, s);
        }
      });
    }
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }
  }
  class al extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'handleClick', () => {
        const t = this.closest(c.GalleryPortal),
          e = t.getAttribute('xo-name') || '';
        t.scrollLeft + t.offsetWidth < t.scrollWidth - t.offsetWidth ? (t.scrollTo(t.scrollLeft + t.offsetWidth, 0), el(e)) : (t.scrollTo(0, 0), Zt(e, 0));
      });
    }
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }
  }
  class ll extends HTMLElement {
    constructor() {
      super();
      o(this, 'unsubscribe', () => {});
      o(this, 'listener', () => {
        const { indexes: t } = Kt(),
          e = t[this.name],
          s = document.querySelector(`${c.Gallery}[xo-name="${this.name}"]`);
        s && (this.innerText = `${e + 1} / ${s.querySelectorAll(c.GalleryItem).length}`);
      });
      this.unsubscribe = vi(this.listener);
    }
    get name() {
      return this.getAttribute('xo-name') || '';
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  const yd = '';
  Ja(), B({ [c.Gallery]: vs, [c.GalleryItem]: il, [c.GalleryPortal]: ol, [c.GalleryPrev]: rl, [c.GalleryNext]: al, [c.GalleryCounter]: ll });
  const Ei = 'quantity',
    Es = 'QUICKVIEW_FIELD_SIGNAL',
    wi = 'STICKY_FIELD_SIGNAL';
  function cl() {
    g.create('xo-cart-form', { initialState: {} });
  }
  function ws(n, i, t) {
    const e = `${n}/${i}`;
    g.set('xo-cart-form', (s) => {
      var a, l;
      const r = (l = (a = s == null ? void 0 : s[e]) == null ? void 0 : a[Ei]) != null ? l : 1;
      return { ...s, [e]: { ...(s == null ? void 0 : s[e]), [Ei]: Math.max(1, t(r)) } };
    })('xo-cart-form/setFormQuantity');
  }
  function Cs(n, i, t, e) {
    const s = `${n}/${i}`;
    g.set('xo-cart-form', (r) => {
      var a;
      return { ...r, [s]: { ...(r == null ? void 0 : r[s]), variantSelected: { ...((a = r == null ? void 0 : r[s]) == null ? void 0 : a.variantSelected), [t]: e } } };
    })('xo-cart-form/setFormVariant');
  }
  function hl(n, i) {
    const t = `${n}/${i}`;
    g.set('xo-cart-form', (e) => {
      const { [t]: s, ...r } = e;
      return r;
    })('xo-cart-form/removeCartFormItem');
  }
  function zt() {
    return g.get('xo-cart-form');
  }
  function Ss(n, i) {
    return g.subscribe('xo-cart-form', n, i);
  }
  function dl() {
    g.create('xo-product', { initialState: { status: 'idle', productHtml: '', pickupAvailabilityHtml: '', quickviewProductHtml: '', featuredProductHtmls: {}, productData: {} } });
  }
  function ul(n) {
    g.set('xo-product', (i) => ({ ...i, productData: { ...i.productData, [n.id]: n } }))('xo-product/setProductData');
  }
  async function Ci(n, i = !1) {
    const t = new URL(n);
    t.search = '';
    const e = t.href;
    try {
      g.set('xo-product', (r) => ({ ...r, status: 'loading' }))('xo-product/getProductHtml/request');
      const s = await Bt.getProductHtml(n);
      g.set('xo-product', (r) => ({
        ...r,
        status: 'success',
        productHtml: i ? r.productHtml : s,
        featuredProductHtmls: i ? { ...r.featuredProductHtmls, [e]: s } : r.featuredProductHtmls,
        productUrl: e,
      }))('xo-product/getProductHtml/success');
    } catch {
      g.set('xo-product', (s) => ({ ...s, status: 'error' }))('xo-product/getProductHtml/failure');
    }
  }
  async function pl(n) {
    const i = new URL(n);
    i.search = '';
    const t = i.href;
    try {
      g.set('xo-product', (s) => ({ ...s, status: 'loading' }))('xo-product/getQuickviewProductHtml/request');
      const e = await Bt.getProductHtml(n);
      g.set('xo-product', (s) => ({ ...s, status: 'success', quickviewProductHtml: e, productUrl: t }))('xo-product/getQuickviewProductHtml/success');
    } catch {
      g.set('xo-product', (e) => ({ ...e, status: 'error' }))('xo-product/getQuickviewProductHtml/failure');
    }
  }
  async function ml(n, i) {
    try {
      const t = Mt(n, i),
        e = await Bt.getPickupAvailability(t);
      g.set('xo-product', (s) => ({ ...s, pickupAvailabilityHtml: e }))('xo-product/getPickupAvailabilityHtml');
    } catch (t) {
      console.log(t);
    }
  }
  function Jt() {
    return g.get('xo-product');
  }
  function fl(n, i) {
    return g.subscribe('xo-product', n, i);
  }
  class xl {
    constructor() {
      o(this, 'hasFieldSignal', (i) => /\[|\]/g.test(i));
      o(this, 'addFieldSignal', (i, t) => (this.hasFieldSignal(i) ? i : `[${t}]${i}`));
      o(this, 'removeFieldSignal', (i) => i.replace(/^\[.*\]/g, ''));
    }
  }
  const lt = new xl();
  function gl() {
    return window.XO_DEV ? !0 : window.location.pathname.includes('/products/');
  }
  function Si(n, i, t) {
    (n.closest(c.Cart) || n.closest(c.CartMini)) && pn(i, t);
  }
  function ln(n, i) {
    const e = new DOMParser().parseFromString(n, 'text/html'),
      s = e.querySelector('.shopify-section'),
      r = Array.from(e.querySelectorAll(`${c.Product}[xo-product-id]`));
    i &&
      E(r, (h) => {
        const d = h.getAttribute('xo-product-id');
        i.includes(d) || h.remove();
      });
    const a = s.querySelector(c.Cart);
    if (a) return a.innerHTML;
    const l = s.querySelector(c.CartMini);
    return l ? l.innerHTML : s.innerHTML;
  }
  function Mt(n, i) {
    var l, h, d, u, p;
    const t = `${n}/${i}`;
    let e = '';
    const s = (h = (l = zt()) == null ? void 0 : l[t]) == null ? void 0 : h.variantSelected,
      { productData: r } = Jt(),
      a = (d = r == null ? void 0 : r[i]) == null ? void 0 : d.variants;
    if (s && a) {
      const m = ie(s);
      e =
        (p =
          (u = a.find((x) => (x.options.length === m.length ? Pt(x.options.sort(), m.sort()) : x.options.sort().toString().includes(m.sort().toString())))) == null
            ? void 0
            : u.id) != null
          ? p
          : '';
    }
    return e;
  }
  function bl(n, i, t, e) {
    var h, d, u;
    const s = `${n}/${i}`,
      r = (d = (h = zt()) == null ? void 0 : h[s]) == null ? void 0 : d.variantSelected,
      { productData: a } = Jt(),
      l = (u = a == null ? void 0 : a[i]) == null ? void 0 : u.variants;
    if (r && l) {
      const p = ie({ ...r, [t]: e }).filter(Boolean);
      return l.some((m) => Pt(m.options.sort(), p.sort()) && m.available);
    }
    return !0;
  }
  function yl(n, i, t, e) {
    var h, d, u;
    const s = `${n}/${i}`,
      r = (d = (h = zt()) == null ? void 0 : h[s]) == null ? void 0 : d.variantSelected,
      { productData: a } = Jt(),
      l = (u = a == null ? void 0 : a[i]) == null ? void 0 : u.variants;
    if (r && l) {
      const p = ie({ ...r, [t]: e }).filter(Boolean);
      return l.some((m) => m.options.every((x) => p.includes(x)));
    }
    return !0;
  }
  function ki(n, i = !0) {
    var e;
    const t = n.closest(c.Modal) || n.closest(c.Popover);
    if (t && (t.getAttribute('xo-for-cart-mini') === null || n.tagName.toLowerCase() === c.CartMini)) {
      const s = (e = t.getAttribute('xo-name')) != null ? e : '';
      t.tagName.toLowerCase() === c.Modal ? ne[i ? 'open' : 'close'](s) : re[i ? 'open' : 'close'](s);
    }
  }
  function we(n) {
    const i = n.closest(c.Cart) || n.closest(c.CartMini);
    if (!i) return;
    const t = n.getAttribute('xo-product-id'),
      e = Array.from(i.querySelectorAll(c.Product));
    return (
      yt(
        e,
        (l, h) => {
          const d = h.getAttribute('xo-product-id');
          return l.includes(d) ? l : [...l, d];
        },
        [],
      ).indexOf(t) + 1
    );
  }
  function ks() {
    var e, s, r, a, l, h, d, u;
    if (window.Xotiny) {
      const p = (e = document.querySelector(c.Cart)) == null ? void 0 : e.id,
        m = (s = document.querySelector(c.CartMini)) == null ? void 0 : s.id;
      return window.location.pathname.includes('/cart') ? [p, m] : [m];
    }
    const n = document.querySelector('cart-notification'),
      i =
        (l =
          (a = (r = document.querySelector('.shopify-section[id^="shopify-section-template--"][id$="__cart-items"]')) == null ? void 0 : r.id) == null
            ? void 0
            : a.replace(/^shopify-section-/g, '')) != null
          ? l
          : '',
      t =
        (u =
          (d = (h = document.querySelector('.shopify-section[id^="shopify-section-template--"][id$="__cart-footer"]')) == null ? void 0 : h.id) == null
            ? void 0
            : d.replace(/^shopify-section-/g, '')) != null
          ? u
          : '';
    return n
      ? window.location.pathname.includes('/cart')
        ? [i, t, 'cart-icon-bubble', 'cart-live-region-text'].filter(Boolean)
        : ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble']
      : window.location.pathname.includes('/cart')
      ? [i, t, 'cart-icon-bubble', 'cart-live-region-text'].filter(Boolean)
      : ['cart-drawer', 'cart-icon-bubble'];
  }
  function vl() {
    var s, r;
    const n = Array.from(document.querySelectorAll('input[name="selling_radio"]')),
      i = document.querySelector('input[name="selling_plan"]'),
      t = (s = n.find((a) => a.checked)) == null ? void 0 : s.value,
      e = i ? ((r = i == null ? void 0 : i.value) != null ? r : '') : void 0;
    return { sellingRadio: t, sellingPlan: e };
  }
  async function El(n, i, t, e, s, r, a) {
    var u;
    const l = new FormData();
    if (
      (l.append('form_type', 'product'),
      l.append('utf8', '\u2713'),
      l.append('id', n),
      l.append('quantity', `${i}`),
      l.append('product-id', t),
      r != null && l.append('selling_radio', r),
      a != null && l.append('selling_plan', a),
      e != null && e['properties[__shopify_send_gift_card_to_recipient]'])
    )
      for (const p in e) {
        const m = e[p];
        l.append(p, m);
      }
    if ((l.append('sections', ks()), l.append('section_url', window.location.pathname), s))
      for (const p in s) {
        const m = s[p];
        l.append(p, m);
      }
    const h = await fetch(`${window.Shopify.routes.root}cart/add`, {
      method: 'POST',
      body: l,
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if ((window.XO_DEV && (await P(400)), h.status === 404)) return Promise.reject(new Error(h.statusText));
    if (h.status === 422) {
      const p = await h.json();
      return Promise.reject(new Error((u = p == null ? void 0 : p.description) != null ? u : p.message));
    }
    const d = await h.json();
    return d.status ? Promise.reject(d) : d;
  }
  async function wl(n, i) {
    const e = {
        items: nt(n, (a, l) => {
          var h;
          return { id: a, quantity: i.length === 1 ? i[0] : (h = i[l]) != null ? h : 1 };
        }),
        sections: ks(),
        section_url: window.location.pathname,
      },
      s = await fetch(`${window.Shopify.routes.root}cart/add`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(e),
      });
    if ((window.XO_DEV && (await P(400)), s.status === 404)) return Promise.reject(new Error(s.statusText));
    const r = await s.json();
    return r.errors ? Promise.reject(r) : r;
  }
  async function Cl(n, i) {
    const t = await fetch(`${window.Shopify.routes.root}cart/change`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: n, quantity: i, sections: ks(), section_url: window.location.pathname }),
    });
    if ((window.XO_DEV && (await P(400)), t.status === 404)) return Promise.reject(new Error(t.statusText));
    const e = await t.json();
    return e.errors ? Promise.reject(e) : e;
  }
  async function Sl(n, i) {
    const t = await fetch(`${window.Shopify.routes.root}cart/change`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: n, quantity: i, sections: ks(), section_url: window.location.pathname }),
    });
    if ((window.XO_DEV && (await P(400)), t.status === 404)) return Promise.reject(new Error(t.statusText));
    const e = await t.json();
    return e.errors ? Promise.reject(e) : e;
  }
  async function kl(n) {
    const i = await fetch(`${window.Shopify.routes.root}cart/update`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: n }),
    });
    return window.XO_DEV && (await P(400)), i.status !== 200 && i.status !== 201 ? Promise.reject(i.statusText) : await i.json();
  }
  async function Al(n, i, t) {
    const e = await fetch(`${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address[zip]=${n}&shipping_address[country]=${i}&shipping_address[province]=${t}`, {
      method: 'GET',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    });
    if ((window.XO_DEV && (await P(400)), e.status === 404)) return Promise.reject(new Error(e.statusText));
    const s = await e.json();
    return s.shipping_rates ? s : Promise.reject(ie(s).flatMap((r) => r));
  }
  async function Pl(n) {
    const i = await fetch(n, { method: 'GET' });
    return window.XO_DEV && (await P(400)), i.status !== 200 && i.status !== 201 ? Promise.reject(i.statusText) : await i.text();
  }
  async function Tl(n) {
    const i = await fetch(`${window.Shopify.routes.root}variants/${n}/?section_id=pickup-availability`, { method: 'GET' });
    return i.status !== 200 && i.status !== 201 ? Promise.reject(i.statusText) : await i.text();
  }
  const Bt = { addCart: El, addCartMulti: wl, changeCart: Cl, changeCartByVariantId: Sl, getProductHtml: Pl, postCartNote: kl, getShippingRates: Al, getPickupAvailability: Tl },
    $l = { 'properties[__shopify_send_gift_card_to_recipient]': '', 'properties[Message]': '', 'properties[Recipient email]': '', 'properties[Recipient name]': '' };
  function cn(n, i) {
    g.set('xo-recipient', (t) => ({ ...t, [n]: i }))('xo-cart/setRecipientState');
  }
  function Ml() {
    g.set('xo-recipient', $l)('xo-cart/resetRecipientState');
  }
  function hn() {
    return g.get('xo-recipient');
  }
  function Ll(n, i) {
    return g.subscribe('xo-recipient', n, i);
  }
  function Il() {
    g.create('xo-cart', {
      initialState: { addIdLoading: '', isAdded: !1, variantId: '', changeLineLoading: -1, addErrorMessage: '', changeErrorMessage: '', size: 0, sections: { [c.Cart]: '' } },
    });
  }
  function Dl(n) {
    g.set('xo-cart', (i) => ({ ...i, size: n }))('xo-cart/setCartSize');
  }
  function Nl(n, i) {
    const t = `${n}/${i}`;
    g.set('xo-cart', (e) => ({ ...e, addIdLoading: t, addErrorMessage: '', isAdded: !1, variantId: '', productIdsForCartNotification: void 0 }))('xo-cart/addCartRequest');
  }
  async function Ol(n, i, t, e, s, r) {
    var l, h, d, u, p, m, x;
    const a = `${n}/${i}`;
    try {
      let y = i;
      const b = (h = (l = zt()) == null ? void 0 : l[a]) == null ? void 0 : h.variantSelected,
        { productData: v } = Jt(),
        k = (d = v == null ? void 0 : v[i]) == null ? void 0 : d.variants;
      (u = k == null ? void 0 : k[0]) != null && u.id && (y = (p = k == null ? void 0 : k[0]) == null ? void 0 : p.id), (y = Mt(n, i) || y);
      const A = hn(),
        T = await Bt.addCart(y, e, i, A, b, s, r);
      g.set('xo-cart', (M) => ({ ...M, size: M.size + e, sections: T.sections, item: T, addIdLoading: '', isAdded: !0, variantId: y, productIdsForCartNotification: [`${T.id}`] }))(
        'xo-cart/addCartSuccess',
      );
    } catch (y) {
      const b = y,
        v = (m = b == null ? void 0 : b.description) != null ? m : b == null ? void 0 : b.message;
      dn(v), v && !t && !((x = window.xbEditor) != null && x.designMode) && be({ content: v, className: 'xo-cart-add-error', placement: 'top-center', delay: 4e3 });
    }
  }
  async function Fl(n, i, t, e) {
    var s, r;
    try {
      const a = i.map((d) => {
          var x, y, b;
          let u = d;
          const { productData: p } = Jt(),
            m = (x = p == null ? void 0 : p[d]) == null ? void 0 : x.variants;
          return (y = m == null ? void 0 : m[0]) != null && y.id && (u = (b = m == null ? void 0 : m[0]) == null ? void 0 : b.id), (u = Mt(n, d) || u), u;
        }),
        l = await Bt.addCartMulti(a, e),
        h = e.reduce((d, u) => d + u, 0);
      g.set('xo-cart', (d) => ({ ...d, size: d.size + h * i.length, sections: l.sections, items: l.items, addIdLoading: '', productIdsForCartNotification: nt(a, (u) => `${u}`) }))(
        'xo-cart/addCartSuccess',
      );
    } catch (a) {
      const l = a,
        h = (s = l == null ? void 0 : l.description) != null ? s : l == null ? void 0 : l.message;
      dn(h), h && !t && !((r = window.xbEditor) != null && r.designMode) && be({ content: h, className: 'xo-cart-add-error', placement: 'top-center', delay: 4e3 });
    }
  }
  function dn(n) {
    g.set('xo-cart', (i) => ({ ...i, addIdLoading: '', addErrorMessage: n, isAdded: !1, variantId: '' }))('xo-cart/addCartFailure');
  }
  async function un(n, i, t, e, s = !1, r, a, l) {
    if ((Nl(n, i), /^\[|\]$/g.test(i))) {
      const h = at(i);
      await Fl(n, h, e, r || [t]);
    } else await Ol(n, i, e, t, a, l);
    s && (window.location.href = '/checkout');
  }
  function Hl(n) {
    g.set('xo-cart', (i) => ({ ...i, changeLineLoading: n, changeErrorMessage: '' }))('xo-cart/changeCartRequest');
  }
  async function Rl(n, i) {
    var t, e;
    try {
      const s = await Bt.changeCart(n, i);
      g.set('xo-cart', (r) => ({ ...r, size: s.item_count, sections: s.sections, changeLineLoading: -1 }))('xo-cart/changeCartSuccess');
    } catch (s) {
      const r = s,
        a = (t = r == null ? void 0 : r.errors) != null ? t : s == null ? void 0 : s.message;
      ql(a), a && !((e = window.xbEditor) != null && e.designMode) && be({ content: a, className: 'xo-cart-change-error', placement: 'top-center', delay: 4e3 });
    }
  }
  function ql(n) {
    g.set('xo-cart', (i) => ({ ...i, changeLineLoading: -1, changeErrorMessage: n }))('xo-cart/changeCartFailure');
  }
  async function pn(n, i) {
    Hl(n), await Rl(n, i);
  }
  function mn() {
    return g.get('xo-cart');
  }
  function Ai(n, i) {
    return g.subscribe('xo-cart', n, i);
  }
  function Vl() {
    g.create('xo-cart-note', { initialState: { status: 'idle', note: '', noteDraft: '' } });
  }
  function fn(n) {
    g.set('xo-cart-note', (i) => ({ ...i, noteDraft: n }))('xo-cart/setCartNoteDraft');
  }
  function zl() {
    g.set('xo-cart-note', (n) => ({ ...n, status: 'loading' }));
  }
  async function Bl(n) {
    try {
      const i = await Bt.postCartNote(n);
      g.set('xo-cart-note', (t) => ({ ...t, status: 'success', note: i.note }))('xo-cart/postCartNoteSuccess');
    } catch {
      _l();
    }
  }
  function _l() {
    g.set('xo-cart-note', (n) => ({ ...n, status: 'error' }))('xo-cart/postCartNoteFailure');
  }
  async function xn(n) {
    zl(), await Bl(n);
  }
  function Wl() {
    return g.get('xo-cart-note');
  }
  function Ul(n, i) {
    return g.subscribe('xo-cart-note', n, i);
  }
  function Xl() {
    g.create('xo-cart-discount', { initialState: { discount: '' }, useStorage: !0 });
  }
  function gn(n) {
    g.set('xo-cart-discount', (i) => ({ ...i, discount: n }))('xo-cart/setCartDiscount');
  }
  function Yl() {
    return g.get('xo-cart-discount');
  }
  function Gl(n, i) {
    return g.subscribe('xo-cart-discount', n, i);
  }
  function jl() {
    g.create('xo-cart-shipping-rates', { initialState: { status: 'idle', shippingRates: [], errorMessages: [] } });
  }
  function Ql() {
    g.set('xo-cart-shipping-rates', (n) => ({ ...n, status: 'loading' }));
  }
  async function Zl(n, i, t) {
    try {
      const e = await Bt.getShippingRates(n, i, t);
      g.set('xo-cart-shipping-rates', (s) => ({ ...s, status: 'success', shippingRates: e.shipping_rates }))('xo-cart/getCartShippingRatesSuccess');
    } catch (e) {
      Array.isArray(e) ? bn(e) : bn([e.message]);
    }
  }
  function bn(n) {
    g.set('xo-cart-shipping-rates', (i) => ({ ...i, status: 'error', errorMessages: n }))('xo-cart/getCartShippingRatesFailure');
  }
  async function Kl(n, i, t) {
    Ql(), await Zl(n, i, t);
  }
  function Jl() {
    return g.get('xo-cart-shipping-rates');
  }
  function tc(n, i) {
    return g.subscribe('xo-cart-shipping-rates', n, i);
  }
  function ec() {
    g.create('xo-cart-shipping-rates-form', { initialState: { zip: '', country: '', province: '', provinces: [] } });
  }
  function sc(n, i) {
    g.set('xo-cart-shipping-rates-form', (t) => ({ ...t, [n]: i }))('xo-cart-shipping-rates-form/setCartShippingRatesField');
  }
  function ic(n) {
    g.set('xo-cart-shipping-rates-form', (i) => ({ ...i, provinces: n }))('xo-cart-shipping-rates-form/setProvinces');
  }
  function oc() {
    return g.get('xo-cart-shipping-rates-form');
  }
  function nc(n, i) {
    return g.subscribe('xo-cart-shipping-rates-form', n, i);
  }
  function rc() {
    Il(), cl(), dl(), Vl(), Xl(), jl(), ec();
  }
  const Ct = { cart: mn, cartForm: zt, product: Jt, cartNote: Wl, cartDiscount: Yl, cartShippingRates: Jl, cartShippingRatesForm: oc, recipient: hn },
    J = { cart: Ai, cartForm: Ss, product: fl, cartNote: Ul, cartDiscount: Gl, cartShippingRates: tc, cartShippingRatesForm: nc, recipient: Ll };
  class ac extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
    }
    connectedCallback() {
      if (!this.id) throw new Error(`The ${c.Cart} component must have the id="{{ section.id }}" attribute`);
      this.unsubscribe = J.cart((t) => {
        const e = t.sections[this.id],
          s = t.changeLineLoading !== -1;
        if (e && this.innerHTML !== e && !s) {
          const r = Array.from(this.querySelectorAll(c.CartWillChange));
          if (r.length) {
            const l = new DOMParser().parseFromString(e, 'text/html');
            E(r, (h) => {
              const d = h.getAttribute('xo-unique-id'),
                u = l.querySelector(`${c.CartWillChange}[xo-unique-id="${d}"]`);
              if (u && h.innerHTML !== (u == null ? void 0 : u.innerHTML)) {
                h.innerHTML = u.innerHTML;
                const p = Array.from(u.attributes);
                E(p, (m) => {
                  h.setAttribute(m.name, m.value);
                });
              }
            });
          } else this.innerHTML = ln(e);
        }
      });
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  class lc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, '_options');
      o(this, 'handleAddToCart', async (t) => {
        var m, x, y, b;
        t.preventDefault();
        const e = Ct.cart(),
          { xoProductId: s, xoProductQuantity: r, xoCartOpened: a = !0, xoCheckoutRedirection: l = !1, xoProductQuantities: h, xoTestFly: d } = this.options,
          u = !!((m = this.closest(c.Product)) != null && m.querySelector(c.CartAddError));
        if (this.productEl) {
          const { xoSectionId: v } = this.productOptions,
            k = `${v}/${s}`,
            A = (b = (y = (x = Ct.cartForm()) == null ? void 0 : x[`${v}/${s}`]) == null ? void 0 : y.quantity) != null ? b : 1;
          if (e.addIdLoading !== k && s) {
            const { sellingRadio: T, sellingPlan: M } = vl();
            await un(v, s, r != null ? r : A, u, l, h, T, M);
          }
        } else {
          const v = `single/${s}`;
          e.addIdLoading !== v && s && (await un('single', s, r != null ? r : 1, u, l, h));
        }
        const p = Ct.cart();
        if (a && p.addErrorMessage === '') {
          const v = document.querySelector(c.CartMini);
          v && (await P(0), ki(v));
        }
        (p.addErrorMessage === '' || d) && this.handleCartFly();
      });
      o(this, 'handleCartFly', () => {
        const t = document.querySelector(c.CartFly);
        t == null || t.handle(this);
      });
    }
    get options() {
      return this._options;
    }
    set options(t) {
      this._options = t;
    }
    setOptions() {
      const t = $(this, {
        pick: ['xoProductId', 'xoProductQuantity', 'xoCartOpened', 'xoDisabled', 'xoCheckoutRedirection', 'xoProductQuantities', 'xoTestFly'],
        types: {
          xoProductId: 'string',
          xoProductQuantity: 'number',
          xoCartOpened: 'boolean',
          xoDisabled: 'boolean',
          xoCheckoutRedirection: 'boolean',
          xoProductQuantities: 'array',
          xoTestFly: 'boolean',
        },
      });
      this.productEl ? (this.options = { ...t, xoProductId: this.productOptions.xoProductId }) : (this.options = t);
    }
    static get observedAttributes() {
      return ['xo-product-id', 'xo-product-quantity', 'xo-disabled'];
    }
    get productEl() {
      return this.closest(c.Product);
    }
    get productOptions() {
      return this.productEl.options;
    }
    connectedCallback() {
      this.setOptions();
      const { xoProductId: t, xoDisabled: e = !1 } = this.options;
      e ||
        !t ||
        (this.addEventListener('click', this.handleAddToCart),
        (this.unsubscribe = J.cart(({ addIdLoading: s }) => {
          const { xoProductId: r } = this.options;
          let a = `single/${r}`;
          if (this.productEl) {
            const { xoSectionId: l } = this.productOptions;
            a = `${l}/${r}`;
          }
          f.set(this, 'xo-loading', s === a);
        })));
    }
    attributeChangedCallback(t, e, s) {
      e != null && e !== s && this.setOptions();
    }
    disconnectedCallback() {
      this.unsubscribe(), this.removeEventListener('click', this.handleAddToCart);
    }
  }
  class cc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'handleClick', async (t) => {
        t.preventDefault();
        const { xoSectionId: e, xoProductId: s } = this.productOptions,
          r = we(this.productEl);
        r && (await pn(r, 0), hl(e, s));
      });
    }
    get productEl() {
      return this.closest(c.Product);
    }
    get productOptions() {
      return this.productEl.options;
    }
    connectedCallback() {
      if (!this.productEl) throw new Error(`${c.CartRemove} must be inside ${c.Product}`);
      this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }
  }
  class hc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'prevSize', Number(this.innerText));
      o(this, 'timeId', -1);
      o(this, 'unsubscribe', () => {});
    }
    connectedCallback() {
      const t = Number(this.innerText);
      Dl(t),
        (this.unsubscribe = J.cart(async (e) => {
          if (((this.innerText = `${e.size}`), (this.prevSize !== e.size || f.get(this, 'xo-test-fly')) && !e.addIdLoading)) {
            const s = document.querySelector('[xo-cart-fly-end]');
            if (s) {
              clearTimeout(this.timeId), f.set(s, 'xo-cart-fly-end-animated', !1), await P(), f.set(s, 'xo-cart-fly-end-animated', !0);
              const r = Number(window.getComputedStyle(s).animationDuration.replace('s', '')) * 1e3,
                a = Number(window.getComputedStyle(s).animationDelay.replace('s', '')) * 1e3;
              this.timeId = window.setTimeout(() => {
                f.set(s, 'xo-cart-fly-end-animated', !1);
              }, r + a);
            }
          }
          this.prevSize = e.size;
        }));
    }
    disconnectedCallback() {
      this.unsubscribe(), clearTimeout(this.timeId);
    }
  }
  class dc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'cartScrollEl', null);
      o(this, 'scScrollTop', 0);
      o(this, 'handleScroll', () => {
        var t, e;
        this.scScrollTop = (e = (t = this.cartScrollEl) == null ? void 0 : t.scrollTop) != null ? e : this.scScrollTop;
      });
    }
    connectedCallback() {
      var e;
      if (!this.id) throw new Error(`The ${c.CartMini} component must have the id="{{ section.id }}" attribute`);
      const t = this.closest(c.Modal);
      (this.cartScrollEl = this.querySelector(c.CartScroll)),
        t && f.set(t, 'xo-for-cart-mini', !0),
        (e = this.cartScrollEl) == null || e.addEventListener('scroll', this.handleScroll),
        (this.unsubscribe = J.cart((s) => {
          var a, l;
          const r = s.sections[this.id];
          if (r)
            if (s.changeLineLoading !== -1) this.scScrollTop = (l = (a = this.cartScrollEl) == null ? void 0 : a.scrollTop) != null ? l : this.scScrollTop;
            else {
              const d = f.get(this, 'xo-notification');
              if (this.innerHTML !== r) {
                const u = Array.from(this.querySelectorAll(c.CartWillChange));
                if (u.length) {
                  const m = new DOMParser().parseFromString(r, 'text/html');
                  E(u, (x) => {
                    const y = x.getAttribute('xo-unique-id'),
                      b = m.querySelector(`${c.CartWillChange}[xo-unique-id="${y}"]`);
                    if (b && x.innerHTML !== (b == null ? void 0 : b.innerHTML)) {
                      x.innerHTML = b.innerHTML;
                      const v = Array.from(b.attributes);
                      E(v, (k) => {
                        x.setAttribute(k.name, k.value);
                      });
                    }
                  });
                } else this.innerHTML = ln(r, d ? s.productIdsForCartNotification : void 0);
                (this.cartScrollEl = this.querySelector(c.CartScroll)), this.cartScrollEl && (this.cartScrollEl.scrollTop = this.scScrollTop);
              }
            }
        }));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.cartScrollEl && this.cartScrollEl.removeEventListener('scroll', this.handleScroll);
    }
  }
  class uc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
    }
    get productEl() {
      return this.closest(c.Product);
    }
    connectedCallback() {
      if (!this.productEl) throw new Error(`${c.CartChangeFallback} must be inside ${c.Product}.`);
      this.unsubscribe = J.cart(({ changeLineLoading: t }) => {
        const e = we(this.productEl);
        e && f.set(this, 'xo-visible', e === t);
      });
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  class pc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'inputEl', null);
      o(this, 'handleInput', (t) => {
        var l;
        const e = t.target;
        ((l = Number(e.value)) != null ? l : 1) < 1 && (e.value = '1');
        const { xoSectionId: r, xoProductId: a } = this.productOptions;
        ws(r, a, () => Number(e.value));
      });
      o(this, 'handleBlur', (t) => {
        const { xoCartExclude: e = !1 } = this.productOptions,
          s = t.target,
          r = we(this.productEl);
        r && !e && Si(this, r, Number(s.value));
      });
    }
    get productEl() {
      return this.closest(c.Product);
    }
    get productOptions() {
      return this.productEl.options;
    }
    connectedCallback() {
      var s;
      if ((s = window.xbEditor) != null && s.designMode) return;
      if (!this.productEl) throw new Error(`${c.CartQuantity} must be in ${c.Product}`);
      if (((this.inputEl = this.querySelector('input')), !this.inputEl)) throw new Error(`${c.CartQuantity} must have an input number element`);
      (this.inputEl.name = Ei), (this.inputEl.value == null || this.inputEl.value === '') && (this.inputEl.value = '1'), (this.inputEl.min = '1');
      const { xoSectionId: t, xoProductId: e } = this.productOptions;
      ws(t, e, () => {
        var r, a;
        return Number((a = (r = this.inputEl) == null ? void 0 : r.value) != null ? a : 1);
      }),
        this.inputEl.addEventListener('input', this.handleInput),
        this.inputEl.addEventListener('blur', this.handleBlur),
        (this.unsubscribe = J.cartForm((r) => {
          var l;
          const a = (l = r == null ? void 0 : r[`${t}/${e}`]) == null ? void 0 : l.quantity;
          a != null && (this.inputEl.value = `${a}`);
        }));
    }
    disconnectedCallback() {
      var t;
      ((t = window.xbEditor) != null && t.designMode) ||
        (this.unsubscribe(), this.inputEl && (this.inputEl.removeEventListener('input', this.handleInput), this.inputEl.removeEventListener('blur', this.handleBlur)));
    }
  }
  class mc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'quantityEl', null);
      o(this, 'handleDecrement', () => {
        var l, h;
        const { xoSectionId: t, xoProductId: e, xoCartExclude: s = !1 } = this.productOptions;
        this.getOptions(), ws(t, e, (d) => d - 1);
        const r = (h = (l = Ct.cartForm()) == null ? void 0 : l[`${t}/${e}`]) == null ? void 0 : h.quantity,
          a = we(this.productEl);
        a && !s && Si(this, a, r);
      });
    }
    get productEl() {
      return this.closest(c.Product);
    }
    get productOptions() {
      return this.productEl.options;
    }
    getOptions() {
      return $(this, { pick: ['xoAutoUpdateCart'], types: { xoAutoUpdateCart: 'boolean' } });
    }
    connectedCallback() {
      if (((this.quantityEl = this.closest(c.CartQuantity)), !this.quantityEl)) throw new Error(`${c.CartQuantityMinus} must be inside ${c.CartQuantity}`);
      this.addEventListener('click', this.handleDecrement);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleDecrement);
    }
  }
  class fc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'quantityEl', null);
      o(this, 'handleIncrement', () => {
        var l, h;
        const { xoSectionId: t, xoProductId: e, xoCartExclude: s = !1 } = this.productOptions;
        this.getOptions(), ws(t, e, (d) => d + 1);
        const r = (h = (l = Ct.cartForm()) == null ? void 0 : l[`${t}/${e}`]) == null ? void 0 : h.quantity,
          a = we(this.productEl);
        a && !s && Si(this, a, r);
      });
    }
    get productEl() {
      return this.closest(c.Product);
    }
    get productOptions() {
      return this.productEl.options;
    }
    getOptions() {
      return $(this, { pick: ['xoAutoUpdateCart'], types: { xoAutoUpdateCart: 'boolean' } });
    }
    connectedCallback() {
      if (((this.quantityEl = this.closest(c.CartQuantity)), !this.quantityEl)) throw new Error(`${c.CartQuantityPlus} must be inside ${c.CartQuantity}`);
      this.addEventListener('click', this.handleIncrement);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleIncrement);
    }
  }
  class xc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'textareaEl', null);
      o(this, 'buttonEl', null);
      o(this, 'handleInput', (t) => {
        const e = t.target;
        fn(e.value);
      });
      o(
        this,
        'handleInputDebounced',
        st((t) => {
          const e = t.target;
          fn(e.value), xn(e.value);
        }, 600),
      );
    }
    connectedCallback() {
      if (((this.textareaEl = this.querySelector('textarea[name="note"]')), !this.textareaEl)) throw new Error(`${c.CartNote} must have a textarea element with name="note"`);
      (this.buttonEl = this.querySelector(c.CartNoteSubmit)),
        this.buttonEl ? this.textareaEl.addEventListener('input', this.handleInput) : this.textareaEl.addEventListener('input', this.handleInputDebounced),
        (this.unsubscribe = J.cartNote(({ status: t }) => {
          f.set(this, 'xo-loading', t === 'loading');
        }));
    }
    disconnectedCallback() {
      this.unsubscribe(),
        this.textareaEl &&
          (this.buttonEl ? this.textareaEl.removeEventListener('input', this.handleInput) : this.textareaEl.removeEventListener('input', this.handleInputDebounced));
    }
  }
  class gc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'cartNoteEl', null);
      o(this, 'handleClick', async (t) => {
        t.preventDefault();
        const { noteDraft: e } = Ct.cartNote();
        await xn(e), ki(this, !1);
      });
    }
    connectedCallback() {
      if (((this.cartNoteEl = this.closest(c.CartNote)), !this.cartNoteEl)) throw new Error(`${c.CartNoteSubmit} must be inside ${c.CartNote}`);
      this.addEventListener('click', this.handleClick),
        (this.unsubscribe = J.cartNote(({ status: t }) => {
          f.set(this, 'xo-loading', t === 'loading');
        }));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.removeEventListener('click', this.handleClick);
    }
  }
  class bc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'inputEl', null);
      o(this, 'handleInput', (t) => {
        const e = t.target;
        gn(e.value);
      });
    }
    connectedCallback() {
      if (((this.inputEl = this.querySelector('input[type="text"][name="discount"]')), !this.inputEl))
        throw new Error(`${c.CartDiscount} must have a input element with name="discount"`);
      const { discount: t } = Ct.cartDiscount();
      (this.inputEl.value = t), this.querySelector(c.CartDiscountSubmit) || this.inputEl.addEventListener('input', this.handleInput);
    }
    disconnectedCallback() {
      this.inputEl && this.inputEl.removeEventListener('input', this.handleInput);
    }
  }
  class yc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'cartDiscountEl', null);
      o(this, 'handleClick', (t) => {
        t.preventDefault();
        const e = this.cartDiscountEl.querySelector('input[type="text"][name="discount"]');
        gn(e.value), ki(this, !1);
      });
    }
    connectedCallback() {
      if (((this.cartDiscountEl = this.closest(c.CartDiscount)), !this.cartDiscountEl)) throw new Error(`${c.CartDiscountSubmit} must be inside ${c.CartDiscount}`);
      this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }
  }
  class vc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'fieldEl', null);
      o(this, 'handleChange', (t) => {
        const e = t.target;
        this.setState(e.name, e.value);
      });
    }
    setState(t, e) {
      var r;
      const s = t.replace(/address\[|\]/g, '');
      if ((sc(s, e), s === 'country')) {
        const a = this.fieldEl.querySelector(`option[value="${this.fieldEl.value}"]`);
        ic(at((r = a.getAttribute('data-provinces')) != null ? r : '[]'));
      }
    }
    connectedCallback() {
      if (((this.fieldEl = this.querySelector('select, input[type="text"]')), !this.fieldEl)) throw new Error(`${c.CartShippingRatesField} must have a select or input element`);
      const t = this.fieldEl instanceof HTMLInputElement ? 'input' : 'change';
      this.setState(this.fieldEl.name, this.fieldEl.value), this.fieldEl.addEventListener(t, this.handleChange);
      const e = this.fieldEl.name.replace(/address\[|\]/g, '');
      e === 'province' && f.set(this, 'xo-disabled', Ct.cartShippingRatesForm().provinces.length === 0),
        (this.unsubscribe = J.cartShippingRatesForm(
          ({ provinces: s }) => {
            if (e === 'province') {
              this.fieldEl.innerHTML = s.map(([a, l]) => `<option value="${a}">${l}</option>`).join('');
              const r = this.fieldEl.querySelector('option');
              r && this.setState(this.fieldEl.name, r.value), f.set(this, 'xo-disabled', s.length === 0);
            }
          },
          (s, r) => Pt(s == null ? void 0 : s.provinces, r.provinces),
        ));
    }
    disconnectedCallback() {
      if ((this.unsubscribe(), this.fieldEl)) {
        const t = this.fieldEl instanceof HTMLInputElement ? 'input' : 'change';
        this.fieldEl.removeEventListener(t, this.handleChange);
      }
    }
  }
  class Ec extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'handleClick', async (t) => {
        t.preventDefault();
        const { zip: e, country: s, province: r } = Ct.cartShippingRatesForm();
        await Kl(e, s, r);
      });
    }
    connectedCallback() {
      this.addEventListener('click', this.handleClick),
        (this.unsubscribe = J.cartShippingRates(({ status: t }) => {
          f.set(this, 'xo-loading', t === 'loading');
        }));
    }
    disconnectedCallback() {
      this.unsubscribe(), this.removeEventListener('click', this.handleClick);
    }
  }
  class wc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
    }
    connectedCallback() {
      this.unsubscribe = J.cartShippingRates(({ status: t, errorMessages: e }) => {
        t === 'error' && (this.innerHTML = e.join(', '));
      });
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  class Cc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'animated', _());
    }
    connectedCallback() {
      var e;
      const t = (e = this.querySelector(c.CartAddErrorMessage)) != null ? e : this;
      this.unsubscribe = J.cart(async ({ addErrorMessage: s }) => {
        s
          ? ((this.style.visibility = 'visible'),
            (this.style.height = 'auto'),
            (t.innerHTML = s),
            await P(4e3),
            this.animated({
              from: this.offsetHeight,
              to: 0,
              duration: 300,
              onUpdate: (r) => {
                this.style.height = `${r}px`;
              },
              onEnd: () => {
                (t.innerHTML = ''), this.style.removeProperty('visibility');
              },
            }))
          : (t.innerHTML = '');
      });
    }
    disconnectedCallback() {
      this.animated.off(), this.unsubscribe();
    }
  }
  class Sc extends HTMLElement {
    get options() {
      return $(this, { pick: ['xoUniqueId'], types: { xoUniqueId: 'string' } });
    }
    connectedCallback() {
      const { xoUniqueId: i } = this.options;
      if (!i) throw new Error(`${c.CartWillChange}: Attribute xo-unique-id is required (Note: xo-unique-id is unique)`);
    }
  }
  const Lt = new pe(),
    kc = window.history.pushState,
    Ac = window.history.replaceState;
  (window.history.pushState = function (n, i, t) {
    kc.call(window.history, n, i, t), Lt.emit('change', void 0);
  }),
    (window.history.replaceState = function (n, i, t) {
      Ac.call(window.history, n, i, t), Lt.emit('change', void 0);
    }),
    window.addEventListener('popstate', () => {
      Lt.emit('change', void 0);
    });
  function Pc(n) {
    const i = n.closest(c.Sticky);
    if (i) {
      const t = Array.from(i.querySelectorAll('input[type="radio"], select'));
      E(t, (e) => {
        const s = e.id,
          r = document.querySelector(`label[for="${s}"]`);
        (e.name = lt.addFieldSignal(e.name, wi)), s && (e.id = lt.addFieldSignal(s, wi)), r && r.setAttribute('for', lt.addFieldSignal(s, wi));
      });
    }
  }
  let Pi = -1,
    yn = -1;
  const vn = new Map();
  class En extends HTMLElement {
    constructor(t, e = 'input[type="radio"]:not([xo-for-quick-view]), select:not([xo-for-quick-view])', s = !1) {
      super();
      o(this, 'fieldEls', []);
      o(this, 'productEl', this.closest(c.Product));
      o(this, 'fieldSelector');
      o(this, 'isProductQuickViewVariant');
      o(this, 'cartFormUnsubscribe', () => {});
      o(this, 'handleChange', (t) => {
        var m, x, y;
        const e = t.target,
          { value: s } = e,
          { name: r } = e,
          { xoSectionId: a, xoProductId: l, xoFeaturedProduct: h, xoProductUrl: d } = this.productEl.options,
          { productUrl: u } = Ct.product(),
          p = lt.removeFieldSignal(r);
        if ((Cs(a, l, p, s), this.closePopover(), this.condChangeVariantAndRequest())) this.handleProductInformation();
        else if (h) {
          const b = vt.stringify({ section_id: a, variant: Mt(a, l) }),
            v = `${d}?${b}`;
          Ci(v, !0), this.bindAvailable();
        } else if (u != null) {
          const b = vt.stringify({ section_id: a, variant: Mt(a, l) }),
            v = `${u}?${b}`;
          Ci(v), this.bindAvailable();
        } else {
          const b = Mt(a, l),
            v = at((y = (x = (m = this.productEl) == null ? void 0 : m.querySelector(c.ProductLiquidStatic)) == null ? void 0 : x.textContent) != null ? y : '{}'),
            k = v == null ? void 0 : v[b],
            A = Array.from(this.productEl.querySelectorAll('[xo-binding]'));
          E(A, (T) => {
            const M = T.getAttribute('xo-binding');
            if (ee(k) === 'object') {
              const L = k[M];
              L != null && (T.innerHTML = L);
            }
          }),
            this.bindAvailable();
        }
        this.handleUnavailable();
      });
      o(this, 'setFormVariantAfterLocationChange', () => {
        const { xoSectionId: t, xoProductId: e } = this.productEl.options,
          { productData: s } = Jt(),
          r = vt.parse(window.location.search, !0).variant,
          a = document.querySelector('[action*="/cart/add"] input[name="id"]');
        a && (a.value = r);
        const l = s[e].variants.find((h) => h.id == r);
        if (l) {
          const h = l.options.reduce((d, u) => {
            var p;
            return [
              ...d,
              ...Array.from(this.querySelectorAll(`input[type="radio"]:not([xo-for-quick-view])[value="${u}"]`)),
              ...Array.from((p = this.querySelector(`select:not([xo-for-quick-view])[value="${u}"]`)) != null ? p : []),
            ];
          }, []);
          E(h, (d) => {
            if (d) {
              const u = lt.removeFieldSignal(d.name);
              Cs(t, e, u, d.value);
            }
          }),
            this.bindAvailable();
        }
      });
      o(this, 'handleLocationChange', async () => {
        const { xoSectionId: t, xoProductId: e, xoProductInformation: s } = this.productEl.options;
        if (this.condChangeVariantAndRequest() && s) {
          this.setFormVariantAfterLocationChange(), ml(t, e);
          const { href: r } = window.location,
            a = r.includes('?') ? `${r}&section_id=${t}` : `${r}?section_id=${t}`;
          await Ci(a);
        }
      });
      o(this, 'handleProductVariantSelected', (t) => {
        const e = lt.removeFieldSignal(t.name),
          s = Array.from(this.productEl.querySelectorAll(`${c.ProductVariantSelected}[xo-name="${e}"]`));
        E(s, (r) => {
          r && (r.innerHTML = t.value);
        });
      });
      o(this, 'closePopover', () => {
        const t = this.closest(c.Popover),
          e = t == null ? void 0 : t.querySelector(c.Product);
        if (t && !e) {
          const s = t.getAttribute('xo-name');
          re.close(s);
        }
      });
      o(this, 'isUnavailable', () => {
        const { xoSectionId: t, xoProductId: e } = this.productEl.options;
        return !Mt(t, e);
      });
      o(this, 'handleUnavailable', () => {
        f.set(this.productEl, 'xo-unavailable', this.isUnavailable());
      });
      o(this, 'handleAvailable', (t, e) => {
        if (t instanceof HTMLInputElement) {
          const { xoSectionId: s, xoProductId: r } = this.productEl.options,
            a = lt.removeFieldSignal(t.name),
            l = bl(s, r, a, t.value),
            h = yl(s, r, a, t.value);
          f.set(t, 'xo-disabled', !l), f.set(t, 'xo-unavailable', !h);
        }
      });
      o(this, 'bindAvailable', () => {
        const t = Array.from(this.productEl.querySelectorAll(this.fieldSelector));
        E(t, this.handleAvailable), this.handleUnavailable();
      });
      o(this, 'cartFormListener', () => {
        var a, l;
        const { xoSectionId: t, xoProductId: e } = this.productEl.options,
          s = `${t}/${e}`,
          r = (l = (a = zt()) == null ? void 0 : a[s]) == null ? void 0 : l.variantSelected;
        r &&
          !Pt(vn.get(s), r) &&
          E(ft(r), (h) => {
            const d = r[h];
            this.handleSyncFields(h, d);
          }),
          vn.set(s, r);
      });
      (this.fieldSelector = e), (this.isProductQuickViewVariant = s), (this.productEl = t != null ? t : this.closest(c.Product)), yn++, Pc(this);
    }
    condChangeVariantAndRequest() {
      const { xoProductInformation: t } = this.productEl.options,
        e = this.closest(c.ProductQuickView);
      return gl() && t && !e;
    }
    handleProductInformation() {
      const { xoSectionId: t, xoProductId: e } = this.productEl.options,
        s = Mt(t, e),
        r = `${window.location.pathname}${s ? `?variant=${s}` : ''}`;
      window.location.href !== r && window.history.replaceState({}, '', r);
    }
    handleSyncFields(t, e) {
      var r, a;
      const { xoProductInformation: s } = this.productEl.options;
      if (s) {
        const l = Array.from(
          (a =
            (r = this.productEl) == null
              ? void 0
              : r.querySelectorAll(`input[type="radio"][name="${t}"][value="${e}"], input[type="radio"][name$="${t}"][value="${e}"], select[name="${t}"], select[name$="${t}"]`)) !=
            null
            ? a
            : [],
        );
        E(l, (h) => {
          if (!(h.closest(c.ProductRecommendations) || h.getAttribute('xo-for-quick-view')))
            if (h instanceof HTMLSelectElement) {
              const u = Array.from(h.querySelectorAll('option'));
              E(u, (p) => {
                p.selected = p.value === e;
              });
            } else h instanceof HTMLInputElement && ((h.checked = !0), this.handleProductVariantSelected(h));
        });
      }
    }
    handleFirstVariant(t) {
      const { xoSectionId: e, xoProductId: s } = this.productEl.options,
        r = lt.removeFieldSignal(t.name);
      if (t instanceof HTMLInputElement)
        (t.checked || (t.hasAttribute('checked') && t.getAttribute('checked') !== 'false')) && ((t.checked = !0), Cs(e, s, r, t.value), this.handleProductVariantSelected(t));
      else if (t instanceof HTMLSelectElement) {
        const a = Array.from(t.querySelectorAll('option'));
        E(a, (l) => {
          (l.selected || (l.hasAttribute('selected') && l.getAttribute('selected') !== 'false')) && ((l.selected = !0), Cs(e, s, r, t.value));
        });
      }
    }
    connectedCallback() {
      var s;
      if ((s = window.xbEditor) != null && s.designMode) return;
      if (!this.productEl) throw new Error(`${c.CartAdd} must be in ${c.Product}`);
      const { xoProductId: t, xoProductInformation: e } = this.productEl.options;
      (this.fieldEls = Array.from(this.querySelectorAll(this.fieldSelector))),
        !this.isProductQuickViewVariant && e && (Lt.off(Pi), (Pi = Lt.on('change', this.handleLocationChange))),
        E(this.fieldEls, (r) => {
          (r.name = lt.addFieldSignal(r.name, `SIGNAL_${t}_${yn}`)), this.handleFirstVariant(r), r.addEventListener('change', this.handleChange);
        }),
        this.bindAvailable(),
        (this.cartFormUnsubscribe = Ss(this.cartFormListener));
    }
    disconnectedCallback() {
      var e;
      if ((e = window.xbEditor) != null && e.designMode) return;
      const { xoProductInformation: t } = this.productEl.options;
      E(this.fieldEls, (s) => {
        s.removeEventListener('change', this.handleChange);
      }),
        !this.isProductQuickViewVariant && t && Lt.off(Pi),
        this.cartFormUnsubscribe();
    }
  }
  class Tc extends HTMLElement {
    connectedCallback() {
      var e;
      const i = at(this.textContent),
        { productData: t } = Ct.product();
      if (i.id) ft(t).includes(i.id.toString()) || ul(i);
      else throw new Error(`ProductData: Invalid product data (Content: ${(e = this.textContent) == null ? void 0 : e.trim()}).`);
    }
  }
  class $c extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
      o(this, 'buyItNowEl', null);
      o(this, 'productEl', this.closest(c.Product));
      o(this, 'handleBuyItNow', (t) => {
        t.preventDefault();
      });
      o(this, 'handleChange', (t, e, s) => {
        var b, v;
        if (!this.productEl) return;
        const { xoUniqueId: r } = this.options,
          l = new DOMParser().parseFromString(e, 'text/html'),
          h = !!s;
        let d = null;
        h
          ? (d = l.querySelector(`${c.Product}[xo-featured-product][xo-product-url="${s}"] ${c.ProductWillChange}[xo-unique-id="${r}"]`))
          : (d = l.querySelector(`${c.ProductWillChange}[xo-unique-id="${r}"]`));
        const { xoProductUrl: u, xoSectionId: p } = this.productEl.options,
          m = (b = d == null ? void 0 : d.closest(c.Product)) == null ? void 0 : b.getAttribute('xo-product-url'),
          x = (v = d == null ? void 0 : d.closest(c.Product)) == null ? void 0 : v.getAttribute('xo-section-id');
        let y = d && this.innerHTML !== d.innerHTML && t === 'success';
        if ((h && (y = y && u === m && p === x), y)) {
          const k = this.querySelector('[data-shopify="payment-button"]'),
            A = f.get(d, 'xo-disabled');
          if ((f.set(this, 'xo-disabled', A), !k)) {
            this.innerHTML = d.innerHTML;
            const T = Array.from(d.attributes);
            E(T, (M) => {
              this.setAttribute(M.name, M.value);
            });
          }
        }
      });
    }
    get options() {
      return $(this, { pick: ['xoUniqueId', 'xoDisabled'], types: { xoUniqueId: 'string', xoDisabled: 'boolean' } });
    }
    connectedCallback() {
      var s;
      const { xoUniqueId: t, xoDisabled: e = !1 } = this.options;
      if (!t) throw new Error(`${c.ProductWillChange}: Attribute xo-unique-id is required (Note: xo-unique-id is unique)`);
      if (e) {
        (this.buyItNowEl = this.querySelector('[data-shopify="payment-button"]')), (s = this.buyItNowEl) == null || s.addEventListener('click', this.handleBuyItNow);
        return;
      }
      this.unsubscribe = J.product(({ status: r, productHtml: a, featuredProductHtmls: l }) => {
        if (this.productEl) {
          const { xoFeaturedProduct: h } = this.productEl.options;
          h
            ? ft(l).forEach((d) => {
                const u = l[d];
                this.handleChange(r, u, d);
              })
            : this.handleChange(r, a);
        }
      });
    }
    disconnectedCallback() {
      var t;
      this.unsubscribe(), (t = this.buyItNowEl) == null || t.removeEventListener('click', this.handleBuyItNow);
    }
  }
  class Mc extends HTMLElement {
    get options() {
      return $(this, {
        pick: ['xoProductId', 'xoSectionId', 'xoProductInformation', 'xoFeaturedProduct', 'xoProductUrl', 'xoCartExclude'],
        types: { xoProductId: 'string', xoSectionId: 'string', xoProductInformation: 'boolean', xoFeaturedProduct: 'boolean', xoProductUrl: 'string', xoCartExclude: 'boolean' },
      });
    }
    connectedCallback() {
      const { xoProductId: i, xoSectionId: t } = this.options;
      if (!i) throw new Error(`${c.Product}: Attribute xo-product-id is required.`);
      if (!t) throw new Error(`${c.Product}: Attribute xo-section-id is required.`);
    }
  }
  class Lc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
    }
    connectedCallback() {
      this.unsubscribe = J.product(({ pickupAvailabilityHtml: t }) => {
        if (t) {
          const s = new DOMParser().parseFromString(t, 'text/html').querySelector(`${c.ProductPickupAvailability}`);
          s ? this.innerHTML !== s.innerHTML && (this.innerHTML = s.innerHTML) : (this.innerHTML = '');
        }
      });
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  class Ic extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
    }
    connectedCallback() {
      this.unsubscribe = J.product(({ pickupAvailabilityHtml: t }) => {
        if (t) {
          const s = new DOMParser().parseFromString(t, 'text/html').querySelector(c.ProductPickupAvailabilityList);
          s ? this.innerHTML !== s.innerHTML && (this.innerHTML = s.innerHTML) : (this.innerHTML = '');
        }
      });
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  class Dc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'unsubscribe', () => {});
    }
    connectedCallback() {
      this.unsubscribe = J.product(({ status: t, quickviewProductHtml: e }) => {
        var m;
        const s = e.replace(new RegExp(`${c.ProductVariant}(?=(\\s|>))`, 'g'), c.ProductQuickViewVariant),
          a = new DOMParser().parseFromString(s, 'text/html'),
          l = Array.from(a.querySelectorAll(c.Animate));
        E(l, (x) => {
          x.setAttribute('xo-type', 'none');
        });
        const h = a.querySelector('template[xo-quick-view-content]'),
          d = a.querySelector(`${c.Product}[xo-product-information]:not([xo-product-information="false"])`),
          u = h == null ? void 0 : h.content.cloneNode(!0);
        if ((u == null ? void 0 : u.children.length) && (u == null ? void 0 : u.children.length) > 1)
          throw new Error('The <template xo-quick-view-content> element must have only one child node.');
        const p = (u == null ? void 0 : u.children[0]) || d;
        if (p && this.innerHTML === '' && t === 'success') {
          const x = Array.from(p.querySelectorAll(`${c.ProductQuickViewVariant} input[type="radio"], ${c.ProductQuickViewVariant} select`));
          E(x, (b) => {
            const v = b.id,
              k = a.querySelector(`label[for="${v}"]`);
            (b.name = lt.addFieldSignal(b.name, Es)),
              v && (b.id = lt.addFieldSignal(v, Es)),
              k && k.setAttribute('for', lt.addFieldSignal(v, Es)),
              f.set(b, 'xo-for-quick-view', !0);
          });
          const y = Array.from(p.querySelectorAll(`[xo-name]:not(${c.ProductVariantSelected})`));
          E(y, (b) => {
            b.setAttribute('xo-name', lt.addFieldSignal(b.getAttribute('xo-name'), Es));
          }),
            this.innerHTML !== p.outerHTML && ((this.innerHTML = p.outerHTML), (m = window.Shopify.PaymentButton) == null || m.init());
        }
      });
    }
    disconnectedCallback() {
      this.unsubscribe();
    }
  }
  class Nc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'handleClick', async () => {
        const { xoModalName: t, xoProductUrl: e } = this.options,
          s = document.querySelector(c.ProductQuickView);
        s && (s.innerHTML = ''), f.set(this, 'xo-loading', !0), await pl(e), f.set(this, 'xo-loading', !1), ne.open(t);
      });
    }
    get options() {
      return $(this, { pick: ['xoProductUrl', 'xoModalName'], types: { xoProductUrl: 'string', xoModalName: 'string' } });
    }
    connectedCallback() {
      const { xoProductUrl: t, xoModalName: e } = this.options;
      if (!e) throw new Error(`${c.ProductQuickViewTrigger} must have a xo-modal-name attribute`);
      if (!t) throw new Error(`${c.ProductQuickViewTrigger} must have a xo-product-url attribute`);
      this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }
  }
  class Oc extends En {
    constructor() {
      const i = document.querySelector(`${c.ProductQuickView} ${c.Product}`);
      super(i, 'input[type="radio"][xo-for-quick-view], select[xo-for-quick-view]', !0);
    }
  }
  class Fc extends HTMLElement {
    connectedCallback() {
      if (!this.closest(c.Product)) throw new Error(`${c.ProductLiquidStatic} must be a child of ${c.Product}}`);
    }
  }
  let Ti = -1;
  class Hc extends HTMLElement {
    constructor() {
      super();
      o(this, 'recipientFieldsLiveRegion');
      o(this, 'checkboxInput', this.querySelector('input[type="checkbox"][name="properties[__shopify_send_gift_card_to_recipient]"]'));
      o(this, 'hiddenControlField', this.querySelector('input[type="hidden"][name="properties[__shopify_send_gift_card_to_recipient]"]'));
      o(this, 'emailInput', this.querySelector('input[name="properties[Recipient email]"]'));
      o(this, 'nameInput', this.querySelector('input[name="properties[Recipient name]"]'));
      o(this, 'messageInput', this.querySelector('textarea[name="properties[Message]"]'));
      o(this, 'sendonInput', this.querySelector('input[name="properties[Send on]"]'));
      o(this, 'offsetProperty', this.querySelector('input[name="properties[__shopify_offset]"]'));
      o(this, 'currentProductVariantId', '');
      o(this, 'unsubscribe', () => {});
      o(this, 'handleChange', () => {
        var t;
        (t = this.checkboxInput) != null && t.checked
          ? (cn(this.checkboxInput.name, 'on'),
            this.enableInputFields(),
            f.set(this, 'xo-active', !0),
            this.recipientFieldsLiveRegion &&
              window.accessibilityStrings.recipientFormExpanded &&
              (this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded))
          : (this.clearInputFields(),
            this.disableInputFields(),
            Ml(),
            f.set(this, 'xo-active', !1),
            this.recipientFieldsLiveRegion &&
              window.accessibilityStrings.recipientFormCollapsed &&
              (this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed));
      });
      o(this, 'clearInputFields', () => {
        E(this.inputFields, (t) => {
          t && (t.value = '');
        });
      });
      o(this, 'enableInputFields', () => {
        E(this.disableableFields, (t) => {
          t && (t.disabled = !1);
        });
      });
      o(this, 'disableInputFields', () => {
        E(this.disableableFields, (t) => {
          t && (t.disabled = !0);
        });
      });
      o(this, 'resetRecipientForm', () => {
        var t;
        (t = this.checkboxInput) != null && t.checked && ((this.checkboxInput.checked = !1), this.handleChange(), f.set(this, 'xo-error', !1));
      });
      o(this, 'setCurrentVariantId', () => {
        const { xoSectionId: t, xoProductId: e } = this.productEl.options,
          s = Mt(t, e);
        this.currentProductVariantId = s;
      });
      o(this, 'handleFieldsChange', (t) => {
        const e = t.target,
          { name: s, value: r } = e;
        cn(s, r);
      });
      o(this, 'bindFieldChange', () => {
        E(this.inputFields, (t) => {
          t && t.addEventListener('input', this.handleFieldsChange);
        });
      });
      (this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`)),
        this.checkboxInput && (this.checkboxInput.disabled = !1),
        this.hiddenControlField && (this.hiddenControlField.disabled = !0),
        this.offsetProperty && (this.offsetProperty.value = new Date().getTimezoneOffset().toString());
    }
    get productEl() {
      return this.closest(c.Product);
    }
    get inputFields() {
      return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
    }
    get disableableFields() {
      return [...this.inputFields, this.offsetProperty];
    }
    connectedCallback() {
      if (!this.productEl) throw new Error(`${c.ProductRecipientForm} must be in ${c.Product}`);
      this.bindFieldChange(),
        this.handleChange(),
        this.addEventListener('change', this.handleChange),
        this.setCurrentVariantId(),
        Lt.off(Ti),
        (Ti = Lt.on('change', this.setCurrentVariantId)),
        (this.unsubscribe = J.cart(({ isAdded: t, variantId: e, addErrorMessage: s }) => {
          if (s) {
            const r = this.querySelector(c.ProductRecipientFormError);
            r && ((r.innerText = s), f.set(this, 'xo-error', !0));
          }
          t && e === this.currentProductVariantId && this.resetRecipientForm();
        }));
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange), Lt.off(Ti), this.unsubscribe();
    }
  }
  const Rc = 'intent=related';
  class qc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'handleIntersection', async (t, e) => {
        var s;
        try {
          if (!t[0].isIntersecting) return;
          e.unobserve(this);
          const { xoUrl: r } = this.options,
            l = await (await fetch(r)).text(),
            h = document.createElement('div');
          h.innerHTML = l;
          const d = h.querySelector(c.ProductRecommendations);
          if (d && d.innerHTML.trim().length) {
            this.innerHTML = d.innerHTML;
            const u = (s = this.closest('[id^="shopify-section-template--"]')) == null ? void 0 : s.querySelectorAll('[xo-products-count]');
            u == null ||
              u.forEach((p, m) => {
                const x = h.querySelectorAll('[xo-products-count]')[m];
                p.setAttribute('xo-products-count', `${x.getAttribute('xo-products-count')}`);
              });
          } else if (window.Xotiny) {
            if (r.endsWith(Rc)) {
              const u = this.closest('[id^="shopify-section-template--"]');
              u == null || u.remove();
            }
          } else {
            const u = this.closest('[data-xb-section-id]');
            u == null || u.remove();
          }
        } catch (r) {
          console.error(r);
        }
      });
    }
    get options() {
      return $(this, { pick: ['xoUrl'], types: { xoUrl: 'string' } });
    }
    connectedCallback() {
      var t;
      ((t = window.xbEditor) != null && t.designMode) || new IntersectionObserver(this.handleIntersection, { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }
  }
  const Ce = 0,
    Se = 100;
  let wn =
    ((zs = class extends Et {
      constructor() {
        super(...arguments);
        o(this, 'unsubscribe', () => {});
        o(this, 'animated', _());
        o(this, 'handleAnimate', (t, e) => (s) => {
          const { top: r, left: a } = X(t),
            { width: l, height: h } = t.getBoundingClientRect(),
            { top: d, left: u } = X(e),
            { width: p, height: m } = e.getBoundingClientRect(),
            x = D({ inputRange: [Ce, Se], outputRange: [r, d], value: s }),
            y = D({ inputRange: [Ce, Se], outputRange: [a, u], value: s }),
            b = D({ inputRange: [Ce, Se], outputRange: [l, p], value: s }),
            v = D({ inputRange: [Ce, Se], outputRange: [h, m], value: s });
          (this.style.top = `${x}px`), (this.style.left = `${y}px`), (this.style.width = `${b}px`), (this.style.height = `${v}px`);
        });
        o(this, 'handle', (t) => {
          const { xoSpeed: e, xoEasing: s } = this.props,
            r = document.querySelector('[xo-cart-fly-end]');
          r &&
            ((this.style.display = 'block'),
            this.animated({
              from: Ce,
              to: Se,
              duration: e,
              easing: H[s],
              onUpdate: this.handleAnimate(t, r),
              onEnd: () => {
                this.style.removeProperty('display');
              },
            }));
        });
      }
      mount() {
        this.unsubscribe = J.cart((t) => {
          var s, r;
          let e = '';
          t.item ? (e = (s = t.item) == null ? void 0 : s.featured_image.src) : t.items && t.items.length > 0 && (e = (r = t.items[0]) == null ? void 0 : r.featured_image.src),
            e && this.style.setProperty('--product-featured-image', `url('${So(e, { width: 300 })}')`);
        });
      }
      unmount() {
        this.unsubscribe();
      }
    }),
    o(zs, 'propTypes', { xoSpeed: 'number', xoEasing: 'string' }),
    o(zs, 'defaultProps', { xoSpeed: 1e3, xoEasing: 'easeOutExpo' }),
    zs);
  wn = Ot([Nt(c.CartFly)], wn);
  const vd = '';
  rc();
  const Cn = {
    on(n, i) {
      return J.product(({ status: e, productHtml: s }) => {
        e === n && i(s);
      });
    },
  };
  (window.xoProductQuickView = Cn),
    (window.cartFormSubscribe = Ss),
    (window.cartSubscribe = Ai),
    (window.getCartFormState = zt),
    B({
      [c.ProductData]: Tc,
      [c.Product]: Mc,
      [c.Cart]: ac,
      [c.CartMini]: dc,
      [c.CartAdd]: lc,
      [c.CartAddError]: Cc,
      [c.CartRemove]: cc,
      [c.CartSize]: hc,
      [c.CartChangeFallback]: uc,
      [c.CartQuantity]: pc,
      [c.CartQuantityMinus]: mc,
      [c.CartQuantityPlus]: fc,
      [c.CartNote]: xc,
      [c.CartNoteSubmit]: gc,
      [c.CartDiscount]: bc,
      [c.CartDiscountSubmit]: yc,
      [c.CartShippingRatesField]: vc,
      [c.CartShippingRatesSubmit]: Ec,
      [c.CartShippingRatesError]: wc,
      [c.CartWillChange]: Sc,
      [c.ProductVariant]: En,
      [c.ProductWillChange]: $c,
      [c.ProductPickupAvailability]: Lc,
      [c.ProductPickupAvailabilityList]: Ic,
      [c.ProductQuickView]: Dc,
      [c.ProductQuickViewTrigger]: Nc,
      [c.ProductQuickViewVariant]: Oc,
      [c.ProductLiquidStatic]: Fc,
      [c.ProductRecipientForm]: Hc,
      [c.ProductRecommendations]: qc,
    });
  const $i = new pe();
  class Vc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'buttonEls', []);
      o(this, 'handleClick', (t) => {
        t.preventDefault();
        const e = t.currentTarget;
        f.set(e, 'xo-active', !0),
          E(this.buttonEls, (s) => {
            s !== e && f.set(s, 'xo-active', !1);
          }),
          $i.emit('change', { element: e, index: this.buttonEls.indexOf(e) });
      });
    }
    connectedCallback() {
      (this.buttonEls = Array.from(this.querySelectorAll(c.GroupButton))),
        E(this.buttonEls, (t) => {
          t.addEventListener('click', this.handleClick);
        });
    }
    disconnectedCallback() {
      E(this.buttonEls, (t) => {
        t.removeEventListener('click', this.handleClick);
      });
    }
  }
  const Sn = { on: $i.on.bind($i) };
  (window.xoGroup = Sn), B({ [c.Group]: Vc });
  const As = {
    easeLight: 'cubic-bezier(0, 0, 0.3, 1)',
    easeInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    easeOut: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    easeIn: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
    ease: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    easeInBack: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)',
    easeOutBack: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    easeInOutBack: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    easeInCirc: 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
    easeOutCirc: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    easeInOutCirc: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
    easeInCubic: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
    easeOutCubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    easeInOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    easeInExpo: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
    easeOutExpo: 'cubic-bezier(0.19, 1, 0.22, 1)',
    easeInOutExpo: 'cubic-bezier(1, 0, 0, 1)',
    easeInQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    easeOutQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    easeInOutQuad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    easeInQuart: 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
    easeOutQuart: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    easeInOutQuart: 'cubic-bezier(0.77, 0, 0.175, 1)',
    easeInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    easeOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    easeInOutQuint: 'cubic-bezier(0.86, 0, 0.07, 1)',
    easeInSine: 'cubic-bezier(0.47, 0, 0.745, 0.715)',
    easeOutSine: 'cubic-bezier(0.39, 0.575, 0.565, 1)',
    easeInOutSine: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
    easeInBounce: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    easeOutBounce: 'cubic-bezier(0.23, 1, 0.32, 1)',
    linear: 'cubic-bezier(0, 0, 1, 1)',
  };
  function zc(n) {
    const i = Array.from(n.querySelectorAll('[xo-next-stroke-dasharray], [xo-next-stroke-dashoffset]'));
    E(i, (t) => {
      const e = t.getAttribute('d'),
        s = t.getAttribute('xo-next-d'),
        r = t.hasAttribute('xo-prev-d'),
        a = t.getAttribute('stroke-dasharray'),
        l = t.getAttribute('xo-next-stroke-dasharray'),
        h = t.hasAttribute('xo-prev-stroke-dasharray'),
        d = t.getAttribute('stroke-dashoffset'),
        u = t.getAttribute('xo-next-stroke-dashoffset'),
        p = t.hasAttribute('xo-prev-stroke-dashoffset');
      e && s && !r && t.setAttribute('xo-prev-d', e), a && l && !h && t.setAttribute('xo-prev-stroke-dasharray', a), d && u && !p && t.setAttribute('xo-prev-stroke-dashoffset', d);
    });
  }
  function Mi(n, i) {
    const { xoDuration: t } = i,
      e = Array.from(n.querySelectorAll('[xo-next-d], [xo-next-stroke-dasharray], [xo-next-stroke-dashoffset]'));
    E(e, (s) => {
      const r = _(),
        a = s.getAttribute('d'),
        l = s.getAttribute('xo-next-d'),
        h = s.getAttribute('stroke-dasharray'),
        d = s.getAttribute('xo-next-stroke-dasharray'),
        u = s.getAttribute('stroke-dashoffset'),
        p = s.getAttribute('xo-next-stroke-dashoffset');
      if (a && l) {
        const m = si.toArray(a),
          x = si.toArray(l);
        r({
          from: 0,
          to: 1,
          duration: t,
          easing: H.linear,
          onUpdate: (y) => {
            const b = nt(m, (v, k) => {
              const A = x[k];
              if (v.type === (A == null ? void 0 : A.type)) {
                const T = nt(v.values, (M, L) => {
                  const V = A.values[L];
                  return D({ value: y, inputRange: [0, 1], outputRange: [M, V] });
                }).filter(Boolean);
                return { ...v, values: T };
              }
              return v;
            });
            s.setAttribute('d', si.toString(b));
          },
        });
      }
      if (h && d) {
        const m = h.replace(/\s+/g, ' ').split(' '),
          x = d.replace(/\s+/g, ' ').split(' ');
        r({
          from: 0,
          to: 1,
          duration: t,
          easing: H.linear,
          onUpdate: (y) => {
            const b = nt(m, (v, k) => {
              var M, L;
              const A = x[k];
              return D({
                value: y,
                inputRange: [0, 1],
                outputRange: [Number(((M = v.match(/[\d.]*/g)) == null ? void 0 : M[0]) || 0), Number(((L = A.match(/[\d.]*/g)) == null ? void 0 : L[0]) || 0)],
              });
            });
            s.setAttribute('stroke-dasharray', b.join(' '));
          },
        });
      }
      if (u && p) {
        const m = u.replace(/\s+/g, ' ').split(' '),
          x = p.replace(/\s+/g, ' ').split(' ');
        r({
          from: 0,
          to: 1,
          duration: t,
          easing: H.linear,
          onUpdate: (y) => {
            const b = nt(m, (v, k) => {
              var M, L;
              const A = x[k];
              return D({
                value: y,
                inputRange: [0, 1],
                outputRange: [Number(((M = v.match(/[\d.]*/g)) == null ? void 0 : M[0]) || 0), Number(((L = A.match(/[\d.]*/g)) == null ? void 0 : L[0]) || 0)],
              });
            });
            s.setAttribute('stroke-dashoffset', b.join(' '));
          },
        });
      }
    });
  }
  function kn(n) {
    const i = Array.from(n.querySelectorAll('[xo-prev-d], [xo-prev-stroke-dasharray], [xo-prev-stroke-dashoffset]'));
    E(i, (t) => {
      const e = t.getAttribute('d'),
        s = t.getAttribute('xo-prev-d'),
        r = t.getAttribute('stroke-dasharray'),
        a = t.getAttribute('xo-prev-stroke-dasharray'),
        l = t.getAttribute('stroke-dashoffset'),
        h = t.getAttribute('xo-prev-stroke-dashoffset');
      s && e && t.setAttribute('d', s), a && r && t.setAttribute('stroke-dasharray', a), h && l && t.setAttribute('stroke-dashoffset', h);
    });
  }
  function Bc(n) {
    const i = Array.from(n.querySelectorAll('[xo-next-stroke-dasharray], [xo-next-stroke-dashoffset]'));
    E(i, (t) => {
      const e = t.getAttribute('d'),
        s = t.getAttribute('xo-next-d'),
        r = t.getAttribute('stroke-dasharray'),
        a = t.getAttribute('xo-next-stroke-dasharray'),
        l = t.getAttribute('stroke-dashoffset'),
        h = t.getAttribute('xo-next-stroke-dashoffset');
      e && s && (t.style.setProperty('--xo-d', e), t.style.setProperty('--xo-next-d', s)),
        r && a && (t.style.setProperty('--xo-stroke-dasharray', r), t.style.setProperty('--xo-next-stroke-dasharray', a)),
        l && h && (t.style.setProperty('--xo-stroke-dashoffset', l), t.style.setProperty('--xo-next-stroke-dashoffset', h));
    });
  }
  function _c() {
    const n = `
      <svg class="xo-hidden">
        <defs>
          <filter id="xo-goo-1">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0" result="blur"></feGaussianBlur>
            <feColorMatrix in="blur" mode="matrix" values="	1 0 0 0 0
                0 1 0 0 0
                1 0 1 0 0
                0 0 0 13 -6" result="goo"></feColorMatrix>
            <feComposite in="SourceGraphic" in2="goo" operator="atop"></feComposite>
          </filter>
          <filter id="xo-goo-2">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0" result="blur"></feGaussianBlur>
            <feColorMatrix in="blur" mode="matrix" values="	1 0 0 0 0
                0 1 0 0 0
                1 0 1 0 0
                0 0 0 12 -4" result="goo"></feColorMatrix>
            <feTurbulence type="turbulence" baseFrequency="1" numOctaves="1" seed="2" result="noise"></feTurbulence>
            <feDisplacementMap in="goo" in2="noise" scale="0" result="displacement"></feDisplacementMap>
            <feComposite in="SourceGraphic" in2="displacement" operator="atop"></feComposite>
          </filter>
          <filter id="xo-goo-3">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0" result="blur"></feGaussianBlur>
            <feColorMatrix in="blur" mode="matrix" values="	1 0 0 0 0
                0 1 0 0 0
                1 0 1 0 0
                0 0 0 15 -8" result="goo"></feColorMatrix>
            <feTurbulence type="fractalNoise" baseFrequency="0.1 0.5" numOctaves="5" seed="2" result="noise"></feTurbulence>
            <feDisplacementMap in="goo" in2="noise" scale="0" result="displacement"></feDisplacementMap>
            <feComposite in="SourceGraphic" in2="displacement" operator="atop"></feComposite>
          </filter>
          <filter id="xo-goo-4">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0" result="blur"></feGaussianBlur>
            <feColorMatrix in="blur" mode="matrix" values="	1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 18 -8" result="goo"></feColorMatrix>
            <feTurbulence type="fractalNoise" baseFrequency="1 0.01" numOctaves="1" seed="1" result="noise"></feTurbulence>
            <feDisplacementMap in="goo" in2="noise" scale="0" result="displacement"></feDisplacementMap>
            <feComposite in="SourceGraphic" in2="displacement" operator="atop"></feComposite>
          </filter>
          <filter id="xo-goo-5">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0" result="blur"></feGaussianBlur>
            <feColorMatrix in="blur" mode="matrix" values="	1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 14 -1" result="goo"></feColorMatrix>
            <feTurbulence type="fractalNoise" baseFrequency="0.009 1" numOctaves="1" seed="1" result="noise"></feTurbulence>
            <feDisplacementMap in="goo" in2="noise" scale="0" result="displacement"></feDisplacementMap>
            <feComposite in="SourceGraphic" in2="displacement" operator="atop"></feComposite>
          </filter>
          <filter id="xo-goo-6">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0" result="blur"></feGaussianBlur>
            <feColorMatrix in="blur" mode="matrix" values="	1 0 0 0 0
                0 1 0 0 0
                1 0 1 0 0
                0 0 0 12 -8" result="goo"></feColorMatrix>
            <feTurbulence type="fractalNoise" baseFrequency="1" numOctaves="1" seed="1" result="noise"></feTurbulence>
            <feDisplacementMap in="goo" in2="noise" scale="0" result="displacement"></feDisplacementMap>
            <feComposite in="SourceGraphic" in2="displacement" operator="atop"></feComposite>
          </filter>
          <filter id="xo-goo-7">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0" result="blur"></feGaussianBlur>
            <feColorMatrix in="blur" mode="matrix" values="	1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 18 -5" result="goo"></feColorMatrix>
            <feTurbulence type="fractalNoise" baseFrequency="0.07 0.3" numOctaves="1" seed="1" result="noise"></feTurbulence>
            <feDisplacementMap in="goo" in2="noise" scale="0" result="displacement"></feDisplacementMap>
            <feComposite in="SourceGraphic" in2="displacement" operator="atop"></feComposite>
          </filter>
        </defs>
      </svg>
    `;
    document.body.insertAdjacentHTML('beforeend', n);
  }
  const Li = {
    'xo-goo-1': { stdDeviation: { start: 50, end: 0 } },
    'xo-goo-2': { stdDeviation: { start: 20, end: 0 }, scale: { start: 100, end: 0 }, baseFrequency: { start: 0.1, end: 0.05 } },
    'xo-goo-3': { stdDeviation: { start: 40, end: 0 }, scale: { start: 150, end: 0 } },
    'xo-goo-4': { stdDeviation: { start: 70, end: 0 }, scale: { start: 200, end: 0 } },
    'xo-goo-5': { stdDeviation: { start: 40, end: 0 }, scale: { start: 100, end: 0 } },
    'xo-goo-6': { stdDeviation: { start: 90, end: 0 }, scale: { start: 300, end: 0 }, baseFrequency: { start: 0.1, end: 0.01 } },
    'xo-goo-7': { stdDeviation: { start: 35, end: 0 }, scale: { start: 250, end: 0 } },
  };
  function Ii(n) {
    var h, d, u;
    const i = n.getAttribute('xo-type'),
      t = (u = (d = Number(n.getAttribute('xo-duration'))) != null ? d : (h = window.settings) == null ? void 0 : h.animate_duration) != null ? u : 500;
    if (!(i != null && i.startsWith('goo-'))) return;
    const e = `xo-${i}`,
      s = document.querySelector(`#${e} feGaussianBlur`),
      r = document.querySelector(`#${e} feTurbulence`),
      a = document.querySelector(`#${e} feDisplacementMap`);
    (n.style.filter = `url(#${e})`),
      (n.style.opacity = '0'),
      _()({
        from: 0,
        to: 1,
        duration: t + 1200,
        easing: H.easeOutExpo,
        onUpdate(p) {
          const m = [0, 1],
            x = Li[e].stdDeviation,
            y = Li[e].scale,
            b = Li[e].baseFrequency,
            v = x != null ? D({ value: p, inputRange: m, outputRange: [x.start, x.end] }) : null,
            k = y != null ? D({ value: p, inputRange: m, outputRange: [y.start, y.end] }) : null,
            A = b != null ? D({ value: p, inputRange: m, outputRange: [b.start, b.end] }) : null;
          v && (s == null || s.setAttribute('stdDeviation', v.toString())),
            k && (a == null || a.setAttribute('scale', k.toString())),
            A && (r == null || r.setAttribute('baseFrequency', A.toString())),
            (n.style.opacity = p.toString());
        },
      });
  }
  function Di(n) {
    return (
      n.closest(`${c.Carousel}:not([xo-per-view]):not([xo-column-width])`) ||
      n.closest(`${c.Carousel}[xo-per-view="1"]:not([xo-column-width])`) ||
      n.closest(c.Toggle) ||
      n.closest(c.Modal) ||
      n.closest(c.Popover) ||
      n.closest(c.TabsPane)
    );
  }
  const ke = new IntersectionObserver(
    (n) => {
      const i = requestAnimationFrame(() => {
        let t = -1;
        n.forEach(async (e) => {
          const s = e.target,
            { xoCascade: r, xoDuration: a } = s.options;
          e.isIntersecting &&
            (f.set(s, 'xo-visible', !0),
            s.removeAttribute('aria-disabled'),
            s.handleWidthIncrement(),
            Mi(s, s.options),
            Di(s) || Ii(s),
            r && (t++, s.style.setProperty('--xo-order', `${t}`)),
            ke.unobserve(s),
            cancelAnimationFrame(i),
            await P(a * Math.max(1, t + 1) + 500),
            (s.style.animation = 'none'),
            (s.style.opacity = '1'));
        });
      });
    },
    { rootMargin: '0px 0px -50px 0px' },
  );
  function Wc(n) {
    var t, e, s, r, a, l;
    const h = class extends n {
      constructor() {
        super(...arguments);
        o(this, 'timeId', -1);
        o(this, 'cssId', '');
        o(this, '_options');
        o(this, 'cancel', () => {});
        o(this, 'handleWidthIncrement', () => {
          const { xoType: p, xoDuration: m } = this.options;
          if (p === 'width-increment') {
            const x = Array.from(this.children);
            E(x, (y) => {
              (y.style.width = 'var(--xo-width)'), (y.style.maxWidth = 'none');
            }),
              (this.style.width = 'var(--xo-width)'),
              clearTimeout(this.timeId),
              (this.timeId = window.setTimeout(() => {
                E(x, (y) => {
                  y.style.removeProperty('width'), y.style.removeProperty('max-width');
                }),
                  this.style.removeProperty('width'),
                  clearTimeout(this.timeId);
              }, m));
          }
        });
        o(this, 'setOptions', () => {
          this.options = $(this, {
            pick: ['xoDuration', 'xoConstant', 'xoOrder', 'xoType', 'xoEasing', 'xoStrength', 'xoCascade', 'xoDisabled'],
            types: {
              xoDuration: 'number',
              xoConstant: 'number',
              xoOrder: 'number',
              xoType: 'string',
              xoEasing: 'string',
              xoStrength: 'number',
              xoCascade: 'boolean',
              xoDisabled: 'boolean',
            },
          });
        });
      }
      static get observedAttributes() {
        return ['xo-observed', 'xo-duration', 'xo-type', 'xo-easing', 'xo-strength', 'xo-cascade', 'xo-order', 'xo-constant', 'xo-disabled'];
      }
      get options() {
        return { ...h.defaultOptions, ...this._options };
      }
      set options(p) {
        this._options = p;
      }
      async connectedCallback() {
        var M, L, V;
        this.setOptions();
        const { xoConstant: p, xoOrder: m, xoDuration: x, xoEasing: y, xoStrength: b, xoType: v, xoCascade: k, xoDisabled: A } = this.options;
        if (A) {
          f.set(this, 'xo-visible', !1),
            this.style.removeProperty('animation'),
            this.style.removeProperty('--xo-order'),
            this.style.removeProperty('--xo-strength'),
            this.style.removeProperty('--xo-constant'),
            this.style.removeProperty('--xo-duration'),
            this.style.removeProperty('--xo-easing');
          return;
        }
        const T = Di(this);
        if (
          (!f.get(this, 'xo-visible') && !T && ((this.style.opacity = '0.01'), this.setAttribute('aria-disabled', 'true')),
          this.setAttribute('xo-type', `${v}`),
          this.style.setProperty('--xo-order', `${m}`),
          this.style.setProperty('--xo-strength', `${b}`),
          this.style.setProperty('--xo-constant', `${p}`),
          this.style.setProperty('--xo-duration', `${x}`),
          this.style.setProperty('--xo-easing', (M = As[y]) != null ? M : y),
          v === 'width-increment' && this.offsetWidth > 0 && (this.style.setProperty('--xo-width', `${this.offsetWidth}px`), (this.style.width = '0px')),
          await P(0),
          T)
        ) {
          if (((this.style.transition = `all ${x}ms ${(L = As[y]) != null ? L : y} calc(((var(--xo-order) * var(--xo-constant)) + var(--xo-wrap-duration, 0)) * 1ms)`), k)) {
            const ot = (V = T.getAttribute('xo-duration')) != null ? V : '300',
              ut = Array.from(T.querySelectorAll(`${c.Animate}, [is^="${c.Animate}"]`));
            E(ut, (pt, gt) => {
              this === pt && (this.style.setProperty('--xo-order', `${gt}`), this.style.setProperty('--xo-wrap-duration', `${Number(ot) / 3}`));
            });
          }
        } else ke.observe(this);
      }
      async attributeChangedCallback(p, m, x) {
        (p === 'xo-observed' ||
          p === 'xo-type' ||
          p === 'xo-duration' ||
          p === 'xo-easing' ||
          p === 'xo-cascade' ||
          p === 'xo-strength' ||
          p === 'xo-order' ||
          p === 'xo-disabled' ||
          p === 'xo-constant') &&
          m !== x &&
          (Di(this) || (f.set(this, 'xo-visible', !1), this.style.removeProperty('animation'), ke.unobserve(this), ke.observe(this)), this.connectedCallback());
      }
      disconnectedCallback() {
        clearTimeout(this.timeId), ke.unobserve(this), this.cancel();
      }
    };
    let i = h;
    return (
      o(i, 'defaultOptions', {
        xoDuration: (e = (t = window.settings) == null ? void 0 : t.animate_duration) != null ? e : 500,
        xoType: (r = (s = window.settings) == null ? void 0 : s.animate_effect) != null ? r : 'fade-up',
        xoConstant: 75,
        xoOrder: 0,
        xoStrength: (l = (a = window.settings) == null ? void 0 : a.animate_strength) != null ? l : 1,
        xoEasing: 'easeLight',
        xoCascade: !1,
        xoDisabled: !1,
      }),
      i
    );
  }
  const eo = class {
    constructor() {
      o(this, 'observer');
      o(this, 'mutation');
      o(this, 'updateMutation');
      o(this, 'timeIds', new WeakMap());
      o(this, 'handleWidthIncrement', async (i) => {
        await P(10);
        const { xoType: t, xoDuration: e } = this.getOptions(i);
        if (t === 'width-increment') {
          const s = Array.from(i.children);
          E(s, (a) => {
            (a.style.width = 'var(--xo-width)'), (a.style.maxWidth = 'none');
          }),
            (i.style.width = 'var(--xo-width)'),
            clearTimeout(this.timeIds.get(i)),
            this.timeIds.delete(i);
          const r = window.setTimeout(() => {
            E(s, (a) => {
              a.style.removeProperty('width'), a.style.removeProperty('max-width');
            }),
              i.style.removeProperty('width'),
              clearTimeout(this.timeIds.get(i)),
              this.timeIds.delete(i);
          }, e);
          this.timeIds.set(i, r);
        }
      });
      o(this, 'handleIntersection', (i, t) => {
        let e = -1;
        i.forEach((s, r) => {
          var b, v, k;
          const a = s.target,
            { xoAnimate: l, xoType: h, xoCascade: d, xoOrder: u, xoStrength: p, xoDuration: m, xoConstant: x, xoEasing: y } = this.getOptions(a);
          if (
            (a.setAttribute('xo-type', `${h}`),
            a.style.setProperty('--xo-strength', `${p}`),
            a.style.setProperty('--xo-constant', `${x}`),
            a.style.setProperty('--xo-duration', `${m}`),
            a.style.setProperty('--xo-easing', (b = As[y]) != null ? b : y),
            h === 'width-increment' && a.offsetWidth > 0 && (a.style.setProperty('--xo-width', `${a.offsetWidth}px`), (a.style.width = '0px')),
            s.isIntersecting)
          ) {
            if (l === 'scroll') {
              e++;
              let A = -1;
              (v = window.xbEditor) != null && v.designMode ? (A = d ? e : u) : (A = d ? r : u),
                a.style.setProperty('--xo-order', `${A}`),
                f.set(a, 'xo-visible', !0),
                f.set(a, 'xo-opacity', !1),
                a.removeAttribute('aria-disabled'),
                a.querySelector('svg') && Mi(a, this.getOptions(a)),
                (k = a.getAttribute('xo-type')) != null && k.startsWith('goo-') && Ii(a),
                this.handleWidthIncrement(a),
                t.unobserve(a);
            }
          } else f.set(a, 'xo-visible', !1);
        });
      });
      o(this, 'handleMutation', (i) => {
        i.forEach(async (t) => {
          var s;
          const e = t.target;
          if (t.attributeName === 'xo-observed' || t.attributeName === 'xo-animate' || t.attributeName === 'xo-type' || t.attributeName === 'xo-duration') {
            const { xoAnimate: r } = this.getOptions(e);
            r === 'scroll'
              ? (f.set(e, 'xo-visible', !0),
                e.querySelector('svg') && (kn(e), Mi(e, this.getOptions(e))),
                (s = e.getAttribute('xo-type')) != null && s.startsWith('xo-goo-') && Ii(e),
                this.handleWidthIncrement(e))
              : r === 'svg-infinite'
              ? this.handleSingleSVG(e)
              : f.set(e, 'xo-visible', !1);
          }
        });
      });
      o(this, 'getEls', () => {
        var i;
        return document.querySelectorAll(
          (i = window.xbEditor) != null && i.designMode
            ? '[xo-animate="none"], [xo-animate="scroll"], [xo-animate="infinite"], [xo-animate="svg-infinite"]'
            : '[xo-animate="scroll"]',
        );
      });
      o(this, 'handleSingleSVG', async (i) => {
        var s;
        const { xoDuration: t, xoEasing: e } = this.getOptions(i);
        i.querySelector('svg') &&
          (kn(i),
          i.style.setProperty('--xo-duration', `${t}`),
          i.style.setProperty('--xo-easing', (s = As[e]) != null ? s : e),
          i.classList.add('xo-animate-svg-none'),
          Bc(i),
          await P(50),
          i.classList.remove('xo-animate-svg-none'));
      });
      o(this, 'svgInfinite', () => {
        document.querySelectorAll('[xo-animate="svg-infinite"]').forEach(this.handleSingleSVG);
      });
      o(this, 'handleAllSvg', () => {
        document.querySelectorAll('[xo-animate="scroll"], [xo-animate="svg-infinite"]').forEach((t) => {
          t.querySelector('svg') && zc(t);
        });
      });
      o(this, 'initIntersection', () => {
        this.getEls().forEach((t) => {
          this.observer.observe(t);
        });
      });
      o(this, 'first', () => {
        this.getEls().forEach((t) => {
          const { xoAnimate: e } = this.getOptions(t);
          !f.get(t, 'xo-visible') && e === 'scroll' && (f.set(t, 'xo-opacity', !0), t.setAttribute('aria-disabled', 'true'));
        });
      });
      o(this, 'initMutation', () => {
        this.getEls().forEach((t) => {
          this.mutation.observe(t, { attributes: !0, attributeFilter: ['xo-observed', 'xo-animate', 'xo-type', 'xo-duration'] });
        });
      });
      o(this, 'update', async () => {
        await P(), this.init();
      });
      (this.observer = new IntersectionObserver(this.handleIntersection, { rootMargin: '0px 0px -50px 0px' })),
        (this.mutation = new MutationObserver(this.handleMutation)),
        (this.updateMutation = new MutationObserver(this.update)),
        this.updateMutation.observe(document.body, { attributes: !0, attributeFilter: ['xo-animate-observed'] });
    }
    getOptions(i) {
      const t = $(i, {
        pick: ['xoAnimate', 'xoDuration', 'xoConstant', 'xoOrder', 'xoType', 'xoEasing', 'xoStrength', 'xoCascade', 'xoDisabled', 'xoInfinite'],
        types: {
          xoAnimate: 'string',
          xoDuration: 'number',
          xoConstant: 'number',
          xoOrder: 'number',
          xoType: 'string',
          xoEasing: 'string',
          xoStrength: 'number',
          xoCascade: 'boolean',
          xoDisabled: 'boolean',
          xoInfinite: 'boolean',
        },
      });
      return { ...eo.defaultOptions, ...t };
    }
    init() {
      var i;
      this.observer.disconnect(),
        this.mutation.disconnect(),
        this.first(),
        this.handleAllSvg(),
        this.svgInfinite(),
        this.initIntersection(),
        (i = window == null ? void 0 : window.xbEditor) != null && i.designMode && this.initMutation();
    }
  };
  let Ps = eo;
  o(Ps, 'defaultOptions', {
    xoAnimate: 'none',
    xoDuration: (Xn = (Un = window.settings) == null ? void 0 : Un.animate_duration) != null ? Xn : 500,
    xoType: (Gn = (Yn = window.settings) == null ? void 0 : Yn.animate_effect) != null ? Gn : 'fade-up',
    xoConstant: 75,
    xoOrder: 0,
    xoStrength: (Qn = (jn = window.settings) == null ? void 0 : jn.animate_strength) != null ? Qn : 1,
    xoEasing: 'easeLight',
    xoCascade: !1,
    xoDisabled: !1,
    xoInfinite: !1,
  });
  const ce = new Ps();
  let An = !1;
  (Zn = window == null ? void 0 : window.xbEditor) != null && Zn.designMode
    ? (ce.init(),
      se(async () => {
        An || (await P(500), ce.init());
      }),
      document.addEventListener('xb:element:load', () => {
        (An = !0), ce.init();
      }))
    : (se(() => {
        ce.init();
      }),
      (Kn = window.Shopify) != null &&
        Kn.designMode &&
        (document.addEventListener('shopify:section:load', () => ce.init()), document.addEventListener('shopify:section:reorder', () => ce.init())));
  const Ed = '';
  _c();
  const Uc = Wc(HTMLElement);
  B({ [c.Animate]: Uc });
  const wd = '',
    so = class extends HTMLElement {
      constructor() {
        super(...arguments);
        o(this, 'imageZoomItemEl', null);
        o(this, 'innerEl', null);
        o(this, 'thumbEl', null);
        o(this, 'zoomState', 4);
        o(this, '_options');
        o(this, 'pan', null);
        o(this, 'setOptions', () => {
          this.options = $(this, {
            pick: ['xoName', 'xoZoom', 'xoZoomSrc', 'xoPlacement', 'xoZoomFull', 'xoUseWheel'],
            types: { xoName: 'string', xoZoom: 'number', xoZoomSrc: 'string', xoPlacement: 'string', xoZoomFull: 'boolean', xoUseWheel: 'boolean' },
          });
        });
        o(this, 'handleThumb', (t, e) => {
          const s = this.thumbEl,
            { offsetWidth: r, offsetHeight: a } = this,
            l = r / this.zoomState,
            h = a / this.zoomState,
            d = Y(e - s.offsetHeight / 2, 0, a - s.offsetHeight),
            u = Y(t - s.offsetWidth / 2, 0, r - s.offsetWidth);
          (s.style.width = `${l}px`), (s.style.height = `${h}px`), (s.style.top = `${d}px`), (s.style.left = `${u}px`);
        });
        o(this, 'handleZoomImage', (t, e) => {
          var l;
          const { xoZoomSrc: s, xoZoomFull: r } = this.options,
            a = this.imageZoomItemEl;
          r ? f.set(this, 'xo-active', this.zoomState > 1) : f.set(this, 'xo-active', !0),
            a.setAttribute('xo-zoom', `${this.zoomState}`),
            (a.style.backgroundImage = `url('${s}')`),
            (a.style.transform = `translate3d(${t}px, ${e}px, 0) scale(${this.zoomState})`),
            (l = this.pan) == null || l.setValue({ dx: t, dy: e });
        });
        o(this, 'resetTransform', () => {
          const t = this.imageZoomItemEl;
          (t.style.transform = 'translate3d(0, 0, 0) scale(1)'), t.removeAttribute('xo-zoom');
        });
        o(this, 'handler', (t) => {
          const { xoPlacement: e } = this.options,
            { offsetX: s, offsetY: r } = t,
            { offsetWidth: a, offsetHeight: l } = this,
            h = e === 'center',
            d = a / this.zoomState,
            u = l / this.zoomState,
            p = h ? 0 : d / 2,
            m = h ? 0 : u / 2,
            x = D({ value: s, inputRange: [p, a - p], outputRange: [0, -(a * (this.zoomState - 1))] }),
            y = D({ value: r, inputRange: [m, l - m], outputRange: [0, -(l * (this.zoomState - 1))] });
          this.handleZoomImage(x, y), this.handleThumb(s, r);
        });
        o(this, 'handleMouseLeave', () => {
          const { xoZoom: t, xoZoomFull: e } = this.options;
          e || (f.set(this, 'xo-active', !1), (this.zoomState = t));
        });
        o(this, 'handleWheel', (t) => {
          t.preventDefault();
          const { deltaY: e } = t;
          (this.zoomState = Y(this.zoomState + e / 60, 1, 10)), this.handler(t);
        });
        o(this, 'handleWindowClick', (t) => {
          this.contains(t.target) || (f.set(this, 'xo-active', !1), this.resetTransform(), (this.zoomState = this.options.xoZoom));
        });
      }
      get options() {
        return { ...so.defaultOptions, ...this._options };
      }
      set options(t) {
        this._options = t;
      }
      static get observedAttributes() {
        return ['xo-observed'];
      }
      createChild() {
        const { xoPlacement: t, xoName: e } = this.options;
        (this.thumbEl = document.createElement(c.ImageZoomThumb)),
          (this.imageZoomItemEl = document.createElement(c.ImageZoomItem)),
          t === 'manual' ? (this.innerEl = document.querySelector(`${c.ImageZoomManual}[xo-name="${e}"]`)) : (this.innerEl = document.createElement(c.ImageZoomInner)),
          this.innerEl.appendChild(this.imageZoomItemEl),
          this.appendChild(this.innerEl),
          t !== 'center' && this.appendChild(this.thumbEl);
      }
      connectedCallback() {
        this.setOptions();
        const { xoPlacement: t, xoZoom: e, xoZoomFull: s, xoUseWheel: r } = this.options;
        (this.zoomState = e),
          this.setAttribute('xo-placement', t),
          this.createChild(),
          U.any
            ? s && (this.pan = Gt({ element: this.imageZoomItemEl, onMove: () => {} }))
            : (this.addEventListener('mousemove', this.handler), this.addEventListener('mouseleave', this.handleMouseLeave), r && this.addEventListener('wheel', this.handleWheel)),
          window.addEventListener('click', this.handleWindowClick);
      }
      attributeChangedCallback(t, e, s) {
        t === 'xo-observed' && e !== s && (this.setOptions(), (this.zoomState = this.options.xoZoom));
      }
      disconnectedCallback() {
        var t;
        this.removeEventListener('mousemove', this.handler),
          this.removeEventListener('mouseleave', this.handleMouseLeave),
          this.removeEventListener('wheel', this.handleWheel),
          window.removeEventListener('click', this.handleWindowClick),
          (t = this.pan) == null || t.destroy();
      }
    };
  let Ts = so;
  o(Ts, 'defaultOptions', { xoName: '', xoZoom: 4, xoZoomSrc: '', xoPlacement: 'center', xoZoomFull: !1, xoUseWheel: !0 }), B({ [c.ImageZoom]: Ts });
  const Cd = '';
  class Xc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'daysEl', null);
      o(this, 'hoursEl', null);
      o(this, 'minutesEl', null);
      o(this, 'secondsEl', null);
      o(this, 'setDefaultText', () => {
        this.daysEl && (this.daysEl.innerText = this.setZeroPad('0')),
          this.hoursEl && (this.hoursEl.innerText = this.setZeroPad('0')),
          this.minutesEl && (this.minutesEl.innerText = this.setZeroPad('0')),
          this.secondsEl && (this.secondsEl.innerText = this.setZeroPad('0'));
      });
      o(this, 'handleCountdown', () => {
        const t = this.getAttribute('xo-timestamp');
        if (!t) throw new Error(`${c.Countdown}: Attribute xo-timestamp is required.`);
        const s = Number(t) - Date.now();
        if (
          (this.daysEl || (this.daysEl = this.querySelector(c.CountdownDay)),
          this.hoursEl || (this.hoursEl = this.querySelector(c.CountdownHour)),
          this.minutesEl || (this.minutesEl = this.querySelector(c.CountdownMinute)),
          this.secondsEl || (this.secondsEl = this.querySelector(c.CountdownSecond)),
          s > 0)
        ) {
          const r = this.getDays(s),
            a = this.daysEl ?  this.getHours(s) : this.getHours(s) + 24 * r,
            l = this.getMinutes(s),
            h = this.getSeconds(s);
          this.daysEl && Number(this.daysEl.innerText) !== r && (r < 1 ? (this.daysEl.innerText = this.setZeroPad('0')) : (this.daysEl.innerText = this.setZeroPad(`${r}`))),
            this.hoursEl && Number(this.hoursEl.innerText) !== a && (this.hoursEl.innerText = this.setZeroPad(`${a}`)),
            this.minutesEl && Number(this.minutesEl.innerText) !== l && (this.minutesEl.innerText = this.setZeroPad(`${l}`)),
            this.secondsEl && Number(this.secondsEl.innerText) !== h && (this.secondsEl.innerText = this.setZeroPad(`${h}`)),
            f.set(this, 'xo-expired', !1);
        } else G.remove(this.handleCountdown), f.set(this, 'xo-expired', !0), this.setDefaultText();
      });
    }
    static get observedAttributes() {
      return ['xo-observed'];
    }
    getDays(t) {
      return Math.floor(t / (1e3 * 60 * 60 * 24));
    }
    getHours(t) {
      return Math.floor((t % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60));
    }
    getMinutes(t) {
      return Math.floor((t % (1e3 * 60 * 60)) / (1e3 * 60));
    }
    getSeconds(t) {
      return Math.floor((t % (1e3 * 60)) / 1e3);
    }
    setZeroPad(t) {
      const e = Number(this.getAttribute('xo-zero-pad')) || 1;
      return t.padStart(e, '0');
    }
    connectedCallback() {
      G.add(this.handleCountdown, !0),
        (this.daysEl = this.querySelector(c.CountdownDay)),
        (this.hoursEl = this.querySelector(c.CountdownHour)),
        (this.minutesEl = this.querySelector(c.CountdownMinute)),
        (this.secondsEl = this.querySelector(c.CountdownSecond)),
        this.setDefaultText();
    }
    disconnectedCallback() {
      G.remove(this.handleCountdown);
    }
    async attributeChangedCallback(t, e, s) {
      t === 'xo-observed' && e !== s && (await P(100), this.disconnectedCallback(), this.connectedCallback());
    }
  }
  B({ [c.Countdown]: Xc });
  let Pn =
    (($e = class extends Et {
      constructor() {
        super(...arguments);
        o(this, 'observer', null);
        o(this, 'animated', _());
        o(this, 'attrAnimated', _());
        o(this, 'timeId', -1);
        o(this, 'handleCountto', async () => {
          const { xoFrom: t, xoTo: e, xoDuration: s, xoDelay: r, xoEasing: a } = this.props,
            l = this.querySelector(c.CounttoNumber);
          this.timeId = window.setTimeout(() => {
            this.animated({
              from: t,
              to: e,
              duration: s,
              onUpdate: (h) => {
                const d = Math.round(h).toString();
                l ? (l.textContent = d) : (this.textContent = d);
              },
            }),
              this.attrAnimated({
                from: t,
                to: e,
                duration: s,
                easing: H[a],
                onUpdate: (h) => {
                  this.style.setProperty('--xo-value', `${h}`);
                },
              });
          }, r);
        });
      }
      mount() {
        (this.observer = new IntersectionObserver(
          (t) => {
            t.forEach((e) => {
              var s;
              e.isIntersecting && (this.handleCountto(), (s = this.observer) == null || s.unobserve(this));
            });
          },
          { rootMargin: '0px 0px -50px 0px' },
        )),
          this.observer.observe(this);
      }
      propUpdate({ name: t, prevProp: e, nextProp: s }) {
        t === 'xoObserved' && e != null && e !== s && (clearTimeout(this.timeId), this.animated.off(), this.attrAnimated.off(), this.handleCountto());
      }
      unmount() {
        var t;
        (t = this.observer) == null || t.unobserve(this), this.animated.off(), this.attrAnimated.off();
      }
    }),
    o($e, 'propTypes', { xoFrom: 'number', xoTo: 'number', xoDuration: 'number', xoDelay: 'number', xoEasing: 'string' }),
    o($e, 'defaultProps', { xoFrom: 0, xoTo: 100, xoDuration: 2e3, xoDelay: 0, xoEasing: 'ease' }),
    o($e, 'observedProps', ['xoObserved']),
    $e);
  Pn = Ot([Nt(c.Countto)], Pn);
  function Tn(n) {
    return n.search(/^https?:\/\/(www|)\.youtube\.com/g) !== -1;
  }
  function $n(n) {
    return n.search(/^https?:\/\/(player\.|)vimeo\.com/g) !== -1;
  }
  function Yc(n, i = !0) {
    return `https://player.vimeo.com/video/${n.replace(/(^.*(video|vimeo\.com)\/)(\w*)(.*$)/g, '$3')}?${i ? 'autoplay=1&' : ''}loop=1&background=1&muted=1`;
  }
  function Gc(n, i = !0) {
    const t = n.replace(/(^.*(embed\/|(\?|&)v=))(\w*)(.*$)/g, '$4');
    return `https://www.youtube.com/embed/${t}?${i ? 'autoplay=1&' : ''}loop=1&mute=1&controls=0&iv_load_policy=1&disablekb=1&playlist=${t}&modestbranding=1&playsinline=1`;
  }
  function jc(n, i) {
    return $n(n) ? Yc(n, i) : Tn(n) ? Gc(n, i) : n;
  }
  async function Qc(n) {
    const t = await (await fetch(`https://www.youtube.com/oembed?url=${n}&format=json`)).json();
    return t.width / t.height;
  }
  class Zc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, '_options');
      o(this, 'videoRatio', 16 / 9);
      o(this, 'itemEl', null);
      o(this, 'videoEl', null);
      o(this, 'getAutoplay', () => {
        const { xoAutoplay: t = !0 } = this.options;
        return t ? 'autoplay' : '';
      });
      o(
        this,
        'renderVimeo',
        (t) => `<${c.VideoCoverItem}>
        <iframe
          src="${t}"
          title="Vimeo video"
          frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; allowsInlineMediaPlayback; ${this.getAutoplay()}"
          allowfullscreen
        ></iframe>
      </${c.VideoCoverItem}>`,
      );
      o(
        this,
        'renderYoutube',
        (t) => `<${c.VideoCoverItem}>
        <iframe
          src="${t}"
          title="YouTube video"
          frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; allowsInlineMediaPlayback; ${this.getAutoplay()}"
          allowfullscreen
          allowsInlineMediaPlayback
        ></iframe>
      </${c.VideoCoverItem}>`,
      );
      o(
        this,
        'renderVideo',
        (t) => `<${c.VideoCoverItem}>
        <video
          src="${t}"
          title="Video"
          ${this.getAutoplay()}
          muted
          loop
          playsinline
          preload="metadata"
        ></video>
      </${c.VideoCoverItem}>`,
      );
      o(this, 'setVideoSize', () => {
        if (this.itemEl) {
          const t = this.offsetWidth / this.offsetHeight;
          this.videoRatio > t
            ? ((this.itemEl.style.height = `${this.offsetHeight}px`), (this.itemEl.style.width = `${this.offsetHeight * this.videoRatio}px`))
            : ((this.itemEl.style.width = `${this.offsetWidth}px`), (this.itemEl.style.height = `${this.offsetWidth / this.videoRatio}px`));
        }
      });
      o(this, 'handleVideoRatio', () => {
        this.videoEl && ((this.videoRatio = this.videoEl.videoWidth / this.videoEl.videoHeight), this.setVideoSize());
      });
      o(this, 'handleYoutubeRatio', async () => {
        try {
          (this.videoRatio = await Qc(this.options.xoSrc)), this.setVideoSize();
        } catch {
          console.log('error');
        }
      });
      o(this, 'handleVideo', () => {
        this.videoEl instanceof HTMLVideoElement &&
          (this.videoEl.readyState >= 2 ? this.handleVideoRatio() : this.videoEl.addEventListener('loadedmetadata', this.handleVideoRatio));
      });
      o(this, 'assignEl', () => {
        var t;
        (this.itemEl = this.querySelector(c.VideoCoverItem)), (this.videoEl = (t = this.itemEl) == null ? void 0 : t.querySelector('iframe, video'));
      });
      o(this, 'init', () => {
        this.setOptions();
        const { xoSrc: t, xoAutoplay: e = !0 } = this.options,
          s = jc(t, e);
        $n(t)
          ? (this.insertAdjacentHTML('beforeend', this.renderVimeo(s)), this.assignEl(), this.setVideoSize())
          : Tn(t)
          ? (this.insertAdjacentHTML('beforeend', this.renderYoutube(s)), this.assignEl(), this.handleYoutubeRatio())
          : (this.insertAdjacentHTML('beforeend', this.renderVideo(s)), this.assignEl(), this.handleVideo());
      });
      o(this, 'destroy', () => {
        this.videoEl instanceof HTMLVideoElement && this.videoEl.removeEventListener('loadedmetadata', this.handleVideo);
      });
      o(
        this,
        'handleResize',
        st(
          me('x', () => {
            this.destroy(), this.init();
          }),
          400,
        ),
      );
    }
    static get observedAttributes() {
      return ['xo-observed', 'xo-src', 'xo-breakpoints', 'xo-autoplay'];
    }
    get options() {
      return this._options;
    }
    set options(t) {
      this._options = t;
    }
    setOptions() {
      var s;
      const t = $(this, { pick: ['xoSrc', 'xoBreakpoints', 'xoAutoplay'], types: { xoSrc: 'string', xoBreakpoints: 'object', xoAutoplay: 'boolean' } }),
        e = Dt(t.xoBreakpoints);
      (this.options = t), e && (this.options = { ...t, xoSrc: (s = e == null ? void 0 : e.src) != null ? s : t.xoSrc });
    }
    connectedCallback() {
      this.init(), this.dispatchEvent(new CustomEvent('xo-video-cover:init')), window.addEventListener('resize', this.handleResize);
    }
    async attributeChangedCallback(t, e, s) {
      (t === 'xo-observed' || t === 'xo-src' || t === 'xo-breakpoints') && e != null && e !== s && (await P(0), this.destroy(), this.init());
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize), this.destroy();
    }
  }
  let Mn = class extends Et {
    constructor() {
      super();
      o(this, 'wcVideoEl', null);
      o(this, 'handleClick', () => {
        this.setState((t) => ({ isPlaying: !t.isPlaying }));
      });
      o(this, 'handleVideoInit', () => {
        var e;
        const t = (e = this.wcVideoEl) == null ? void 0 : e.getAttribute('xo-autoplay');
        this.setState({ isPlaying: t ? t == 'true' : !0 });
      });
      this.state = { isPlaying: void 0 };
    }
    mount() {
      var t;
      (this.wcVideoEl = this.closest(c.VideoCover)),
        (t = this.wcVideoEl) == null || t.addEventListener('xo-video-cover:init', this.handleVideoInit),
        this.addEventListener('click', this.handleClick);
    }
    unmount() {
      var t;
      (t = this.wcVideoEl) == null || t.removeEventListener('xo-video-cover:init', this.handleVideoInit), this.removeEventListener('click', this.handleClick);
    }
    stateUpdate(t) {
      const { isPlaying: e } = this.state;
      if (t.isPlaying !== e) {
        const s = this.closest(c.VideoCover),
          r = s == null ? void 0 : s.querySelector('video');
        r && s && (e ? (r.play(), f.set(s, 'xo-playing', !0), f.set(s, 'xo-paused', !1)) : (r.pause(), f.set(s, 'xo-paused', !0), f.set(s, 'xo-playing', !1)));
      }
    }
  };
  Mn = Ot([Nt(c.VideoCoverButton), Bo('design:paramtypes', [])], Mn);
  const Sd = '';
  B({ [c.VideoCover]: Zc });
  function Kc() {
    const n = `
      <svg class="xo-hidden">
      <defs>
        <filter id="xo-typing-goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation="0" result="blur"></feGaussianBlur>
          <feColorMatrix in="blur" mode="matrix" values="	1 0 0 0 0
                    0 1 0 0 0
                    1 0 1 0 0
                    0 0 0 18 -8" result="goo"></feColorMatrix>
          <feComposite in="SourceGraphic" in2="goo" operator="atop"></feComposite>
      </filter>
      </defs>
    </svg>
    `;
    document.body.insertAdjacentHTML('beforeend', n);
  }
  const Ln = 1e3 / 60,
    io = class {
      constructor(i, t) {
        o(this, 'el');
        o(this, 'options');
        o(this, 'line', 0);
        o(this, 'start', Date.now());
        o(this, 'cancel', () => {});
        o(this, 'animated', _());
        o(this, 'typingContent', null);
        o(this, 'init', () => {
          const { xoDuration: i, xoDelay: t } = this.options,
            e = `<${c.TypingInner} style="--xo-duration: ${i}; --xo-delay: ${t}"><${c.TypingContent}></${c.TypingContent}></${c.TypingInner}>`;
          (this.el.innerHTML = e), (this.typingContent = this.el.querySelector(c.TypingContent)), (this.el.style.filter = 'url(#xo-typing-goo)');
        });
        o(this, 'handleGoo', (i) => {
          const { xoDuration: t } = this.options,
            e = document.querySelector('#xo-typing-goo feGaussianBlur');
          this.animated({
            from: i === 'inc' ? 0 : 8,
            to: i === 'inc' ? 8 : 0,
            duration: t,
            onUpdate(s) {
              e == null || e.setAttribute('stdDeviation', s.toString());
            },
          });
        });
        o(this, 'handleFrame', async () => {
          const { xoContent: i, xoDuration: t, xoDelay: e } = this.options;
          Date.now() - this.start > e &&
            (f.set(this.el, 'xo-goo', !0),
            this.handleGoo('inc'),
            (this.start = Date.now()),
            this.animated.off(),
            this.handleGoo('dec'),
            (this.cancel = await P(t - Ln)),
            f.set(this.el, 'xo-goo', !1),
            (this.line = (this.line + 1) % i.length));
          const r = i[this.line],
            a = (this.line + 1) % i.length,
            l = i[a],
            h = `<span>${r}</span><span>${l}</span>`,
            d = Array.from(this.el.querySelectorAll('span'));
          E(d, (u, p) => {
            const m = u.offsetWidth;
            this.el.style.setProperty(`--xo-width-${p}`, `${m}px`);
          }),
            this.typingContent && this.typingContent.innerHTML !== h && (this.typingContent.innerHTML = h);
        });
        o(this, 'destroy', () => {
          G.remove(this.handleFrame), this.cancel(), this.animated.off();
        });
        (this.el = i), (this.options = t), (this.el = i), (this.options = { ...io.defaultOptions, ...t }), G.add(this.handleFrame, !0), this.init();
      }
    };
  let $s = io;
  o($s, 'defaultOptions', { xoContent: [], xoDuration: 1e3, xoDelay: 2e3, xoEffect: 'typing' });
  const oo = class {
    constructor(i, t) {
      o(this, 'el');
      o(this, 'options');
      o(this, 'line', 0);
      o(this, 'start', Date.now());
      o(this, 'cancel', () => {});
      o(this, 'typingContent', null);
      o(this, 'init', () => {
        const { xoDuration: i, xoDelay: t } = this.options,
          e = `<${c.TypingInner} style="--xo-duration: ${i}; --xo-delay: ${t}"><${c.TypingContent}></${c.TypingContent}></${c.TypingInner}>`;
        (this.el.innerHTML = e), (this.typingContent = this.el.querySelector(c.TypingContent));
      });
      o(this, 'handleFrame', async () => {
        const { xoContent: i, xoDuration: t, xoDelay: e } = this.options;
        Date.now() - this.start > e &&
          (f.set(this.el, 'xo-slide', !0), (this.start = Date.now()), (this.cancel = await P(t - Ln)), f.set(this.el, 'xo-slide', !1), (this.line = (this.line + 1) % i.length));
        const r = i[this.line],
          a = (this.line + 1) % i.length,
          l = i[a],
          h = `<span>${r}</span><span>${l}</span>`,
          d = Array.from(this.el.querySelectorAll('span'));
        E(d, (u, p) => {
          const m = u.offsetWidth;
          this.el.style.setProperty(`--xo-width-${p}`, `${m}px`);
        }),
          this.typingContent && this.typingContent.innerHTML !== h && (this.typingContent.innerHTML = h);
      });
      o(this, 'destroy', () => {
        G.remove(this.handleFrame), this.cancel();
      });
      (this.el = i), (this.options = t), (this.el = i), (this.options = { ...oo.defaultOptions, ...t }), G.add(this.handleFrame, !0), this.init();
    }
  };
  let Ms = oo;
  o(Ms, 'defaultOptions', { xoContent: [], xoDuration: 300, xoDelay: 2e3, xoEffect: 'typing' });
  const no = class {
    constructor(i, t) {
      o(this, 'el');
      o(this, 'options');
      o(this, 'type', '');
      o(this, 'line', -1);
      o(this, 'minIndex', -1);
      o(this, 'sameText', '');
      o(this, 'index', -1);
      o(this, 'start', Date.now());
      o(this, 'start2', Date.now());
      o(this, 'start3', Date.now());
      o(this, 'increasing', !0);
      o(this, 'handleFrame', () => {
        const { xoContent: i, xoDuration: t, xoDelay: e, xoCursorChar: s } = this.options;
        this.index === this.minIndex && ((this.line = (this.line + 1) % i.length), (this.increasing = !0), (this.sameText = ''), (this.minIndex = -1));
        const r = 30,
          a = i[this.line],
          l = e + (t + r) * a.length;
        if (i.length > 1) {
          const m = (this.line + 1) % i.length,
            x = i[m];
          if (!this.increasing)
            for (let y = 0; y < a.length; y++) {
              const b = a[y];
              if (new RegExp(`^${this.sameText}`, 'g').test(x)) (this.minIndex = this.sameText.length - 1), (this.sameText += b);
              else break;
            }
        }
        Date.now() - this.start > t && this.increasing && this.index < a.length - 1 && ((this.index = (this.index + 1) % a.length), (this.start = Date.now())),
          this.index === a.length - 1 && Date.now() - this.start2 > l && ((this.increasing = !1), (this.start2 = Date.now()));
        const d = Date.now() - this.start3;
        !this.increasing && d > r && ((this.index = this.index - 1), (this.start3 = Date.now())),
          (this.type = a.substring(0, Math.min(this.index + 1, a.length))),
          this.el.innerHTML !== this.type && (this.el.innerHTML = this.type);
        const u = this.el.offsetHeight,
          p = this.el.offsetWidth;
        u > 0 && this.el.style.setProperty('--xo-height', `${u}px`), this.el.style.setProperty('--xo-width', `${p}px`), this.el.setAttribute('xo-cursor-char', `${s}`);
      });
      o(this, 'destroy', () => {
        G.remove(this.handleFrame);
      });
      (this.el = i), (this.options = t), (this.el = i), (this.options = { ...no.defaultOptions, ...t }), G.add(this.handleFrame, !0);
    }
  };
  let Ls = no;
  o(Ls, 'defaultOptions', { xoContent: [], xoDuration: 100, xoDelay: 2e3, xoEffect: 'typing', xoCursorChar: '|' });
  class Jc extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'typing', null);
      o(this, 'slide', null);
      o(this, 'goo', null);
      o(this, 'init', () => {
        const t = this.getOptions();
        switch (t.xoEffect) {
          case 'slide':
            this.slide = new Ms(this, t);
            break;
          case 'goo':
            this.goo = new $s(this, t);
            break;
          case 'typing':
          default:
            this.typing = new Ls(this, t);
            break;
        }
      });
      o(this, 'destroy', () => {
        var t, e, s;
        (t = this.typing) == null || t.destroy(), (e = this.slide) == null || e.destroy(), (s = this.goo) == null || s.destroy();
      });
    }
    static get observedAttributes() {
      return ['xo-observed', 'xo-duration', 'xo-content', 'xo-delay', 'xo-effect', 'xo-cursor-char'];
    }
    getOptions() {
      return $(this, {
        pick: ['xoContent', 'xoDuration', 'xoDelay', 'xoEffect', 'xoCursorChar'],
        types: { xoContent: 'array', xoDuration: 'number', xoDelay: 'number', xoEffect: 'string', xoCursorChar: 'string' },
      });
    }
    connectedCallback() {
      this.init();
    }
    disconnectedCallback() {
      this.destroy();
    }
    async attributeChangedCallback(t, e, s) {
      (t === 'xo-observed' || t === 'xo-duration' || t === 'xo-content' || t === 'xo-delay' || t === 'xo-effect' || t === 'xo-cursor-char') &&
        e !== s &&
        (await P(100), this.destroy(), this.init());
    }
  }
  const Ad = '';
  Kc(), B({ [c.Typing]: Jc });
  const he = { Idle: 'idle', Target: 'target', Lock: 'lock' },
    ro = class extends HTMLElement {
      constructor() {
        super(...arguments);
        o(this, 'handleEl');
        o(this, 'pan');
        o(this, 'animated', _());
        o(this, 'prevDx', 0);
        o(this, 'axis', he.Idle);
        o(this, 'setVariables', (t) => {
          this.style.setProperty('--xo-value', `${t}`), this.setAttribute('xo-value', `${t}`);
        });
        o(this, 'handler', () => {
          const { xoDefaultPercent: t } = this.getOptions();
          this.setVariables(t), (this.handleEl = this.querySelector(`${c.ImageComparison}-handle`));
          const { width: e } = this.getBoundingClientRect(),
            s = 1.5;
          (this.prevDx = e * (t / 100)),
            (this.pan = Gt({
              element: this,
              dx: e * (t / 100),
              onMove: ({ dx: r, dy: a }) => {
                const { width: l } = this.getBoundingClientRect();
                if ((this.axis === he.Idle && (Math.abs(r - this.prevDx) / s >= Math.abs(a) ? (this.axis = he.Target) : (this.axis = he.Lock)), this.axis === he.Target)) {
                  (this.style.touchAction = 'none'), (this.style.cursor = 'ew-resize');
                  const h = D({ value: r, inputRange: [0, l], outputRange: [0, 100] });
                  this.setVariables(h), (this.prevDx = r);
                }
              },
              onEnd: () => {
                (this.axis = he.Idle), this.pan.setValue({ dx: this.prevDx, dy: 0 }), this.style.removeProperty('cursor'), this.style.removeProperty('touch-action');
              },
            }));
        });
        o(this, 'handleClick', (t) => {
          if (!this.handleEl.contains(t.target)) {
            const { width: e } = this.getBoundingClientRect(),
              { offsetX: s } = t,
              r = D({ value: s, inputRange: [0, e], outputRange: [0, 100] });
            this.animated({
              from: Number(this.style.getPropertyValue('--xo-value')),
              to: r,
              duration: 100,
              easing: H.decay,
              onUpdate: (a) => {
                this.setVariables(a), this.pan.setValue({ dx: e * (a / 100) });
              },
            });
          }
        });
        o(this, 'init', () => {
          this.handler(), U.any || this.addEventListener('mousedown', this.handleClick);
        });
        o(this, 'destroy', () => {
          this.pan.destroy(), this.animated.off(), U.any || this.removeEventListener('mousedown', this.handleClick);
        });
      }
      static get observedAttributes() {
        return ['xo-observed', 'xo-value', 'xo-default-percent'];
      }
      getOptions() {
        const t = $(this, { pick: ['xoDefaultPercent'], types: { xoDefaultPercent: 'number' } });
        return { ...ro.defaultOptions, ...t };
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        this.destroy();
      }
      async attributeChangedCallback(t, e, s) {
        (t === 'xo-observed' || t === 'xo-default-percent') && e !== s && (await P(100), this.destroy(), this.init());
      }
    };
  let Is = ro;
  o(Is, 'defaultOptions', { xoDefaultPercent: 50 });
  const Pd = '';
  B({ [c.ImageComparison]: Is });
  const th = (n) => `xb-menu-${n.toString().slice(-8)}`;
  async function eh(n) {
    const i = th(n);
    return await (await fetch(`/?section_id=${i}`)).text();
  }
  const In = '.shopify-section.section-mega-menu',
    sh = 'StorefrontMessage::FetchSectionAssets',
    ih = 'StorefrontMessage::ReplaceSection',
    oh = 'StorefrontMessage::SelectElement',
    nh = 'StorefrontMessage::DeselectElement',
    te = class extends HTMLElement {
      constructor() {
        var t;
        super();
        o(this, 'linkEl', null);
        o(this, 'sectionEls', []);
        o(this, 'prevIndex', null);
        o(this, 'sectionGidSelected', '');
        o(this, 'builderMegaMenuHtml', '');
        o(this, 'setPositionStatic', (t) => {
          if (!te.isEmpty(t)) {
            const s = t.parentElement;
            s.tagName.toLowerCase() !== c.Toggle && (s.style.position = 'static');
          }
        });
        o(this, 'handleLinkClick', (t) => {
          const e = t.target,
            s = e.getAttribute('xo-modal-name');
          s && e instanceof HTMLAnchorElement && (t.preventDefault(), ne.open(s));
        });
        o(this, 'handleMenuHamburger', () => {
          const t = this.closest(c.Modal),
            e = !te.isEmpty(this);
          t &&
            e &&
            ((this.linkEl = t.previousElementSibling),
            this.linkEl && (this.linkEl.setAttribute('xo-modal-name', t.getAttribute('xo-name')), this.linkEl.addEventListener('click', this.handleLinkClick)));
        });
        o(this, 'renderForTheme', () => {
          const { xoIndex: t, xoName: e } = this.options,
            s = `template[xo-mega-menu-name='${e}'][xo-mega-menu-index="${t}"]`,
            r = document.querySelector(s);
          r && te.isEmpty(this) && this.appendChild(r.content.cloneNode(!0));
        });
        o(this, 'renderForBuilder', async () => {
          try {
            const { xoName: t, xoPreviewMode: e } = this.options;
            if (e) {
              const s = `template[xo-mega-menu-name='${t}']`,
                r = document.querySelector(s);
              r && te.isEmpty(this) && this.appendChild(r.content.cloneNode(!0));
            } else {
              this.builderMegaMenuHtml || (this.builderMegaMenuHtml = await eh(t));
              const s = new RegExp(`(<template.*xo-mega-menu-name=['"]${t}['"]>|<\\/template>)`, 'g'),
                r = `<xo-fragment>${this.builderMegaMenuHtml.replace(s, '')}</xo-fragment>`,
                a = new DOMParser().parseFromString(r, 'text/html'),
                l = Array.from(a.querySelectorAll('script')).filter((h) => h.type === '' || h.type === 'text/javascript');
              if (r && te.isEmpty(this)) {
                E(l, (d) => {
                  d.remove();
                });
                const h = a.body.querySelector('xo-fragment');
                E(Array.from(h.children), (d) => {
                  this.appendChild(d);
                }),
                  E(l, (d) => {
                    d.src ? ei({ id: d.id || `id-${Js(d.src)}`, file: d.src }) : d.textContent && ei({ id: d.id || `id-${Js(d.textContent)}`, content: d.textContent });
                  });
              }
            }
          } catch {}
        });
        o(this, 'render', () => {
          const { xoBuilder: t } = this.options;
          t ? this.renderForBuilder() : this.renderForTheme();
        });
        o(this, 'handleMessage', async (t) => {
          var s;
          const { xoBuilder: e } = this.options;
          if (!e) {
            if (
              (t.data.type === oh && ((this.sectionEls = Array.from(document.querySelectorAll(In))), (this.sectionGidSelected = t.data.payload.sectionGid)),
              t.data.type === nh && (this.prevIndex = null),
              t.data.type === sh)
            ) {
              const r = `shopify-section-${t.data.payload.sectionGid}`,
                a = this.sectionEls.find((l) => l.id === r);
              if (a) {
                const l = a.querySelector('template');
                this.prevIndex = (s = l == null ? void 0 : l.getAttribute('xo-mega-menu-index')) != null ? s : '';
              }
            }
            if (t.data.type === ih) {
              const r = t.data.payload.markup,
                l = new DOMParser().parseFromString(r, 'text/html').querySelector('template[xo-mega-menu-name]'),
                h = l == null ? void 0 : l.getAttribute('xo-mega-menu-index');
              if (!!this.querySelector(`[data-id="${this.sectionGidSelected}"]`) && !!l) {
                const u = l.cloneNode(!0);
                this.innerHTML.trim() !== u.innerHTML.trim() && (this.innerHTML = u.innerHTML);
              }
              this.prevIndex != null && this.prevIndex !== h && (await P(400), window.location.reload());
            }
          }
        });
        (t = window.Shopify) != null && t.designMode && (window.addEventListener('message', this.handleMessage), (this.sectionEls = Array.from(document.querySelectorAll(In))));
      }
      static get observedAttributes() {
        return ['xo-name'];
      }
      get options() {
        return $(this, {
          pick: ['xoIndex', 'xoName', 'xoBuilder', 'xoPreviewMode'],
          types: { xoIndex: 'number', xoName: 'string', xoBuilder: 'boolean', xoPreviewMode: 'boolean' },
        });
      }
      connectedCallback() {
        var t;
        ((t = window.xbEditor) != null && t.designMode) || (this.render(), window.Xotiny && this.setPositionStatic(this), this.handleMenuHamburger());
      }
      disconnectedCallback() {
        var t;
        (t = this.linkEl) == null || t.removeEventListener('click', this.handleLinkClick), window.removeEventListener('message', this.handleMessage);
      }
    };
  let Ds = te;
  o(Ds, 'isEmpty', (t) => t.innerHTML.trim() === ''), B({ [c.MegaMenu]: Ds });
  class rh extends HTMLElement {
    constructor() {
      super();
      o(this, 'colorSchemeIds', ((Jn = window.settings) == null ? void 0 : Jn.color_scheme_ids) || []);
      o(this, 'darkModeMapping', (tr = window.settings) == null ? void 0 : tr.dark_mode_mapping);
      o(this, 'colorSchemeMapping');
      o(this, 'prevIds', new Map());
      o(this, 'nextIds', new Map());
      o(this, 'rootPrevId', '');
      o(this, 'rootNextId', '');
      o(this, 'handleToggles', []);
      if (this.darkModeMapping)
        try {
          this.colorSchemeMapping = this.darkModeMapping
            .trim()
            .split(
              `
  `,
            )
            .reduce((t, e) => {
              const [s, r] = e.replace(/:\s+/g, ':').split(':');
              return { ...t, [s]: r };
            }, {});
        } catch {
          this.colorSchemeMapping = {};
        }
      else this.colorSchemeMapping = {};
    }
    connectedCallback() {
      var t;
      for (let e in this.colorSchemeMapping) {
        const s = Number(e.replace(/Scheme\s/g, '')) - 1,
          r = Number(this.colorSchemeMapping[e].replace(/Scheme\s/g, '')) - 1,
          a = this.colorSchemeIds[s],
          l = this.colorSchemeIds[r],
          h = Array.from(document.querySelectorAll(`.color-${a}`));
        E(h, (m) => {
          this.prevIds.set(m, a), this.nextIds.set(m, l);
        }),
          s === 0 && ((this.rootPrevId = a), (this.rootNextId = l));
        let d = ((t = at(oe.getItem('@xo/darkMode') || '{}')) == null ? void 0 : t[a]) === 'dark';
        const u = () => {
            this.setAttribute('xo-type', d ? 'dark' : 'light'),
              E(h, (m) => {
                d
                  ? (m.classList.remove(`color-${this.prevIds.get(m)}`), m.classList.add(`color-${this.nextIds.get(m)}`))
                  : (m.classList.remove(`color-${this.nextIds.get(m)}`), m.classList.add(`color-${this.prevIds.get(m)}`));
              }),
              s === 0 &&
                (d
                  ? (document.documentElement.classList.remove(`color-${this.rootPrevId}`), document.documentElement.classList.add(`color-${this.rootNextId}`))
                  : (document.documentElement.classList.remove(`color-${this.rootNextId}`), document.documentElement.classList.add(`color-${this.rootPrevId}`)));
          },
          p = () => {
            d = !d;
            const m = JSON.stringify({ ...at(oe.getItem('@xo/darkMode') || '{}'), [a]: d ? 'dark' : 'light' });
            oe.setItem('@xo/darkMode', m), u();
          };
        u(), this.addEventListener('click', p), this.handleToggles.push(p);
      }
    }
    disconnectedCallback() {
      E(this.handleToggles, (t) => {
        this.removeEventListener('click', t);
      });
    }
  }
  se(async () => {
    await P(0), B({ [c.DarkMode]: rh });
  });
  const ah = 300,
    Bs = class extends HTMLElement {
      constructor() {
        super();
        o(this, 'heights', []);
        o(this, 'resized', !1);
        o(this, 'debounceId', -1);
        o(this, 'resizeObserver', null);
        o(this, 'prevWidth', 0);
        o(this, '_options');
        o(this, 'setOptions', () => {
          var s, r, a, l;
          const t = $(this, { pick: ['xoGap', 'xoColumn', 'xoBreakpoints'], types: { xoGap: 'number', xoColumn: 'number', xoBreakpoints: 'object' } }),
            e = Dt(t.xoBreakpoints);
          this.options = {
            ...t,
            xoGap: (r = (s = e == null ? void 0 : e.gap) != null ? s : t.xoGap) != null ? r : Bs.defaultOptions.xoGap,
            xoColumn: (l = (a = e == null ? void 0 : e.column) != null ? a : t.xoColumn) != null ? l : Bs.defaultOptions.xoColumn,
          };
        });
        o(this, 'setItemStyles', (t) => {
          const { xoGap: e } = this.options,
            { xoColumn: s } = this.options;
          (t.style.position = 'absolute'),
            (t.style.width = `${100 / s}%`),
            (t.style.left = `${(100 / s) * this.indexSelected}%`),
            (t.style.top = `${this.minHeight}px`),
            (t.style.padding = `${e / 2}px`),
            this.resized && (t.style.transition = 'all 0.4s ease');
        });
        o(this, 'handleMasonryElement', () => {
          const { xoGap: t } = this.options,
            e = Array.from(this.querySelectorAll(c.MasonryItem));
          E(e, (s) => {
            this.setItemStyles(s), (this.heights[this.indexSelected] += s.offsetHeight);
          }),
            (this.style.height = `${this.maxHeight}px`),
            (this.style.margin = `-${t / 2}`),
            this.debounceId && clearTimeout(this.debounceId),
            (this.debounceId = window.setTimeout(() => {
              e.forEach((s) => {
                s.style.removeProperty('transition');
              }),
                (this.resized = !1);
            }, 500));
        });
        o(this, 'setDefaultHeights', () => {
          const { xoColumn: t } = this.options;
          this.heights = Array(t).fill(0);
        });
        o(this, 'update', () => {
          this.setOptions(), this.setDefaultHeights(), this.handleMasonryElement();
        });
        o(
          this,
          'handleResize',
          st((t) => {
            for (let e of t) {
              const s = e.contentRect.width;
              s !== this.prevWidth && ((this.resized = !0), this.update(), (this.prevWidth = s));
            }
          }, ah),
        );
      }
      static get observedAttributes() {
        return ['xo-observed'];
      }
      get options() {
        return this._options;
      }
      set options(t) {
        this._options = t;
      }
      get minHeight() {
        return Math.min(...this.heights);
      }
      get maxHeight() {
        return Math.max(...this.heights);
      }
      get indexSelected() {
        return ti(this.heights, (t) => t === this.minHeight);
      }
      connectedCallback() {
        this.update(), (this.resizeObserver = new ResizeObserver(this.handleResize)), this.resizeObserver.observe(this);
      }
      disconnectedCallback() {
        var t;
        clearTimeout(this.debounceId), (t = this.resizeObserver) == null || t.disconnect(), this.update();
      }
      async attributeChangedCallback(t, e, s) {
        var r;
        t === 'xo-observed' && e !== s && (await P(100), clearTimeout(this.debounceId), (r = this.resizeObserver) == null || r.disconnect(), this.update());
      }
    };
  let Ns = Bs;
  o(Ns, 'defaultOptions', { xoGap: 30, xoColumn: 4, xoBreakpoints: {} });
  const lh = 300;
  class ch extends HTMLElement {
    constructor() {
      super(...arguments);
      o(this, 'resizeObserver', null);
      o(this, 'prevWidth', 0);
      o(this, 'prevHeight', 0);
      o(this, 'masonryEl', null);
      o(
        this,
        'handleResize',
        st((t) => {
          var e;
          for (const s of t) {
            const r = s.contentRect.width,
              a = s.contentRect.height;
            (r !== this.prevWidth || a !== this.prevHeight) && ((e = this.masonryEl) == null || e.update(), (this.prevWidth = r), (this.prevHeight = a));
          }
        }, lh),
      );
    }
    connectedCallback() {
      var t;
      (this.masonryEl = this.closest(c.Masonry)),
        (this.resizeObserver = new ResizeObserver(this.handleResize)),
        this.resizeObserver.observe(this),
        (t = this.masonryEl) == null || t.update();
    }
    disconnectedCallback() {
      var e;
      const t = this.closest(c.Masonry);
      clearTimeout(t == null ? void 0 : t.debounceId), (e = this.resizeObserver) == null || e.disconnect();
    }
  }
  const Td = '';
  B({ [c.Masonry]: Ns, [c.MasonryItem]: ch });
  function hh(n, i, t, e) {
    var s = n - i,
      r = t - e;
    return Math.hypot(s, r);
  }
  const dh = 1e3 / 60,
    ao = class extends HTMLDivElement {
      constructor() {
        super();
        o(this, 'targetValueX', 0);
        o(this, 'targetValueY', 0);
        o(this, 'currentValueX', 0);
        o(this, 'currentValueY', 0);
        o(this, 'displacementX', 0);
        o(this, 'displacementY', 0);
        o(this, 'isHover', !1);
        o(this, 'handleFrameSyncUpdate', ({ delta: t }) => {
          if (this.itemEl) {
            const e = Math.abs(this.targetValueX - this.currentValueX),
              s = Math.abs(this.targetValueY - this.currentValueY);
            if (e < 0.001 && s < 0.001) return;
            let r = t / dh;
            const a = Math.round(r);
            a >= 1 && (r = a);
            const { xoLerpEase: l } = this.options,
              h = jt(this.currentValueX, this.targetValueX, (this.isHover ? l : 1) * r),
              d = jt(this.currentValueY, this.targetValueY, (this.isHover ? l : 1) * r);
            (this.itemEl.style.top = `${d}px`),
              (this.itemEl.style.left = `${h}px`),
              (this.currentValueX = h),
              (this.currentValueY = d),
              (this.isHover = !0),
              this.handleDistortion(r);
          }
        });
        o(this, 'handleDistortion', (t) => {
          const { xoLerpEase: e, xoDistortion: s } = this.options;
          if (s === 'none') return;
          (this.itemEl.style.filter = `url(#xo-cursor-${s})`),
            (this.displacementX = jt(this.displacementX, this.targetValueX, e * t)),
            (this.displacementY = jt(this.displacementY, this.targetValueY, e * t));
          const r = hh(this.displacementX, this.targetValueX, this.displacementY, this.targetValueY),
            a = document.querySelector(`#xo-cursor-${s} feDisplacementMap`);
          a.scale.baseVal = r;
        });
        o(this, 'setHoverButton', (t) => {
          const e = !!t.target.closest('a') || !!t.target.closest('button') || !!t.target.closest('[role="button"]');
          this.itemEl && f.set(this.itemEl, 'xo-is-hovering-button', e);
        });
        o(this, 'handleMouseMove', (t) => {
          const { xoAbsolute: e } = this.options;
          E(this.itemEls, (a) => {
            f.set(a, 'xo-active', !1);
          }),
            this.itemEl && !f.get(this.itemEl, 'xo-active') && f.set(this.itemEl, 'xo-active', !0);
          const { scrollX: s, scrollY: r } = this.getScrollXY();
          if (e) {
            const { top: a, left: l } = X(this);
            (this.targetValueX = t.pageX - l), (this.targetValueY = t.pageY - a);
          } else (this.targetValueX = t.pageX - s), (this.targetValueY = t.pageY - r);
          this.setHoverButton(t);
        });
        o(this, 'handleMouseLeave', (t) => {
          t.stopPropagation(), this.itemEl && (f.set(this.itemEl, 'xo-active', !1), (this.isHover = !1), G.remove(this.handleFrameSyncUpdate));
        });
        o(this, 'handleMouseEnter', (t) => {
          t.stopPropagation(), this.itemEl && (this.setHoverButton(t), G.add(this.handleFrameSyncUpdate, !0));
        });
        G.add(this.handleFrameSyncUpdate, !0);
      }
      get options() {
        const t = $(this, {
          pick: ['xoName', 'xoLerpEase', 'xoDistortion', 'xoAbsolute'],
          types: { xoName: 'string', xoLerpEase: 'number', xoDistortion: 'string', xoAbsolute: 'boolean' },
        });
        return { ...ao.defaultOptions, ...t };
      }
      get itemEl() {
        const { xoName: t } = this.options;
        return t ? this.querySelector(`${c.CursorItem}[xo-name="${t}"]`) : this.querySelector(c.CursorItem);
      }
      get itemEls() {
        return Array.from(document.querySelectorAll(c.CursorItem));
      }
      getScrollXY() {
        const t = window.scrollX,
          e = window.scrollY;
        return { scrollX: t, scrollY: e };
      }
      connectedCallback() {
        const { top: t, left: e } = X(this),
          { scrollX: s, scrollY: r } = this.getScrollXY();
        (this.targetValueX = e + this.offsetWidth / 2 - s),
          (this.targetValueY = t + this.offsetHeight / 2 - r),
          (this.currentValueX = this.targetValueX),
          (this.currentValueY = this.targetValueY),
          this.addEventListener('mouseenter', this.handleMouseEnter, !1),
          this.addEventListener('mousemove', this.handleMouseMove, !1),
          this.addEventListener('mouseleave', this.handleMouseLeave, !1);
      }
      disconnectedCallback() {
        this.removeEventListener('mouseenter', this.handleMouseEnter, !1),
          this.removeEventListener('mousemove', this.handleMouseMove, !1),
          this.removeEventListener('mouseleave', this.handleMouseLeave, !1),
          G.remove(this.handleFrameSyncUpdate);
      }
    };
  let Os = ao;
  o(Os, 'defaultOptions', { xoName: '', xoLerpEase: 0.1, xoDistortion: 'none', xoAbsolute: !1 });
  function uh() {
    const n = `
      <svg class="xo-hidden">
        <filter id="xo-cursor-distortion-1">
          <feTurbulence type="fractalNoise" baseFrequency="0.01 0.003" numOctaves="5" seed="2" stitchTiles="noStitch" x="0%" y="0%" width="100%" height="100%" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse" />
        </filter>
        <filter id="xo-cursor-distortion-2">
          <feTurbulence type="turbulence" baseFrequency="0.07 0.01" numOctaves="5" seed="2" stitchTiles="stitch" x="0%" y="0%" width="100%" height="100%" result="noise"></feTurbulence />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse" />
        </filter>
        <filter id="xo-cursor-distortion-3">
          <feTurbulence type="fractalNoise" baseFrequency="0.1" numOctaves="5" seed="2" stitchTiles="noStitch" x="0%" y="0%" width="100%" height="100%" result="noise"></feTurbulence />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse" />
        </filter>
        <filter id="xo-cursor-distortion-4">
          <feTurbulence type="fractalNoise" baseFrequency="0 0.04" numOctaves="5" seed="2" stitchTiles="noStitch" x="0%" y="0%" width="100%" height="100%" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse" />
        </filter>
        <filter id="xo-cursor-distortion-5">
          <feTurbulence type="fractalNoise" baseFrequency="1" numOctaves="5" seed="2" stitchTiles="noStitch" x="0%" y="0%" width="100%" height="100%" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="G" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse" />
        </filter>
      </svg>
    `;
    document.body.insertAdjacentHTML('beforeend', n);
  }
  const Md = '';
  uh(), customElements.get(c.Cursor) || customElements.define(c.Cursor, Os, { extends: 'div' });
  function ph() {
    var n;
    if (!((n = window.xbEditor) != null && n.designMode)) {
      let i = function (e) {
        const s = { xoOffset: 0, xoDuration: 500, xoEasing: 'easeInOutCubic' },
          r = $(e, { pick: ['xoOffset', 'xoDuration', 'xoEasing'], types: { xoOffset: 'number', xoDuration: 'number', xoEasing: 'string' } });
        return { ...s, ...r };
      };
      const t = _();
      window.addEventListener('click', (e) => {
        var l, h;
        const r = e.target.closest('[xo-scroll-to]'),
          a =
            (h = (l = r == null ? void 0 : r.getAttribute('href')) != null ? l : r == null ? void 0 : r.getAttribute('xb-href')) != null
              ? h
              : r == null
              ? void 0
              : r.getAttribute('xo-href');
        if (r && a) {
          e.preventDefault();
          const { xoOffset: d, xoDuration: u, xoEasing: p } = i(r);
          if (a === '#top')
            t({
              from: window.scrollY,
              to: 0 + d,
              duration: u,
              easing: H[p],
              onUpdate: (m) => {
                window.scrollTo({ top: m });
              },
            });
          else {
            const m = document.querySelector(a);
            if (m != null) {
              const x = window.scrollY,
                y = m.getBoundingClientRect().top + window.scrollY + d;
              t({
                from: x,
                to: y,
                duration: u,
                easing: H[p],
                onUpdate: (b) => {
                  const v = xi('top'),
                    k = D({ inputRange: [x, y], outputRange: [0, v], value: b });
                  window.scrollTo({ top: b - k });
                },
              });
            }
          }
        }
      });
    }
  }
  ph();
  function mh(n) {
    if (n.startsWith('[') && n.endsWith(']')) return at(n);
    const i = [],
      [t, e] = n.replace(/.*{/g, '').replace(/}.*/g, '').replace(/\s/g, '').split(','),
      s = Number(t),
      r = Number(e),
      a = t.replace(/\d/g, '0');
    for (let l = s; l <= r; l++) {
      const h = new RegExp(`(.*)(\\d{${l.toString().length}})`, 'g'),
        d = a.length === 1 ? `${l}` : a.replace(h, `$1${l}`),
        u = n.replace(/{.*}/g, d);
      i.push(u);
    }
    return i;
  }
  function fh(n) {
    return new Promise((i, t) => {
      const e = new Image();
      (e.onload = () => i(n)), (e.onerror = () => t('Error loading image')), (e.src = n);
    });
  }
  class xh {
    constructor(i = 0) {
      o(this, 'listeners', []);
      o(this, 'state');
      o(this, 'increment', () => {
        const { index: i, max: t, min: e } = this.state;
        i === t ? this.setState({ index: e }) : this.setState({ index: i + 1 });
      });
      o(this, 'decrement', () => {
        const { index: i, min: t, max: e } = this.state;
        i === t ? this.setState({ index: e }) : this.setState({ index: i - 1 });
      });
      o(this, 'setIndexWrapAroundRange', (i) => {
        const { min: t, max: e } = this.getState(),
          s = He(Math.floor(i), t, e);
        this.setState({ index: s });
      });
      o(this, 'imagesRequest', async (i) => {
        try {
          const t = mh(i),
            s = (await Promise.allSettled(t.map((r) => fh(r)))).reduce((r, a) => (a.status === 'fulfilled' && r.push(a.value), r), []);
          this.setState({ max: s.length - 1, images: s, loading: !1 });
        } catch {
          this.setState({ loading: !1 });
        }
      });
      this.state = { index: i, loading: !0, images: [], min: 0, max: 0 };
    }
    setState(i) {
      (this.state = { ...this.state, ...i }), this.listeners.forEach((t) => t());
    }
    getState() {
      return this.state;
    }
    subscribe(i) {
      return (
        this.listeners.push(i),
        () => {
          this.listeners = this.listeners.filter((t) => t !== i);
        }
      );
    }
  }
  const gh = 1e3,
    bh = 100,
    yh = 2e3,
    lo = class extends HTMLElement {
      constructor() {
        super(...arguments);
        o(this, 'store');
        o(this, 'nextEl', null);
        o(this, 'prevEl', null);
        o(this, 'playEl', null);
        o(this, 'pauseEl', null);
        o(this, 'pan', null);
        o(this, 'prevDx', 0);
        o(this, 'start', Date.now());
        o(this, 'animated', _());
        o(this, 'image', new Image());
        o(this, 'unsubscribe', () => {});
        o(this, 'stopAnimated', () => {});
        o(this, 'getOptions', () => {
          const t = $(this, { pick: ['xoSpeed', 'xoImages', 'xoPanSpeed'], types: { xoSpeed: 'number', xoImages: 'string', xoPanSpeed: 'number' } });
          return { ...lo.defaultOptions, ...t };
        });
        o(this, 'listener', () => {
          const { loading: t } = this.store.getState();
          t || (f.set(this, 'xo-loading', !1), this.appendImage());
        });
        o(this, 'appendImage', () => {
          const { index: t, images: e } = this.store.getState(),
            s = this.querySelector(c.Xo360ViewerContent);
          s &&
            ((this.image.src = e[t]),
            (this.image.alt = ''),
            (this.image.width = window.innerWidth),
            (this.image.height = window.innerHeight),
            s.firstChild || s.appendChild(this.image));
        });
        o(this, 'handleNext', () => {
          this.store.increment();
        });
        o(this, 'handlePrev', () => {
          this.store.decrement();
        });
        o(this, 'handleFrameUpdate', () => {
          const { xoSpeed: t } = this.getOptions();
          Date.now() - this.start > gh / t && (this.store.increment(), (this.start = Date.now()));
        });
        o(this, 'handlePlay', () => {
          this.stopAnimated(), f.set(this, 'xo-playing', !0), G.add(this.handleFrameUpdate, !0);
        });
        o(this, 'handlePause', () => {
          f.set(this, 'xo-playing', !1), G.remove(this.handleFrameUpdate);
        });
        o(this, 'bindEvents', () => {
          var s, r, a, l;
          const { xoPanSpeed: t } = this.getOptions();
          (s = this.nextEl) == null || s.addEventListener('click', this.handleNext),
            (r = this.prevEl) == null || r.addEventListener('click', this.handlePrev),
            (a = this.playEl) == null || a.addEventListener('click', this.handlePlay),
            (l = this.pauseEl) == null || l.addEventListener('click', this.handlePause);
          const e = this.querySelector(c.Xo360ViewerContent);
          this.pan = Gt({
            element: e,
            onStart: () => {
              this.stopAnimated();
            },
            onMove: ({ dx: h }) => {
              Date.now() - this.start > bh / t &&
                (h > this.prevDx ? this.store.decrement() : h < this.prevDx && this.store.increment(), (this.prevDx = h), (this.start = Date.now()));
            },
            onEnd: ({ vx: h }) => {
              const { index: d } = this.store.getState(),
                { setIndexWrapAroundRange: u } = this.store;
              this.stopAnimated = this.animated({ from: d, to: d - h, duration: yh, easing: H.easeOutExpo, onUpdate: u });
            },
          });
        });
        o(this, 'initial', () => {
          (this.nextEl = this.querySelector(c.Xo360ViewerNext)),
            (this.prevEl = this.querySelector(c.Xo360ViewerPrev)),
            (this.playEl = this.querySelector(c.Xo360ViewerPlay)),
            (this.pauseEl = this.querySelector(c.Xo360ViewerPause)),
            (this.store = new xh(0)),
            (this.pan = null),
            f.set(this, 'xo-loading', !0);
        });
        o(this, 'renderContent', () => {
          const t = `<${c.Xo360ViewerContent}></${c.Xo360ViewerContent}>`;
          this.insertAdjacentHTML('afterbegin', t);
        });
        o(this, 'loadImages', async () => {
          const { xoImages: t } = this.getOptions(),
            { imagesRequest: e } = this.store;
          await e(t), this.removeAttribute('xo-images');
        });
      }
      connectedCallback() {
        this.initial(), this.loadImages(), this.renderContent(), this.bindEvents(), (this.unsubscribe = this.store.subscribe(this.listener));
      }
      disconnectedCallback() {
        var t;
        this.unsubscribe(), (t = this.pan) == null || t.destroy();
      }
    };
  let Fs = lo;
  o(Fs, 'defaultOptions', { xoSpeed: 10, xoImages: '', xoPanSpeed: 10 });
  const Ld = '';
  B({ [c.Xo360Viewer]: Fs });
  const vh = 1200,
    Eh = 30,
    wh = 0.3;
  let Dn =
    ((_s = class extends Et {
      constructor() {
        super(...arguments);
        o(this, 'innerEl', this.children[0]);
        o(this, 'animated', _());
        o(this, 'pan', null);
        o(this, 'nextEl', this.querySelector(c.ScrollCarouselNext));
        o(this, 'prevEl', this.querySelector(c.ScrollCarouselPrev));
        o(this, 'anchorEls', Array.from(this.querySelectorAll('a')));
        o(this, 'isPanMove', !1);
        o(this, 'stopAnimated', () => {});
        o(this, 'state', { isDragging: !1, x: 0, navTarget: !1 });
        o(this, 'getDirConstant', () => {
          const { xoRtl: t } = this.props;
          return t ? -1 : 1;
        });
        o(this, 'endX', () => {
          const { xoGap: t } = this.props;
          return (this.offsetWidth - this.innerEl.scrollWidth + t) * this.getDirConstant();
        });
        o(this, 'getValue', (t, e = !0) => {
          const { xoRtl: s } = this.props,
            r = s ? 0 : this.endX(),
            a = s ? this.endX() : 0;
          return e ? Po(r, a, t, wh) : Y(t, r, a);
        });
        o(this, 'handlePanStart', (t) => {
          var e, s;
          (((e = this.nextEl) == null ? void 0 : e.contains(t.target)) || ((s = this.prevEl) == null ? void 0 : s.contains(t.target))) && this.setState({ navTarget: !0 }),
            (this.isPanMove = !1),
            this.stopAnimated();
        });
        o(this, 'handlePanMove', ({ dx: t, isHorizontalSwipe: e }, s) => {
          const { navTarget: r, isHorizontalSwipeState: a } = this.state;
          if (r) return;
          if ((a == null && this.setState({ isHorizontalSwipeState: e }), U.any ? this.state.isHorizontalSwipeState : !0)) {
            s.preventDefault(), (this.isPanMove = !0);
            const h = this.getValue(t);
            this.setState({ x: h, isDragging: !0 });
          }
        });
        o(this, 'handlePanEnd', ({ dx: t, vx: e }) => {
          const { isDragging: s } = this.state;
          s &&
            (this.setState({ isDragging: !1 }),
            (this.stopAnimated = this.animated({
              from: t,
              to: this.getValue(t + e * Eh, !1),
              duration: vh,
              easing: H.easeOutExpo,
              onUpdate: (r) => {
                var l;
                const a = this.getValue(r);
                this.setState({ x: a }), (l = this.pan) == null || l.setValue({ dx: a });
              },
            }))),
            this.setState({ isHorizontalSwipeState: void 0, navTarget: !1 });
        });
        o(this, 'handleWheel', (t) => {
          var l;
          const { deltaX: e, deltaY: s } = t;
          if (s) return;
          t.preventDefault();
          const { x: r } = this.state,
            a = Math.round(this.getValue(r - e + (e > 0 ? 1 : -1)));
          this.stopAnimated(), this.setState({ x: a }), (l = this.pan) == null || l.setValue({ dx: a });
        });
        o(this, 'getFirstLastEls', () => {
          const t = Array.from(this.innerEl.children);
          let e = t.filter((s) => {
            const { left: r } = X(s),
              a = r + s.offsetWidth;
            return r >= 0 && a < window.innerWidth;
          });
          return (
            e.length === 0 &&
              (e = t.filter((s) => {
                const r = s.getBoundingClientRect();
                return r.left + r.width >= 0 && r.left <= window.innerWidth;
              })),
            { firstEl: (e.length === 1 && e[0].previousElementSibling) || e[0], lastEl: e[e.length - 1] }
          );
        });
        o(this, 'handleGo', (t) => {
          const { xoSpeed: e, xoEasing: s } = this.props,
            { x: r } = this.state;
          (this.stopAnimated = this.animated({
            from: r,
            to: this.getValue(t, !1),
            duration: e,
            easing: H[s],
            onUpdate: (a) => {
              var h;
              const l = this.getValue(a);
              this.setState({ x: l, navTarget: !1 }), (h = this.pan) == null || h.setValue({ dx: l });
            },
          })),
            this.setState({ isHorizontalSwipeState: void 0 });
        });
        o(this, 'handleNext', (t) => {
          t.preventDefault();
          const { xoRtl: e } = this.props,
            { x: s } = this.state,
            { lastEl: r } = this.getFirstLastEls(),
            a = this.offsetWidth - r.offsetLeft,
            l = -(r.offsetLeft + r.offsetWidth),
            h = e ? a : l;
          s !== this.endX() && (h === s ? this.handleGo(s - this.offsetWidth * this.getDirConstant()) : this.handleGo(h));
        });
        o(this, 'handlePrev', (t) => {
          t.preventDefault();
          const { xoGap: e, xoRtl: s } = this.props,
            { x: r } = this.state,
            { firstEl: a } = this.getFirstLastEls(),
            l = (a.offsetLeft + e) * -1,
            h = (a.offsetLeft + a.offsetWidth - this.offsetWidth - e) * -1,
            d = s ? l : h;
          r !== 0 && (d === r ? this.handleGo(r + this.offsetWidth * this.getDirConstant()) : this.handleGo(d));
        });
        o(this, 'handleAnchor', (t) => {
          this.isPanMove && t.preventDefault();
        });
        o(this, 'bindAnchor', () => {
          E(this.anchorEls, (t) => {
            t.addEventListener('click', this.handleAnchor);
          });
        });
        o(this, 'unbindAnchor', () => {
          E(this.anchorEls, (t) => {
            t.removeEventListener('click', this.handleAnchor);
          });
        });
        o(this, 'updateUI', () => {
          const { x: t } = this.state;
          (this.innerEl.style.transform = `translate3d(${t}px, 0, 0)`),
            this.nextEl && f.set(this.nextEl, 'xo-disabled', t >= 0),
            this.prevEl && f.set(this.prevEl, 'xo-disabled', t <= this.endX());
        });
      }
      mount() {
        var e, s;
        const { xoGap: t } = this.props;
        !this.innerEl ||
          (this.updateUI(),
          this.innerEl.style.setProperty('--xo-gap', `${t}px`),
          this.bindAnchor(),
          (this.pan = Gt({ element: this, onStart: this.handlePanStart, onMove: this.handlePanMove, onEnd: this.handlePanEnd })),
          this.innerEl.addEventListener('wheel', this.handleWheel),
          (e = this.nextEl) == null || e.addEventListener('click', this.handleNext),
          (s = this.prevEl) == null || s.addEventListener('click', this.handlePrev));
      }
      stateUpdate() {
        this.updateUI();
      }
      unmount() {
        var t, e, s;
        (t = this.pan) == null || t.destroy(),
          this.stopAnimated(),
          this.unbindAnchor(),
          this.innerEl.removeEventListener('wheel', this.handleWheel),
          (e = this.nextEl) == null || e.removeEventListener('click', this.handleNext),
          (s = this.prevEl) == null || s.removeEventListener('click', this.handlePrev);
      }
    }),
    o(_s, 'propTypes', { xoSpeed: 'number', xoGap: 'number', xoEasing: 'string', xoRtl: 'boolean' }),
    o(_s, 'defaultProps', { xoSpeed: 200, xoEasing: 'ease', xoGap: 30, xoRtl: document.documentElement.dir === 'rtl' }),
    _s);
  Dn = Ot([Nt(c.ScrollCarousel)], Dn);
  const Id = '',
    Ch = 'cubic-bezier(.29,.99,.53,.88)';
  let Nn =
    ((Ws = class extends Et {
      constructor() {
        super(...arguments);
        o(this, 'handleMouseMove', (t) => {
          const { xoDuration: e, xoRadius: s } = this.props,
            r = this.querySelector(c.MagneticContent),
            { top: a, left: l, width: h, height: d } = this.getBoundingClientRect(),
            u = l + h / 2,
            p = a + d / 2,
            m = Math.max(u - t.clientX, 0),
            x = Math.max(t.clientX - u, 0),
            y = Math.max(p - t.clientY, 0),
            b = Math.max(t.clientY - p, 0),
            v = s,
            k = 1.3;
          if (!!r)
            if (this.checkCircle(t.clientX, t.clientY, u, p, v)) {
              const A = Math.abs(t.clientX) - u,
                T = Math.abs(t.clientY) - p,
                M = Math.sqrt(Math.pow(A, 2) + Math.pow(T, 2));
              let L = 0,
                V = 0;
              m > 0 ? (L = m / -k) : x > 0 && (L = x / k),
                y > 0 ? (V = y / -k) : b > 0 && (V = b / k),
                (L = L / (M / v + 0.5)),
                (V = V / (M / v + 0.5)),
                f.set(this, 'xo-active', !0),
                (r.style.transition = `${e}ms ${Ch}`),
                (r.style.transform = `translate(${L}px, ${V}px)`);
            } else f.set(this, 'xo-active', !1), (r.style.transform = 'translate(0, 0)');
        });
        o(this, 'getContainerEl', () => {
          var s;
          const { xoTarget: t } = this.props,
            e = this.closest('.shopify-section') || document.body;
          return t && (s = this.closest(t)) != null ? s : e;
        });
      }
      checkCircle(t, e, s, r, a) {
        return Math.pow(t - s, 2) + Math.pow(e - r, 2) <= Math.pow(a, 2);
      }
      mount() {
        this.getContainerEl().addEventListener('mousemove', this.handleMouseMove);
      }
      unmount() {
        this.getContainerEl().removeEventListener('mousemove', this.handleMouseMove);
      }
    }),
    o(Ws, 'propTypes', { xoDuration: 'number', xoRadius: 'number', xoTarget: 'string' }),
    o(Ws, 'defaultProps', { xoDuration: 600, xoRadius: 100 }),
    Ws);
  Nn = Ot([Nt(c.Magnetic)], Nn);
  const Dd = '';
  function Sh(n, i, t, e, s, r = 0.5) {
    const a = n.map((h, d) => {
      const u = (d / e) * i,
        p = t - (h / s) * t;
      return { x: u, y: p };
    });
    let l = `M ${a[0].x} ${a[0].y}`;
    for (let h = 0; h < a.length - 1; h++) {
      const d = a[h - 1] || a[h],
        u = a[h],
        p = a[h + 1],
        m = a[h + 2] || a[h + 1],
        x = u.x + ((p.x - d.x) * r) / 6,
        y = u.y + ((p.y - d.y) * r) / 6,
        b = p.x - ((m.x - u.x) * r) / 6,
        v = p.y - ((m.y - u.y) * r) / 6;
      l += ` C ${x} ${y}, ${b} ${v}, ${p.x} ${p.y}`;
    }
    return { path: l, points: a };
  }
  const kh = 400;
  let On =
    ((Me = class extends Et {
      constructor() {
        super(...arguments);
        o(this, 'observer', null);
        o(this, 'resizeObserver', null);
        o(this, 'prevWidth', 0);
        o(this, 'getAnimateEl', () => this.closest(c.Animate));
        o(this, 'getChartDimensions', () => {
          const { xoMargin: t } = this.props,
            e = this.offsetHeight - t * 2,
            s = this.offsetWidth - t * 2;
          return { chartHeight: e, chartWidth: s };
        });
        o(this, 'renderXLabels', () => {
          const { xoXLabels: t } = this.props,
            { chartHeight: e, chartWidth: s } = this.getChartDimensions();
          return t
            .map(
              (r, a) => `
          <text x="${(a / (t.length - 1)) * s}" y="${e + 20}" text-anchor="middle" font-size="12">${r}</text>
        `,
            )
            .join('');
        });
        o(this, 'renderYLabels', () => {
          const { xoYLabels: t } = this.props,
            { chartHeight: e } = this.getChartDimensions();
          return t
            .map(
              (s, r) => `
          <text x="-10" y="${(r / (t.length - 1)) * e}" text-anchor="end" dominant-baseline="middle" font-size="12">${s}</text>
        `,
            )
            .join('');
        });
        o(this, 'renderGridLines', () => {
          const { xoGridColor: t, xoGridType: e, xoXLabels: s, xoYLabels: r } = this.props,
            { chartWidth: a, chartHeight: l } = this.getChartDimensions();
          return [
            ...s.map((h, d) => {
              const u = (d / (s.length - 1)) * a;
              return `
            <line x1="${u}" y1="0" x2="${u}" y2="${l}" stroke="${t}" stroke-width="1"${e === 'dashed' ? ' stroke-dasharray="5,5"' : ''}></line>
          `;
            }),
            ...r.map((h, d) => {
              const u = (d / (r.length - 1)) * l;
              return `
            <line x1="0" y1="${u}" x2="${a}" y2="${u}" stroke="${t}" stroke-width="1"${e === 'dashed' ? ' stroke-dasharray="5,5"' : ''}></line>
          `;
            }),
          ].join('');
        });
        o(this, 'renderPoints', (t, e, s, r, a) =>
          e
            ? t
                .map((l) => `<circle cx="${l.x}" cy="${l.y}" r="${r}" fill="${s}"${a && this.getAnimateEl() ? ' style="transition: 1s ease 0.2s; opacity: 0;"' : ''}></circle>`)
                .join('')
            : '',
        );
        o(this, 'renderLines', (t) => {
          const { xoDatasets: e, xoMax: s, xoYLabels: r, xoXLabels: a, xoSmoothness: l } = this.props,
            { chartWidth: h, chartHeight: d } = this.getChartDimensions();
          return e
            .map((u) => {
              const { data: p, lineColor: m = '#3438fb', lineWidth: x = 2, lineCap: y = 'square', dotEnabled: b = !0, dotColor: v, dotSize: k = 4 } = u,
                A = a.length - 1,
                T = s != null ? s : Math.max(...r.map(Number)),
                { path: M, points: L } = Sh(p, h, d, A, T, Y(l, 0, 1));
              return `
            <path d="${M}" fill="none" stroke="${m}" stroke-width="${x}" stroke-linecap="${y}"></path>
            ${this.renderPoints(L, b, v || m, k, t)}
          `;
            })
            .join('');
        });
        o(this, 'renderChart', (t) => {
          const { xoMargin: e } = this.props,
            { chartWidth: s, chartHeight: r } = this.getChartDimensions();
          return `
        <svg width="${s + e * 2}" height="${r + e * 2}" version="1.1" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle">
          <g transform="translate(${e}, ${e})">
            ${this.renderXLabels()}
            ${this.renderYLabels()}
            ${this.renderGridLines()}
            ${this.renderLines(t)}
          </g>
        </svg>
      `;
        });
        o(this, 'handler', (t = !1) => {
          (this.innerHTML = this.renderChart(t)), t && this.handleAnimate(), (this.resizeObserver = new ResizeObserver(this.handleResize)), this.resizeObserver.observe(this);
        });
        o(
          this,
          'handleResize',
          st((t) => {
            var e;
            for (let s of t) {
              const r = s.contentRect.width;
              r !== this.prevWidth && (this.prevWidth !== 0 && ((this.innerHTML = ''), (e = this.observer) == null || e.disconnect(), this.handler()), (this.prevWidth = r));
            }
          }, kh),
        );
      }
      handleAnimate() {
        const t = Array.from(this.querySelectorAll('path')),
          e = Array.from(this.querySelectorAll('circle'));
        this.getAnimateEl() &&
          (E(t, (r) => {
            const a = r.getTotalLength();
            r.setAttribute('stroke-dashoffset', String(a)), r.setAttribute('stroke-dasharray', String(a)), r.setAttribute('xo-next-stroke-dashoffset', '0');
          }),
          (this.observer = new MutationObserver((r) => {
            E(r, (a) => {
              var h;
              const l = a.target.getAttribute('stroke-dashoffset');
              (l === '0' || !l) &&
                (E(e, (d) => {
                  d.style.opacity = '1';
                }),
                (h = this.observer) == null || h.disconnect());
            });
          })),
          this.observer.observe(t[0], { attributes: !0, attributeFilter: ['stroke-dashoffset'] }));
      }
      destroy() {
        var t, e;
        (this.innerHTML = ''), (t = this.observer) == null || t.disconnect(), (e = this.resizeObserver) == null || e.disconnect();
      }
      mount() {
        this.handler(!0);
      }
      unmount() {
        this.destroy();
      }
      propUpdate({ prevProp: t, nextProp: e }) {
        t != null && t !== e && (this.destroy(), this.handler());
      }
    }),
    o(Me, 'propTypes', {
      xoXLabels: 'array',
      xoYLabels: 'array',
      xoMax: 'number',
      xoDatasets: 'array',
      xoGridColor: 'string',
      xoGridType: 'string',
      xoMargin: 'number',
      xoSmoothness: 'number',
    }),
    o(Me, 'defaultProps', { xoXLabels: [], xoYLabels: [], xoDatasets: [], xoGridColor: '#ddd', xoGridType: 'dashed', xoMargin: 40, xoSmoothness: 1 }),
    o(Me, 'observedProps', ['xoXLabels', 'xoYLabels', 'xoDatasets', 'xoMax', 'xoGridColor', 'xoGridType', 'xoMargin']),
    Me);
  On = Ot([Nt(c.LineChart)], On);
  const Nd = '';
  let Fn =
    ((Us = class extends Et {
      constructor() {
        super(...arguments);
        o(this, 'timeId', -1);
        o(this, 'itemEls', Array.from(this.querySelectorAll(`:scope > ${c.ScrollSceneInner} > ${c.ScrollSceneItem}`)));
        o(this, 'state', { activeIndex: 0 });
        o(this, 'getThreshold', () => {
          const { xoThreshold: t } = this.props;
          return /Mac/.test(navigator.userAgent) ? t + 0.3 : t;
        });
        o(this, 'handleScroll', () => {
          const t = this.getThreshold(),
            { top: e } = this.getBoundingClientRect(),
            s = Math.trunc((e * -1) / (window.innerHeight * t)),
            r = Y(s, 0, this.itemEls.length - 1);
          this.setState({ activeIndex: r });
        });
        o(this, 'updateUI', () => {
          var a, l;
          const { activeIndex: t } = this.state,
            e = this.itemEls[t],
            s = (a = this.itemEls) == null ? void 0 : a[t - 1],
            r = (l = this.itemEls) == null ? void 0 : l[t + 1];
          E(this.itemEls, (h) => {
            f.set(h, 'xo-active', !1), f.set(h, 'xo-prev', !1), f.set(h, 'xo-next', !1);
          }),
            e && f.set(e, 'xo-active', !0),
            s && f.set(s, 'xo-prev', !0),
            r && f.set(r, 'xo-next', !0);
        });
      }
      setActive(t) {
        this.setState({ activeIndex: t });
      }
      mount() {
        if (this.itemEls.length <= 1) return;
        this.updateUI();
        const t = this.getThreshold();
        window.addEventListener('scroll', this.handleScroll), (this.style.height = `${100 * (this.itemEls.length + 1 / t) * t}vh`);
      }
      stateUpdate(t) {
        const { activeIndex: e } = this.state;
        t.activeIndex !== e && (this.updateUI(), this.emit('xo:scroll-scene:change', { bubbles: !0, detail: { activeIndex: e } }));
      }
      unmount() {
        clearTimeout(this.timeId), window.removeEventListener('scroll', this.handleScroll);
      }
    }),
    o(Us, 'propTypes', { xoThreshold: 'number' }),
    o(Us, 'defaultProps', { xoThreshold: 0.5 }),
    Us);
  Fn = Ot([Nt(c.ScrollScene)], Fn);
  const Od = '';
  function Ah() {
    document.addEventListener('keydown', async (n) => {
      const i = n.key === 'Enter' || n.key === ' ',
        t = n.target;
      if (t) {
        (f.get(t, 'data-button') || t.getAttribute('role') === 'button') && i && (await P(), t.click());
        const s = t.getAttribute('xb-href');
        s && i && (n.ctrlKey || n.metaKey ? window.open(s, '_blank') : (window.location.href = s));
      }
    });
  }
  function Ph() {
    var t;
    const n = 'https://unpkg.com/@dotlottie/player-component@2.7.12/dist/dotlottie-player.js',
      i = document.querySelector('dotlottie-player');
    (t = i == null ? void 0 : i.getAttribute('src')) != null &&
      t.endsWith('.lottie') &&
      (ei({ id: 'dotlottie-player', file: n }), Dr({ id: 'dotlottie-player', content: 'dotlottie-player { width: 100% !important; height: auto !important }' }));
  }
  se(() => {
    Ah(), Ph();
  });
  const Fd = '';
  console.log('WC V1.3.10'),
    (q.CircleBar = ge),
    (q.cartFormSubscribe = Ss),
    (q.cartSubscribe = Ai),
    (q.fieldSignal = lt),
    (q.getCartFormState = zt),
    (q.getCartState = mn),
    (q.xoCarousel = Ma),
    (q.xoCircleBar = xe),
    (q.xoCollapse = Ke),
    (q.xoFilters = bi),
    (q.xoGroup = Sn),
    (q.xoModal = ne),
    (q.xoPopover = re),
    (q.xoProductQuickView = Cn),
    (q.xoSticky = gi),
    (q.xoStore = g),
    (q.xoTabs = Yo),
    (q.xoToast = be),
    Object.defineProperties(q, { __esModule: { value: !0 }, [Symbol.toStringTag]: { value: 'Module' } });
});
